
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5271"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5271"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("bVR6A", function(module, exports) {

$parcel$export(module.exports, "fetchStates", () => $8afe362f5f765739$export$2bc3cba6f94d7400);
$parcel$export(module.exports, "fetchCategories", () => $8afe362f5f765739$export$416ec9f5729de215);
$parcel$export(module.exports, "fetchSubscriptionPackages", () => $8afe362f5f765739$export$ab04f8fd61bc91c0);
$parcel$export(module.exports, "fetchDistrictsByState", () => $8afe362f5f765739$export$ba5e21da449f1ef1);
$parcel$export(module.exports, "fetchTalukasByDistrict", () => $8afe362f5f765739$export$415625ec264edf5c);
$parcel$export(module.exports, "fetchSubcategoriesByCategory", () => $8afe362f5f765739$export$77974d798ce6fed4);
$parcel$export(module.exports, "fetchServicesByCategory", () => $8afe362f5f765739$export$89638f89f329fa22);
$parcel$export(module.exports, "fetchPaymentModes", () => $8afe362f5f765739$export$14d3ed471e81ae25);
$parcel$export(module.exports, "default", () => $8afe362f5f765739$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $8afe362f5f765739$export$2bc3cba6f94d7400 = (0, $iDqdB.createAsyncThunk)("public/fetchStates", async ()=>{
    const res = await (0, $ivNbC.default).get("/public/states");
    return res.data;
});
const $8afe362f5f765739$export$416ec9f5729de215 = (0, $iDqdB.createAsyncThunk)("public/fetchCategories", async ()=>{
    const res = await (0, $ivNbC.default).get("/public/categories");
    return res.data;
});
const $8afe362f5f765739$export$ab04f8fd61bc91c0 = (0, $iDqdB.createAsyncThunk)("public/fetchsubscriptionPackages", async ()=>{
    const res = await (0, $ivNbC.default).get("/public/subscription-packages");
    return res.data;
});
const $8afe362f5f765739$export$ba5e21da449f1ef1 = (0, $iDqdB.createAsyncThunk)("public/fetchDistrictsByState", async (stateId)=>{
    const res = await (0, $ivNbC.default).get(`/public/states/${stateId}/districts`);
    return res.data;
});
const $8afe362f5f765739$export$415625ec264edf5c = (0, $iDqdB.createAsyncThunk)("public/fetchTalukasByDistrict", async (districtId)=>{
    const res = await (0, $ivNbC.default).get(`/public/districts/${districtId}/talukas`);
    return res.data;
});
const $8afe362f5f765739$export$77974d798ce6fed4 = (0, $iDqdB.createAsyncThunk)("public/fetchSubcategoriesByCategory", async (slug)=>{
    const res = await (0, $ivNbC.default).get(`/public/categories/${slug}/sub-categories`);
    return res.data;
});
const $8afe362f5f765739$export$89638f89f329fa22 = (0, $iDqdB.createAsyncThunk)("public/fetchServicesByCategory", async (slug)=>{
    const res = await (0, $ivNbC.default).get(`/public/categories/${slug}/services`);
    return res.data;
});
const $8afe362f5f765739$export$14d3ed471e81ae25 = (0, $iDqdB.createAsyncThunk)("public/fetchPaymentModes", async ()=>{
    // Fetch only active payment modes for public use
    const res = await (0, $ivNbC.default).get("/dashboard/payment-modes?per_page=100");
    // API returns { success, message, data: [...], pagination }
    // Extract just the data array
    return res?.data || [];
});
const $8afe362f5f765739$var$commonApiSlice = (0, $iDqdB.createSlice)({
    name: "common",
    initialState: {
        states: [],
        districts: [],
        categories: [],
        subcategories: [],
        talukas: [],
        subscriptionPackages: [],
        categoryServices: [],
        paymentModes: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($8afe362f5f765739$export$2bc3cba6f94d7400.pending, (state)=>{
            state.loading = true;
        }).addCase($8afe362f5f765739$export$2bc3cba6f94d7400.fulfilled, (state, action)=>{
            state.loading = false;
            state.states = action.payload;
        }).addCase($8afe362f5f765739$export$2bc3cba6f94d7400.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        }).addCase($8afe362f5f765739$export$416ec9f5729de215.fulfilled, (state, action)=>{
            state.categories = action.payload;
        }).addCase($8afe362f5f765739$export$ab04f8fd61bc91c0.fulfilled, (state, action)=>{
            state.subscriptionPackages = action.payload;
        }).addCase($8afe362f5f765739$export$ba5e21da449f1ef1.fulfilled, (state, action)=>{
            state.districts = action.payload;
        }).addCase($8afe362f5f765739$export$77974d798ce6fed4.fulfilled, (state, action)=>{
            state.subcategories = action.payload;
        }).addCase($8afe362f5f765739$export$89638f89f329fa22.fulfilled, (state, action)=>{
            state.categoryServices = action.payload;
        }).addCase($8afe362f5f765739$export$415625ec264edf5c.fulfilled, (state, action)=>{
            state.talukas = action.payload;
        }).addCase($8afe362f5f765739$export$14d3ed471e81ae25.fulfilled, (state, action)=>{
            state.paymentModes = action.payload || [];
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
var $8afe362f5f765739$export$2e2bcd8739ae039 = $8afe362f5f765739$var$commonApiSlice.reducer;

});
parcelRegister("iDqdB", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $d91034f47eb948f2$export$7d8a5b498da695ac);
$parcel$export(module.exports, "isPending", () => $d91034f47eb948f2$export$872dec21e9a69476);
$parcel$export(module.exports, "isRejected", () => $d91034f47eb948f2$export$a5c5d27e3994c5be);
$parcel$export(module.exports, "isFulfilled", () => $d91034f47eb948f2$export$1da80a6ef1307441);
$parcel$export(module.exports, "createAsyncThunk", () => $d91034f47eb948f2$export$6abd22dc03e5063f);
$parcel$export(module.exports, "createSlice", () => $d91034f47eb948f2$export$4d8d9bd83c24ae8b);

var $i5N98 = parcelRequire("i5N98");

var $8cYiI = parcelRequire("8cYiI");

var $4KtEQ = parcelRequire("4KtEQ");

var $5RifM = parcelRequire("5RifM");
var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $4KtEQ.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $8cYiI.isDraft)(value) ? (0, $8cYiI.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $4KtEQ.weakMapMemoize));
// src/devtoolsExtension.ts
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $i5N98.compose;
    return (0, $i5N98.compose).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $i5N98.isAction)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $i5N98.isAction)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $8cYiI.isDraftable)(val) ? (0, $8cYiI.produce)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $i5N98.isPlainObject)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $5RifM.thunk));
            else middlewareArray.push((0, $5RifM.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $i5N98.isPlainObject)(reducer)) rootReducer = (0, $i5N98.combineReducers)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $i5N98.compose);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $i5N98.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $i5N98.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $8cYiI.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $8cYiI.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $8cYiI.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $d91034f47eb948f2$var$isDraftTyped = (0, $8cYiI.isDraft);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $8cYiI.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $8cYiI.isDraft)(value) ? (0, $8cYiI.current)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $i5N98.isAction)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $i5N98.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $i5N98.combineReducers)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("i5N98", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $d2bed10dff9b4968$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createStore", () => $d2bed10dff9b4968$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $d2bed10dff9b4968$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $d2bed10dff9b4968$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $d2bed10dff9b4968$export$9ff26e0402cc7b7);
$parcel$export(module.exports, "isAction", () => $d2bed10dff9b4968$export$b956e38827fca970);
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("8cYiI", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => $5f9e38360d79f95a$export$541ac630993a4c84);
$parcel$export(module.exports, "isDraftable", () => $5f9e38360d79f95a$export$16e3aed3edb85946);
$parcel$export(module.exports, "current", () => $5f9e38360d79f95a$export$97aac956da55dae9);
$parcel$export(module.exports, "produce", () => $5f9e38360d79f95a$export$b46cabe22e78bc00);
var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$O = Object;
var $5f9e38360d79f95a$var$getPrototypeOf = $5f9e38360d79f95a$var$O.getPrototypeOf;
var $5f9e38360d79f95a$var$CONSTRUCTOR = "constructor";
var $5f9e38360d79f95a$var$PROTOTYPE = "prototype";
var $5f9e38360d79f95a$var$CONFIGURABLE = "configurable";
var $5f9e38360d79f95a$var$ENUMERABLE = "enumerable";
var $5f9e38360d79f95a$var$WRITABLE = "writable";
var $5f9e38360d79f95a$var$VALUE = "value";
var $5f9e38360d79f95a$export$541ac630993a4c84 = (value)=>!!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || $5f9e38360d79f95a$var$isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value[$5f9e38360d79f95a$var$CONSTRUCTOR]) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE][$5f9e38360d79f95a$var$CONSTRUCTOR].toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || !$5f9e38360d79f95a$var$isObjectish(value)) return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null || proto === $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE]) return true;
    const Ctor = $5f9e38360d79f95a$var$O.hasOwnProperty.call(proto, $5f9e38360d79f95a$var$CONSTRUCTOR) && proto[$5f9e38360d79f95a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$5f9e38360d79f95a$var$isFunction(Ctor)) return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $5f9e38360d79f95a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : $5f9e38360d79f95a$var$isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $5f9e38360d79f95a$var$has = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $5f9e38360d79f95a$var$get = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $5f9e38360d79f95a$var$set = (thing, propOrOldValue, value, type = $5f9e38360d79f95a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $5f9e38360d79f95a$var$isArray = Array.isArray;
var $5f9e38360d79f95a$var$isMap = (target)=>target instanceof Map;
var $5f9e38360d79f95a$var$isSet = (target)=>target instanceof Set;
var $5f9e38360d79f95a$var$isObjectish = (target)=>typeof target === "object";
var $5f9e38360d79f95a$var$isFunction = (target)=>typeof target === "function";
var $5f9e38360d79f95a$var$isBoolean = (target)=>typeof target === "boolean";
function $5f9e38360d79f95a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $5f9e38360d79f95a$var$getProxyDraft = (value)=>{
    if (!$5f9e38360d79f95a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$5f9e38360d79f95a$var$DRAFT_STATE];
};
var $5f9e38360d79f95a$var$latest = (state)=>state.copy_ || state.base_;
var $5f9e38360d79f95a$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $5f9e38360d79f95a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if ($5f9e38360d79f95a$var$isArray(base)) return Array[$5f9e38360d79f95a$var$PROTOTYPE].slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $5f9e38360d79f95a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$5f9e38360d79f95a$var$WRITABLE] === false) {
                desc[$5f9e38360d79f95a$var$WRITABLE] = true;
                desc[$5f9e38360d79f95a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$5f9e38360d79f95a$var$CONFIGURABLE]: true,
                [$5f9e38360d79f95a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
                [$5f9e38360d79f95a$var$VALUE]: base[key]
            };
        }
        return $5f9e38360d79f95a$var$O.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = $5f9e38360d79f95a$var$O.create(proto);
        return $5f9e38360d79f95a$var$O.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) $5f9e38360d79f95a$var$O.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    $5f9e38360d79f95a$var$O.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>{
        $5f9e38360d79f95a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    [$5f9e38360d79f95a$var$VALUE]: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || !$5f9e38360d79f95a$var$isObjectish(obj)) return true;
    return $5f9e38360d79f95a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$PluginMapSet = "MapSet";
var $5f9e38360d79f95a$var$PluginPatches = "Patches";
var $5f9e38360d79f95a$var$PluginArrayMethods = "ArrayMethods";
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
var $5f9e38360d79f95a$var$isPluginLoaded = (pluginKey)=>!!$5f9e38360d79f95a$var$plugins[pluginKey];
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$getCurrentScope = ()=>$5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginMapSet) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginArrayMethods) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginArrayMethods) : void 0
    });
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
var $5f9e38360d79f95a$var$enterScope = (immer2)=>$5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) result = $5f9e38360d79f95a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft);
    $5f9e38360d79f95a$var$maybeFreeze(scope, result, true);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $5f9e38360d79f95a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
function $5f9e38360d79f95a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $5f9e38360d79f95a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT = [];
function $5f9e38360d79f95a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $5f9e38360d79f95a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $5f9e38360d79f95a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $5f9e38360d79f95a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $5f9e38360d79f95a$var$each(parentCopy, (key, value)=>{
            if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$5f9e38360d79f95a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
        $5f9e38360d79f95a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $5f9e38360d79f95a$var$markStateFinalized(state);
    }
}
function $5f9e38360d79f95a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
        const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
        if ($5f9e38360d79f95a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $5f9e38360d79f95a$var$prepareCopy(target);
            const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
            $5f9e38360d79f95a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $5f9e38360d79f95a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $5f9e38360d79f95a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($5f9e38360d79f95a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $5f9e38360d79f95a$var$handleValue($5f9e38360d79f95a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $5f9e38360d79f95a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(target) || handledSet.has(target) || !$5f9e38360d79f95a$export$16e3aed3edb85946(target) || $5f9e38360d79f95a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $5f9e38360d79f95a$var$each(target, (key, value)=>{
        if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
            const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
            if ($5f9e38360d79f95a$var$isSameScope(state, rootScope)) {
                const updatedValue = $5f9e38360d79f95a$var$getFinalValue(state);
                $5f9e38360d79f95a$var$set(target, key, updatedValue, target.type_);
                $5f9e38360d79f95a$var$markStateFinalized(state);
            }
        } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) $5f9e38360d79f95a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const baseIsArray = $5f9e38360d79f95a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop, state.type_)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $5f9e38360d79f95a$var$isArrayIndex(prop)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop, state.type_))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $5f9e38360d79f95a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $5f9e38360d79f95a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$5f9e38360d79f95a$var$WRITABLE]: true,
            [$5f9e38360d79f95a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
            [$5f9e38360d79f95a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
for(let key in $5f9e38360d79f95a$var$objectTraps){
    let fn = $5f9e38360d79f95a$var$objectTraps[key];
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? $5f9e38360d79f95a$var$VALUE in desc ? desc[$5f9e38360d79f95a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($5f9e38360d79f95a$var$isFunction(base) && !$5f9e38360d79f95a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$5f9e38360d79f95a$var$isFunction(recipe)) $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && !$5f9e38360d79f95a$var$isFunction(patchListener)) $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || !$5f9e38360d79f95a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($5f9e38360d79f95a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft($5f9e38360d79f95a$var$get(parentCopy, state.key_));
            const valueAtKey = $5f9e38360d79f95a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $5f9e38360d79f95a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $5f9e38360d79f95a$var$get(current2, key);
            if (!$5f9e38360d79f95a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$5f9e38360d79f95a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key, type_);
            const value = $5f9e38360d79f95a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $5f9e38360d79f95a$var$CONSTRUCTOR)) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if ($5f9e38360d79f95a$var$isFunction(base) && p === $5f9e38360d79f95a$var$PROTOTYPE) $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (!$5f9e38360d79f95a$var$isObjectish(base)) $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if ($5f9e38360d79f95a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $5f9e38360d79f95a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
                $5f9e38360d79f95a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($5f9e38360d79f95a$var$getValue(value));
            });
        }
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $5f9e38360d79f95a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        const result = operation();
        $5f9e38360d79f95a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c05b21e3257751e5 = (value)=>value;
var $5f9e38360d79f95a$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("4KtEQ", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", () => $375276bea32f9eda$export$8402dc26d96f6902);
$parcel$export(module.exports, "createSelectorCreator", () => $375276bea32f9eda$export$5943f4447f6ef248);
var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});

});

parcelRegister("5RifM", function(module, exports) {

$parcel$export(module.exports, "thunk", () => $44400fc0fe63e7bd$export$dd164f5517779f15);
$parcel$export(module.exports, "withExtraArgument", () => $44400fc0fe63e7bd$export$16d06542a1949d9e);
// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;

});


parcelRegister("ivNbC", function(module, exports) {

$parcel$export(module.exports, "axiosInstance", () => $d7a146a865304023$export$155ec85c4e3b5e85);
$parcel$export(module.exports, "http", () => $d7a146a865304023$export$7d6f1c8842f9f527);
$parcel$export(module.exports, "default", () => $d7a146a865304023$export$2e2bcd8739ae039);
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $i4rfT = parcelRequire("i4rfT");
const $d7a146a865304023$export$155ec85c4e3b5e85 = (0, $7we3r.default).create({
    baseURL: (0, $i4rfT.config).API_BASE_URL,
    withCredentials: false,
    timeout: 30000
});
$d7a146a865304023$export$155ec85c4e3b5e85.interceptors.request.use((config)=>{
    const token = localStorage.getItem("authToken");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
}, (error)=>Promise.reject(error));
$d7a146a865304023$export$155ec85c4e3b5e85.interceptors.response.use((response)=>response, (error)=>{
    // Define login endpoints that should be excluded from 401 handling
    const loginEndpoints = [
        '/dashboard/auth/login',
        '/dashboard/auth/business/login'
    ];
    // Check if the request URL is a login endpoint
    const requestUrl = error?.config?.url;
    const isLoginEndpoint = loginEndpoints.some((endpoint)=>requestUrl?.includes(endpoint));
    if (error?.response?.status === 401 && !isLoginEndpoint) {
        // Handle unauthorized - clear auth data and redirect to login
        const authUser = localStorage.getItem("authUser");
        let userRole = null;
        try {
            if (authUser) {
                const user = JSON.parse(authUser);
                userRole = user?.role?.toLowerCase();
            }
        } catch (e) {
        // Invalid JSON, ignore
        }
        localStorage.removeItem("authToken");
        localStorage.removeItem("authUser");
        // Redirect to appropriate login page based on user role
        if (userRole === "business") window.location.href = "/login";
        else window.location.href = "/admin/auth/login";
    }
    return Promise.reject(error);
});
const $d7a146a865304023$export$7d6f1c8842f9f527 = {
    get: async (url, config = {})=>{
        const response = await $d7a146a865304023$export$155ec85c4e3b5e85.get(url, config);
        return response.data;
    },
    post: async (url, data, config = {})=>{
        const isFormData = data instanceof FormData;
        const headers = isFormData ? {
            "Content-Type": "multipart/form-data"
        } : {
            "Content-Type": "application/json"
        };
        const response = await $d7a146a865304023$export$155ec85c4e3b5e85.post(url, data, {
            ...config,
            headers: {
                ...headers,
                ...config.headers
            }
        });
        return response.data;
    },
    put: async (url, data, config = {})=>{
        const isFormData = data instanceof FormData;
        const headers = isFormData ? {
            "Content-Type": "multipart/form-data"
        } : {
            "Content-Type": "application/json"
        };
        const response = await $d7a146a865304023$export$155ec85c4e3b5e85.put(url, data, {
            ...config,
            headers: {
                ...headers,
                ...config.headers
            }
        });
        return response.data;
    },
    delete: async (url, config = {})=>{
        const response = await $d7a146a865304023$export$155ec85c4e3b5e85.delete(url, config);
        return response.data;
    },
    patch: async (url, data, config = {})=>{
        const response = await $d7a146a865304023$export$155ec85c4e3b5e85.patch(url, data, config);
        return response.data;
    }
};
var $d7a146a865304023$export$2e2bcd8739ae039 = $d7a146a865304023$export$7d6f1c8842f9f527;

});
parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = $c319b2c832c2914a$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $gKvUL.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $gKvUL.default).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $gKvUL.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", () => $e6cbd383b18c9625$export$659081b45d03227d);
$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $e6cbd383b18c9625$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $6HVMZ.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $gKvUL.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $4e2395edb77acf3a$var$REDACTED = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $gKvUL.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $gKvUL.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $gKvUL.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $bxxyx.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $gKvUL.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $gKvUL.default).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$var$REDACTED : visit(value);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $gKvUL.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $gKvUL.default).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $gKvUL.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});
parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");

var $lnc0M = parcelRequire("lnc0M");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $lnc0M.sanitizeHeaderValue)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $gKvUL.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $gKvUL.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("lnc0M", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", () => $f8f5102fdfcbfec9$export$9e344cffce061a22);
$parcel$export(module.exports, "toByteStringHeaderObject", () => $f8f5102fdfcbfec9$export$c30c72bb7e677d54);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $gKvUL.default).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $gKvUL.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $gKvUL.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $jOwpo = parcelRequire("jOwpo");
'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $jOwpo.DEFAULT_FORM_DATA_MAX_DEPTH);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $6HVMZ.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = (0, $gKvUL.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $gKvUL.default).hasOwnProp(target, name) || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $lnc0M = parcelRequire("lnc0M");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach((0, $lnc0M.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && !(0, $g65xr.default).protocols.includes(protocol)) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $6HVMZ.default).ERR_BAD_REQUEST : (0, $6HVMZ.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $gKvUL.default).asap(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $cbIsf = parcelRequire("cbIsf");
const $ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ab4625fac3104691$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $lk5EI.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $gKvUL.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $gKvUL.default).getSafeProp(auth, 'username') || '';
        const password = (0, $gKvUL.default).getSafeProp(auth, 'password') || '';
        headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
    }
    if ((0, $gKvUL.default).isFormData(data)) {
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv || (0, $gKvUL.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $gKvUL.default).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $ab4625fac3104691$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        if ((0, $gKvUL.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $889er.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $598acbfafd2c63c5$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url) {
    return $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url).replace($598acbfafd2c63c5$var$httpProtocolControlCharacters, '');
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string' && $598acbfafd2c63c5$var$malformedHttpProtocol.test($598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url))) throw new (0, $6HVMZ.default)('Invalid URL: missing "//" after protocol', (0, $6HVMZ.default).ERR_INVALID_URL, config);
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $fE4ul.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $gKvUL.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $gKvUL.default).isUndefined(transitional2)) {
            if ((0, $gKvUL.default).isPlainObject(transitional2)) {
                if ((0, $gKvUL.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $gKvUL.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $gKvUL.default).isPlainObject(transitional1) && (0, $gKvUL.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $gKvUL.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $gKvUL.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $gKvUL.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $gKvUL.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $gKvUL.default).hasOwnProp(config2, 'validateStatus') && (0, $gKvUL.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $gKvUL.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");

var $iKBwL = parcelRequire("iKBwL");

var $35BUy = parcelRequire("35BUy");

var $lnc0M = parcelRequire("lnc0M");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $gKvUL.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $gKvUL.default).global !== undefined && (0, $gKvUL.default).global !== null ? (0, $gKvUL.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $g65xr.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $eHGD2.default)(config);
        const hasMaxContentLength = (0, $gKvUL.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $gKvUL.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $gKvUL.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $6HVMZ.default)('Request body larger than maxBodyLength limit', (0, $6HVMZ.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $gKvUL.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $gKvUL.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $g65xr.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $iKBwL.default)(url);
                if (estimated > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $gKvUL.default).isReadableStream(data) || (0, $gKvUL.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $hhnAb.trackStream)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $6HVMZ.default)('Stream request bodies are not supported by the current fetch implementation', (0, $6HVMZ.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $gKvUL.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $35BUy.VERSION), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $lnc0M.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $bxxyx.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $gKvUL.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $6HVMZ.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $6HVMZ.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("iKBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $da69a2069c6136ea$export$2e2bcd8739ae039);
/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $da69a2069c6136ea$var$isHexDigit(a) && $da69a2069c6136ea$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}

});

parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.18.0";

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});


parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("i4rfT", function(module, exports) {

$parcel$export(module.exports, "config", () => $d27dbe10f1bffb7d$export$e506a1d27d1eaa20);
const $d27dbe10f1bffb7d$export$e506a1d27d1eaa20 = {
    API_BASE_URL: "https://api.connectri.in/api/v1",
    NODE_ENV: "development"
};

});



parcelRegister("i32x1", function(module, exports) {

$parcel$export(module.exports, "fetchShops", () => $d23a7884b4c17d0a$export$8f32cd9fa9b94ce6);
$parcel$export(module.exports, "createShop", () => $d23a7884b4c17d0a$export$c7411683bab50cec);
$parcel$export(module.exports, "updateShopStatus", () => $d23a7884b4c17d0a$export$82db64c99e30a26c);
$parcel$export(module.exports, "fetchShopById", () => $d23a7884b4c17d0a$export$feaf69aed0e380cb);
$parcel$export(module.exports, "updateShop", () => $d23a7884b4c17d0a$export$fc26c6b39871d9db);
$parcel$export(module.exports, "updateShopContact", () => $d23a7884b4c17d0a$export$df188b3adcbd1d87);
$parcel$export(module.exports, "updateShopDiscount", () => $d23a7884b4c17d0a$export$f8ef0222a31cd4e4);
$parcel$export(module.exports, "updateShopGallery", () => $d23a7884b4c17d0a$export$19b1a0fe6d9a1820);
$parcel$export(module.exports, "updateBusinessSettings", () => $d23a7884b4c17d0a$export$93d5024de41b5784);
$parcel$export(module.exports, "updateBusinessLocation", () => $d23a7884b4c17d0a$export$1cd761d4ec61b85d);
$parcel$export(module.exports, "updateBusinessCategoriesServices", () => $d23a7884b4c17d0a$export$2b4d796a54f987a7);
$parcel$export(module.exports, "updateBusinessInfo", () => $d23a7884b4c17d0a$export$3e620ce9f2a30d96);
$parcel$export(module.exports, "createUserAccount", () => $d23a7884b4c17d0a$export$10108b86f07d630c);
$parcel$export(module.exports, "default", () => $d23a7884b4c17d0a$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $d23a7884b4c17d0a$export$8f32cd9fa9b94ce6 = (0, $iDqdB.createAsyncThunk)("shops/fetchShops", async (params = {})=>{
    const { page: page = 1, per_page: per_page = 10 } = params;
    const res = await (0, $ivNbC.default).get(`/dashboard/businesses?page=${page}&per_page=${per_page}`);
    return res;
});
const $d23a7884b4c17d0a$export$c7411683bab50cec = (0, $iDqdB.createAsyncThunk)("shops/createShop", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/businesses", payload);
        return res;
    } catch (err) {
        console.log('Full error:', err);
        console.log('Error response:', err.response);
        console.log('Error response data:', err.response?.data);
        // The backend returns: { success: false, message: "...", data: { field: ["error"] } }
        const errorResponse = err.response?.data || {};
        return rejectWithValue({
            message: errorResponse.message || err.message || "Failed to create shop",
            data: errorResponse.data || null,
            success: errorResponse.success
        });
    }
});
const $d23a7884b4c17d0a$export$82db64c99e30a26c = (0, $iDqdB.createAsyncThunk)("shops/updateShopStatus", async (payload, { rejectWithValue: rejectWithValue })=>{
    console.log(payload);
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/businesses/${payload.uuid}/toggle-status`, payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update shop status");
    }
});
const $d23a7884b4c17d0a$export$feaf69aed0e380cb = (0, $iDqdB.createAsyncThunk)("shops/fetchShopById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/businesses/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch shop details");
    }
});
const $d23a7884b4c17d0a$export$fc26c6b39871d9db = (0, $iDqdB.createAsyncThunk)("shops/updateShop", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post(`/dashboard/businesses/${uuid}`, data);
        return res;
    } catch (err) {
        console.log('Update shop error:', err);
        console.log('Error response data:', err.response?.data);
        // The backend returns: { success: false, message: "...", data: { field: ["error"] } }
        const errorResponse = err.response?.data || {};
        return rejectWithValue({
            message: errorResponse.message || err.message || "Failed to update shop",
            data: errorResponse.data || null,
            success: errorResponse.success
        });
    }
});
const $d23a7884b4c17d0a$export$df188b3adcbd1d87 = (0, $iDqdB.createAsyncThunk)("shops/updateShopContact", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        // Format data to match backend expectations
        const formattedData = {
            uuid: uuid
        };
        // Add optional fields only if they exist
        if (data.contact_numbers && data.contact_numbers.length > 0) formattedData.contact_numbers = data.contact_numbers;
        if (data.whatsapp) formattedData.whatsapp = data.whatsapp;
        if (data.email) formattedData.email = data.email;
        if (data.website) formattedData.website = data.website;
        const res = await (0, $ivNbC.default).put(`/dashboard/businesses/update-contact`, formattedData);
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update contact information");
    }
});
const $d23a7884b4c17d0a$export$f8ef0222a31cd4e4 = (0, $iDqdB.createAsyncThunk)("shops/updateShopDiscount", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        // Format data to match backend expectations
        const formattedData = {
            uuid: uuid
        };
        // Add optional fields only if they exist
        if (data.discount_text) formattedData.discount_text = data.discount_text;
        if (data.fixed_discount !== undefined && data.fixed_discount !== null) formattedData.fixed_discount = data.fixed_discount;
        if (data.customer_discount !== undefined && data.customer_discount !== null) formattedData.customer_discount = data.customer_discount;
        if (data.company_commission !== undefined && data.company_commission !== null) formattedData.company_commission = data.company_commission;
        const res = await (0, $ivNbC.default).put(`/dashboard/businesses/update-discounts`, formattedData);
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update discount information");
    }
});
const $d23a7884b4c17d0a$export$19b1a0fe6d9a1820 = (0, $iDqdB.createAsyncThunk)("shops/updateShopGallery", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        console.log('updateShopGallery called with:', {
            uuid: uuid,
            data: data
        });
        const formData = new FormData();
        // Add UUID to form data
        formData.append('uuid', uuid);
        // Add new gallery images
        if (data.gallery && data.gallery.length > 0) data.gallery.forEach((file, index)=>{
            // Handle both File objects directly and wrapped file objects
            if (file instanceof File) formData.append(`gallery[${index}]`, file);
            else if (file.file && !file.existing) formData.append(`gallery[${index}]`, file.file);
        });
        // Add images to remove as individual array items
        if (data.remove_images && data.remove_images.length > 0) data.remove_images.forEach((imageUuid, index)=>{
            formData.append(`remove_images[${index}]`, imageUuid);
        });
        const res = await (0, $ivNbC.default).post(`/dashboard/businesses/update-gallery`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update gallery");
    }
});
const $d23a7884b4c17d0a$export$93d5024de41b5784 = (0, $iDqdB.createAsyncThunk)("shops/updateBusinessSettings", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        // Format data to match backend validation rules
        const formattedData = {
            uuid: uuid
        };
        // Add optional fields only if they exist
        if (data.subscription_package_id) formattedData.subscription_package_id = data.subscription_package_id;
        // Send payment_modes as array (backend expects: 'payment_modes' => 'sometimes|array')
        if (data.payment_modes && Array.isArray(data.payment_modes)) formattedData.payment_modes = data.payment_modes;
        // Send business_timings as nested array object (backend expects: 'business_timings' => 'sometimes|array')
        if (data.business_timings) formattedData.business_timings = data.business_timings;
        const res = await (0, $ivNbC.default).put(`/dashboard/businesses/update-business-settings`, formattedData);
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update business settings");
    }
});
const $d23a7884b4c17d0a$export$1cd761d4ec61b85d = (0, $iDqdB.createAsyncThunk)("shops/updateBusinessLocation", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        // Format data to match backend expectations
        const formattedData = {
            uuid: uuid
        };
        // Add optional fields only if they exist
        if (data.state_id) formattedData.state_id = data.state_id;
        if (data.district_id) formattedData.district_id = data.district_id;
        if (data.taluka_id) formattedData.taluka_id = data.taluka_id;
        if (data.address) formattedData.address = data.address;
        if (data.pincode) formattedData.pincode = data.pincode;
        if (data.business_location_map) formattedData.business_location_map = data.business_location_map;
        if (data.latitude !== null && data.latitude !== undefined) formattedData.latitude = data.latitude;
        if (data.longitude !== null && data.longitude !== undefined) formattedData.longitude = data.longitude;
        const res = await (0, $ivNbC.default).put(`/dashboard/businesses/update-location`, formattedData);
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update business location");
    }
});
const $d23a7884b4c17d0a$export$2b4d796a54f987a7 = (0, $iDqdB.createAsyncThunk)("shops/updateBusinessCategoriesServices", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        // Format data to match backend expectations
        const formattedData = {
            uuid: uuid
        };
        // Add optional fields only if they exist
        if (data.category_id) formattedData.category_id = data.category_id;
        if (data.sub_categories && Array.isArray(data.sub_categories)) formattedData.sub_categories = data.sub_categories;
        if (data.services && Array.isArray(data.services)) formattedData.services = data.services;
        const res = await (0, $ivNbC.default).put(`/dashboard/businesses/update-categories-services`, formattedData);
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update categories and services");
    }
});
const $d23a7884b4c17d0a$export$3e620ce9f2a30d96 = (0, $iDqdB.createAsyncThunk)("shops/updateBusinessInfo", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        // Format data to match backend expectations
        const formattedData = {
            uuid: uuid
        };
        // Add optional fields only if they exist
        if (data.business_name) formattedData.business_name = data.business_name;
        if (data.about_business !== undefined) formattedData.about_business = data.about_business;
        if (data.username) formattedData.username = data.username;
        if (data.is_trending !== undefined) formattedData.is_trending = data.is_trending ? true : false;
        if (data.is_recently_added !== undefined) formattedData.is_recently_added = data.is_recently_added ? true : false;
        const res = await (0, $ivNbC.default).put(`/dashboard/businesses/update-basic-info`, formattedData);
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update business information");
    }
});
const $d23a7884b4c17d0a$export$10108b86f07d630c = (0, $iDqdB.createAsyncThunk)("shops/createUserAccount", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post(`/dashboard/businesses/create-user-account`, {
            uuid: uuid
        });
        return {
            uuid: uuid,
            data: res.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create user account");
    }
});
const $d23a7884b4c17d0a$var$shopsSlice = (0, $iDqdB.createSlice)({
    name: "shop",
    initialState: {
        shops: [],
        pagination: null,
        shop: null,
        shopCreateStatus: "loading",
        shopCreateError: null,
        shopChangeStatus: "loading",
        shopFetchStatus: "idle",
        shopUpdateStatus: "idle",
        shopUpdateError: null,
        shopContactUpdateStatus: "idle",
        shopDiscountUpdateStatus: "idle",
        shopGalleryUpdateStatus: "idle",
        businessInfoUpdateStatus: "idle",
        businessSettingsUpdateStatus: "idle",
        businessLocationUpdateStatus: "idle",
        businessCategoriesServicesUpdateStatus: "idle",
        createUserAccountStatus: "idle"
    },
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($d23a7884b4c17d0a$export$8f32cd9fa9b94ce6.fulfilled, (state, action)=>{
            state.shops = action.payload.data;
            state.pagination = action.payload.pagination;
        }).addCase($d23a7884b4c17d0a$export$82db64c99e30a26c.pending, (state)=>{
            state.shopChangeStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$82db64c99e30a26c.rejected, (state)=>{
            state.shopChangeStatus = "failed";
        }).addCase($d23a7884b4c17d0a$export$82db64c99e30a26c.fulfilled, (state, action)=>{
            const index = state.shops.findIndex((shop)=>shop.uuid === action.meta.arg.uuid);
            if (index !== -1) state.shops[index].status = action.meta.arg.status === "enable" ? 1 : 0;
            state.shopChangeStatus = "success";
        }).addCase($d23a7884b4c17d0a$export$c7411683bab50cec.fulfilled, (state, action)=>{
            state.shopCreateStatus = "success";
            state.shopCreateError = null;
            state.shop = null;
        }).addCase($d23a7884b4c17d0a$export$c7411683bab50cec.rejected, (state, action)=>{
            state.shop = null;
            state.shopCreateStatus = "failed";
            state.shopCreateError = action.payload;
        }).addCase($d23a7884b4c17d0a$export$feaf69aed0e380cb.pending, (state)=>{
            state.shopFetchStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$feaf69aed0e380cb.fulfilled, (state, action)=>{
            state.shopFetchStatus = "success";
            state.shop = action.payload.data;
        }).addCase($d23a7884b4c17d0a$export$feaf69aed0e380cb.rejected, (state)=>{
            state.shopFetchStatus = "failed";
            state.shop = null;
        }).addCase($d23a7884b4c17d0a$export$fc26c6b39871d9db.pending, (state)=>{
            state.shopUpdateStatus = "loading";
            state.shopUpdateError = null;
        }).addCase($d23a7884b4c17d0a$export$fc26c6b39871d9db.fulfilled, (state, action)=>{
            state.shopUpdateStatus = "success";
            state.shopUpdateError = null;
            // Update the shop in the shops array if it exists
            const index = state.shops.findIndex((shop)=>shop.uuid === action.meta.arg.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
            state.shop = action.payload.data;
        }).addCase($d23a7884b4c17d0a$export$fc26c6b39871d9db.rejected, (state, action)=>{
            state.shopUpdateStatus = "failed";
            state.shopUpdateError = action.payload;
        })// Update shop contact
        .addCase($d23a7884b4c17d0a$export$df188b3adcbd1d87.pending, (state)=>{
            state.shopContactUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$df188b3adcbd1d87.fulfilled, (state, action)=>{
            state.shopContactUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$df188b3adcbd1d87.rejected, (state)=>{
            state.shopContactUpdateStatus = "failed";
        })// Update shop discount
        .addCase($d23a7884b4c17d0a$export$f8ef0222a31cd4e4.pending, (state)=>{
            state.shopDiscountUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$f8ef0222a31cd4e4.fulfilled, (state, action)=>{
            state.shopDiscountUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$f8ef0222a31cd4e4.rejected, (state)=>{
            state.shopDiscountUpdateStatus = "failed";
        })// Update shop gallery
        .addCase($d23a7884b4c17d0a$export$19b1a0fe6d9a1820.pending, (state)=>{
            state.shopGalleryUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$19b1a0fe6d9a1820.fulfilled, (state, action)=>{
            state.shopGalleryUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$19b1a0fe6d9a1820.rejected, (state)=>{
            state.shopGalleryUpdateStatus = "failed";
        })// Update business info
        .addCase($d23a7884b4c17d0a$export$3e620ce9f2a30d96.pending, (state)=>{
            state.businessInfoUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$3e620ce9f2a30d96.fulfilled, (state, action)=>{
            state.businessInfoUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$3e620ce9f2a30d96.rejected, (state)=>{
            state.businessInfoUpdateStatus = "failed";
        })// Update business settings
        .addCase($d23a7884b4c17d0a$export$93d5024de41b5784.pending, (state)=>{
            state.businessSettingsUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$93d5024de41b5784.fulfilled, (state, action)=>{
            state.businessSettingsUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$93d5024de41b5784.rejected, (state)=>{
            state.businessSettingsUpdateStatus = "failed";
        })// Update business location
        .addCase($d23a7884b4c17d0a$export$1cd761d4ec61b85d.pending, (state)=>{
            state.businessLocationUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$1cd761d4ec61b85d.fulfilled, (state, action)=>{
            state.businessLocationUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$1cd761d4ec61b85d.rejected, (state)=>{
            state.businessLocationUpdateStatus = "failed";
        })// Update business categories and services
        .addCase($d23a7884b4c17d0a$export$2b4d796a54f987a7.pending, (state)=>{
            state.businessCategoriesServicesUpdateStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$2b4d796a54f987a7.fulfilled, (state, action)=>{
            state.businessCategoriesServicesUpdateStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$2b4d796a54f987a7.rejected, (state)=>{
            state.businessCategoriesServicesUpdateStatus = "failed";
        })// Create user account
        .addCase($d23a7884b4c17d0a$export$10108b86f07d630c.pending, (state)=>{
            state.createUserAccountStatus = "loading";
        }).addCase($d23a7884b4c17d0a$export$10108b86f07d630c.fulfilled, (state, action)=>{
            state.createUserAccountStatus = "success";
            const index = state.shops.findIndex((shop)=>shop.uuid === action.payload.uuid);
            if (index !== -1) state.shops[index] = {
                ...state.shops[index],
                ...action.payload.data
            };
        }).addCase($d23a7884b4c17d0a$export$10108b86f07d630c.rejected, (state)=>{
            state.createUserAccountStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
var $d23a7884b4c17d0a$export$2e2bcd8739ae039 = $d23a7884b4c17d0a$var$shopsSlice.reducer;

});

parcelRegister("lHUkp", function(module, exports) {

$parcel$export(module.exports, "fetchBanners", () => $fcd94ebe85548aa5$export$66c48144ef5a6ace);
$parcel$export(module.exports, "createBanner", () => $fcd94ebe85548aa5$export$596743d694fcb1b6);
$parcel$export(module.exports, "updateBannerStatus", () => $fcd94ebe85548aa5$export$fac336625880a1fd);
$parcel$export(module.exports, "fetchBannerById", () => $fcd94ebe85548aa5$export$64d995f50d564171);
$parcel$export(module.exports, "updateBanner", () => $fcd94ebe85548aa5$export$9ebbcadb541b09bc);
$parcel$export(module.exports, "resetBannerStatuses", () => $fcd94ebe85548aa5$export$5f318c4e9df9f071);
$parcel$export(module.exports, "default", () => $fcd94ebe85548aa5$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $fcd94ebe85548aa5$export$66c48144ef5a6ace = (0, $iDqdB.createAsyncThunk)("banners/fetchBanners", async ()=>{
    const res = await (0, $ivNbC.default).get("/dashboard/banners");
    return res;
});
const $fcd94ebe85548aa5$export$596743d694fcb1b6 = (0, $iDqdB.createAsyncThunk)("banners/createBanner", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/banners", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create banner");
    }
});
const $fcd94ebe85548aa5$export$fac336625880a1fd = (0, $iDqdB.createAsyncThunk)("banners/updateBannerStatus", async ({ uuid: uuid, status: status }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post(`/dashboard/banners/${uuid}/toggle-status`, {
            status: status
        });
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update banner status");
    }
});
const $fcd94ebe85548aa5$export$64d995f50d564171 = (0, $iDqdB.createAsyncThunk)("banners/fetchBannerById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/banners/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch banner details");
    }
});
const $fcd94ebe85548aa5$export$9ebbcadb541b09bc = (0, $iDqdB.createAsyncThunk)("banners/updateBanner", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post(`/dashboard/banners/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update banner");
    }
});
const $fcd94ebe85548aa5$var$bannersSlice = (0, $iDqdB.createSlice)({
    name: "banner",
    initialState: {
        banners: [],
        pagination: null,
        banner: null,
        bannerCreateStatus: "idle",
        bannerChangeStatus: "idle",
        bannerFetchStatus: "idle",
        bannerUpdateStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetBannerStatuses (state) {
            state.bannerCreateStatus = "idle";
            state.bannerUpdateStatus = "idle";
            state.bannerFetchStatus = "idle";
            state.bannerChangeStatus = "idle";
            state.banner = null;
        },
        resetBannerChangeStatus (state) {
            state.bannerChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// ── fetchBanners ───────────────────────────────────────────────────────
        .addCase($fcd94ebe85548aa5$export$66c48144ef5a6ace.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($fcd94ebe85548aa5$export$66c48144ef5a6ace.fulfilled, (state, action)=>{
            state.loading = false;
            state.banners = action.payload?.data || [];
            state.pagination = action.payload?.pagination || null;
        }).addCase($fcd94ebe85548aa5$export$66c48144ef5a6ace.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        })// ── updateBannerStatus ─────────────────────────────────────────────────
        .addCase($fcd94ebe85548aa5$export$fac336625880a1fd.pending, (state)=>{
            state.bannerChangeStatus = "loading";
        }).addCase($fcd94ebe85548aa5$export$fac336625880a1fd.fulfilled, (state, action)=>{
            state.bannerChangeStatus = "success";
            const { uuid: uuid, status: status } = action.meta.arg;
            const index = state.banners.findIndex((b)=>b.id === uuid);
            if (index !== -1) state.banners[index].is_enabled = status === "enable" ? 1 : 0;
        }).addCase($fcd94ebe85548aa5$export$fac336625880a1fd.rejected, (state)=>{
            state.bannerChangeStatus = "failed";
        })// ── createBanner ───────────────────────────────────────────────────────
        .addCase($fcd94ebe85548aa5$export$596743d694fcb1b6.pending, (state)=>{
            state.loading = true;
            state.bannerCreateStatus = "loading";
        }).addCase($fcd94ebe85548aa5$export$596743d694fcb1b6.fulfilled, (state)=>{
            state.loading = false;
            state.bannerCreateStatus = "success";
            state.banner = null;
        }).addCase($fcd94ebe85548aa5$export$596743d694fcb1b6.rejected, (state)=>{
            state.loading = false;
            state.banner = null;
            state.bannerCreateStatus = "failed";
        })// ── fetchBannerById ────────────────────────────────────────────────────
        .addCase($fcd94ebe85548aa5$export$64d995f50d564171.pending, (state)=>{
            state.loading = true;
            state.bannerFetchStatus = "loading";
        }).addCase($fcd94ebe85548aa5$export$64d995f50d564171.fulfilled, (state, action)=>{
            state.loading = false;
            state.bannerFetchStatus = "success";
            state.banner = action.payload.data;
        }).addCase($fcd94ebe85548aa5$export$64d995f50d564171.rejected, (state)=>{
            state.loading = false;
            state.bannerFetchStatus = "failed";
            state.banner = null;
        })// ── updateBanner ───────────────────────────────────────────────────────
        .addCase($fcd94ebe85548aa5$export$9ebbcadb541b09bc.pending, (state)=>{
            state.loading = true;
            state.bannerUpdateStatus = "loading";
        }).addCase($fcd94ebe85548aa5$export$9ebbcadb541b09bc.fulfilled, (state, action)=>{
            state.loading = false;
            state.bannerUpdateStatus = "success";
            const index = state.banners.findIndex((b)=>b.id === action.meta.arg.uuid);
            if (index !== -1) state.banners[index] = {
                ...state.banners[index],
                ...action.payload.data
            };
            state.banner = action.payload.data;
        }).addCase($fcd94ebe85548aa5$export$9ebbcadb541b09bc.rejected, (state)=>{
            state.loading = false;
            state.bannerUpdateStatus = "failed";
        });
    }
});
const { resetBannerStatuses: $fcd94ebe85548aa5$export$5f318c4e9df9f071, resetBannerChangeStatus: $fcd94ebe85548aa5$export$cca3da60106d8c2d } = $fcd94ebe85548aa5$var$bannersSlice.actions;
var $fcd94ebe85548aa5$export$2e2bcd8739ae039 = $fcd94ebe85548aa5$var$bannersSlice.reducer;

});

parcelRegister("3iTov", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $267e05af9054ab74$export$416ec9f5729de215);
$parcel$export(module.exports, "createCategory", () => $267e05af9054ab74$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "fetchCategoryById", () => $267e05af9054ab74$export$f7994d6d35ed4f7b);
$parcel$export(module.exports, "updateCategory", () => $267e05af9054ab74$export$daaacb0271870c9);
$parcel$export(module.exports, "deleteCategory", () => $267e05af9054ab74$export$c0a90379dccf4f2f);
$parcel$export(module.exports, "toggleCategoryStatus", () => $267e05af9054ab74$export$c85e0bc71adb2a7);
$parcel$export(module.exports, "resetCategoryStatuses", () => $267e05af9054ab74$export$246095045391d621);
$parcel$export(module.exports, "default", () => $267e05af9054ab74$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $267e05af9054ab74$export$416ec9f5729de215 = (0, $iDqdB.createAsyncThunk)("categories/fetchCategories", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    const res = await (0, $ivNbC.default).get(`/dashboard/categories?${params.toString()}`);
    return res;
});
const $267e05af9054ab74$export$7ce9dbcc6d544b1 = (0, $iDqdB.createAsyncThunk)("categories/createCategory", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/categories", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create category");
    }
});
const $267e05af9054ab74$export$f7994d6d35ed4f7b = (0, $iDqdB.createAsyncThunk)("categories/fetchCategoryById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/categories/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch category details");
    }
});
const $267e05af9054ab74$export$daaacb0271870c9 = (0, $iDqdB.createAsyncThunk)("categories/updateCategory", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post(`/dashboard/categories/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update category");
    }
});
const $267e05af9054ab74$export$c0a90379dccf4f2f = (0, $iDqdB.createAsyncThunk)("categories/deleteCategory", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/categories/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete category");
    }
});
const $267e05af9054ab74$export$ff65b72579e8bf5b = (0, $iDqdB.createAsyncThunk)("categories/enableCategory", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/categories/${uuid}/enable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to enable category");
    }
});
const $267e05af9054ab74$export$845d0df466decfc4 = (0, $iDqdB.createAsyncThunk)("categories/disableCategory", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/categories/${uuid}/disable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to disable category");
    }
});
const $267e05af9054ab74$export$c85e0bc71adb2a7 = (0, $iDqdB.createAsyncThunk)("categories/toggleCategoryStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/categories/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle category status");
    }
});
const $267e05af9054ab74$export$f72b67e6509afb87 = (0, $iDqdB.createAsyncThunk)("categories/updateCategoryIcon", async ({ uuid: uuid, icon: icon }, { rejectWithValue: rejectWithValue })=>{
    try {
        const formData = new FormData();
        formData.append("icon", icon);
        const res = await (0, $ivNbC.default).post(`/dashboard/categories/${uuid}/update-icon`, formData);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update category icon");
    }
});
const $267e05af9054ab74$export$4ac843d70cbcd13f = (0, $iDqdB.createAsyncThunk)("categories/removeCategoryIcon", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/categories/${uuid}/remove-icon`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to remove category icon");
    }
});
const $267e05af9054ab74$var$categoriesSlice = (0, $iDqdB.createSlice)({
    name: "categories",
    initialState: {
        categories: [],
        pagination: null,
        category: null,
        categoryCreateStatus: "idle",
        categoryUpdateStatus: "idle",
        categoryDeleteStatus: "idle",
        categoryFetchStatus: "idle",
        categoryStatusChangeStatus: "idle",
        categoryIconUpdateStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetCategoryStatuses: (state)=>{
            state.categoryCreateStatus = "idle";
            state.categoryUpdateStatus = "idle";
            state.categoryDeleteStatus = "idle";
            state.categoryStatusChangeStatus = "idle";
            state.categoryIconUpdateStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch categories
        .addCase($267e05af9054ab74$export$416ec9f5729de215.fulfilled, (state, action)=>{
            state.categories = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create category
        .addCase($267e05af9054ab74$export$7ce9dbcc6d544b1.pending, (state)=>{
            state.categoryCreateStatus = "loading";
        }).addCase($267e05af9054ab74$export$7ce9dbcc6d544b1.fulfilled, (state, action)=>{
            state.categoryCreateStatus = "success";
            state.category = action.payload.data;
        }).addCase($267e05af9054ab74$export$7ce9dbcc6d544b1.rejected, (state)=>{
            state.categoryCreateStatus = "failed";
        })// Fetch category by ID
        .addCase($267e05af9054ab74$export$f7994d6d35ed4f7b.pending, (state)=>{
            state.categoryFetchStatus = "loading";
        }).addCase($267e05af9054ab74$export$f7994d6d35ed4f7b.fulfilled, (state, action)=>{
            state.categoryFetchStatus = "success";
            state.category = action.payload.data;
        }).addCase($267e05af9054ab74$export$f7994d6d35ed4f7b.rejected, (state)=>{
            state.categoryFetchStatus = "failed";
            state.category = null;
        })// Update category
        .addCase($267e05af9054ab74$export$daaacb0271870c9.pending, (state)=>{
            state.categoryUpdateStatus = "loading";
        }).addCase($267e05af9054ab74$export$daaacb0271870c9.fulfilled, (state, action)=>{
            state.categoryUpdateStatus = "success";
            const index = state.categories.findIndex((cat)=>cat.uuid === action.meta.arg.uuid);
            if (index !== -1) state.categories[index] = action.payload.data;
            state.category = action.payload.data;
        }).addCase($267e05af9054ab74$export$daaacb0271870c9.rejected, (state)=>{
            state.categoryUpdateStatus = "failed";
        })// Delete category
        .addCase($267e05af9054ab74$export$c0a90379dccf4f2f.pending, (state)=>{
            state.categoryDeleteStatus = "loading";
        }).addCase($267e05af9054ab74$export$c0a90379dccf4f2f.fulfilled, (state, action)=>{
            state.categoryDeleteStatus = "success";
            state.categories = state.categories.filter((cat)=>cat.uuid !== action.payload.uuid);
        }).addCase($267e05af9054ab74$export$c0a90379dccf4f2f.rejected, (state)=>{
            state.categoryDeleteStatus = "failed";
        })// Toggle status
        .addCase($267e05af9054ab74$export$c85e0bc71adb2a7.pending, (state)=>{
            state.categoryStatusChangeStatus = "loading";
        }).addCase($267e05af9054ab74$export$c85e0bc71adb2a7.fulfilled, (state, action)=>{
            state.categoryStatusChangeStatus = "success";
            const index = state.categories.findIndex((cat)=>cat.uuid === action.meta.arg);
            if (index !== -1) state.categories[index] = action.payload.data;
        }).addCase($267e05af9054ab74$export$c85e0bc71adb2a7.rejected, (state)=>{
            state.categoryStatusChangeStatus = "failed";
        })// Update icon
        .addCase($267e05af9054ab74$export$f72b67e6509afb87.pending, (state)=>{
            state.categoryIconUpdateStatus = "loading";
        }).addCase($267e05af9054ab74$export$f72b67e6509afb87.fulfilled, (state, action)=>{
            state.categoryIconUpdateStatus = "success";
            const index = state.categories.findIndex((cat)=>cat.uuid === action.meta.arg.uuid);
            if (index !== -1) state.categories[index] = action.payload.data;
            if (state.category?.uuid === action.meta.arg.uuid) state.category = action.payload.data;
        }).addCase($267e05af9054ab74$export$f72b67e6509afb87.rejected, (state)=>{
            state.categoryIconUpdateStatus = "failed";
        })// Remove icon
        .addCase($267e05af9054ab74$export$4ac843d70cbcd13f.fulfilled, (state, action)=>{
            const index = state.categories.findIndex((cat)=>cat.uuid === action.meta.arg);
            if (index !== -1) state.categories[index] = action.payload.data;
            if (state.category?.uuid === action.meta.arg) state.category = action.payload.data;
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetCategoryStatuses: $267e05af9054ab74$export$246095045391d621 } = $267e05af9054ab74$var$categoriesSlice.actions;
var $267e05af9054ab74$export$2e2bcd8739ae039 = $267e05af9054ab74$var$categoriesSlice.reducer;

});

parcelRegister("1vvaG", function(module, exports) {

$parcel$export(module.exports, "fetchSubCategories", () => $1190dda82c70d7db$export$2f9e8b3fd928a8c2);
$parcel$export(module.exports, "createSubCategory", () => $1190dda82c70d7db$export$26fa6f8facd30156);
$parcel$export(module.exports, "fetchSubCategoryById", () => $1190dda82c70d7db$export$534771078d33553f);
$parcel$export(module.exports, "updateSubCategory", () => $1190dda82c70d7db$export$f55a30d0864db1f2);
$parcel$export(module.exports, "deleteSubCategory", () => $1190dda82c70d7db$export$1cef25646f278d5d);
$parcel$export(module.exports, "toggleSubCategoryStatus", () => $1190dda82c70d7db$export$e0b52d9c64e3d312);
$parcel$export(module.exports, "resetSubCategoryStatuses", () => $1190dda82c70d7db$export$eda4013b02734104);
$parcel$export(module.exports, "default", () => $1190dda82c70d7db$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $1190dda82c70d7db$export$2f9e8b3fd928a8c2 = (0, $iDqdB.createAsyncThunk)("subCategories/fetchSubCategories", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search, category_uuid: category_uuid } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    if (category_uuid) params.append("category_uuid", category_uuid);
    const res = await (0, $ivNbC.default).get(`/dashboard/sub-categories?${params.toString()}`);
    return res;
});
const $1190dda82c70d7db$export$26fa6f8facd30156 = (0, $iDqdB.createAsyncThunk)("subCategories/createSubCategory", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/sub-categories", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create subcategory");
    }
});
const $1190dda82c70d7db$export$534771078d33553f = (0, $iDqdB.createAsyncThunk)("subCategories/fetchSubCategoryById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/sub-categories/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch subcategory details");
    }
});
const $1190dda82c70d7db$export$f55a30d0864db1f2 = (0, $iDqdB.createAsyncThunk)("subCategories/updateSubCategory", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post(`/dashboard/sub-categories/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update subcategory");
    }
});
const $1190dda82c70d7db$export$1cef25646f278d5d = (0, $iDqdB.createAsyncThunk)("subCategories/deleteSubCategory", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/sub-categories/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete subcategory");
    }
});
const $1190dda82c70d7db$export$1eb90f85722ed566 = (0, $iDqdB.createAsyncThunk)("subCategories/enableSubCategory", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/sub-categories/${uuid}/enable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to enable subcategory");
    }
});
const $1190dda82c70d7db$export$e8fe8c3754fa9587 = (0, $iDqdB.createAsyncThunk)("subCategories/disableSubCategory", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/sub-categories/${uuid}/disable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to disable subcategory");
    }
});
const $1190dda82c70d7db$export$e0b52d9c64e3d312 = (0, $iDqdB.createAsyncThunk)("subCategories/toggleSubCategoryStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/sub-categories/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle subcategory status");
    }
});
const $1190dda82c70d7db$export$24aa057699a711e9 = (0, $iDqdB.createAsyncThunk)("subCategories/updateSubCategoryIcon", async ({ uuid: uuid, icon: icon }, { rejectWithValue: rejectWithValue })=>{
    try {
        const formData = new FormData();
        formData.append("icon", icon);
        const res = await (0, $ivNbC.default).post(`/dashboard/sub-categories/${uuid}/update-icon`, formData);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update subcategory icon");
    }
});
const $1190dda82c70d7db$export$2023d6a91f421440 = (0, $iDqdB.createAsyncThunk)("subCategories/removeSubCategoryIcon", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/sub-categories/${uuid}/remove-icon`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to remove subcategory icon");
    }
});
const $1190dda82c70d7db$var$subCategoriesSlice = (0, $iDqdB.createSlice)({
    name: "subCategories",
    initialState: {
        subCategories: [],
        pagination: null,
        subCategory: null,
        subCategoryCreateStatus: "idle",
        subCategoryUpdateStatus: "idle",
        subCategoryDeleteStatus: "idle",
        subCategoryFetchStatus: "idle",
        subCategoryStatusChangeStatus: "idle",
        subCategoryIconUpdateStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetSubCategoryStatuses: (state)=>{
            state.subCategoryCreateStatus = "idle";
            state.subCategoryUpdateStatus = "idle";
            state.subCategoryDeleteStatus = "idle";
            state.subCategoryStatusChangeStatus = "idle";
            state.subCategoryIconUpdateStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch subcategories
        .addCase($1190dda82c70d7db$export$2f9e8b3fd928a8c2.fulfilled, (state, action)=>{
            state.subCategories = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create subcategory
        .addCase($1190dda82c70d7db$export$26fa6f8facd30156.pending, (state)=>{
            state.subCategoryCreateStatus = "loading";
        }).addCase($1190dda82c70d7db$export$26fa6f8facd30156.fulfilled, (state, action)=>{
            state.subCategoryCreateStatus = "success";
            state.subCategory = action.payload.data;
        }).addCase($1190dda82c70d7db$export$26fa6f8facd30156.rejected, (state)=>{
            state.subCategoryCreateStatus = "failed";
        })// Fetch subcategory by ID
        .addCase($1190dda82c70d7db$export$534771078d33553f.pending, (state)=>{
            state.subCategoryFetchStatus = "loading";
        }).addCase($1190dda82c70d7db$export$534771078d33553f.fulfilled, (state, action)=>{
            state.subCategoryFetchStatus = "success";
            state.subCategory = action.payload.data;
        }).addCase($1190dda82c70d7db$export$534771078d33553f.rejected, (state)=>{
            state.subCategoryFetchStatus = "failed";
            state.subCategory = null;
        })// Update subcategory
        .addCase($1190dda82c70d7db$export$f55a30d0864db1f2.pending, (state)=>{
            state.subCategoryUpdateStatus = "loading";
        }).addCase($1190dda82c70d7db$export$f55a30d0864db1f2.fulfilled, (state, action)=>{
            state.subCategoryUpdateStatus = "success";
            const index = state.subCategories.findIndex((subCat)=>subCat.uuid === action.meta.arg.uuid);
            if (index !== -1) state.subCategories[index] = action.payload.data;
            state.subCategory = action.payload.data;
        }).addCase($1190dda82c70d7db$export$f55a30d0864db1f2.rejected, (state)=>{
            state.subCategoryUpdateStatus = "failed";
        })// Delete subcategory
        .addCase($1190dda82c70d7db$export$1cef25646f278d5d.pending, (state)=>{
            state.subCategoryDeleteStatus = "loading";
        }).addCase($1190dda82c70d7db$export$1cef25646f278d5d.fulfilled, (state, action)=>{
            state.subCategoryDeleteStatus = "success";
            state.subCategories = state.subCategories.filter((subCat)=>subCat.uuid !== action.payload.uuid);
        }).addCase($1190dda82c70d7db$export$1cef25646f278d5d.rejected, (state)=>{
            state.subCategoryDeleteStatus = "failed";
        })// Toggle status
        .addCase($1190dda82c70d7db$export$e0b52d9c64e3d312.pending, (state)=>{
            state.subCategoryStatusChangeStatus = "loading";
        }).addCase($1190dda82c70d7db$export$e0b52d9c64e3d312.fulfilled, (state, action)=>{
            state.subCategoryStatusChangeStatus = "success";
            const index = state.subCategories.findIndex((subCat)=>subCat.uuid === action.meta.arg);
            if (index !== -1) state.subCategories[index] = action.payload.data;
        }).addCase($1190dda82c70d7db$export$e0b52d9c64e3d312.rejected, (state)=>{
            state.subCategoryStatusChangeStatus = "failed";
        })// Update icon
        .addCase($1190dda82c70d7db$export$24aa057699a711e9.pending, (state)=>{
            state.subCategoryIconUpdateStatus = "loading";
        }).addCase($1190dda82c70d7db$export$24aa057699a711e9.fulfilled, (state, action)=>{
            state.subCategoryIconUpdateStatus = "success";
            const index = state.subCategories.findIndex((subCat)=>subCat.uuid === action.meta.arg.uuid);
            if (index !== -1) state.subCategories[index] = action.payload.data;
            if (state.subCategory?.uuid === action.meta.arg.uuid) state.subCategory = action.payload.data;
        }).addCase($1190dda82c70d7db$export$24aa057699a711e9.rejected, (state)=>{
            state.subCategoryIconUpdateStatus = "failed";
        })// Remove icon
        .addCase($1190dda82c70d7db$export$2023d6a91f421440.fulfilled, (state, action)=>{
            const index = state.subCategories.findIndex((subCat)=>subCat.uuid === action.meta.arg);
            if (index !== -1) state.subCategories[index] = action.payload.data;
            if (state.subCategory?.uuid === action.meta.arg) state.subCategory = action.payload.data;
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetSubCategoryStatuses: $1190dda82c70d7db$export$eda4013b02734104 } = $1190dda82c70d7db$var$subCategoriesSlice.actions;
var $1190dda82c70d7db$export$2e2bcd8739ae039 = $1190dda82c70d7db$var$subCategoriesSlice.reducer;

});

parcelRegister("uGwQ1", function(module, exports) {

$parcel$export(module.exports, "fetchCategoryServices", () => $05c3cac2784dac7a$export$81ac35db9b3638c4);
$parcel$export(module.exports, "createCategoryService", () => $05c3cac2784dac7a$export$7c71cebba3d31cc4);
$parcel$export(module.exports, "fetchCategoryServiceById", () => $05c3cac2784dac7a$export$ca49e8135fc327e6);
$parcel$export(module.exports, "updateCategoryService", () => $05c3cac2784dac7a$export$8c3834e0dcfdb900);
$parcel$export(module.exports, "deleteCategoryService", () => $05c3cac2784dac7a$export$9fc38f4b2a5fd7e3);
$parcel$export(module.exports, "toggleCategoryServiceStatus", () => $05c3cac2784dac7a$export$454970de2c1f8268);
$parcel$export(module.exports, "resetCategoryServiceStatuses", () => $05c3cac2784dac7a$export$5a48ed8f141b18ee);
$parcel$export(module.exports, "default", () => $05c3cac2784dac7a$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $05c3cac2784dac7a$export$81ac35db9b3638c4 = (0, $iDqdB.createAsyncThunk)("categoryServices/fetchCategoryServices", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search, category_uuid: category_uuid } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    if (category_uuid) params.append("category_uuid", category_uuid);
    const res = await (0, $ivNbC.default).get(`/dashboard/category-services?${params.toString()}`);
    return res;
});
const $05c3cac2784dac7a$export$7c71cebba3d31cc4 = (0, $iDqdB.createAsyncThunk)("categoryServices/createCategoryService", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/category-services", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create category service");
    }
});
const $05c3cac2784dac7a$export$ca49e8135fc327e6 = (0, $iDqdB.createAsyncThunk)("categoryServices/fetchCategoryServiceById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/category-services/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch category service details");
    }
});
const $05c3cac2784dac7a$export$8c3834e0dcfdb900 = (0, $iDqdB.createAsyncThunk)("categoryServices/updateCategoryService", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put(`/dashboard/category-services/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update category service");
    }
});
const $05c3cac2784dac7a$export$9fc38f4b2a5fd7e3 = (0, $iDqdB.createAsyncThunk)("categoryServices/deleteCategoryService", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/category-services/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete category service");
    }
});
const $05c3cac2784dac7a$export$55400613566f1fc1 = (0, $iDqdB.createAsyncThunk)("categoryServices/enableCategoryService", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/category-services/${uuid}/enable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to enable category service");
    }
});
const $05c3cac2784dac7a$export$bb9f3c2395c98cd4 = (0, $iDqdB.createAsyncThunk)("categoryServices/disableCategoryService", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/category-services/${uuid}/disable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to disable category service");
    }
});
const $05c3cac2784dac7a$export$454970de2c1f8268 = (0, $iDqdB.createAsyncThunk)("categoryServices/toggleCategoryServiceStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/category-services/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle category service status");
    }
});
const $05c3cac2784dac7a$var$categoryServicesSlice = (0, $iDqdB.createSlice)({
    name: "categoryServices",
    initialState: {
        categoryServices: [],
        pagination: null,
        categoryService: null,
        categoryServiceCreateStatus: "idle",
        categoryServiceUpdateStatus: "idle",
        categoryServiceDeleteStatus: "idle",
        categoryServiceFetchStatus: "idle",
        categoryServiceStatusChangeStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetCategoryServiceStatuses: (state)=>{
            state.categoryServiceCreateStatus = "idle";
            state.categoryServiceUpdateStatus = "idle";
            state.categoryServiceDeleteStatus = "idle";
            state.categoryServiceStatusChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch category services
        .addCase($05c3cac2784dac7a$export$81ac35db9b3638c4.fulfilled, (state, action)=>{
            state.categoryServices = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create category service
        .addCase($05c3cac2784dac7a$export$7c71cebba3d31cc4.pending, (state)=>{
            state.categoryServiceCreateStatus = "loading";
        }).addCase($05c3cac2784dac7a$export$7c71cebba3d31cc4.fulfilled, (state, action)=>{
            state.categoryServiceCreateStatus = "success";
            state.categoryService = action.payload.data;
        }).addCase($05c3cac2784dac7a$export$7c71cebba3d31cc4.rejected, (state)=>{
            state.categoryServiceCreateStatus = "failed";
        })// Fetch category service by ID
        .addCase($05c3cac2784dac7a$export$ca49e8135fc327e6.pending, (state)=>{
            state.categoryServiceFetchStatus = "loading";
        }).addCase($05c3cac2784dac7a$export$ca49e8135fc327e6.fulfilled, (state, action)=>{
            state.categoryServiceFetchStatus = "success";
            state.categoryService = action.payload.data;
        }).addCase($05c3cac2784dac7a$export$ca49e8135fc327e6.rejected, (state)=>{
            state.categoryServiceFetchStatus = "failed";
            state.categoryService = null;
        })// Update category service
        .addCase($05c3cac2784dac7a$export$8c3834e0dcfdb900.pending, (state)=>{
            state.categoryServiceUpdateStatus = "loading";
        }).addCase($05c3cac2784dac7a$export$8c3834e0dcfdb900.fulfilled, (state, action)=>{
            state.categoryServiceUpdateStatus = "success";
            const index = state.categoryServices.findIndex((service)=>service.uuid === action.meta.arg.uuid);
            if (index !== -1) state.categoryServices[index] = action.payload.data;
            state.categoryService = action.payload.data;
        }).addCase($05c3cac2784dac7a$export$8c3834e0dcfdb900.rejected, (state)=>{
            state.categoryServiceUpdateStatus = "failed";
        })// Delete category service
        .addCase($05c3cac2784dac7a$export$9fc38f4b2a5fd7e3.pending, (state)=>{
            state.categoryServiceDeleteStatus = "loading";
        }).addCase($05c3cac2784dac7a$export$9fc38f4b2a5fd7e3.fulfilled, (state, action)=>{
            state.categoryServiceDeleteStatus = "success";
            state.categoryServices = state.categoryServices.filter((service)=>service.uuid !== action.payload.uuid);
        }).addCase($05c3cac2784dac7a$export$9fc38f4b2a5fd7e3.rejected, (state)=>{
            state.categoryServiceDeleteStatus = "failed";
        })// Toggle status
        .addCase($05c3cac2784dac7a$export$454970de2c1f8268.pending, (state)=>{
            state.categoryServiceStatusChangeStatus = "loading";
        }).addCase($05c3cac2784dac7a$export$454970de2c1f8268.fulfilled, (state, action)=>{
            state.categoryServiceStatusChangeStatus = "success";
            const index = state.categoryServices.findIndex((service)=>service.uuid === action.meta.arg);
            if (index !== -1) state.categoryServices[index] = action.payload.data;
        }).addCase($05c3cac2784dac7a$export$454970de2c1f8268.rejected, (state)=>{
            state.categoryServiceStatusChangeStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetCategoryServiceStatuses: $05c3cac2784dac7a$export$5a48ed8f141b18ee } = $05c3cac2784dac7a$var$categoryServicesSlice.actions;
var $05c3cac2784dac7a$export$2e2bcd8739ae039 = $05c3cac2784dac7a$var$categoryServicesSlice.reducer;

});

parcelRegister("5vhYX", function(module, exports) {

$parcel$export(module.exports, "fetchStates", () => $401dcbe7ee9e7372$export$2bc3cba6f94d7400);
$parcel$export(module.exports, "createState", () => $401dcbe7ee9e7372$export$e6a0daad8304de);
$parcel$export(module.exports, "fetchStateById", () => $401dcbe7ee9e7372$export$d5ccd15fd8552df2);
$parcel$export(module.exports, "updateState", () => $401dcbe7ee9e7372$export$4971331372cec95a);
$parcel$export(module.exports, "deleteState", () => $401dcbe7ee9e7372$export$763e9bee4a22656f);
$parcel$export(module.exports, "toggleStateStatus", () => $401dcbe7ee9e7372$export$29de3f1da1a6e626);
$parcel$export(module.exports, "resetStateStatuses", () => $401dcbe7ee9e7372$export$80e609a3d8f7a6fc);
$parcel$export(module.exports, "default", () => $401dcbe7ee9e7372$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $401dcbe7ee9e7372$export$2bc3cba6f94d7400 = (0, $iDqdB.createAsyncThunk)("states/fetchStates", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    const res = await (0, $ivNbC.default).get(`/dashboard/states?${params.toString()}`);
    return res;
});
const $401dcbe7ee9e7372$export$e6a0daad8304de = (0, $iDqdB.createAsyncThunk)("states/createState", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/states", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create state");
    }
});
const $401dcbe7ee9e7372$export$d5ccd15fd8552df2 = (0, $iDqdB.createAsyncThunk)("states/fetchStateById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/states/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch state details");
    }
});
const $401dcbe7ee9e7372$export$4971331372cec95a = (0, $iDqdB.createAsyncThunk)("states/updateState", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put(`/dashboard/states/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update state");
    }
});
const $401dcbe7ee9e7372$export$763e9bee4a22656f = (0, $iDqdB.createAsyncThunk)("states/deleteState", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/states/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete state");
    }
});
const $401dcbe7ee9e7372$export$29de3f1da1a6e626 = (0, $iDqdB.createAsyncThunk)("states/toggleStateStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/states/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle state status");
    }
});
const $401dcbe7ee9e7372$var$statesSlice = (0, $iDqdB.createSlice)({
    name: "states",
    initialState: {
        states: [],
        pagination: null,
        state: null,
        stateCreateStatus: "idle",
        stateUpdateStatus: "idle",
        stateDeleteStatus: "idle",
        stateFetchStatus: "idle",
        stateStatusChangeStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetStateStatuses: (state)=>{
            state.stateCreateStatus = "idle";
            state.stateUpdateStatus = "idle";
            state.stateDeleteStatus = "idle";
            state.stateStatusChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch states
        .addCase($401dcbe7ee9e7372$export$2bc3cba6f94d7400.fulfilled, (state, action)=>{
            state.states = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create state
        .addCase($401dcbe7ee9e7372$export$e6a0daad8304de.pending, (state)=>{
            state.stateCreateStatus = "loading";
        }).addCase($401dcbe7ee9e7372$export$e6a0daad8304de.fulfilled, (state, action)=>{
            state.stateCreateStatus = "success";
            state.state = action.payload.data;
        }).addCase($401dcbe7ee9e7372$export$e6a0daad8304de.rejected, (state)=>{
            state.stateCreateStatus = "failed";
        })// Fetch state by ID
        .addCase($401dcbe7ee9e7372$export$d5ccd15fd8552df2.pending, (state)=>{
            state.stateFetchStatus = "loading";
        }).addCase($401dcbe7ee9e7372$export$d5ccd15fd8552df2.fulfilled, (state, action)=>{
            state.stateFetchStatus = "success";
            state.state = action.payload.data;
        }).addCase($401dcbe7ee9e7372$export$d5ccd15fd8552df2.rejected, (state)=>{
            state.stateFetchStatus = "failed";
            state.state = null;
        })// Update state
        .addCase($401dcbe7ee9e7372$export$4971331372cec95a.pending, (state)=>{
            state.stateUpdateStatus = "loading";
        }).addCase($401dcbe7ee9e7372$export$4971331372cec95a.fulfilled, (state, action)=>{
            state.stateUpdateStatus = "success";
            const index = state.states.findIndex((st)=>st.uuid === action.meta.arg.uuid);
            if (index !== -1) state.states[index] = action.payload.data;
            state.state = action.payload.data;
        }).addCase($401dcbe7ee9e7372$export$4971331372cec95a.rejected, (state)=>{
            state.stateUpdateStatus = "failed";
        })// Delete state
        .addCase($401dcbe7ee9e7372$export$763e9bee4a22656f.pending, (state)=>{
            state.stateDeleteStatus = "loading";
        }).addCase($401dcbe7ee9e7372$export$763e9bee4a22656f.fulfilled, (state, action)=>{
            state.stateDeleteStatus = "success";
            state.states = state.states.filter((st)=>st.uuid !== action.payload.uuid);
        }).addCase($401dcbe7ee9e7372$export$763e9bee4a22656f.rejected, (state)=>{
            state.stateDeleteStatus = "failed";
        })// Toggle status
        .addCase($401dcbe7ee9e7372$export$29de3f1da1a6e626.pending, (state)=>{
            state.stateStatusChangeStatus = "loading";
        }).addCase($401dcbe7ee9e7372$export$29de3f1da1a6e626.fulfilled, (state, action)=>{
            state.stateStatusChangeStatus = "success";
            const index = state.states.findIndex((st)=>st.uuid === action.meta.arg);
            if (index !== -1) state.states[index] = action.payload.data;
        }).addCase($401dcbe7ee9e7372$export$29de3f1da1a6e626.rejected, (state)=>{
            state.stateStatusChangeStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetStateStatuses: $401dcbe7ee9e7372$export$80e609a3d8f7a6fc } = $401dcbe7ee9e7372$var$statesSlice.actions;
var $401dcbe7ee9e7372$export$2e2bcd8739ae039 = $401dcbe7ee9e7372$var$statesSlice.reducer;

});

parcelRegister("bG6ee", function(module, exports) {

$parcel$export(module.exports, "fetchDistricts", () => $880872ca3c2b397d$export$74cada442523b44a);
$parcel$export(module.exports, "createDistrict", () => $880872ca3c2b397d$export$1399ad17a68bdaf2);
$parcel$export(module.exports, "fetchDistrictById", () => $880872ca3c2b397d$export$30628b7ca9bbd76b);
$parcel$export(module.exports, "updateDistrict", () => $880872ca3c2b397d$export$bc202e612775a1f3);
$parcel$export(module.exports, "deleteDistrict", () => $880872ca3c2b397d$export$70a45bc788c9e6b7);
$parcel$export(module.exports, "toggleDistrictStatus", () => $880872ca3c2b397d$export$d42e8a32ea847458);
$parcel$export(module.exports, "resetDistrictStatuses", () => $880872ca3c2b397d$export$9e3ed24eec36026a);
$parcel$export(module.exports, "default", () => $880872ca3c2b397d$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $880872ca3c2b397d$export$74cada442523b44a = (0, $iDqdB.createAsyncThunk)("districts/fetchDistricts", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search, state_uuid: state_uuid } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    if (state_uuid) params.append("state_uuid", state_uuid);
    const res = await (0, $ivNbC.default).get(`/dashboard/districts?${params.toString()}`);
    return res;
});
const $880872ca3c2b397d$export$1399ad17a68bdaf2 = (0, $iDqdB.createAsyncThunk)("districts/createDistrict", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/districts", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create district");
    }
});
const $880872ca3c2b397d$export$30628b7ca9bbd76b = (0, $iDqdB.createAsyncThunk)("districts/fetchDistrictById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/districts/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch district details");
    }
});
const $880872ca3c2b397d$export$bc202e612775a1f3 = (0, $iDqdB.createAsyncThunk)("districts/updateDistrict", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put(`/dashboard/districts/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update district");
    }
});
const $880872ca3c2b397d$export$70a45bc788c9e6b7 = (0, $iDqdB.createAsyncThunk)("districts/deleteDistrict", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/districts/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete district");
    }
});
const $880872ca3c2b397d$export$d42e8a32ea847458 = (0, $iDqdB.createAsyncThunk)("districts/toggleDistrictStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/districts/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle district status");
    }
});
const $880872ca3c2b397d$var$districtsSlice = (0, $iDqdB.createSlice)({
    name: "districts",
    initialState: {
        districts: [],
        pagination: null,
        district: null,
        districtCreateStatus: "idle",
        districtUpdateStatus: "idle",
        districtDeleteStatus: "idle",
        districtFetchStatus: "idle",
        districtStatusChangeStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetDistrictStatuses: (state)=>{
            state.districtCreateStatus = "idle";
            state.districtUpdateStatus = "idle";
            state.districtDeleteStatus = "idle";
            state.districtStatusChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch districts
        .addCase($880872ca3c2b397d$export$74cada442523b44a.fulfilled, (state, action)=>{
            state.districts = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create district
        .addCase($880872ca3c2b397d$export$1399ad17a68bdaf2.pending, (state)=>{
            state.districtCreateStatus = "loading";
        }).addCase($880872ca3c2b397d$export$1399ad17a68bdaf2.fulfilled, (state, action)=>{
            state.districtCreateStatus = "success";
            state.district = action.payload.data;
        }).addCase($880872ca3c2b397d$export$1399ad17a68bdaf2.rejected, (state)=>{
            state.districtCreateStatus = "failed";
        })// Fetch district by ID
        .addCase($880872ca3c2b397d$export$30628b7ca9bbd76b.pending, (state)=>{
            state.districtFetchStatus = "loading";
        }).addCase($880872ca3c2b397d$export$30628b7ca9bbd76b.fulfilled, (state, action)=>{
            state.districtFetchStatus = "success";
            state.district = action.payload.data;
        }).addCase($880872ca3c2b397d$export$30628b7ca9bbd76b.rejected, (state)=>{
            state.districtFetchStatus = "failed";
            state.district = null;
        })// Update district
        .addCase($880872ca3c2b397d$export$bc202e612775a1f3.pending, (state)=>{
            state.districtUpdateStatus = "loading";
        }).addCase($880872ca3c2b397d$export$bc202e612775a1f3.fulfilled, (state, action)=>{
            state.districtUpdateStatus = "success";
            const index = state.districts.findIndex((dist)=>dist.uuid === action.meta.arg.uuid);
            if (index !== -1) state.districts[index] = action.payload.data;
            state.district = action.payload.data;
        }).addCase($880872ca3c2b397d$export$bc202e612775a1f3.rejected, (state)=>{
            state.districtUpdateStatus = "failed";
        })// Delete district
        .addCase($880872ca3c2b397d$export$70a45bc788c9e6b7.pending, (state)=>{
            state.districtDeleteStatus = "loading";
        }).addCase($880872ca3c2b397d$export$70a45bc788c9e6b7.fulfilled, (state, action)=>{
            state.districtDeleteStatus = "success";
            state.districts = state.districts.filter((dist)=>dist.uuid !== action.payload.uuid);
        }).addCase($880872ca3c2b397d$export$70a45bc788c9e6b7.rejected, (state)=>{
            state.districtDeleteStatus = "failed";
        })// Toggle status
        .addCase($880872ca3c2b397d$export$d42e8a32ea847458.pending, (state)=>{
            state.districtStatusChangeStatus = "loading";
        }).addCase($880872ca3c2b397d$export$d42e8a32ea847458.fulfilled, (state, action)=>{
            state.districtStatusChangeStatus = "success";
            const index = state.districts.findIndex((dist)=>dist.uuid === action.meta.arg);
            if (index !== -1) state.districts[index] = action.payload.data;
        }).addCase($880872ca3c2b397d$export$d42e8a32ea847458.rejected, (state)=>{
            state.districtStatusChangeStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetDistrictStatuses: $880872ca3c2b397d$export$9e3ed24eec36026a } = $880872ca3c2b397d$var$districtsSlice.actions;
var $880872ca3c2b397d$export$2e2bcd8739ae039 = $880872ca3c2b397d$var$districtsSlice.reducer;

});

parcelRegister("824th", function(module, exports) {

$parcel$export(module.exports, "fetchTalukas", () => $5d91fa8bb1c5ad69$export$c39b43b551b7ae78);
$parcel$export(module.exports, "createTaluka", () => $5d91fa8bb1c5ad69$export$16779f185a64243f);
$parcel$export(module.exports, "fetchTalukaById", () => $5d91fa8bb1c5ad69$export$8dcb5f84d78778e0);
$parcel$export(module.exports, "updateTaluka", () => $5d91fa8bb1c5ad69$export$4288873bc07abf03);
$parcel$export(module.exports, "deleteTaluka", () => $5d91fa8bb1c5ad69$export$4833d5bcf9255d24);
$parcel$export(module.exports, "toggleTalukaStatus", () => $5d91fa8bb1c5ad69$export$f26969c5895cb9e8);
$parcel$export(module.exports, "resetTalukaStatuses", () => $5d91fa8bb1c5ad69$export$9d77b1db4f27a5fe);
$parcel$export(module.exports, "default", () => $5d91fa8bb1c5ad69$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $5d91fa8bb1c5ad69$export$c39b43b551b7ae78 = (0, $iDqdB.createAsyncThunk)("talukas/fetchTalukas", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search, district_uuid: district_uuid } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    if (district_uuid) params.append("district_uuid", district_uuid);
    const res = await (0, $ivNbC.default).get(`/dashboard/talukas?${params.toString()}`);
    return res;
});
const $5d91fa8bb1c5ad69$export$16779f185a64243f = (0, $iDqdB.createAsyncThunk)("talukas/createTaluka", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/talukas", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create taluka");
    }
});
const $5d91fa8bb1c5ad69$export$8dcb5f84d78778e0 = (0, $iDqdB.createAsyncThunk)("talukas/fetchTalukaById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/talukas/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch taluka details");
    }
});
const $5d91fa8bb1c5ad69$export$4288873bc07abf03 = (0, $iDqdB.createAsyncThunk)("talukas/updateTaluka", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put(`/dashboard/talukas/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update taluka");
    }
});
const $5d91fa8bb1c5ad69$export$4833d5bcf9255d24 = (0, $iDqdB.createAsyncThunk)("talukas/deleteTaluka", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/talukas/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete taluka");
    }
});
const $5d91fa8bb1c5ad69$export$f26969c5895cb9e8 = (0, $iDqdB.createAsyncThunk)("talukas/toggleTalukaStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/talukas/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle taluka status");
    }
});
const $5d91fa8bb1c5ad69$var$talukasSlice = (0, $iDqdB.createSlice)({
    name: "talukas",
    initialState: {
        talukas: [],
        pagination: null,
        taluka: null,
        talukaCreateStatus: "idle",
        talukaUpdateStatus: "idle",
        talukaDeleteStatus: "idle",
        talukaFetchStatus: "idle",
        talukaStatusChangeStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetTalukaStatuses: (state)=>{
            state.talukaCreateStatus = "idle";
            state.talukaUpdateStatus = "idle";
            state.talukaDeleteStatus = "idle";
            state.talukaStatusChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch talukas
        .addCase($5d91fa8bb1c5ad69$export$c39b43b551b7ae78.fulfilled, (state, action)=>{
            state.talukas = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create taluka
        .addCase($5d91fa8bb1c5ad69$export$16779f185a64243f.pending, (state)=>{
            state.talukaCreateStatus = "loading";
        }).addCase($5d91fa8bb1c5ad69$export$16779f185a64243f.fulfilled, (state, action)=>{
            state.talukaCreateStatus = "success";
            state.taluka = action.payload.data;
        }).addCase($5d91fa8bb1c5ad69$export$16779f185a64243f.rejected, (state)=>{
            state.talukaCreateStatus = "failed";
        })// Fetch taluka by ID
        .addCase($5d91fa8bb1c5ad69$export$8dcb5f84d78778e0.pending, (state)=>{
            state.talukaFetchStatus = "loading";
        }).addCase($5d91fa8bb1c5ad69$export$8dcb5f84d78778e0.fulfilled, (state, action)=>{
            state.talukaFetchStatus = "success";
            state.taluka = action.payload.data;
        }).addCase($5d91fa8bb1c5ad69$export$8dcb5f84d78778e0.rejected, (state)=>{
            state.talukaFetchStatus = "failed";
            state.taluka = null;
        })// Update taluka
        .addCase($5d91fa8bb1c5ad69$export$4288873bc07abf03.pending, (state)=>{
            state.talukaUpdateStatus = "loading";
        }).addCase($5d91fa8bb1c5ad69$export$4288873bc07abf03.fulfilled, (state, action)=>{
            state.talukaUpdateStatus = "success";
            const index = state.talukas.findIndex((tal)=>tal.uuid === action.meta.arg.uuid);
            if (index !== -1) state.talukas[index] = action.payload.data;
            state.taluka = action.payload.data;
        }).addCase($5d91fa8bb1c5ad69$export$4288873bc07abf03.rejected, (state)=>{
            state.talukaUpdateStatus = "failed";
        })// Delete taluka
        .addCase($5d91fa8bb1c5ad69$export$4833d5bcf9255d24.pending, (state)=>{
            state.talukaDeleteStatus = "loading";
        }).addCase($5d91fa8bb1c5ad69$export$4833d5bcf9255d24.fulfilled, (state, action)=>{
            state.talukaDeleteStatus = "success";
            state.talukas = state.talukas.filter((tal)=>tal.uuid !== action.payload.uuid);
        }).addCase($5d91fa8bb1c5ad69$export$4833d5bcf9255d24.rejected, (state)=>{
            state.talukaDeleteStatus = "failed";
        })// Toggle status
        .addCase($5d91fa8bb1c5ad69$export$f26969c5895cb9e8.pending, (state)=>{
            state.talukaStatusChangeStatus = "loading";
        }).addCase($5d91fa8bb1c5ad69$export$f26969c5895cb9e8.fulfilled, (state, action)=>{
            state.talukaStatusChangeStatus = "success";
            const index = state.talukas.findIndex((tal)=>tal.uuid === action.meta.arg);
            if (index !== -1) state.talukas[index] = action.payload.data;
        }).addCase($5d91fa8bb1c5ad69$export$f26969c5895cb9e8.rejected, (state)=>{
            state.talukaStatusChangeStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetTalukaStatuses: $5d91fa8bb1c5ad69$export$9d77b1db4f27a5fe } = $5d91fa8bb1c5ad69$var$talukasSlice.actions;
var $5d91fa8bb1c5ad69$export$2e2bcd8739ae039 = $5d91fa8bb1c5ad69$var$talukasSlice.reducer;

});

parcelRegister("bGldA", function(module, exports) {

$parcel$export(module.exports, "fetchSubscriptionPackages", () => $881413735f5c4939$export$ab04f8fd61bc91c0);
$parcel$export(module.exports, "createSubscriptionPackage", () => $881413735f5c4939$export$a4b59d6424b48dc8);
$parcel$export(module.exports, "fetchSubscriptionPackageById", () => $881413735f5c4939$export$e5507e49bbd8bde1);
$parcel$export(module.exports, "updateSubscriptionPackage", () => $881413735f5c4939$export$3714e70c101cd39f);
$parcel$export(module.exports, "deleteSubscriptionPackage", () => $881413735f5c4939$export$cf6a69ee04ac50c4);
$parcel$export(module.exports, "toggleSubscriptionPackageStatus", () => $881413735f5c4939$export$597dd4b186e8bb15);
$parcel$export(module.exports, "resetPackageStatuses", () => $881413735f5c4939$export$8386274e37a24678);
$parcel$export(module.exports, "default", () => $881413735f5c4939$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $881413735f5c4939$export$ab04f8fd61bc91c0 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/fetchSubscriptionPackages", async ({ page: page = 1, per_page: per_page = 15, status: status, search: search } = {})=>{
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("per_page", per_page);
    if (status !== undefined) params.append("status", status);
    if (search) params.append("search", search);
    const res = await (0, $ivNbC.default).get(`/dashboard/subscription-packages?${params.toString()}`);
    return res;
});
const $881413735f5c4939$export$a4b59d6424b48dc8 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/createSubscriptionPackage", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/subscription-packages", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to create subscription package");
    }
});
const $881413735f5c4939$export$e5507e49bbd8bde1 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/fetchSubscriptionPackageById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/subscription-packages/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch subscription package details");
    }
});
const $881413735f5c4939$export$3714e70c101cd39f = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/updateSubscriptionPackage", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put(`/dashboard/subscription-packages/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update subscription package");
    }
});
const $881413735f5c4939$export$cf6a69ee04ac50c4 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/deleteSubscriptionPackage", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/subscription-packages/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete subscription package");
    }
});
const $881413735f5c4939$export$116322765ff198a7 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/enableSubscriptionPackage", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/subscription-packages/${uuid}/enable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to enable subscription package");
    }
});
const $881413735f5c4939$export$2f9dade3794c6c51 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/disableSubscriptionPackage", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/subscription-packages/${uuid}/disable`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to disable subscription package");
    }
});
const $881413735f5c4939$export$597dd4b186e8bb15 = (0, $iDqdB.createAsyncThunk)("subscriptionPackages/toggleSubscriptionPackageStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/subscription-packages/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle subscription package status");
    }
});
const $881413735f5c4939$var$subscriptionPackagesSlice = (0, $iDqdB.createSlice)({
    name: "subscriptionPackages",
    initialState: {
        subscriptionPackages: [],
        pagination: null,
        subscriptionPackage: null,
        packageCreateStatus: "idle",
        packageUpdateStatus: "idle",
        packageDeleteStatus: "idle",
        packageFetchStatus: "idle",
        packageStatusChangeStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetPackageStatuses: (state)=>{
            state.packageCreateStatus = "idle";
            state.packageUpdateStatus = "idle";
            state.packageDeleteStatus = "idle";
            state.packageStatusChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch subscription packages
        .addCase($881413735f5c4939$export$ab04f8fd61bc91c0.fulfilled, (state, action)=>{
            state.subscriptionPackages = action.payload.data;
            state.pagination = action.payload.pagination;
        })// Create subscription package
        .addCase($881413735f5c4939$export$a4b59d6424b48dc8.pending, (state)=>{
            state.packageCreateStatus = "loading";
        }).addCase($881413735f5c4939$export$a4b59d6424b48dc8.fulfilled, (state, action)=>{
            state.packageCreateStatus = "success";
            state.subscriptionPackage = action.payload.data;
        }).addCase($881413735f5c4939$export$a4b59d6424b48dc8.rejected, (state)=>{
            state.packageCreateStatus = "failed";
        })// Fetch subscription package by ID
        .addCase($881413735f5c4939$export$e5507e49bbd8bde1.pending, (state)=>{
            state.packageFetchStatus = "loading";
        }).addCase($881413735f5c4939$export$e5507e49bbd8bde1.fulfilled, (state, action)=>{
            state.packageFetchStatus = "success";
            state.subscriptionPackage = action.payload.data;
        }).addCase($881413735f5c4939$export$e5507e49bbd8bde1.rejected, (state)=>{
            state.packageFetchStatus = "failed";
            state.subscriptionPackage = null;
        })// Update subscription package
        .addCase($881413735f5c4939$export$3714e70c101cd39f.pending, (state)=>{
            state.packageUpdateStatus = "loading";
        }).addCase($881413735f5c4939$export$3714e70c101cd39f.fulfilled, (state, action)=>{
            state.packageUpdateStatus = "success";
            const index = state.subscriptionPackages.findIndex((pkg)=>pkg.uuid === action.meta.arg.uuid);
            if (index !== -1) state.subscriptionPackages[index] = action.payload.data;
            state.subscriptionPackage = action.payload.data;
        }).addCase($881413735f5c4939$export$3714e70c101cd39f.rejected, (state)=>{
            state.packageUpdateStatus = "failed";
        })// Delete subscription package
        .addCase($881413735f5c4939$export$cf6a69ee04ac50c4.pending, (state)=>{
            state.packageDeleteStatus = "loading";
        }).addCase($881413735f5c4939$export$cf6a69ee04ac50c4.fulfilled, (state, action)=>{
            state.packageDeleteStatus = "success";
            state.subscriptionPackages = state.subscriptionPackages.filter((pkg)=>pkg.uuid !== action.payload.uuid);
        }).addCase($881413735f5c4939$export$cf6a69ee04ac50c4.rejected, (state)=>{
            state.packageDeleteStatus = "failed";
        })// Toggle status
        .addCase($881413735f5c4939$export$597dd4b186e8bb15.pending, (state)=>{
            state.packageStatusChangeStatus = "loading";
        }).addCase($881413735f5c4939$export$597dd4b186e8bb15.fulfilled, (state, action)=>{
            state.packageStatusChangeStatus = "success";
            const index = state.subscriptionPackages.findIndex((pkg)=>pkg.uuid === action.meta.arg);
            if (index !== -1) state.subscriptionPackages[index] = action.payload.data;
        }).addCase($881413735f5c4939$export$597dd4b186e8bb15.rejected, (state)=>{
            state.packageStatusChangeStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetPackageStatuses: $881413735f5c4939$export$8386274e37a24678 } = $881413735f5c4939$var$subscriptionPackagesSlice.actions;
var $881413735f5c4939$export$2e2bcd8739ae039 = $881413735f5c4939$var$subscriptionPackagesSlice.reducer;

});

parcelRegister("5cRsT", function(module, exports) {

$parcel$export(module.exports, "fetchCompanyDetails", () => $3ca78bc7bc936865$export$2ac34acdad039cf1);
$parcel$export(module.exports, "storeOrUpdateCompanyDetails", () => $3ca78bc7bc936865$export$88f5d8beb5c5eed9);
$parcel$export(module.exports, "default", () => $3ca78bc7bc936865$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $3ca78bc7bc936865$export$2ac34acdad039cf1 = (0, $iDqdB.createAsyncThunk)("companyDetails/fetchCompanyDetails", async ()=>{
    const res = await (0, $ivNbC.default).get("/dashboard/company-details");
    return res;
});
const $3ca78bc7bc936865$export$88f5d8beb5c5eed9 = (0, $iDqdB.createAsyncThunk)("companyDetails/storeOrUpdateCompanyDetails", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/company-details", payload);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to save company details");
    }
});
const $3ca78bc7bc936865$var$companyDetailsSlice = (0, $iDqdB.createSlice)({
    name: "companyDetails",
    initialState: {
        companyDetails: null,
        companyDetailsFetchStatus: "idle",
        companyDetailsSaveStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetCompanyDetailsStatuses: (state)=>{
            state.companyDetailsSaveStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch company details
        .addCase($3ca78bc7bc936865$export$2ac34acdad039cf1.pending, (state)=>{
            state.companyDetailsFetchStatus = "loading";
            state.loading = true;
        }).addCase($3ca78bc7bc936865$export$2ac34acdad039cf1.fulfilled, (state, action)=>{
            state.companyDetailsFetchStatus = "success";
            state.companyDetails = action.payload?.data || null;
            state.loading = false;
        }).addCase($3ca78bc7bc936865$export$2ac34acdad039cf1.rejected, (state, action)=>{
            state.companyDetailsFetchStatus = "failed";
            state.loading = false;
            state.error = action.error.message;
        })// Store or update company details
        .addCase($3ca78bc7bc936865$export$88f5d8beb5c5eed9.pending, (state)=>{
            state.companyDetailsSaveStatus = "loading";
            state.loading = true;
        }).addCase($3ca78bc7bc936865$export$88f5d8beb5c5eed9.fulfilled, (state, action)=>{
            state.companyDetailsSaveStatus = "success";
            state.companyDetails = action.payload?.data || null;
            state.loading = false;
        }).addCase($3ca78bc7bc936865$export$88f5d8beb5c5eed9.rejected, (state)=>{
            state.companyDetailsSaveStatus = "failed";
            state.loading = false;
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetCompanyDetailsStatuses: $3ca78bc7bc936865$export$653be266e86c58f0 } = $3ca78bc7bc936865$var$companyDetailsSlice.actions;
var $3ca78bc7bc936865$export$2e2bcd8739ae039 = $3ca78bc7bc936865$var$companyDetailsSlice.reducer;

});

parcelRegister("6J3qC", function(module, exports) {

$parcel$export(module.exports, "clearMessage", () => $4e599ad7cde75260$export$c2be75a38cda5942);
$parcel$export(module.exports, "default", () => $4e599ad7cde75260$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $4e599ad7cde75260$export$d2adf65b87e47523 = (0, $iDqdB.createAsyncThunk)("utility/clearCache", async ()=>{
    const res = await (0, $ivNbC.default).post("/dashboard/utility/clear-cache");
    return res.data;
});
const $4e599ad7cde75260$export$f86764b611d59708 = (0, $iDqdB.createAsyncThunk)("utility/clearHomepageCache", async ()=>{
    const res = await (0, $ivNbC.default).post("/dashboard/utility/clear-homepage-cache");
    return res.data;
});
const $4e599ad7cde75260$var$utilitySlice = (0, $iDqdB.createSlice)({
    name: "utility",
    initialState: {
        loading: false,
        error: null,
        message: null
    },
    reducers: {
        clearMessage: (state)=>{
            state.message = null;
            state.error = null;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4e599ad7cde75260$export$d2adf65b87e47523.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($4e599ad7cde75260$export$d2adf65b87e47523.fulfilled, (state, action)=>{
            state.loading = false;
            state.message = "Cache cleared successfully!";
        }).addCase($4e599ad7cde75260$export$d2adf65b87e47523.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        }).addCase($4e599ad7cde75260$export$f86764b611d59708.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($4e599ad7cde75260$export$f86764b611d59708.fulfilled, (state, action)=>{
            state.loading = false;
            state.message = "Homepage cache cleared successfully!";
        }).addCase($4e599ad7cde75260$export$f86764b611d59708.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { clearMessage: $4e599ad7cde75260$export$c2be75a38cda5942 } = $4e599ad7cde75260$var$utilitySlice.actions;
var $4e599ad7cde75260$export$2e2bcd8739ae039 = $4e599ad7cde75260$var$utilitySlice.reducer;

});

parcelRegister("2OTVO", function(module, exports) {

$parcel$export(module.exports, "getBusinessDashboard", () => $20dba3183b25fcb2$export$5666ba7ce03b8fd6);
$parcel$export(module.exports, "getBusinessDetails", () => $20dba3183b25fcb2$export$d8842388fb193136);
$parcel$export(module.exports, "updateBusinessDetails", () => $20dba3183b25fcb2$export$fda5b0f564b5d272);
$parcel$export(module.exports, "updateBusinessDiscount", () => $20dba3183b25fcb2$export$615ea53e3add1727);
$parcel$export(module.exports, "updateBusinessGallery", () => $20dba3183b25fcb2$export$fa8f86db2e9731f1);
$parcel$export(module.exports, "fetchServicesBySlug", () => $20dba3183b25fcb2$export$e200d5b024ce9507);
$parcel$export(module.exports, "fetchBusinessOwnerPaymentModes", () => $20dba3183b25fcb2$export$399e77cf2bbf2fa3);
$parcel$export(module.exports, "getTransactionSummaryReport", () => $20dba3183b25fcb2$export$f99ce1eedc56d33c);
$parcel$export(module.exports, "exportReportXlsx", () => $20dba3183b25fcb2$export$48d5d02836006eea);
$parcel$export(module.exports, "exportReportPdf", () => $20dba3183b25fcb2$export$476b080e07b2cfa0);
$parcel$export(module.exports, "getBusinessInvoicePaidMonths", () => $20dba3183b25fcb2$export$74b33d1696de79a1);
$parcel$export(module.exports, "downloadBusinessInvoice", () => $20dba3183b25fcb2$export$d9495a2d040e2f6a);
$parcel$export(module.exports, "resetUpdateStatus", () => $20dba3183b25fcb2$export$82c8c67573f5d764);
$parcel$export(module.exports, "default", () => $20dba3183b25fcb2$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");

var $i4rfT = parcelRequire("i4rfT");
const $20dba3183b25fcb2$export$5666ba7ce03b8fd6 = (0, $iDqdB.createAsyncThunk)("businessOwner/getBusinessDashboard", async ({ filter: filter = "THIS_MONTH", from: from = "", to: to = "" } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = new URLSearchParams();
        params.append("filter", filter);
        if (filter === "CUSTOM" && from && to) {
            params.append("from", from);
            params.append("to", to);
        }
        const query = params.toString();
        const url = `/dashboard/business-owner/reports/dashboard${query ? `?${query}` : ""}`;
        const res = await (0, $ivNbC.default).get(url);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch dashboard data");
    }
});
const $20dba3183b25fcb2$export$d8842388fb193136 = (0, $iDqdB.createAsyncThunk)("businessOwner/getBusinessDetails", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get("/dashboard/business-owner/business");
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch business details");
    }
});
const $20dba3183b25fcb2$export$fda5b0f564b5d272 = (0, $iDqdB.createAsyncThunk)("businessOwner/updateBusinessDetails", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put("/dashboard/business-owner/business", data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update business details");
    }
});
const $20dba3183b25fcb2$export$615ea53e3add1727 = (0, $iDqdB.createAsyncThunk)("businessOwner/updateBusinessDiscount", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put("/dashboard/business-owner/business/discount", data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update discount");
    }
});
const $20dba3183b25fcb2$export$fa8f86db2e9731f1 = (0, $iDqdB.createAsyncThunk)("businessOwner/updateBusinessGallery", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const formData = new FormData();
        // Add new gallery images
        if (data.gallery && data.gallery.length > 0) data.gallery.forEach((file, index)=>{
            if (file instanceof File) formData.append(`gallery[${index}]`, file);
            else if (file.file && !file.existing) formData.append(`gallery[${index}]`, file.file);
        });
        // Add images to remove
        if (data.remove_images && data.remove_images.length > 0) data.remove_images.forEach((imageUuid, index)=>{
            formData.append(`remove_images[${index}]`, imageUuid);
        });
        const res = await (0, $ivNbC.default).post("/dashboard/business-owner/business/gallery", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update gallery");
    }
});
const $20dba3183b25fcb2$export$1916b112c7c35950 = (0, $iDqdB.createAsyncThunk)("businessOwner/setPrimaryImage", async (imageUuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch("/business-owner/business/gallery/set-primary", {
            image_uuid: imageUuid
        });
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to set primary image");
    }
});
const $20dba3183b25fcb2$export$e200d5b024ce9507 = (0, $iDqdB.createAsyncThunk)("businessOwner/fetchServicesBySlug", async (slug, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await fetch(`${(0, $i4rfT.config).API_BASE_URL}/public/categories/${slug}/services`);
        if (!response.ok) throw new Error('Failed to fetch services');
        const data = await response.json();
        return data;
    } catch (err) {
        return rejectWithValue(err.message || "Failed to fetch services");
    }
});
const $20dba3183b25fcb2$export$399e77cf2bbf2fa3 = (0, $iDqdB.createAsyncThunk)("businessOwner/fetchPaymentModes", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get("/dashboard/business-owner/payment-modes");
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch payment modes");
    }
});
const $20dba3183b25fcb2$export$f99ce1eedc56d33c = (0, $iDqdB.createAsyncThunk)("businessOwner/getTransactionSummaryReport", async ({ year: year, month: month, from_date: from_date, to_date: to_date, per_page: per_page = 15, page: page = 1 } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = new URLSearchParams();
        if (year) params.append("year", year);
        if (month) params.append("month", month);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        if (per_page) params.append("per_page", per_page);
        if (page) params.append("page", page);
        const query = params.toString();
        const url = `/dashboard/business-owner/reports/transactions/summary${query ? `?${query}` : ""}`;
        const res = await (0, $ivNbC.default).get(url);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch transaction report");
    }
});
const $20dba3183b25fcb2$export$48d5d02836006eea = (0, $iDqdB.createAsyncThunk)("businessOwner/exportReportXlsx", async ({ year: year, month: month, from_date: from_date, to_date: to_date } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const token = localStorage.getItem("authToken");
        const params = new URLSearchParams();
        if (year) params.append("year", year);
        if (month) params.append("month", month);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        const query = params.toString();
        const url = `${(0, $i4rfT.config).API_BASE_URL}/dashboard/business-owner/reports/transactions/export${query ? `?${query}` : ""}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error("Export failed");
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        return {
            blobUrl: blobUrl,
            filename: `transactions_${year}_${month}.xlsx`
        };
    } catch (err) {
        return rejectWithValue(err.message || "Failed to export XLSX");
    }
});
const $20dba3183b25fcb2$export$476b080e07b2cfa0 = (0, $iDqdB.createAsyncThunk)("businessOwner/exportReportPdf", async ({ year: year, month: month, from_date: from_date, to_date: to_date } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const token = localStorage.getItem("authToken");
        const params = new URLSearchParams();
        if (year) params.append("year", year);
        if (month) params.append("month", month);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        const query = params.toString();
        const url = `${(0, $i4rfT.config).API_BASE_URL}/dashboard/business-owner/reports/transactions/export-pdf${query ? `?${query}` : ""}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error("Export failed");
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        return {
            blobUrl: blobUrl,
            filename: `transactions_${year}_${month}.pdf`
        };
    } catch (err) {
        return rejectWithValue(err.message || "Failed to export PDF");
    }
});
const $20dba3183b25fcb2$export$74b33d1696de79a1 = (0, $iDqdB.createAsyncThunk)("businessOwner/getBusinessInvoicePaidMonths", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get("/dashboard/business-owner/invoices/paid-months");
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to fetch invoices");
    }
});
const $20dba3183b25fcb2$export$d9495a2d040e2f6a = (0, $iDqdB.createAsyncThunk)("businessOwner/downloadBusinessInvoice", async ({ businessUuid: businessUuid, month: month, year: year, monthName: monthName }, { rejectWithValue: rejectWithValue })=>{
    try {
        const token = localStorage.getItem("authToken");
        const url = `${(0, $i4rfT.config).API_BASE_URL}/dashboard/business-owner/invoices/${businessUuid}/${month}/${year}/download`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            const errData = await response.json().catch(()=>null);
            throw new Error(errData?.message || "Invoice not available");
        }
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        return {
            blobUrl: blobUrl,
            filename: `Invoice-${monthName}-${year}.pdf`,
            month: month,
            year: year
        };
    } catch (err) {
        return rejectWithValue(err.message || "Failed to download invoice");
    }
});
const $20dba3183b25fcb2$var$businessOwnerSlice = (0, $iDqdB.createSlice)({
    name: "businessOwner",
    initialState: {
        business: null,
        dashboard: null,
        loading: false,
        dashboardLoading: false,
        error: null,
        dashboardError: null,
        updateStatus: "idle",
        updateError: null,
        services: [],
        servicesLoading: false,
        servicesError: null,
        paymentModes: [],
        paymentModesLoading: false,
        paymentModesError: null,
        // Transaction report
        report: null,
        reportLoading: false,
        reportError: null,
        exportLoading: false,
        exportError: null,
        // Invoices
        invoicePaidMonths: [],
        invoiceBusiness: null,
        invoiceLoading: false,
        invoiceError: null,
        invoiceDownloadingMap: {}
    },
    reducers: {
        resetUpdateStatus: (state)=>{
            state.updateStatus = "idle";
            state.updateError = null;
        },
        resetServicesState: (state)=>{
            state.services = [];
            state.servicesLoading = false;
            state.servicesError = null;
        }
    },
    extraReducers: (builder)=>{
        builder// Get dashboard data
        .addCase($20dba3183b25fcb2$export$5666ba7ce03b8fd6.pending, (state)=>{
            state.dashboardLoading = true;
            state.dashboardError = null;
        }).addCase($20dba3183b25fcb2$export$5666ba7ce03b8fd6.fulfilled, (state, action)=>{
            state.dashboardLoading = false;
            state.dashboard = action.payload.data;
        }).addCase($20dba3183b25fcb2$export$5666ba7ce03b8fd6.rejected, (state, action)=>{
            state.dashboardLoading = false;
            state.dashboardError = action.payload;
        })// Get business details
        .addCase($20dba3183b25fcb2$export$d8842388fb193136.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($20dba3183b25fcb2$export$d8842388fb193136.fulfilled, (state, action)=>{
            state.loading = false;
            state.business = action.payload.data;
        }).addCase($20dba3183b25fcb2$export$d8842388fb193136.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
        })// Update business details
        .addCase($20dba3183b25fcb2$export$fda5b0f564b5d272.pending, (state)=>{
            state.updateStatus = "loading";
            state.updateError = null;
        }).addCase($20dba3183b25fcb2$export$fda5b0f564b5d272.fulfilled, (state, action)=>{
            state.updateStatus = "success";
            state.business = action.payload.data;
        }).addCase($20dba3183b25fcb2$export$fda5b0f564b5d272.rejected, (state, action)=>{
            state.updateStatus = "failed";
            state.updateError = action.payload;
        })// Update discount
        .addCase($20dba3183b25fcb2$export$615ea53e3add1727.pending, (state)=>{
            state.updateStatus = "loading";
            state.updateError = null;
        }).addCase($20dba3183b25fcb2$export$615ea53e3add1727.fulfilled, (state, action)=>{
            state.updateStatus = "success";
            state.business = action.payload.data;
        }).addCase($20dba3183b25fcb2$export$615ea53e3add1727.rejected, (state, action)=>{
            state.updateStatus = "failed";
            state.updateError = action.payload;
        })// Update gallery
        .addCase($20dba3183b25fcb2$export$fa8f86db2e9731f1.pending, (state)=>{
            state.updateStatus = "loading";
            state.updateError = null;
        }).addCase($20dba3183b25fcb2$export$fa8f86db2e9731f1.fulfilled, (state, action)=>{
            state.updateStatus = "success";
        // Refresh business details after gallery update
        }).addCase($20dba3183b25fcb2$export$fa8f86db2e9731f1.rejected, (state, action)=>{
            state.updateStatus = "failed";
            state.updateError = action.payload;
        })// Set primary image
        .addCase($20dba3183b25fcb2$export$1916b112c7c35950.pending, (state)=>{
            state.updateStatus = "loading";
            state.updateError = null;
        }).addCase($20dba3183b25fcb2$export$1916b112c7c35950.fulfilled, (state, action)=>{
            state.updateStatus = "success";
        }).addCase($20dba3183b25fcb2$export$1916b112c7c35950.rejected, (state, action)=>{
            state.updateStatus = "failed";
            state.updateError = action.payload;
        })// Fetch services by slug
        .addCase($20dba3183b25fcb2$export$e200d5b024ce9507.pending, (state)=>{
            state.servicesLoading = true;
            state.servicesError = null;
        }).addCase($20dba3183b25fcb2$export$e200d5b024ce9507.fulfilled, (state, action)=>{
            state.servicesLoading = false;
            state.services = action.payload.data || [];
        }).addCase($20dba3183b25fcb2$export$e200d5b024ce9507.rejected, (state, action)=>{
            state.servicesLoading = false;
            state.servicesError = action.payload;
        })// Fetch payment modes for business owner
        .addCase($20dba3183b25fcb2$export$399e77cf2bbf2fa3.pending, (state)=>{
            state.paymentModesLoading = true;
            state.paymentModesError = null;
        }).addCase($20dba3183b25fcb2$export$399e77cf2bbf2fa3.fulfilled, (state, action)=>{
            state.paymentModesLoading = false;
            state.paymentModes = action.payload.data || [];
        }).addCase($20dba3183b25fcb2$export$399e77cf2bbf2fa3.rejected, (state, action)=>{
            state.paymentModesLoading = false;
            state.paymentModesError = action.payload;
        })// Get transaction summary report
        .addCase($20dba3183b25fcb2$export$f99ce1eedc56d33c.pending, (state)=>{
            state.reportLoading = true;
            state.reportError = null;
        }).addCase($20dba3183b25fcb2$export$f99ce1eedc56d33c.fulfilled, (state, action)=>{
            state.reportLoading = false;
            // Backend wraps response in { success, message, data: { filter, data, pagination, stats } }
            const responseData = action.payload?.data || action.payload;
            state.report = {
                data: responseData?.data || [],
                pagination: responseData?.pagination || null,
                filter: responseData?.filter || null,
                stats: responseData?.stats || null
            };
        }).addCase($20dba3183b25fcb2$export$f99ce1eedc56d33c.rejected, (state, action)=>{
            state.reportLoading = false;
            state.reportError = action.payload;
            state.report = null;
        })// Export XLSX
        .addCase($20dba3183b25fcb2$export$48d5d02836006eea.pending, (state)=>{
            state.exportLoading = true;
            state.exportError = null;
        }).addCase($20dba3183b25fcb2$export$48d5d02836006eea.fulfilled, (state)=>{
            state.exportLoading = false;
        }).addCase($20dba3183b25fcb2$export$48d5d02836006eea.rejected, (state, action)=>{
            state.exportLoading = false;
            state.exportError = action.payload;
        })// Export PDF
        .addCase($20dba3183b25fcb2$export$476b080e07b2cfa0.pending, (state)=>{
            state.exportLoading = true;
            state.exportError = null;
        }).addCase($20dba3183b25fcb2$export$476b080e07b2cfa0.fulfilled, (state)=>{
            state.exportLoading = false;
        }).addCase($20dba3183b25fcb2$export$476b080e07b2cfa0.rejected, (state, action)=>{
            state.exportLoading = false;
            state.exportError = action.payload;
        })// Get invoice paid months
        .addCase($20dba3183b25fcb2$export$74b33d1696de79a1.pending, (state)=>{
            state.invoiceLoading = true;
            state.invoiceError = null;
        }).addCase($20dba3183b25fcb2$export$74b33d1696de79a1.fulfilled, (state, action)=>{
            state.invoiceLoading = false;
            const payload = action.payload?.data || action.payload;
            state.invoicePaidMonths = payload?.paid_months || [];
            state.invoiceBusiness = payload?.business || null;
        }).addCase($20dba3183b25fcb2$export$74b33d1696de79a1.rejected, (state, action)=>{
            state.invoiceLoading = false;
            state.invoiceError = action.payload;
            state.invoicePaidMonths = [];
        })// Download invoice
        .addCase($20dba3183b25fcb2$export$d9495a2d040e2f6a.pending, (state, action)=>{
            const { month: month, year: year } = action.meta.arg;
            state.invoiceDownloadingMap[`${month}-${year}`] = true;
        }).addCase($20dba3183b25fcb2$export$d9495a2d040e2f6a.fulfilled, (state, action)=>{
            const { month: month, year: year } = action.payload;
            state.invoiceDownloadingMap[`${month}-${year}`] = false;
        }).addCase($20dba3183b25fcb2$export$d9495a2d040e2f6a.rejected, (state, action)=>{
            const { month: month, year: year } = action.meta.arg;
            state.invoiceDownloadingMap[`${month}-${year}`] = false;
        });
    }
});
const { resetUpdateStatus: $20dba3183b25fcb2$export$82c8c67573f5d764, resetServicesState: $20dba3183b25fcb2$export$907536f377030d77 } = $20dba3183b25fcb2$var$businessOwnerSlice.actions;
var $20dba3183b25fcb2$export$2e2bcd8739ae039 = $20dba3183b25fcb2$var$businessOwnerSlice.reducer;

});

parcelRegister("a3mgw", function(module, exports) {

$parcel$export(module.exports, "fetchCustomers", () => $751b74ad464d319b$export$9b3e065657c7cd2e);
$parcel$export(module.exports, "default", () => $751b74ad464d319b$export$2e2bcd8739ae039);

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $751b74ad464d319b$export$9b3e065657c7cd2e = (0, $iDqdB.createAsyncThunk)("customers/fetchCustomers", async (params = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page);
        if (params.per_page) queryParams.append('per_page', params.per_page);
        const res = await (0, $ivNbC.default).get(`/dashboard/customers?${queryParams.toString()}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch customers");
    }
});
const $751b74ad464d319b$export$1d938d1938da3b4b = (0, $iDqdB.createAsyncThunk)("customers/fetchCustomerById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/customers/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch customer details");
    }
});
const $751b74ad464d319b$var$customersSlice = (0, $iDqdB.createSlice)({
    name: "customers",
    initialState: {
        customers: [],
        pagination: null,
        customer: null,
        customerFetchStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        clearCustomer: (state)=>{
            state.customer = null;
            state.customerFetchStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($751b74ad464d319b$export$9b3e065657c7cd2e.fulfilled, (state, action)=>{
            state.customers = action.payload?.data || [];
            state.pagination = action.payload?.pagination || null;
        }).addCase($751b74ad464d319b$export$1d938d1938da3b4b.pending, (state)=>{
            state.customerFetchStatus = "loading";
        }).addCase($751b74ad464d319b$export$1d938d1938da3b4b.fulfilled, (state, action)=>{
            state.customerFetchStatus = "success";
            state.customer = action.payload.data;
        }).addCase($751b74ad464d319b$export$1d938d1938da3b4b.rejected, (state)=>{
            state.customerFetchStatus = "failed";
            state.customer = null;
        }).addMatcher((0, $iDqdB.isPending), (state)=>{
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state)=>{
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { clearCustomer: $751b74ad464d319b$export$f6b9da1d372ccd93 } = $751b74ad464d319b$var$customersSlice.actions;
var $751b74ad464d319b$export$2e2bcd8739ae039 = $751b74ad464d319b$var$customersSlice.reducer;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;


var $a3478a115f13707d$exports = {};
"use client";
"use strict";
var $a3478a115f13707d$var$se = Object.create;
var $a3478a115f13707d$var$k = Object.defineProperty;
var $a3478a115f13707d$var$ae = Object.getOwnPropertyDescriptor;
var $a3478a115f13707d$var$ie = Object.getOwnPropertyNames;
var $a3478a115f13707d$var$ne = Object.getPrototypeOf, $a3478a115f13707d$var$ce = Object.prototype.hasOwnProperty;
var $a3478a115f13707d$var$pe = (e, t)=>{
    for(var o in t)$a3478a115f13707d$var$k(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $a3478a115f13707d$var$G = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let a of $a3478a115f13707d$var$ie(t))!$a3478a115f13707d$var$ce.call(e, a) && a !== o && $a3478a115f13707d$var$k(e, a, {
        get: ()=>t[a],
        enumerable: !(s = $a3478a115f13707d$var$ae(t, a)) || s.enumerable
    });
    return e;
};
var $a3478a115f13707d$var$j = (e, t, o)=>(o = e != null ? $a3478a115f13707d$var$se($a3478a115f13707d$var$ne(e)) : {}, $a3478a115f13707d$var$G(t || !e || !e.__esModule ? $a3478a115f13707d$var$k(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $a3478a115f13707d$var$de = (e)=>$a3478a115f13707d$var$G($a3478a115f13707d$var$k({}, "__esModule", {
        value: !0
    }), e);
var $a3478a115f13707d$var$Ue = {};
$a3478a115f13707d$var$pe($a3478a115f13707d$var$Ue, {
    CheckmarkIcon: ()=>$a3478a115f13707d$var$U,
    ErrorIcon: ()=>$a3478a115f13707d$var$C,
    LoaderIcon: ()=>$a3478a115f13707d$var$L,
    ToastBar: ()=>$a3478a115f13707d$var$N,
    ToastIcon: ()=>$a3478a115f13707d$var$$,
    Toaster: ()=>$a3478a115f13707d$var$oe,
    default: ()=>$a3478a115f13707d$var$Le,
    resolveValue: ()=>$a3478a115f13707d$var$g,
    toast: ()=>$a3478a115f13707d$var$i,
    useToaster: ()=>$a3478a115f13707d$var$M,
    useToasterStore: ()=>$a3478a115f13707d$var$w
});
$a3478a115f13707d$exports = $a3478a115f13707d$var$de($a3478a115f13707d$var$Ue);
var $a3478a115f13707d$var$me = (e)=>typeof e == "function", $a3478a115f13707d$var$g = (e, t)=>$a3478a115f13707d$var$me(e) ? e(t) : e;
var $a3478a115f13707d$var$J = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $a3478a115f13707d$var$_ = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $a3478a115f13707d$var$le = 20, $a3478a115f13707d$var$Y = "default";
var $a3478a115f13707d$var$K = (e, t)=>{
    let { toastLimit: o } = e.settings;
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, o)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: s } = t;
            return $a3478a115f13707d$var$K(e, {
                type: e.toasts.find((r)=>r.id === s.id) ? 1 : 0,
                toast: s
            });
        case 3:
            let { toastId: a } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === a || a === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let n = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + n
                    }))
            };
    }
}, $a3478a115f13707d$var$V = [], $a3478a115f13707d$var$Z = {
    toasts: [],
    pausedAt: void 0,
    settings: {
        toastLimit: $a3478a115f13707d$var$le
    }
}, $a3478a115f13707d$var$T = {}, $a3478a115f13707d$var$ee = (e, t = $a3478a115f13707d$var$Y)=>{
    $a3478a115f13707d$var$T[t] = $a3478a115f13707d$var$K($a3478a115f13707d$var$T[t] || $a3478a115f13707d$var$Z, e), $a3478a115f13707d$var$V.forEach(([o, s])=>{
        o === t && s($a3478a115f13707d$var$T[t]);
    });
}, $a3478a115f13707d$var$Q = (e)=>Object.keys($a3478a115f13707d$var$T).forEach((t)=>$a3478a115f13707d$var$ee(e, t)), $a3478a115f13707d$var$te = (e)=>Object.keys($a3478a115f13707d$var$T).find((t)=>$a3478a115f13707d$var$T[t].toasts.some((o)=>o.id === e)), $a3478a115f13707d$var$P = (e = $a3478a115f13707d$var$Y)=>(t)=>{
        $a3478a115f13707d$var$ee(t, e);
    }, $a3478a115f13707d$var$ue = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $a3478a115f13707d$var$w = (e = {}, t = $a3478a115f13707d$var$Y)=>{
    let [o, s] = (0, (parcelRequire("acw62")).useState)($a3478a115f13707d$var$T[t] || $a3478a115f13707d$var$Z), a = (0, (parcelRequire("acw62")).useRef)($a3478a115f13707d$var$T[t]);
    (0, (parcelRequire("acw62")).useEffect)(()=>(a.current !== $a3478a115f13707d$var$T[t] && s($a3478a115f13707d$var$T[t]), $a3478a115f13707d$var$V.push([
            t,
            s
        ]), ()=>{
            let r = $a3478a115f13707d$var$V.findIndex(([u])=>u === t);
            r > -1 && $a3478a115f13707d$var$V.splice(r, 1);
        }), [
        t
    ]);
    let n = o.toasts.map((r)=>{
        var u, x, y;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((u = e[r.type]) == null ? void 0 : u.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((x = e[r.type]) == null ? void 0 : x.duration) || (e == null ? void 0 : e.duration) || $a3478a115f13707d$var$ue[r.type],
            style: {
                ...e.style,
                ...(y = e[r.type]) == null ? void 0 : y.style,
                ...r.style
            }
        };
    });
    return {
        ...o,
        toasts: n
    };
};
var $a3478a115f13707d$var$Te = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $a3478a115f13707d$var$J()
    }), $a3478a115f13707d$var$D = (e)=>(t, o)=>{
        let s = $a3478a115f13707d$var$Te(t, e, o);
        return $a3478a115f13707d$var$P(s.toasterId || $a3478a115f13707d$var$te(s.id))({
            type: 2,
            toast: s
        }), s.id;
    }, $a3478a115f13707d$var$i = (e, t)=>$a3478a115f13707d$var$D("blank")(e, t);
$a3478a115f13707d$var$i.error = $a3478a115f13707d$var$D("error");
$a3478a115f13707d$var$i.success = $a3478a115f13707d$var$D("success");
$a3478a115f13707d$var$i.loading = $a3478a115f13707d$var$D("loading");
$a3478a115f13707d$var$i.custom = $a3478a115f13707d$var$D("custom");
$a3478a115f13707d$var$i.dismiss = (e, t)=>{
    let o = {
        type: 3,
        toastId: e
    };
    t ? $a3478a115f13707d$var$P(t)(o) : $a3478a115f13707d$var$Q(o);
};
$a3478a115f13707d$var$i.dismissAll = (e)=>$a3478a115f13707d$var$i.dismiss(void 0, e);
$a3478a115f13707d$var$i.remove = (e, t)=>{
    let o = {
        type: 4,
        toastId: e
    };
    t ? $a3478a115f13707d$var$P(t)(o) : $a3478a115f13707d$var$Q(o);
};
$a3478a115f13707d$var$i.removeAll = (e)=>$a3478a115f13707d$var$i.remove(void 0, e);
$a3478a115f13707d$var$i.promise = (e, t, o)=>{
    let s = $a3478a115f13707d$var$i.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let n = t.success ? $a3478a115f13707d$var$g(t.success, a) : void 0;
        return n ? $a3478a115f13707d$var$i.success(n, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : $a3478a115f13707d$var$i.dismiss(s), a;
    }).catch((a)=>{
        let n = t.error ? $a3478a115f13707d$var$g(t.error, a) : void 0;
        n ? $a3478a115f13707d$var$i.error(n, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : $a3478a115f13707d$var$i.dismiss(s);
    }), e;
};

var $a3478a115f13707d$var$ye = 1e3, $a3478a115f13707d$var$M = (e, t = "default")=>{
    let { toasts: o, pausedAt: s } = $a3478a115f13707d$var$w(e, t), a = (0, (parcelRequire("acw62")).useRef)(new Map).current, n = (0, (parcelRequire("acw62")).useCallback)((c, m = $a3478a115f13707d$var$ye)=>{
        if (a.has(c)) return;
        let p = setTimeout(()=>{
            a.delete(c), r({
                type: 4,
                toastId: c
            });
        }, m);
        a.set(c, p);
    }, []);
    (0, (parcelRequire("acw62")).useEffect)(()=>{
        if (s) return;
        let c = Date.now(), m = o.map((p)=>{
            if (p.duration === 1 / 0) return;
            let I = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
            if (I < 0) {
                p.visible && $a3478a115f13707d$var$i.dismiss(p.id);
                return;
            }
            return setTimeout(()=>$a3478a115f13707d$var$i.dismiss(p.id, t), I);
        });
        return ()=>{
            m.forEach((p)=>p && clearTimeout(p));
        };
    }, [
        o,
        s,
        t
    ]);
    let r = (0, (parcelRequire("acw62")).useCallback)($a3478a115f13707d$var$P(t), [
        t
    ]), u = (0, (parcelRequire("acw62")).useCallback)(()=>{
        r({
            type: 5,
            time: Date.now()
        });
    }, [
        r
    ]), x = (0, (parcelRequire("acw62")).useCallback)((c, m)=>{
        r({
            type: 1,
            toast: {
                id: c,
                height: m
            }
        });
    }, [
        r
    ]), y = (0, (parcelRequire("acw62")).useCallback)(()=>{
        s && r({
            type: 6,
            time: Date.now()
        });
    }, [
        s,
        r
    ]), d = (0, (parcelRequire("acw62")).useCallback)((c, m)=>{
        let { reverseOrder: p = !1, gutter: I = 8, defaultPosition: X } = m || {}, W = o.filter((f)=>(f.position || X) === (c.position || X) && f.height), re = W.findIndex((f)=>f.id === c.id), q = W.filter((f, H)=>H < re && f.visible).length;
        return W.filter((f)=>f.visible).slice(...p ? [
            q + 1
        ] : [
            0,
            q
        ]).reduce((f, H)=>f + (H.height || 0) + I, 0);
    }, [
        o
    ]);
    return (0, (parcelRequire("acw62")).useEffect)(()=>{
        o.forEach((c)=>{
            if (c.dismissed) n(c.id, c.removeDelay);
            else {
                let m = a.get(c.id);
                m && (clearTimeout(m), a.delete(c.id));
            }
        });
    }, [
        o,
        n
    ]), {
        toasts: o,
        handlers: {
            updateHeight: x,
            startPause: u,
            endPause: y,
            calculateOffset: d
        }
    };
};

var $a3478a115f13707d$var$h = $a3478a115f13707d$var$j((parcelRequire("acw62")));
let $59bacf62d0c4a6b9$var$e = {
    data: ""
}, $59bacf62d0c4a6b9$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $59bacf62d0c4a6b9$var$e;
}, $59bacf62d0c4a6b9$export$54aba348a7896325 = (e)=>{
    let r = $59bacf62d0c4a6b9$var$t(e), l = r.data;
    return r.data = "", l;
}, $59bacf62d0c4a6b9$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $59bacf62d0c4a6b9$var$a = /\/\*[^]*?\*\/|  +/g, $59bacf62d0c4a6b9$var$n = /\n+/g, $59bacf62d0c4a6b9$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $59bacf62d0c4a6b9$var$o(c, n) : n + "{" + $59bacf62d0c4a6b9$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $59bacf62d0c4a6b9$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $59bacf62d0c4a6b9$var$o.p ? $59bacf62d0c4a6b9$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $59bacf62d0c4a6b9$var$c = {}, $59bacf62d0c4a6b9$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $59bacf62d0c4a6b9$var$s(e[r]);
        return t;
    }
    return e;
}, $59bacf62d0c4a6b9$var$i = (e, t, r, i, p)=>{
    let u = $59bacf62d0c4a6b9$var$s(e), d = $59bacf62d0c4a6b9$var$c[u] || ($59bacf62d0c4a6b9$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$59bacf62d0c4a6b9$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $59bacf62d0c4a6b9$var$l.exec(e.replace($59bacf62d0c4a6b9$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($59bacf62d0c4a6b9$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($59bacf62d0c4a6b9$var$n, " ").trim();
            return o[0];
        })(e);
        $59bacf62d0c4a6b9$var$c[d] = $59bacf62d0c4a6b9$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $59bacf62d0c4a6b9$var$c.g ? $59bacf62d0c4a6b9$var$c.g : null;
    return r && ($59bacf62d0c4a6b9$var$c.g = $59bacf62d0c4a6b9$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($59bacf62d0c4a6b9$var$c[d], t, i, f), d;
}, $59bacf62d0c4a6b9$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $59bacf62d0c4a6b9$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $59bacf62d0c4a6b9$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $59bacf62d0c4a6b9$var$i(l.unshift ? l.raw ? $59bacf62d0c4a6b9$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $59bacf62d0c4a6b9$var$t(r.target), r.g, r.o, r.k);
}
let $59bacf62d0c4a6b9$var$d, $59bacf62d0c4a6b9$var$f, $59bacf62d0c4a6b9$var$g, $59bacf62d0c4a6b9$export$442f1a04865e4790 = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    g: 1
}), $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    k: 1
});
function $59bacf62d0c4a6b9$export$de27182ff8187d6c(e, t, r, l) {
    $59bacf62d0c4a6b9$var$o.p = t, $59bacf62d0c4a6b9$var$d = e, $59bacf62d0c4a6b9$var$f = r, $59bacf62d0c4a6b9$var$g = l;
}
function $59bacf62d0c4a6b9$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $59bacf62d0c4a6b9$var$f && $59bacf62d0c4a6b9$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $59bacf62d0c4a6b9$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $59bacf62d0c4a6b9$var$g && i[0] && $59bacf62d0c4a6b9$var$g(c), $59bacf62d0c4a6b9$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $a3478a115f13707d$var$S = $a3478a115f13707d$var$j((parcelRequire("acw62")));


var $a3478a115f13707d$var$ge = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $a3478a115f13707d$var$he = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$xe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $a3478a115f13707d$var$C = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$ge} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$a3478a115f13707d$var$he} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$a3478a115f13707d$var$xe} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $a3478a115f13707d$var$be = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $a3478a115f13707d$var$L = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$a3478a115f13707d$var$be} 1s linear infinite;
`;

var $a3478a115f13707d$var$Se = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $a3478a115f13707d$var$Ae = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $a3478a115f13707d$var$U = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$Se} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$a3478a115f13707d$var$Ae} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $a3478a115f13707d$var$Pe = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $a3478a115f13707d$var$Re = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $a3478a115f13707d$var$Ee = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$ve = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$a3478a115f13707d$var$Ee} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $a3478a115f13707d$var$$ = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $a3478a115f13707d$var$S.createElement($a3478a115f13707d$var$ve, null, t) : t : o === "blank" ? null : $a3478a115f13707d$var$S.createElement($a3478a115f13707d$var$Re, null, $a3478a115f13707d$var$S.createElement($a3478a115f13707d$var$L, {
        ...s
    }), o !== "loading" && $a3478a115f13707d$var$S.createElement($a3478a115f13707d$var$Pe, null, o === "error" ? $a3478a115f13707d$var$S.createElement($a3478a115f13707d$var$C, {
        ...s
    }) : $a3478a115f13707d$var$S.createElement($a3478a115f13707d$var$U, {
        ...s
    })));
};
var $a3478a115f13707d$var$De = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $a3478a115f13707d$var$Oe = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $a3478a115f13707d$var$Ie = "0%{opacity:0;} 100%{opacity:1;}", $a3478a115f13707d$var$ke = "0%{opacity:1;} 100%{opacity:0;}", $a3478a115f13707d$var$_e = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $a3478a115f13707d$var$Ve = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $a3478a115f13707d$var$we = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, n] = $a3478a115f13707d$var$_() ? [
        $a3478a115f13707d$var$Ie,
        $a3478a115f13707d$var$ke
    ] : [
        $a3478a115f13707d$var$De(s),
        $a3478a115f13707d$var$Oe(s)
    ];
    return {
        animation: t ? `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(n)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $a3478a115f13707d$var$N = $a3478a115f13707d$var$h.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? $a3478a115f13707d$var$we(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, n = $a3478a115f13707d$var$h.createElement($a3478a115f13707d$var$$, {
        toast: e
    }), r = $a3478a115f13707d$var$h.createElement($a3478a115f13707d$var$Ve, {
        ...e.ariaProps
    }, $a3478a115f13707d$var$g(e.message, e));
    return $a3478a115f13707d$var$h.createElement($a3478a115f13707d$var$_e, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: n,
        message: r
    }) : $a3478a115f13707d$var$h.createElement($a3478a115f13707d$var$h.Fragment, null, n, r));
});


var $a3478a115f13707d$var$b = $a3478a115f13707d$var$j((parcelRequire("acw62")));
(0, $59bacf62d0c4a6b9$export$de27182ff8187d6c)($a3478a115f13707d$var$b.createElement);
var $a3478a115f13707d$var$Me = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let n = $a3478a115f13707d$var$b.useCallback((r)=>{
        if (r) {
            let u = ()=>{
                let x = r.getBoundingClientRect().height;
                s(e, x);
            };
            u(), new MutationObserver(u).observe(r, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $a3478a115f13707d$var$b.createElement("div", {
        ref: n,
        className: t,
        style: o
    }, a);
}, $a3478a115f13707d$var$Ce = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $a3478a115f13707d$var$_() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, $a3478a115f13707d$var$Fe = $59bacf62d0c4a6b9$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $a3478a115f13707d$var$z = 16, $a3478a115f13707d$var$oe = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, toasterId: n, containerStyle: r, containerClassName: u })=>{
    let { toasts: x, handlers: y } = $a3478a115f13707d$var$M(o, n);
    return $a3478a115f13707d$var$b.createElement("div", {
        "data-rht-toaster": n || "",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $a3478a115f13707d$var$z,
            left: $a3478a115f13707d$var$z,
            right: $a3478a115f13707d$var$z,
            bottom: $a3478a115f13707d$var$z,
            pointerEvents: "none",
            ...r
        },
        className: u,
        onMouseEnter: y.startPause,
        onMouseLeave: y.endPause
    }, x.map((d)=>{
        let c = d.position || t, m = y.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), p = $a3478a115f13707d$var$Ce(c, m);
        return $a3478a115f13707d$var$b.createElement($a3478a115f13707d$var$Me, {
            id: d.id,
            key: d.id,
            onHeightUpdate: y.updateHeight,
            className: d.visible ? $a3478a115f13707d$var$Fe : "",
            style: p
        }, d.type === "custom" ? $a3478a115f13707d$var$g(d.message, d) : a ? a(d) : $a3478a115f13707d$var$b.createElement($a3478a115f13707d$var$N, {
            toast: d,
            position: c
        }));
    }));
};
var $a3478a115f13707d$var$Le = $a3478a115f13707d$var$i;



var $iDqdB = parcelRequire("iDqdB");

var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $03cf4384aa5e191c$var$storedToken = typeof localStorage !== "undefined" ? localStorage.getItem("authToken") : null;
const $03cf4384aa5e191c$var$storedUser = typeof localStorage !== "undefined" ? localStorage.getItem("authUser") : null;
const $03cf4384aa5e191c$var$initialState = {
    token: $03cf4384aa5e191c$var$storedToken || null,
    user: $03cf4384aa5e191c$var$storedUser ? JSON.parse($03cf4384aa5e191c$var$storedUser) : null,
    isAuthenticated: Boolean($03cf4384aa5e191c$var$storedToken),
    isLoading: false,
    passwordChangeStatus: "idle"
};
const $03cf4384aa5e191c$export$905471c51c0d384d = (0, $iDqdB.createAsyncThunk)("auth/updateAdminPassword", async ({ current_password: current_password, new_password: new_password, new_password_confirmation: new_password_confirmation }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/auth/change-password", {
            current_password: current_password,
            new_password: new_password,
            new_password_confirmation: new_password_confirmation
        });
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to update password");
    }
});
const $03cf4384aa5e191c$export$5fa854eef0f83a6a = (0, $iDqdB.createAsyncThunk)("auth/updateBusinessPassword", async ({ current_password: current_password, new_password: new_password, new_password_confirmation: new_password_confirmation }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/auth/change-password", {
            current_password: current_password,
            new_password: new_password,
            new_password_confirmation: new_password_confirmation
        });
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to update password");
    }
});
const $03cf4384aa5e191c$export$a3e7cd82d8aa2d0 = (0, $iDqdB.createAsyncThunk)("auth/updateBusinessPasswordFirstTime", async ({ new_password: new_password, new_password_confirmation: new_password_confirmation }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/auth/business/update-password", {
            new_password: new_password,
            new_password_confirmation: new_password_confirmation
        });
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to update password");
    }
});
const $03cf4384aa5e191c$var$authSlice = (0, $iDqdB.createSlice)({
    name: "auth",
    initialState: $03cf4384aa5e191c$var$initialState,
    reducers: {
        setCredentials (state, action) {
            const { token: token, user: user } = action.payload || {};
            state.token = token || null;
            state.user = user || null;
            state.isAuthenticated = Boolean(token);
            if (token) localStorage.setItem("authToken", token);
            else localStorage.removeItem("authToken");
            if (user) localStorage.setItem("authUser", JSON.stringify(user));
            else localStorage.removeItem("authUser");
        },
        setLoading (state, action) {
            state.isLoading = action.payload;
        },
        logout (state) {
            state.token = null;
            state.user = null;
            state.isAuthenticated = false;
            state.isLoading = false;
            localStorage.removeItem("authToken");
            localStorage.removeItem("authUser");
            // Clear subscription data on logout
            localStorage.removeItem("business_subscription");
        },
        resetPasswordChangeStatus (state) {
            state.passwordChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Update admin password
        .addCase($03cf4384aa5e191c$export$905471c51c0d384d.pending, (state)=>{
            state.passwordChangeStatus = "loading";
            state.isLoading = true;
        }).addCase($03cf4384aa5e191c$export$905471c51c0d384d.fulfilled, (state)=>{
            state.passwordChangeStatus = "success";
            state.isLoading = false;
        }).addCase($03cf4384aa5e191c$export$905471c51c0d384d.rejected, (state)=>{
            state.passwordChangeStatus = "failed";
            state.isLoading = false;
        })// Update business password
        .addCase($03cf4384aa5e191c$export$5fa854eef0f83a6a.pending, (state)=>{
            state.passwordChangeStatus = "loading";
            state.isLoading = true;
        }).addCase($03cf4384aa5e191c$export$5fa854eef0f83a6a.fulfilled, (state)=>{
            state.passwordChangeStatus = "success";
            state.isLoading = false;
            // Clear authentication after business password change
            state.token = null;
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem("authToken");
            localStorage.removeItem("authUser");
            // Clear subscription data
            localStorage.removeItem("business_subscription");
        }).addCase($03cf4384aa5e191c$export$5fa854eef0f83a6a.rejected, (state)=>{
            state.passwordChangeStatus = "failed";
            state.isLoading = false;
        })// Update business password (first-time)
        .addCase($03cf4384aa5e191c$export$a3e7cd82d8aa2d0.pending, (state)=>{
            state.passwordChangeStatus = "loading";
            state.isLoading = true;
        }).addCase($03cf4384aa5e191c$export$a3e7cd82d8aa2d0.fulfilled, (state)=>{
            state.passwordChangeStatus = "success";
            state.isLoading = false;
            // Clear authentication after first-time business password change
            state.token = null;
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem("authToken");
            localStorage.removeItem("authUser");
            // Clear subscription data
            localStorage.removeItem("business_subscription");
        }).addCase($03cf4384aa5e191c$export$a3e7cd82d8aa2d0.rejected, (state)=>{
            state.passwordChangeStatus = "failed";
            state.isLoading = false;
        });
    }
});
const { setCredentials: $03cf4384aa5e191c$export$3a6cdb4d139acb5f, setLoading: $03cf4384aa5e191c$export$3ac708362c1f96eb, logout: $03cf4384aa5e191c$export$a0973bcfe11b05c9, resetPasswordChangeStatus: $03cf4384aa5e191c$export$c9fd3cd3e28a71a9 } = $03cf4384aa5e191c$var$authSlice.actions;
var $03cf4384aa5e191c$export$2e2bcd8739ae039 = $03cf4384aa5e191c$var$authSlice.reducer;



var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $524252bcdc82386d$export$14d3ed471e81ae25 = (0, $iDqdB.createAsyncThunk)("paymentModes/fetchPaymentModes", async (params = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const { page: page = 1, per_page: per_page = 15, status: status, search: search } = params;
        const queryParams = new URLSearchParams();
        queryParams.append("page", page);
        queryParams.append("per_page", per_page);
        if (status !== undefined) queryParams.append("status", status);
        if (search) queryParams.append("search", search);
        const res = await (0, $ivNbC.default).get(`/dashboard/payment-modes?${queryParams.toString()}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch payment modes");
    }
});
const $524252bcdc82386d$export$4d752bfeb2738c76 = (0, $iDqdB.createAsyncThunk)("paymentModes/createPaymentMode", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).post("/dashboard/payment-modes", payload);
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response.data || "Failed to create payment mode");
    }
});
const $524252bcdc82386d$export$21bfdeebc9dbb847 = (0, $iDqdB.createAsyncThunk)("paymentModes/fetchPaymentModeById", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/payment-modes/${uuid}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch payment mode details");
    }
});
const $524252bcdc82386d$export$511059e0e2893be0 = (0, $iDqdB.createAsyncThunk)("paymentModes/updatePaymentMode", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).put(`/dashboard/payment-modes/${uuid}`, data);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to update payment mode");
    }
});
const $524252bcdc82386d$export$618aee30ea370ed3 = (0, $iDqdB.createAsyncThunk)("paymentModes/deletePaymentMode", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).delete(`/dashboard/payment-modes/${uuid}`);
        return {
            uuid: uuid,
            data: res
        };
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to delete payment mode");
    }
});
const $524252bcdc82386d$export$e4f9c96ad027e489 = (0, $iDqdB.createAsyncThunk)("paymentModes/togglePaymentModeStatus", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/payment-modes/${uuid}/toggle-status`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to toggle payment mode status");
    }
});
const $524252bcdc82386d$var$paymentModesSlice = (0, $iDqdB.createSlice)({
    name: "paymentModes",
    initialState: {
        paymentModes: [],
        pagination: null,
        paymentMode: null,
        paymentModeCreateStatus: "idle",
        paymentModeUpdateStatus: "idle",
        paymentModeDeleteStatus: "idle",
        paymentModeFetchStatus: "idle",
        paymentModeStatusChangeStatus: "idle",
        loading: false,
        error: null
    },
    reducers: {
        resetPaymentModeStatuses: (state)=>{
            state.paymentModeCreateStatus = "idle";
            state.paymentModeUpdateStatus = "idle";
            state.paymentModeDeleteStatus = "idle";
            state.paymentModeStatusChangeStatus = "idle";
        }
    },
    extraReducers: (builder)=>{
        builder// Fetch payment modes
        .addCase($524252bcdc82386d$export$14d3ed471e81ae25.pending, (state)=>{
            state.loading = true;
        }).addCase($524252bcdc82386d$export$14d3ed471e81ae25.fulfilled, (state, action)=>{
            state.paymentModes = action.payload?.data || [];
            state.pagination = action.payload?.pagination || null;
            state.loading = false;
        }).addCase($524252bcdc82386d$export$14d3ed471e81ae25.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        })// Create payment mode
        .addCase($524252bcdc82386d$export$4d752bfeb2738c76.pending, (state)=>{
            state.paymentModeCreateStatus = "loading";
        }).addCase($524252bcdc82386d$export$4d752bfeb2738c76.fulfilled, (state, action)=>{
            state.paymentModeCreateStatus = "success";
            state.paymentMode = action.payload.data;
        }).addCase($524252bcdc82386d$export$4d752bfeb2738c76.rejected, (state)=>{
            state.paymentModeCreateStatus = "failed";
        })// Fetch payment mode by ID
        .addCase($524252bcdc82386d$export$21bfdeebc9dbb847.pending, (state)=>{
            state.paymentModeFetchStatus = "loading";
        }).addCase($524252bcdc82386d$export$21bfdeebc9dbb847.fulfilled, (state, action)=>{
            state.paymentModeFetchStatus = "success";
            state.paymentMode = action.payload.data;
        }).addCase($524252bcdc82386d$export$21bfdeebc9dbb847.rejected, (state)=>{
            state.paymentModeFetchStatus = "failed";
            state.paymentMode = null;
        })// Update payment mode
        .addCase($524252bcdc82386d$export$511059e0e2893be0.pending, (state)=>{
            state.paymentModeUpdateStatus = "loading";
        }).addCase($524252bcdc82386d$export$511059e0e2893be0.fulfilled, (state, action)=>{
            state.paymentModeUpdateStatus = "success";
            const index = state.paymentModes.findIndex((pm)=>pm.uuid === action.meta.arg.uuid);
            if (index !== -1) state.paymentModes[index] = action.payload.data;
            state.paymentMode = action.payload.data;
        }).addCase($524252bcdc82386d$export$511059e0e2893be0.rejected, (state)=>{
            state.paymentModeUpdateStatus = "failed";
        })// Delete payment mode
        .addCase($524252bcdc82386d$export$618aee30ea370ed3.pending, (state)=>{
            state.paymentModeDeleteStatus = "loading";
        }).addCase($524252bcdc82386d$export$618aee30ea370ed3.fulfilled, (state, action)=>{
            state.paymentModeDeleteStatus = "success";
            state.paymentModes = state.paymentModes.filter((pm)=>pm.uuid !== action.payload.uuid);
        }).addCase($524252bcdc82386d$export$618aee30ea370ed3.rejected, (state)=>{
            state.paymentModeDeleteStatus = "failed";
        })// Toggle status
        .addCase($524252bcdc82386d$export$e4f9c96ad027e489.pending, (state)=>{
            state.paymentModeStatusChangeStatus = "loading";
        }).addCase($524252bcdc82386d$export$e4f9c96ad027e489.fulfilled, (state, action)=>{
            state.paymentModeStatusChangeStatus = "success";
            const index = state.paymentModes.findIndex((pm)=>pm.uuid === action.meta.arg);
            if (index !== -1) state.paymentModes[index] = action.payload.data;
        }).addCase($524252bcdc82386d$export$e4f9c96ad027e489.rejected, (state)=>{
            state.paymentModeStatusChangeStatus = "failed";
        }).addMatcher((0, $iDqdB.isPending), (state, action)=>{
            console.log("isPending matcher triggered:", action.type);
            state.loading = true;
            state.error = null;
        }).addMatcher((0, $iDqdB.isFulfilled), (state, action)=>{
            console.log("isFulfilled matcher triggered:", action.type);
            state.loading = false;
        }).addMatcher((0, $iDqdB.isRejected), (state, action)=>{
            console.log("isRejected matcher triggered:", action.type);
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { resetPaymentModeStatuses: $524252bcdc82386d$export$943fb531692d88c9 } = $524252bcdc82386d$var$paymentModesSlice.actions;
var $524252bcdc82386d$export$2e2bcd8739ae039 = $524252bcdc82386d$var$paymentModesSlice.reducer;



var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $3b948c371c69daa7$var$initialState = {
    currentTransaction: null,
    transactionSummary: null,
    transactionHistory: [],
    historyMeta: null,
    customer: null,
    loading: false,
    summaryLoading: false,
    historyLoading: false,
    error: null,
    status: "idle",
    customerLoading: false,
    customerError: null
};
const $3b948c371c69daa7$export$714aebfec8ead7f0 = (0, $iDqdB.createAsyncThunk)("transaction/create", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).post("/dashboard/business-owner/transactions/create", data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to create transaction");
    }
});
const $3b948c371c69daa7$export$d0cfa7ae02a67905 = (0, $iDqdB.createAsyncThunk)("transaction/initiate", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).post("/dashboard/business-owner/transactions/initiate", data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to initiate transaction");
    }
});
const $3b948c371c69daa7$export$1c890677793f064d = (0, $iDqdB.createAsyncThunk)("transaction/fulfill", async ({ uuid: uuid, data: data }, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).patch(`/dashboard/business-owner/transactions/${uuid}/fulfill`, data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to fulfill transaction");
    }
});
const $3b948c371c69daa7$export$ec0c6556a09b65b8 = (0, $iDqdB.createAsyncThunk)("transaction/getTransaction", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).get(`/dashboard/business-owner/transactions/${uuid}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to get transaction");
    }
});
const $3b948c371c69daa7$export$589e52a10659e1d0 = (0, $iDqdB.createAsyncThunk)("transaction/cancel", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).patch(`/dashboard/business-owner/transactions/${uuid}/cancel`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to cancel transaction");
    }
});
const $3b948c371c69daa7$export$2a40d6cb698b9f3 = (0, $iDqdB.createAsyncThunk)("transaction/getTransactionHistory", async (params = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const queryParams = new URLSearchParams();
        // Add filter parameter (TODAY, THIS_WEEK, THIS_MONTH, LAST_MONTH, THIS_YEAR, CUSTOM)
        if (params.filter) {
            queryParams.append('filter', params.filter);
            if (params.filter === 'CUSTOM' && params.from && params.to) {
                queryParams.append('from', params.from);
                queryParams.append('to', params.to);
            }
        }
        // Add other query parameters if provided
        if (params.status) queryParams.append('status', params.status);
        if (params.search) queryParams.append('search', params.search);
        if (params.page) queryParams.append('page', params.page);
        if (params.per_page) queryParams.append('per_page', params.per_page);
        const queryString = queryParams.toString();
        const url = `/dashboard/business-owner/reports/transactions${queryString ? `?${queryString}` : ''}`;
        const response = await (0, $ivNbC.default).get(url);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to fetch transaction history");
    }
});
const $3b948c371c69daa7$export$a1b16a49f384bd24 = (0, $iDqdB.createAsyncThunk)("transaction/getTransactionSummary", async (uuid, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).get(`/dashboard/business-owner/transactions/${uuid}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to get transaction summary");
    }
});
const $3b948c371c69daa7$export$cde0caff919b1ea0 = (0, $iDqdB.createAsyncThunk)("transaction/getCustomerByMobile", async (mobile, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.default).post("/dashboard/business-owner/customers/get-by-mobile", {
            mobile: mobile
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Customer not found");
    }
});
const $3b948c371c69daa7$var$transactionSlice = (0, $iDqdB.createSlice)({
    name: "transaction",
    initialState: $3b948c371c69daa7$var$initialState,
    reducers: {
        clearTransaction: (state)=>{
            state.currentTransaction = null;
            state.transactionSummary = null;
            state.customer = null;
            state.error = null;
            state.status = "idle";
        },
        clearTransactionSummary: (state)=>{
            state.transactionSummary = null;
        },
        clearTransactionHistory: (state)=>{
            state.transactionHistory = [];
            state.historyMeta = null;
        },
        clearCustomer: (state)=>{
            state.customer = null;
            state.customerError = null;
        },
        clearError: (state)=>{
            state.error = null;
            state.customerError = null;
        }
    },
    extraReducers: (builder)=>{
        builder// Create transaction (new business flow)
        .addCase($3b948c371c69daa7$export$714aebfec8ead7f0.pending, (state)=>{
            state.loading = true;
            state.error = null;
            state.status = "loading";
        }).addCase($3b948c371c69daa7$export$714aebfec8ead7f0.fulfilled, (state, action)=>{
            state.loading = false;
            console.log('createTransaction fulfilled - action.payload:', action.payload);
            // The API returns the transaction data in action.payload.data
            state.currentTransaction = action.payload.data || action.payload;
            state.transactionSummary = action.payload.data || action.payload;
            state.status = "success";
        }).addCase($3b948c371c69daa7$export$714aebfec8ead7f0.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
            state.status = "failed";
        })// Initiate transaction (legacy for admin)
        .addCase($3b948c371c69daa7$export$d0cfa7ae02a67905.pending, (state)=>{
            state.loading = true;
            state.error = null;
            state.status = "loading";
        }).addCase($3b948c371c69daa7$export$d0cfa7ae02a67905.fulfilled, (state, action)=>{
            state.loading = false;
            console.log('initiateTransaction fulfilled - action.payload:', action.payload);
            // The API returns the transaction data in action.payload.data
            state.currentTransaction = action.payload.data || action.payload;
            state.status = "success";
        }).addCase($3b948c371c69daa7$export$d0cfa7ae02a67905.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
            state.status = "failed";
        })// Fulfill transaction
        .addCase($3b948c371c69daa7$export$1c890677793f064d.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($3b948c371c69daa7$export$1c890677793f064d.fulfilled, (state, action)=>{
            state.loading = false;
            console.log('fulfillTransaction fulfilled - action.payload:', action.payload);
            state.currentTransaction = action.payload.data || action.payload;
            state.status = "success";
        }).addCase($3b948c371c69daa7$export$1c890677793f064d.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
            state.status = "failed";
        })// Get transaction
        .addCase($3b948c371c69daa7$export$ec0c6556a09b65b8.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($3b948c371c69daa7$export$ec0c6556a09b65b8.fulfilled, (state, action)=>{
            state.loading = false;
            console.log('getTransaction fulfilled - action.payload:', action.payload);
            state.currentTransaction = action.payload.data || action.payload;
        }).addCase($3b948c371c69daa7$export$ec0c6556a09b65b8.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
        })// Cancel transaction
        .addCase($3b948c371c69daa7$export$589e52a10659e1d0.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($3b948c371c69daa7$export$589e52a10659e1d0.fulfilled, (state, action)=>{
            state.loading = false;
            console.log('cancelTransaction fulfilled - action.payload:', action.payload);
            state.currentTransaction = action.payload.data || action.payload;
            state.status = "success";
        }).addCase($3b948c371c69daa7$export$589e52a10659e1d0.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
            state.status = "failed";
        })// Get transaction history
        .addCase($3b948c371c69daa7$export$2a40d6cb698b9f3.pending, (state)=>{
            state.historyLoading = true;
            state.error = null;
        }).addCase($3b948c371c69daa7$export$2a40d6cb698b9f3.fulfilled, (state, action)=>{
            state.historyLoading = false;
            // Handle flexible response structure - accept both { data, pagination } and { data: [...], meta: {...} }
            const payload = action.payload?.data ? action.payload : {
                data: action.payload
            };
            state.transactionHistory = payload?.data || [];
            state.historyMeta = payload?.pagination || payload?.meta || null;
        }).addCase($3b948c371c69daa7$export$2a40d6cb698b9f3.rejected, (state, action)=>{
            state.historyLoading = false;
            state.error = action.payload;
            state.transactionHistory = [];
            state.historyMeta = null;
        })// Get transaction summary
        .addCase($3b948c371c69daa7$export$a1b16a49f384bd24.pending, (state)=>{
            state.summaryLoading = true;
            state.error = null;
        }).addCase($3b948c371c69daa7$export$a1b16a49f384bd24.fulfilled, (state, action)=>{
            state.summaryLoading = false;
            console.log('getTransactionSummary fulfilled - action.payload:', action.payload);
            const transactionData = action.payload.data || action.payload;
            state.transactionSummary = transactionData;
            // If this is a pending transaction, also set it as current transaction
            if (transactionData.status === 'INITIATED') {
                state.currentTransaction = transactionData;
                // Set customer data if available
                if (transactionData.customer) state.customer = transactionData.customer;
            }
        }).addCase($3b948c371c69daa7$export$a1b16a49f384bd24.rejected, (state, action)=>{
            state.summaryLoading = false;
            state.error = action.payload;
        })// Get customer by mobile
        .addCase($3b948c371c69daa7$export$cde0caff919b1ea0.pending, (state)=>{
            state.customerLoading = true;
            state.customerError = null;
        }).addCase($3b948c371c69daa7$export$cde0caff919b1ea0.fulfilled, (state, action)=>{
            state.customerLoading = false;
            console.log('getCustomerByMobile fulfilled - action.payload:', action.payload);
            // Handle different possible response structures
            state.customer = action.payload?.data || action.payload;
        }).addCase($3b948c371c69daa7$export$cde0caff919b1ea0.rejected, (state, action)=>{
            state.customerLoading = false;
            state.customerError = action.payload;
            state.customer = null;
        });
    }
});
const { clearTransaction: $3b948c371c69daa7$export$54fb1287c4db1608, clearTransactionSummary: $3b948c371c69daa7$export$7bac06fd394c3d08, clearTransactionHistory: $3b948c371c69daa7$export$3601c8ba53819021, clearCustomer: $3b948c371c69daa7$export$f6b9da1d372ccd93, clearError: $3b948c371c69daa7$export$a15ba4bdf59dacc9 } = $3b948c371c69daa7$var$transactionSlice.actions;
var $3b948c371c69daa7$export$2e2bcd8739ae039 = $3b948c371c69daa7$var$transactionSlice.reducer;



var $iDqdB = parcelRequire("iDqdB");

var $ivNbC = parcelRequire("ivNbC");
const $8c30697bb77af718$export$b6aad6b2fd350ee6 = (0, $iDqdB.createAsyncThunk)("adminReport/getAdminDashboard", async ({ month: month, year: year, district_id: district_id = "", taluka_id: taluka_id = "", category_id: category_id = "", sub_category_id: sub_category_id = "" } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);
        if (district_id) params.append("district_id", district_id);
        if (taluka_id) params.append("taluka_id", taluka_id);
        if (category_id) params.append("category_id", category_id);
        if (sub_category_id) params.append("sub_category_id", sub_category_id);
        const res = await (0, $ivNbC.default).get(`/dashboard/reports/dashboard?${params.toString()}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch admin dashboard");
    }
});
const $8c30697bb77af718$export$a036198a100a24c9 = (0, $iDqdB.createAsyncThunk)("adminReport/getAdminCommission", async (period = "month", { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).get(`/dashboard/reports/admin/commission?period=${period}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch commission report");
    }
});
const $8c30697bb77af718$export$89e3feaf0c78d9fc = (0, $iDqdB.createAsyncThunk)("adminReport/getCommissionPayments", async ({ month: month, year: year, status: status = "all", search: search = "", district_id: district_id = "", taluka_id: taluka_id = "", category_id: category_id = "", sub_category_id: sub_category_id = "", per_page: per_page = 15, page: page = 1 } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);
        if (status) params.append("status", status);
        if (search) params.append("search", search);
        if (district_id) params.append("district_id", district_id);
        if (taluka_id) params.append("taluka_id", taluka_id);
        if (category_id) params.append("category_id", category_id);
        if (sub_category_id) params.append("sub_category_id", sub_category_id);
        if (per_page) params.append("per_page", per_page);
        if (page) params.append("page", page);
        const res = await (0, $ivNbC.default).get(`/dashboard/commission-payments?${params.toString()}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch commission payments");
    }
});
const $8c30697bb77af718$export$681103cb048131c6 = (0, $iDqdB.createAsyncThunk)("adminReport/getCommissionSummary", async ({ month: month, year: year, district_id: district_id = "", taluka_id: taluka_id = "", category_id: category_id = "", sub_category_id: sub_category_id = "" } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);
        if (district_id) params.append("district_id", district_id);
        if (taluka_id) params.append("taluka_id", taluka_id);
        if (category_id) params.append("category_id", category_id);
        if (sub_category_id) params.append("sub_category_id", sub_category_id);
        const res = await (0, $ivNbC.default).get(`/dashboard/commission-payments/summary?${params.toString()}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch commission summary");
    }
});
const $8c30697bb77af718$export$4ade18399978e9ad = (0, $iDqdB.createAsyncThunk)("adminReport/toggleCommissionPayment", async ({ uuid: uuid, is_paid: is_paid }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $ivNbC.default).patch(`/dashboard/commission-payments/${uuid}/toggle-payment-status`, {
            is_paid: is_paid
        });
        return {
            ...res,
            uuid: uuid,
            is_paid: is_paid
        };
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to update payment status");
    }
});
const $8c30697bb77af718$export$52e092e766585b82 = (0, $iDqdB.createAsyncThunk)("adminReport/getAllPaidInvoices", async ({ month: month, year: year, per_page: per_page = 15, page: page = 1 } = {}, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);
        if (per_page) params.append("per_page", per_page);
        if (page) params.append("page", page);
        const res = await (0, $ivNbC.default).get(`/dashboard/invoices/paid?${params.toString()}`);
        return res;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Failed to fetch invoices");
    }
});
const $8c30697bb77af718$export$4f3db089c45274df = (0, $iDqdB.createAsyncThunk)("adminReport/downloadCommissionInvoice", async ({ businessUuid: businessUuid, month: month, year: year }, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $ivNbC.axiosInstance).get(`/dashboard/invoices/${businessUuid}/${month}/${year}/download`, {
            responseType: "blob"
        });
        // Trigger browser download
        const blob = new Blob([
            response.data
        ], {
            type: "application/pdf"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Invoice-${businessUuid}-${month}-${year}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        return {
            businessUuid: businessUuid,
            month: month,
            year: year
        };
    } catch (err) {
        // Blob error responses need special handling
        if (err.response?.data instanceof Blob) {
            const text = await err.response.data.text();
            try {
                const json = JSON.parse(text);
                return rejectWithValue(json.message || "Invoice not available for this period");
            } catch  {
                return rejectWithValue("Invoice not available for this period");
            }
        }
        return rejectWithValue(err.response?.data?.message || "Invoice not available for this period");
    }
});
// ─── Slice ───────────────────────────────────────────────────────────────────
const $8c30697bb77af718$var$adminReportSlice = (0, $iDqdB.createSlice)({
    name: "adminReport",
    initialState: {
        // Overview tab
        dashboardData: null,
        dashboardLoading: false,
        dashboardError: null,
        commissionData: null,
        commissionLoading: false,
        commissionError: null,
        // Settlements tab
        payments: [],
        paymentsPagination: null,
        paymentsFilter: null,
        paymentsLoading: false,
        paymentsError: null,
        summary: null,
        summaryLoading: false,
        summaryError: null,
        // Per-row toggle loading: { [uuid]: boolean }
        toggleLoadingMap: {},
        toggleError: null,
        // Per-row invoice download loading: { [businessUuid]: boolean }
        invoiceLoadingMap: {},
        invoiceError: null,
        // All paid invoices (admin)
        invoices: [],
        invoicesPagination: null,
        invoicesPeriod: null,
        invoicesLoading: false,
        invoicesError: null
    },
    reducers: {
        clearToggleError (state) {
            state.toggleError = null;
        },
        clearInvoiceError (state) {
            state.invoiceError = null;
        }
    },
    extraReducers: (builder)=>{
        builder// ── getAdminDashboard ──────────────────────────────────────────────
        .addCase($8c30697bb77af718$export$b6aad6b2fd350ee6.pending, (state)=>{
            state.dashboardLoading = true;
            state.dashboardError = null;
        }).addCase($8c30697bb77af718$export$b6aad6b2fd350ee6.fulfilled, (state, action)=>{
            state.dashboardLoading = false;
            state.dashboardData = action.payload?.data || action.payload;
        }).addCase($8c30697bb77af718$export$b6aad6b2fd350ee6.rejected, (state, action)=>{
            state.dashboardLoading = false;
            state.dashboardError = action.payload;
        })// ── getAdminCommission ─────────────────────────────────────────────
        .addCase($8c30697bb77af718$export$a036198a100a24c9.pending, (state)=>{
            state.commissionLoading = true;
            state.commissionError = null;
        }).addCase($8c30697bb77af718$export$a036198a100a24c9.fulfilled, (state, action)=>{
            state.commissionLoading = false;
            state.commissionData = action.payload?.data || action.payload;
        }).addCase($8c30697bb77af718$export$a036198a100a24c9.rejected, (state, action)=>{
            state.commissionLoading = false;
            state.commissionError = action.payload;
        })// ── getCommissionPayments ──────────────────────────────────────────
        .addCase($8c30697bb77af718$export$89e3feaf0c78d9fc.pending, (state)=>{
            state.paymentsLoading = true;
            state.paymentsError = null;
        }).addCase($8c30697bb77af718$export$89e3feaf0c78d9fc.fulfilled, (state, action)=>{
            state.paymentsLoading = false;
            const payload = action.payload?.data || action.payload;
            state.payments = payload?.data || [];
            state.paymentsPagination = payload?.pagination || null;
            state.paymentsFilter = payload?.filter || null;
        }).addCase($8c30697bb77af718$export$89e3feaf0c78d9fc.rejected, (state, action)=>{
            state.paymentsLoading = false;
            state.paymentsError = action.payload;
            state.payments = [];
        })// ── getCommissionSummary ───────────────────────────────────────────
        .addCase($8c30697bb77af718$export$681103cb048131c6.pending, (state)=>{
            state.summaryLoading = true;
            state.summaryError = null;
        }).addCase($8c30697bb77af718$export$681103cb048131c6.fulfilled, (state, action)=>{
            state.summaryLoading = false;
            state.summary = action.payload?.data || action.payload;
        }).addCase($8c30697bb77af718$export$681103cb048131c6.rejected, (state, action)=>{
            state.summaryLoading = false;
            state.summaryError = action.payload;
        })// ── toggleCommissionPayment ────────────────────────────────────────
        .addCase($8c30697bb77af718$export$4ade18399978e9ad.pending, (state, action)=>{
            const { uuid: uuid } = action.meta.arg;
            state.toggleLoadingMap[uuid] = true;
            state.toggleError = null;
        }).addCase($8c30697bb77af718$export$4ade18399978e9ad.fulfilled, (state, action)=>{
            const { uuid: uuid, is_paid: is_paid } = action.payload;
            state.toggleLoadingMap[uuid] = false;
            // Optimistically update the row in the payments list
            const row = state.payments.find((p)=>p.settlement?.uuid === uuid);
            if (row && row.settlement) {
                row.settlement.is_paid = is_paid;
                row.settlement.status = is_paid ? "Paid" : "Unpaid";
                row.settlement.paid_at = action.payload?.data?.settlement?.paid_at || null;
            }
        }).addCase($8c30697bb77af718$export$4ade18399978e9ad.rejected, (state, action)=>{
            const { uuid: uuid } = action.meta.arg;
            state.toggleLoadingMap[uuid] = false;
            state.toggleError = action.payload;
        })// ── getAllPaidInvoices ──────────────────────────────────────────────
        .addCase($8c30697bb77af718$export$52e092e766585b82.pending, (state)=>{
            state.invoicesLoading = true;
            state.invoicesError = null;
        }).addCase($8c30697bb77af718$export$52e092e766585b82.fulfilled, (state, action)=>{
            state.invoicesLoading = false;
            const payload = action.payload?.data || action.payload;
            state.invoices = payload?.data || [];
            state.invoicesPagination = payload?.pagination || null;
            state.invoicesPeriod = payload?.period || null;
        }).addCase($8c30697bb77af718$export$52e092e766585b82.rejected, (state, action)=>{
            state.invoicesLoading = false;
            state.invoicesError = action.payload;
            state.invoices = [];
        })// ── downloadCommissionInvoice ──────────────────────────────────────
        .addCase($8c30697bb77af718$export$4f3db089c45274df.pending, (state, action)=>{
            const { businessUuid: businessUuid } = action.meta.arg;
            state.invoiceLoadingMap[businessUuid] = true;
            state.invoiceError = null;
        }).addCase($8c30697bb77af718$export$4f3db089c45274df.fulfilled, (state, action)=>{
            const { businessUuid: businessUuid } = action.payload;
            state.invoiceLoadingMap[businessUuid] = false;
        }).addCase($8c30697bb77af718$export$4f3db089c45274df.rejected, (state, action)=>{
            const { businessUuid: businessUuid } = action.meta.arg;
            state.invoiceLoadingMap[businessUuid] = false;
            state.invoiceError = action.payload;
        });
    }
});
const { clearToggleError: $8c30697bb77af718$export$cb5b6ed699b4293, clearInvoiceError: $8c30697bb77af718$export$d76d103218205ba } = $8c30697bb77af718$var$adminReportSlice.actions;
var $8c30697bb77af718$export$2e2bcd8739ae039 = $8c30697bb77af718$var$adminReportSlice.reducer;
















const $6a862eba3a58be75$export$6f57813fe9f31bf9 = (0, $iDqdB.configureStore)({
    reducer: {
        auth: (0, $03cf4384aa5e191c$export$2e2bcd8739ae039),
        transaction: (0, $3b948c371c69daa7$export$2e2bcd8739ae039),
        adminReport: (0, $8c30697bb77af718$export$2e2bcd8739ae039),
        common: (parcelRequire("bVR6A")).default,
        shop: (parcelRequire("i32x1")).default,
        banner: (parcelRequire("lHUkp")).default,
        categories: (parcelRequire("3iTov")).default,
        subCategories: (parcelRequire("1vvaG")).default,
        categoryServices: (parcelRequire("uGwQ1")).default,
        states: (parcelRequire("5vhYX")).default,
        districts: (parcelRequire("bG6ee")).default,
        talukas: (parcelRequire("824th")).default,
        subscriptionPackages: (parcelRequire("bGldA")).default,
        paymentModes: (0, $524252bcdc82386d$export$2e2bcd8739ae039),
        companyDetails: (parcelRequire("5cRsT")).default,
        utility: (parcelRequire("6J3qC")).default,
        businessOwner: (parcelRequire("2OTVO")).default,
        customers: (parcelRequire("a3mgw")).default
    },
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "persist/PERSIST"
                ]
            }
        })
});
var $6a862eba3a58be75$export$2e2bcd8739ae039 = $6a862eba3a58be75$export$6f57813fe9f31bf9;



parcelRequire("acw62");
/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $88e75a6fb6edc067$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
];
const $88e75a6fb6edc067$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("activity", $88e75a6fb6edc067$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-alert", $5415d98bde6b29f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1cfbd1e8d8b150cb$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "18",
            x2: "18",
            y1: "20",
            y2: "10",
            key: "1xfpm4"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "20",
            y2: "4",
            key: "be30l9"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6",
            y1: "20",
            y2: "14",
            key: "1r4le6"
        }
    ]
];
const $1cfbd1e8d8b150cb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chart-no-axes-column", $1cfbd1e8d8b150cb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $29f89703686dcaa9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 3h12",
            key: "ggurg9"
        }
    ],
    [
        "path",
        {
            d: "M6 8h12",
            key: "6g4wlu"
        }
    ],
    [
        "path",
        {
            d: "m6 13 8.5 8",
            key: "u1kupk"
        }
    ],
    [
        "path",
        {
            d: "M6 13h3",
            key: "wdp6ag"
        }
    ],
    [
        "path",
        {
            d: "M9 13c6.667 0 6.667-10 0-10",
            key: "1nkvk2"
        }
    ]
];
const $29f89703686dcaa9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("indian-rupee", $29f89703686dcaa9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("loader-circle", $39f04136db3724b2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b97e024910b40ff$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "5",
            y2: "19",
            key: "1x9vlm"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "6.5",
            r: "2.5",
            key: "4mh3h7"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "2.5",
            key: "1mdrzq"
        }
    ]
];
const $7b97e024910b40ff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("percent", $7b97e024910b40ff$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ee6f13a46cf9100a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
const $ee6f13a46cf9100a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shopping-cart", $ee6f13a46cf9100a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f17d085e2e0469d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5",
            key: "slp6dd"
        }
    ],
    [
        "path",
        {
            d: "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
            key: "o0xfot"
        }
    ],
    [
        "path",
        {
            d: "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05",
            key: "wn3emo"
        }
    ]
];
const $3f17d085e2e0469d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("store", $3f17d085e2e0469d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9921f4f81a419f0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trending-up", $c9921f4f81a419f0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $993a4e0d8b7d2457$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978",
            key: "1n3hpd"
        }
    ],
    [
        "path",
        {
            d: "M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978",
            key: "rfe1zi"
        }
    ],
    [
        "path",
        {
            d: "M18 9h1.5a1 1 0 0 0 0-5H18",
            key: "7xy6bh"
        }
    ],
    [
        "path",
        {
            d: "M4 22h16",
            key: "57wxv0"
        }
    ],
    [
        "path",
        {
            d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z",
            key: "1mhfuq"
        }
    ],
    [
        "path",
        {
            d: "M6 9H4.5a1 1 0 0 1 0-5H6",
            key: "tex48p"
        }
    ]
];
const $993a4e0d8b7d2457$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trophy", $993a4e0d8b7d2457$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $09365e579c2377bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "19",
            y1: "8",
            y2: "14",
            key: "1bvyxn"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "11",
            y2: "11",
            key: "1shjgl"
        }
    ]
];
const $09365e579c2377bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-plus", $09365e579c2377bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c38b5b11d1e2b813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $c38b5b11d1e2b813$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("users", $c38b5b11d1e2b813$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");

var $ivNbC = parcelRequire("ivNbC");
const $aa3a63da9f164658$export$f9dd9d24dc1b941 = ({ district_id: district_id = "", category_id: category_id = "" } = {})=>{
    const [districts, setDistricts] = (0, $acw62.useState)([]);
    const [talukas, setTalukas] = (0, $acw62.useState)([]);
    const [categories, setCategories] = (0, $acw62.useState)([]);
    const [subCategories, setSubCategories] = (0, $acw62.useState)([]);
    const [subCategoriesLoading, setSubCategoriesLoading] = (0, $acw62.useState)(false);
    // Load districts and categories on mount
    (0, $acw62.useEffect)(()=>{
        (0, $ivNbC.default).get("/public/districts").then((res)=>{
            setDistricts(res.data || []);
        }).catch(()=>setDistricts([]));
        (0, $ivNbC.default).get("/public/categories").then((res)=>{
            setCategories(res.data || []);
        }).catch(()=>setCategories([]));
    }, []);
    // Load talukas when district changes
    (0, $acw62.useEffect)(()=>{
        if (district_id) (0, $ivNbC.default).get(`/public/districts/${district_id}/talukas`).then((res)=>{
            setTalukas(res.data || []);
        }).catch(()=>setTalukas([]));
        else setTalukas([]);
    }, [
        district_id
    ]);
    // Load sub-categories when category changes
    (0, $acw62.useEffect)(()=>{
        if (category_id) {
            setSubCategoriesLoading(true);
            const category = categories.find((c)=>c.uuid === category_id);
            if (category?.slug) (0, $ivNbC.default).get(`/public/categories/${category.slug}/sub-categories`).then((res)=>{
                setSubCategories(res.data || []);
                setSubCategoriesLoading(false);
            }).catch(()=>{
                setSubCategories([]);
                setSubCategoriesLoading(false);
            });
            else {
                setSubCategories([]);
                setSubCategoriesLoading(false);
            }
        } else setSubCategories([]);
    }, [
        category_id,
        categories
    ]);
    return {
        districts: districts,
        talukas: talukas,
        categories: categories,
        subCategories: subCategories,
        subCategoriesLoading: subCategoriesLoading
    };
};
var $aa3a63da9f164658$export$2e2bcd8739ae039 = $aa3a63da9f164658$export$f9dd9d24dc1b941;



var $acw62 = parcelRequire("acw62");

const $b316e3322c39850e$export$efa05b9051b74a76 = (defaultFilters = {}, { numberFields: numberFields = [] } = {})=>{
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    // Initialize filters from URL, falling back to defaults
    const [filters, setFilters] = (0, $acw62.useState)(()=>{
        const initial = {
            ...defaultFilters
        };
        for (const key of Object.keys(defaultFilters)){
            const urlValue = searchParams.get(key);
            if (urlValue !== null && urlValue !== "") initial[key] = numberFields.includes(key) ? Number(urlValue) : urlValue;
        }
        return initial;
    });
    // Sync filters to URL whenever they change
    (0, $acw62.useEffect)(()=>{
        const params = {};
        for (const [key, value] of Object.entries(filters))// Only include non-default, non-empty values in URL
        if (value !== "" && value !== defaultFilters[key]) params[key] = String(value);
        // Preserve page param if it exists and isn't being managed by filters
        const page = searchParams.get("page");
        if (page && page !== "1" && !("page" in defaultFilters)) params.page = page;
        setSearchParams(params, {
            replace: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters
    ]);
    // Update a single filter (resets dependent fields)
    const updateFilter = (0, $acw62.useCallback)((key, value)=>{
        setFilters((prev)=>{
            const updated = {
                ...prev,
                [key]: value
            };
            if (key === "district_id") updated.taluka_id = "";
            if (key === "category_id") updated.sub_category_id = "";
            return updated;
        });
        // Reset page to 1 on filter change (except search — handled by debounce)
        if (key !== "search") setSearchParams((prev)=>{
            const params = Object.fromEntries(prev.entries());
            params.page = "1";
            return params;
        }, {
            replace: true
        });
    }, [
        setSearchParams
    ]);
    // Reset all filters to defaults
    const resetFilters = (0, $acw62.useCallback)(()=>{
        setFilters({
            ...defaultFilters
        });
        setSearchParams({
            page: "1"
        }, {
            replace: true
        });
    }, [
        defaultFilters,
        setSearchParams
    ]);
    // Get current page from URL
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    // Set page in URL
    const setPage = (0, $acw62.useCallback)((page)=>{
        setSearchParams((prev)=>{
            const params = Object.fromEntries(prev.entries());
            params.page = String(page);
            return params;
        }, {
            replace: true
        });
    }, [
        setSearchParams
    ]);
    return {
        filters: filters,
        updateFilter: updateFilter,
        resetFilters: resetFilters,
        currentPage: currentPage,
        setPage: setPage
    };
};
var $b316e3322c39850e$export$2e2bcd8739ae039 = $b316e3322c39850e$export$efa05b9051b74a76;



/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6e669e1fd7e7ff8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $c6e669e1fd7e7ff8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rotate-ccw", $c6e669e1fd7e7ff8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);


// ─── constants ───────────────────────────────────────────────────────────────
const $9ab5dd6ff469aedd$export$f9a766aa2475e8ba = [
    {
        value: 1,
        label: "January"
    },
    {
        value: 2,
        label: "February"
    },
    {
        value: 3,
        label: "March"
    },
    {
        value: 4,
        label: "April"
    },
    {
        value: 5,
        label: "May"
    },
    {
        value: 6,
        label: "June"
    },
    {
        value: 7,
        label: "July"
    },
    {
        value: 8,
        label: "August"
    },
    {
        value: 9,
        label: "September"
    },
    {
        value: 10,
        label: "October"
    },
    {
        value: 11,
        label: "November"
    },
    {
        value: 12,
        label: "December"
    }
];
const $9ab5dd6ff469aedd$var$now = new Date();
const $9ab5dd6ff469aedd$var$currentYear = $9ab5dd6ff469aedd$var$now.getFullYear();
const $9ab5dd6ff469aedd$export$17bc28c2fa7cc78 = Array.from({
    length: $9ab5dd6ff469aedd$var$currentYear - 2023
}, (_, i)=>$9ab5dd6ff469aedd$var$currentYear - i);
function $9ab5dd6ff469aedd$export$2e2bcd8739ae039({ filters: filters = {}, onFilterChange: onFilterChange, onReset: onReset, dropdowns: dropdowns = {}, showFields: showFields = [
    "year",
    "month",
    "district",
    "taluka",
    "category",
    "sub_category"
], statusOptions: statusOptions = [], searchPlaceholder: searchPlaceholder = "Business name or email\u2026" }) {
    const { districts: districts = [], talukas: talukas = [], categories: categories = [], subCategories: subCategories = [], subCategoriesLoading: subCategoriesLoading = false } = dropdowns;
    const show = (field)=>showFields.includes(field);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-7 gap-3 items-end",
        children: [
            show("year") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Year"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: filters.year || "",
                        onChange: (e)=>onFilterChange("year", Number(e.target.value)),
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[90px]",
                        children: $9ab5dd6ff469aedd$export$17bc28c2fa7cc78.map((y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: y,
                                children: y
                            }, y))
                    })
                ]
            }),
            show("month") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Month"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: filters.month || "",
                        onChange: (e)=>onFilterChange("month", Number(e.target.value)),
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[120px]",
                        children: $9ab5dd6ff469aedd$export$f9a766aa2475e8ba.filter((m)=>{
                            if ((filters.year || $9ab5dd6ff469aedd$var$currentYear) < $9ab5dd6ff469aedd$var$currentYear) return true;
                            return m.value <= $9ab5dd6ff469aedd$var$now.getMonth() + 1;
                        }).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: m.value,
                                children: m.label
                            }, m.value))
                    })
                ]
            }),
            show("status") && statusOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Status"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: filters.status || "all",
                        onChange: (e)=>onFilterChange("status", e.target.value),
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[100px]",
                        children: statusOptions.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: s.value,
                                children: s.label
                            }, s.value))
                    })
                ]
            }),
            show("district") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "District"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: filters.district_id || "",
                        onChange: (e)=>onFilterChange("district_id", e.target.value),
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[120px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "All Districts"
                            }),
                            districts.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: d.uuid,
                                    children: d.name
                                }, d.uuid))
                        ]
                    })
                ]
            }),
            show("taluka") && filters.district_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Taluka"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: filters.taluka_id || "",
                        onChange: (e)=>onFilterChange("taluka_id", e.target.value),
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[120px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "All Talukas"
                            }),
                            talukas.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: t.uuid,
                                    children: t.name
                                }, t.uuid))
                        ]
                    })
                ]
            }),
            show("category") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Category"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: filters.category_id || "",
                        onChange: (e)=>onFilterChange("category_id", e.target.value),
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[120px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "All Categories"
                            }),
                            categories.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: c.uuid,
                                    children: c.name
                                }, c.uuid))
                        ]
                    })
                ]
            }),
            show("sub_category") && filters.category_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Sub-Category"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: filters.sub_category_id || "",
                        onChange: (e)=>onFilterChange("sub_category_id", e.target.value),
                        disabled: subCategoriesLoading,
                        className: "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[120px] disabled:opacity-50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "All Sub-Categories"
                            }),
                            subCategories.map((sc)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: sc.uuid,
                                    children: sc.name
                                }, sc.uuid))
                        ]
                    })
                ]
            }),
            show("search") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1 col-span-2 sm:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-xs text-gray-500 font-semibold uppercase tracking-wide",
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: searchPlaceholder,
                                        value: filters.search || "",
                                        onChange: (e)=>onFilterChange("search", e.target.value),
                                        className: "pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onReset,
                                className: "p-2 text-gray-400 hover:text-orange-600 hover:bg-orange-50 rounded-lg transition-colors",
                                title: "Reset filters",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: onReset,
                className: "p-2 text-gray-400 hover:text-orange-600 hover:bg-orange-50 rounded-lg transition-colors self-end justify-self-start",
                title: "Reset filters",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                    className: "h-4 w-4"
                })
            })
        ]
    });
}


// ─── constants ───────────────────────────────────────────────────────────────
const $ff172fa0860d2cf4$var$now = new Date();
const $ff172fa0860d2cf4$var$currentYear = $ff172fa0860d2cf4$var$now.getFullYear();
const $ff172fa0860d2cf4$var$currentMonth = $ff172fa0860d2cf4$var$now.getMonth() + 1;
const $ff172fa0860d2cf4$var$defaultMonth = $ff172fa0860d2cf4$var$currentMonth === 1 ? 12 : $ff172fa0860d2cf4$var$currentMonth - 1;
const $ff172fa0860d2cf4$var$defaultYear = $ff172fa0860d2cf4$var$currentMonth === 1 ? $ff172fa0860d2cf4$var$currentYear - 1 : $ff172fa0860d2cf4$var$currentYear;
const $ff172fa0860d2cf4$var$DEFAULT_FILTERS = {
    month: $ff172fa0860d2cf4$var$defaultMonth,
    year: $ff172fa0860d2cf4$var$defaultYear,
    district_id: "",
    taluka_id: "",
    category_id: "",
    sub_category_id: ""
};
// ─── helpers ─────────────────────────────────────────────────────────────────
const $ff172fa0860d2cf4$var$fmt = (amount)=>new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount || 0);
const $ff172fa0860d2cf4$var$num = (v)=>(v ?? 0).toLocaleString("en-IN");
// ─── sub-components ──────────────────────────────────────────────────────────
function $ff172fa0860d2cf4$var$KpiCard({ icon: Icon, label: label, value: value, sub: sub, iconBg: iconBg, textColor: textColor }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-lg p-4 border border-gray-200 shadow-sm flex items-start space-x-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${iconBg} p-2.5 rounded-lg flex-shrink-0`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    className: `h-5 w-5 ${textColor}`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 uppercase tracking-wide font-medium",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `text-lg font-bold ${textColor} mt-0.5`,
                        children: value
                    }),
                    sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-400 mt-0.5",
                        children: sub
                    })
                ]
            })
        ]
    });
}
function $ff172fa0860d2cf4$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { dashboardData: dashboardData, dashboardLoading: dashboardLoading, dashboardError: dashboardError } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.adminReport);
    // ── filters (synced with URL) ──────────────────────────────────────────────
    const { filters: filters, updateFilter: updateFilter, resetFilters: resetFilters } = (0, $b316e3322c39850e$export$2e2bcd8739ae039)($ff172fa0860d2cf4$var$DEFAULT_FILTERS, {
        numberFields: [
            "month",
            "year"
        ]
    });
    // ── dropdown data (reusable hook) ──────────────────────────────────────────
    const dropdowns = (0, $aa3a63da9f164658$export$2e2bcd8739ae039)({
        district_id: filters.district_id,
        category_id: filters.category_id
    });
    // ── fetch dashboard ────────────────────────────────────────────────────────
    const fetchDashboard = (0, $acw62.useCallback)((currentFilters = filters)=>{
        dispatch((0, $8c30697bb77af718$export$b6aad6b2fd350ee6)(currentFilters));
    }, [
        dispatch,
        filters
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchDashboard(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.month,
        filters.year,
        filters.district_id,
        filters.taluka_id,
        filters.category_id,
        filters.sub_category_id
    ]);
    // ── filter actions ─────────────────────────────────────────────────────────
    const handleRefresh = ()=>fetchDashboard(filters);
    // ── derived data ───────────────────────────────────────────────────────────
    const period = dashboardData?.period || {};
    const summary = dashboardData?.summary || {};
    const liveStats = dashboardData?.live_statistics || {};
    const topBusinesses = dashboardData?.top_performing_businesses || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-blue-100 p-2 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 sm:h-7 sm:w-7 text-blue-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-xl sm:text-2xl font-bold text-gray-900",
                                            children: "Dashboard"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs sm:text-sm text-gray-500",
                                            children: [
                                                "Overview for ",
                                                period.formatted || `${period.month_name || ""} ${period.year || ""}`
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleRefresh,
                            disabled: dashboardLoading,
                            className: "self-end sm:self-auto p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-40",
                            title: "Refresh",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                className: `h-5 w-5 ${dashboardLoading ? "animate-spin" : ""}`
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab5dd6ff469aedd$export$2e2bcd8739ae039), {
                    filters: filters,
                    onFilterChange: updateFilter,
                    onReset: resetFilters,
                    dropdowns: dropdowns,
                    showFields: [
                        "year",
                        "month",
                        "district",
                        "taluka",
                        "category",
                        "sub_category"
                    ]
                })
            }),
            dashboardLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-center py-20 gap-3 text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 animate-spin text-blue-500"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Loading dashboard\u2026"
                    })
                ]
            }) : dashboardError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-center justify-center py-20 gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                        className: "h-10 w-10 text-red-400"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-600",
                        children: "Failed to load dashboard data."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: handleRefresh,
                        className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-colors",
                        children: "Try Again"
                    })
                ]
            }) : dashboardData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-green-500"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-base font-semibold text-gray-900",
                                        children: "Live Statistics (Today)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $ee6f13a46cf9100a$export$2e2bcd8739ae039),
                                        label: "Transactions Today",
                                        value: $ff172fa0860d2cf4$var$num(liveStats.transactions_done_today),
                                        iconBg: "bg-blue-100",
                                        textColor: "text-blue-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
                                        label: "Transaction Amount",
                                        value: $ff172fa0860d2cf4$var$fmt(liveStats.total_transaction_amount_today),
                                        iconBg: "bg-purple-100",
                                        textColor: "text-purple-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $7b97e024910b40ff$export$2e2bcd8739ae039),
                                        label: "Commission Today",
                                        value: $ff172fa0860d2cf4$var$fmt(liveStats.commission_today),
                                        iconBg: "bg-orange-100",
                                        textColor: "text-orange-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $09365e579c2377bf$export$2e2bcd8739ae039),
                                        label: "New Customers",
                                        value: $ff172fa0860d2cf4$var$num(liveStats.new_customers_today),
                                        iconBg: "bg-green-100",
                                        textColor: "text-green-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
                                        label: "Businesses Joined",
                                        value: $ff172fa0860d2cf4$var$num(liveStats.businesses_joined_today),
                                        iconBg: "bg-teal-100",
                                        textColor: "text-teal-600"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-base font-semibold text-gray-900 mb-4",
                                children: [
                                    "Monthly Summary \u2014 ",
                                    period.formatted || `${period.month_name || ""} ${period.year || ""}`
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
                                        label: "Total Businesses",
                                        value: $ff172fa0860d2cf4$var$num(summary.total_businesses),
                                        iconBg: "bg-gray-100",
                                        textColor: "text-gray-700"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                                        label: "Active Businesses",
                                        value: $ff172fa0860d2cf4$var$num(summary.active_businesses),
                                        iconBg: "bg-blue-100",
                                        textColor: "text-blue-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
                                        label: "New Businesses",
                                        value: $ff172fa0860d2cf4$var$num(summary.new_businesses),
                                        iconBg: "bg-emerald-100",
                                        textColor: "text-emerald-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                                        label: "Total Customers",
                                        value: $ff172fa0860d2cf4$var$num(summary.total_customers),
                                        iconBg: "bg-indigo-100",
                                        textColor: "text-indigo-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $ee6f13a46cf9100a$export$2e2bcd8739ae039),
                                        label: "Transactions Done",
                                        value: $ff172fa0860d2cf4$var$num(summary.total_transactions_done),
                                        iconBg: "bg-purple-100",
                                        textColor: "text-purple-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
                                        label: "Total Revenue",
                                        value: $ff172fa0860d2cf4$var$fmt(summary.total_revenue),
                                        iconBg: "bg-green-100",
                                        textColor: "text-green-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
                                        label: "Discount Given",
                                        value: $ff172fa0860d2cf4$var$fmt(summary.total_discount_given),
                                        iconBg: "bg-yellow-100",
                                        textColor: "text-yellow-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff172fa0860d2cf4$var$KpiCard, {
                                        icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
                                        label: "Connectri Commission",
                                        value: $ff172fa0860d2cf4$var$fmt(summary.connectri_commission),
                                        iconBg: "bg-orange-100",
                                        textColor: "text-orange-600"
                                    })
                                ]
                            })
                        ]
                    }),
                    topBusinesses.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 sm:p-6 border-b border-gray-100 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $993a4e0d8b7d2457$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-yellow-500"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-base font-semibold text-gray-900",
                                                children: "Top Performing Businesses"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>navigate("/reports"),
                                        className: "px-3 py-1.5 text-xs font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors",
                                        children: "View All Businesses"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overflow-x-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "w-full text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            className: "bg-gray-50 border-b border-gray-200",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: [
                                                    "#",
                                                    "Business",
                                                    "District",
                                                    "Category",
                                                    "Revenue",
                                                    "Transactions",
                                                    "Commission"
                                                ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                                        children: col
                                                    }, col))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            className: "bg-white divide-y divide-gray-100",
                                            children: topBusinesses.map((biz)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "hover:bg-gray-50 transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                            children: biz.rank
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900 whitespace-nowrap",
                                                                children: biz.business_name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                            children: biz.district?.name || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                            children: biz.category?.name || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 font-semibold text-gray-900 whitespace-nowrap",
                                                            children: $ff172fa0860d2cf4$var$fmt(biz.total_revenue)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-gray-700 whitespace-nowrap",
                                                            children: $ff172fa0860d2cf4$var$num(biz.transaction_count)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 font-bold text-orange-600 whitespace-nowrap",
                                                            children: $ff172fa0860d2cf4$var$fmt(biz.connectri_commission)
                                                        })
                                                    ]
                                                }, biz.business_uuid))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-center justify-center py-20 gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                        className: "h-12 w-12 text-gray-300"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-500 font-medium",
                        children: "No data available"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $b552d0b73e8c29fd$export$21805fee57372823(value, delay = 500) {
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
var $b552d0b73e8c29fd$export$2e2bcd8739ae039 = $b552d0b73e8c29fd$export$21805fee57372823;


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $737c279b45d43939$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
            key: "1m0v6g"
        }
    ],
    [
        "path",
        {
            d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
            key: "ohrbg2"
        }
    ]
];
const $737c279b45d43939$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("square-pen", $737c279b45d43939$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye", $b285ef0f6f9bf8bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b0408904748dc3b8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const $b0408904748dc3b8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("funnel", $b0408904748dc3b8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5f4bdaa89ec695b9$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            key: "1m3agn"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ]
];
const $5f4bdaa89ec695b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("image", $5f4bdaa89ec695b9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("x", $cfb3b3013a649f15$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");
// src/primitive.tsx
var $b4e9a20689651e16$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $b4e9a20689651e16$export$f21a1ffae260145a(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $b4e9a20689651e16$export$b204af158042fbac(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $b4e9a20689651e16$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b4e9a20689651e16$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($b4e9a20689651e16$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b4e9a20689651e16$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b4e9a20689651e16$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $b4e9a20689651e16$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}


// packages/react/compose-refs/src/compose-refs.tsx

var $acw62 = parcelRequire("acw62");
function $fb3356a19a5676fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $fb3356a19a5676fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $fb3356a19a5676fa$var$setRef(refs[i], null);
            }
        };
    };
}
function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/create-context.tsx

var $acw62 = parcelRequire("acw62");

function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $45e038b71f97d914$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $45e038b71f97d914$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $b68d88740313b08e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


var $11885ec535b13ccc$var$useReactId = $acw62[" useId ".trim().toString()] || (()=>void 0);
var $11885ec535b13ccc$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$useReactId());
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($11885ec535b13ccc$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");

// src/use-effect-event.tsx


var $acw62 = parcelRequire("acw62");
var $07b0b1ce13d5e29f$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $07b0b1ce13d5e29f$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $07b0b1ce13d5e29f$export$7f54fc3180508a52(callback) {
    if (typeof $07b0b1ce13d5e29f$var$useReactEffectEvent === "function") return $07b0b1ce13d5e29f$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $07b0b1ce13d5e29f$var$useReactInsertionEffect === "function") $07b0b1ce13d5e29f$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $aef12de5508fd46e$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $b68d88740313b08e$export$e5c5a5f917a5871c);
function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $aef12de5508fd46e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $aef12de5508fd46e$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $aef12de5508fd46e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $aef12de5508fd46e$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $aef12de5508fd46e$var$isFunction(value) {
    return typeof value === "function";
}
var $aef12de5508fd46e$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $aef12de5508fd46e$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $07b0b1ce13d5e29f$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $aef12de5508fd46e$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $aef12de5508fd46e$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $acw62 = parcelRequire("acw62");

// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// src/slot.tsx

var $acw62 = parcelRequire("acw62");


// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $cf381de56a25bc52$var$createSlotClone(ownerName);
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $acw62.Children.toArray(children);
        const slottable = childrenArray.find($cf381de56a25bc52$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                    return $acw62.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $cf381de56a25bc52$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $cf381de56a25bc52$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$var$createSlotClone(ownerName) {
    const SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($acw62.isValidElement(children)) {
            const childrenRef = $cf381de56a25bc52$var$getElementRef(children);
            const props2 = $cf381de56a25bc52$var$mergeProps(slotProps, children.props);
            if (children.type !== $acw62.Fragment) props2.ref = forwardedRef ? (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $acw62.cloneElement(children, props2);
        }
        return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $cf381de56a25bc52$export$bf68c29d8281d0f7("Slottable");
function $cf381de56a25bc52$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
}
function $cf381de56a25bc52$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $cf381de56a25bc52$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



var $60b09b6752107c03$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $60b09b6752107c03$export$250ffa63cdc0d034 = $60b09b6752107c03$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $60b09b6752107c03$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $60b09b6752107c03$export$be92b6f5f03c0fe9 = $60b09b6752107c03$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/use-callback-ref.tsx

var $acw62 = parcelRequire("acw62");
function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/use-escape-keydown.tsx

var $acw62 = parcelRequire("acw62");

function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $30a399657994b369$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $30a399657994b369$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $30a399657994b369$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $30a399657994b369$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $30a399657994b369$var$originalBodyPointerEvents;
var $30a399657994b369$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $30a399657994b369$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $30a399657994b369$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $30a399657994b369$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $322b9f9e9e453dd6$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $30a399657994b369$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $30a399657994b369$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $60b09b6752107c03$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$30a399657994b369$export$177fb62ff3ec1f22.displayName = $30a399657994b369$var$DISMISSABLE_LAYER_NAME;
var $30a399657994b369$var$BRANCH_NAME = "DismissableLayerBranch";
var $30a399657994b369$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $60b09b6752107c03$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$30a399657994b369$export$4d5eb2109db14228.displayName = $30a399657994b369$var$BRANCH_NAME;
function $30a399657994b369$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $30a399657994b369$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $60b09b6752107c03$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
var $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");

// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $23522668dab07d97$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $23522668dab07d97$export$250ffa63cdc0d034 = $23522668dab07d97$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $23522668dab07d97$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $23522668dab07d97$export$be92b6f5f03c0fe9 = $23522668dab07d97$export$250ffa63cdc0d034;




"use client";
var $03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $03c48a27777929a8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $03c48a27777929a8$var$FOCUS_SCOPE_NAME = "FocusScope";
var $03c48a27777929a8$export$20e40289641fbbb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $03c48a27777929a8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$focusFirst($03c48a27777929a8$var$removeLinks($03c48a27777929a8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                    container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $23522668dab07d97$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$03c48a27777929a8$export$20e40289641fbbb6.displayName = $03c48a27777929a8$var$FOCUS_SCOPE_NAME;
function $03c48a27777929a8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $03c48a27777929a8$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $03c48a27777929a8$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $03c48a27777929a8$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$03c48a27777929a8$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $03c48a27777929a8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$isSelectableInput(element) && select) element.select();
    }
}
var $03c48a27777929a8$var$focusScopesStack = $03c48a27777929a8$var$createFocusScopesStack();
function $03c48a27777929a8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $03c48a27777929a8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $32881c7faf57716d$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $32881c7faf57716d$export$250ffa63cdc0d034 = $32881c7faf57716d$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $32881c7faf57716d$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $32881c7faf57716d$export$be92b6f5f03c0fe9 = $32881c7faf57716d$export$250ffa63cdc0d034;




"use client";
var $95d053caea9c023a$var$PORTAL_NAME = "Portal";
var $95d053caea9c023a$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $32881c7faf57716d$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$95d053caea9c023a$export$602eac185826482c.displayName = $95d053caea9c023a$var$PORTAL_NAME;
var $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");


"use client";
function $3207c0aa9f229d8f$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(presence.ref, $3207c0aa9f229d8f$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = "Presence";
function $3207c0aa9f229d8f$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef(null);
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $3207c0aa9f229d8f$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $3207c0aa9f229d8f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $3207c0aa9f229d8f$export$be92b6f5f03c0fe9 = $3207c0aa9f229d8f$export$99c2b779aa4e8b8b;


// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $0c579cd7a6758c8c$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $0c579cd7a6758c8c$export$250ffa63cdc0d034 = $0c579cd7a6758c8c$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $0c579cd7a6758c8c$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $0c579cd7a6758c8c$export$be92b6f5f03c0fe9 = $0c579cd7a6758c8c$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");
"use client";
var $264faec0fdf8876a$var$count = 0;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $264faec0fdf8876a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $264faec0fdf8876a$var$createFocusGuard());
        $264faec0fdf8876a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $264faec0fdf8876a$var$count--;
        };
    }, []);
}
function $264faec0fdf8876a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        titleId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        descriptionId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eeaeb48e23f662e7$export$3ddf2d174ce01153.displayName = $eeaeb48e23f662e7$var$DIALOG_NAME;
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$eeaeb48e23f662e7$export$2e1e1122cf0cba88.displayName = $eeaeb48e23f662e7$var$TRIGGER_NAME;
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $95d053caea9c023a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eeaeb48e23f662e7$export$dad7c95542bacce0.displayName = $eeaeb48e23f662e7$var$PORTAL_NAME;
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eeaeb48e23f662e7$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$var$OVERLAY_NAME;
var $eeaeb48e23f662e7$var$Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$b6d9565de1e068cf = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eeaeb48e23f662e7$export$b6d9565de1e068cf.displayName = $eeaeb48e23f662e7$var$CONTENT_NAME;
var $eeaeb48e23f662e7$var$DialogContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eeaeb48e23f662e7$var$DialogContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eeaeb48e23f662e7$var$DialogContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$var$TITLE_NAME;
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$94e94c2ec2c954d5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$94e94c2ec2c954d5.displayName = $eeaeb48e23f662e7$var$DESCRIPTION_NAME;
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$fba2fb7cd781b7ac = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eeaeb48e23f662e7$export$fba2fb7cd781b7ac.displayName = $eeaeb48e23f662e7$var$CLOSE_NAME;
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}
var $eeaeb48e23f662e7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$eeaeb48e23f662e7$export$69b62a49393917d6, $eeaeb48e23f662e7$var$useWarningContext] = (0, $45e038b71f97d914$export$fd42f52fd3ae1109)($eeaeb48e23f662e7$var$TITLE_WARNING_NAME, {
    contentName: $eeaeb48e23f662e7$var$CONTENT_NAME,
    titleName: $eeaeb48e23f662e7$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $eeaeb48e23f662e7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $acw62.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $eeaeb48e23f662e7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $acw62.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $eeaeb48e23f662e7$export$be92b6f5f03c0fe9 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
var $eeaeb48e23f662e7$export$41fb9f06171c75f4 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
var $eeaeb48e23f662e7$export$602eac185826482c = $eeaeb48e23f662e7$export$dad7c95542bacce0;
var $eeaeb48e23f662e7$export$c6fdb837b070b4ff = $eeaeb48e23f662e7$export$bd1d06c79be19e17;
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $eeaeb48e23f662e7$export$b6d9565de1e068cf;
var $eeaeb48e23f662e7$export$f99233281efd08a0 = $eeaeb48e23f662e7$export$16f7638e4a34b909;
var $eeaeb48e23f662e7$export$393edc798c47379d = $eeaeb48e23f662e7$export$94e94c2ec2c954d5;
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = $eeaeb48e23f662e7$export$fba2fb7cd781b7ac;



var $acw62 = parcelRequire("acw62");




// packages/react/use-previous/src/use-previous.tsx

var $acw62 = parcelRequire("acw62");
function $44b714300f6a50aa$export$5cae361ad82dce8b(value) {
    const ref = $acw62.useRef({
        value: value,
        previous: value
    });
    return $acw62.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// packages/react/use-size/src/use-size.tsx

var $acw62 = parcelRequire("acw62");

function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}


// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $aeb5ff70029adca8$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $aeb5ff70029adca8$export$250ffa63cdc0d034 = $aeb5ff70029adca8$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $aeb5ff70029adca8$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $aeb5ff70029adca8$export$be92b6f5f03c0fe9 = $aeb5ff70029adca8$export$250ffa63cdc0d034;



"use client";
var $8210163b65dd94e3$var$SWITCH_NAME = "Switch";
var [$8210163b65dd94e3$var$createSwitchContext, $8210163b65dd94e3$export$cf7f5f17f69cbd43] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($8210163b65dd94e3$var$SWITCH_NAME);
var [$8210163b65dd94e3$var$SwitchProvider, $8210163b65dd94e3$var$useSwitchContext] = $8210163b65dd94e3$var$createSwitchContext($8210163b65dd94e3$var$SWITCH_NAME);
var $8210163b65dd94e3$export$b5d5cf8927ab7262 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, form: form, ...switchProps } = props;
    const [button, setButton] = $acw62.useState(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked, setChecked] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $8210163b65dd94e3$var$SWITCH_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($8210163b65dd94e3$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $aeb5ff70029adca8$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": $8210163b65dd94e3$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$var$SwitchBubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$8210163b65dd94e3$export$b5d5cf8927ab7262.displayName = $8210163b65dd94e3$var$SWITCH_NAME;
var $8210163b65dd94e3$var$THUMB_NAME = "SwitchThumb";
var $8210163b65dd94e3$export$4d07bf653ea69106 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $8210163b65dd94e3$var$useSwitchContext($8210163b65dd94e3$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $aeb5ff70029adca8$export$250ffa63cdc0d034).span, {
        "data-state": $8210163b65dd94e3$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$8210163b65dd94e3$export$4d07bf653ea69106.displayName = $8210163b65dd94e3$var$THUMB_NAME;
var $8210163b65dd94e3$var$BUBBLE_INPUT_NAME = "SwitchBubbleInput";
var $8210163b65dd94e3$var$SwitchBubbleInput = $acw62.forwardRef(({ __scopeSwitch: __scopeSwitch, control: control, checked: checked, bubbles: bubbles = true, ...props }, forwardedRef)=>{
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(ref, forwardedRef);
    const prevChecked = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(control);
    $acw62.useEffect(()=>{
        const input = ref.current;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
});
$8210163b65dd94e3$var$SwitchBubbleInput.displayName = $8210163b65dd94e3$var$BUBBLE_INPUT_NAME;
function $8210163b65dd94e3$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $8210163b65dd94e3$export$be92b6f5f03c0fe9 = $8210163b65dd94e3$export$b5d5cf8927ab7262;
var $8210163b65dd94e3$export$6521433ed15a34db = $8210163b65dd94e3$export$4d07bf653ea69106;





var $lHUkp = parcelRequire("lHUkp");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfe54799d1557409$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v10",
            key: "mnfbl"
        }
    ],
    [
        "path",
        {
            d: "M18.4 6.6a9 9 0 1 1-12.77.04",
            key: "obofu9"
        }
    ]
];
const $bfe54799d1557409$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("power", $bfe54799d1557409$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);


const $eb5638f2ca6d7b93$export$e8372f5a01af8b26 = {
    ENABLE_DISABLE: 'enable_disable',
    EDIT: 'edit',
    DELETE: 'delete',
    CONFIRM: 'confirm',
    CUSTOM: 'custom'
};
const $eb5638f2ca6d7b93$var$MODAL_CONFIGS = {
    [$eb5638f2ca6d7b93$export$e8372f5a01af8b26.ENABLE_DISABLE]: {
        icon: (0, $bfe54799d1557409$export$2e2bcd8739ae039),
        getTitle: (data)=>`${data?.status ? 'Disable' : 'Enable'} ${data?.entityType || 'Item'}`,
        getMessage: (data)=>`Are you sure you want to ${data?.status ? 'disable' : 'enable'} this ${data?.entityType?.toLowerCase() || 'item'}?`,
        confirmText: 'Confirm',
        confirmClass: 'bg-blue-600 hover:bg-blue-700'
    },
    [$eb5638f2ca6d7b93$export$e8372f5a01af8b26.DELETE]: {
        icon: (0, $1d55a58c47e43a5b$export$2e2bcd8739ae039),
        getTitle: (data)=>`Delete ${data?.entityType || 'Item'}`,
        getMessage: (data)=>`Are you sure you want to delete this ${data?.entityType?.toLowerCase() || 'item'}? This action cannot be undone.`,
        confirmText: 'Delete',
        confirmClass: 'bg-red-600 hover:bg-red-700'
    },
    [$eb5638f2ca6d7b93$export$e8372f5a01af8b26.EDIT]: {
        icon: (0, $737c279b45d43939$export$2e2bcd8739ae039),
        getTitle: (data)=>`Edit ${data?.entityType || 'Item'}`,
        getMessage: ()=>null,
        confirmText: 'Save Changes',
        confirmClass: 'bg-green-600 hover:bg-green-700'
    },
    [$eb5638f2ca6d7b93$export$e8372f5a01af8b26.CONFIRM]: {
        icon: null,
        getTitle: (data)=>`Confirm Action`,
        getMessage: (data)=>`Are you sure you want to proceed with this action?`,
        confirmText: 'Yes, Proceed',
        confirmClass: 'bg-purple-600 hover:bg-purple-700'
    }
};
function $eb5638f2ca6d7b93$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, type: type = $eb5638f2ca6d7b93$export$e8372f5a01af8b26.CUSTOM, title: title, message: customMessage, data: data, onConfirm: onConfirm, onCancel: onCancel, children: children, confirmText: confirmText, cancelText: cancelText = "Cancel", showActions: showActions = true, loading: loading = false, size: size = "default" // "default" | "large"
 }) {
    const config = $eb5638f2ca6d7b93$var$MODAL_CONFIGS[type];
    const Icon = config?.icon;
    const modalTitle = title || (config?.getTitle ? config.getTitle(data) : '');
    const message = customMessage || (config?.getMessage ? config.getMessage(data) : null);
    const confirmButtonText = confirmText || config?.confirmText || 'Confirm';
    const confirmButtonClass = config?.confirmClass || 'bg-blue-600 hover:bg-blue-700';
    const sizeClasses = {
        default: 'max-w-lg',
        large: 'max-w-4xl'
    };
    const modalSizeClass = sizeClasses[size] || sizeClasses.default;
    const handleConfirm = ()=>{
        if (onConfirm) onConfirm(data);
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
        else onOpenChange(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
                    className: "fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                    className: `fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] ${modalSizeClass} max-h-[90vh] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white shadow-lg focus:outline-none flex flex-col sm:w-full`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between p-6 pb-4 border-b border-gray-200 flex-shrink-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            className: "h-5 w-5 text-gray-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
                                            className: "text-lg font-semibold text-gray-900",
                                            children: modalTitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "rounded-md p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors",
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex-1 overflow-y-auto p-6 pt-4",
                            children: [
                                message && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-700 mb-4",
                                    children: message
                                }),
                                children
                            ]
                        }),
                        showActions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-2 p-6 pt-4 border-t border-gray-200 flex-shrink-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: handleCancel,
                                    disabled: loading,
                                    className: "rounded border px-4 py-2 text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: cancelText
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: handleConfirm,
                                    disabled: loading,
                                    className: `rounded px-4 py-2 text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${confirmButtonClass}`,
                                    children: loading ? 'Processing...' : confirmButtonText
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



const $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17 = {
    // Success toast
    success: (message, options = {})=>{
        (0, $a3478a115f13707d$exports.toast).success(message, {
            duration: 3000,
            position: "top-right",
            style: {
                background: "#F0FDF4",
                color: "#166534",
                border: "1px solid #BBF7D0"
            },
            ...options
        });
    },
    // Error toast
    error: (message, options = {})=>{
        (0, $a3478a115f13707d$exports.toast).error(message, {
            duration: 5000,
            position: "top-right",
            style: {
                background: "#FEF2F2",
                color: "#DC2626",
                border: "1px solid #FECACA"
            },
            ...options
        });
    },
    // Info toast
    info: (message, options = {})=>{
        (0, $a3478a115f13707d$exports.toast)(message, {
            duration: 4000,
            position: "top-right",
            style: {
                background: "#EFF6FF",
                color: "#1E40AF",
                border: "1px solid #BFDBFE"
            },
            ...options
        });
    },
    // Warning toast
    warning: (message, options = {})=>{
        (0, $a3478a115f13707d$exports.toast)(message, {
            duration: 4000,
            position: "top-right",
            style: {
                background: "#FFFBEB",
                color: "#92400E",
                border: "1px solid #FED7AA"
            },
            icon: "\u26A0\uFE0F",
            ...options
        });
    },
    // Loading toast (returns toast ID for dismissal)
    loading: (message, options = {})=>{
        return (0, $a3478a115f13707d$exports.toast).loading(message, {
            position: "top-right",
            style: {
                background: "#F0F9FF",
                color: "#0369A1",
                border: "1px solid #BAE6FD"
            },
            ...options
        });
    },
    // Dismiss specific toast
    dismiss: (toastId)=>{
        (0, $a3478a115f13707d$exports.toast).dismiss(toastId);
    },
    // Dismiss all toasts
    dismissAll: ()=>{
        (0, $a3478a115f13707d$exports.toast).dismiss();
    }
};
const $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3 = (error, fallbackMessage = "Something went wrong")=>{
    try {
        console.log('showApiError - error:', error);
        console.log('showApiError - error type:', typeof error);
        // If error is null or undefined, show fallback
        if (!error) {
            $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(String(fallbackMessage));
            return;
        }
        // If error is a string, show it directly
        if (typeof error === 'string') {
            $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(String(error));
            return;
        }
        // Extract the response data
        const responseData = error?.response?.data;
        // Check if there's a message in the response
        if (responseData?.message) {
            $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(String(responseData.message));
            return;
        }
        // Handle validation errors in data field
        const validationErrors = responseData?.data;
        if (validationErrors && typeof validationErrors === 'object' && !Array.isArray(validationErrors) && Object.keys(validationErrors).length > 0) {
            // Extract all error messages from the validation errors object
            const errorMessages = [];
            Object.keys(validationErrors).forEach((field)=>{
                const fieldErrors = validationErrors[field];
                if (Array.isArray(fieldErrors)) // If it's an array of errors, add all of them
                errorMessages.push(...fieldErrors);
                else if (typeof fieldErrors === 'string') // If it's a single string error
                errorMessages.push(fieldErrors);
            });
            // Show each error message as a separate toast
            if (errorMessages.length > 0) {
                errorMessages.forEach((msg)=>{
                    $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(String(msg));
                });
                return;
            }
        }
        // Fallback to the main error message or fallback
        const message = error?.message || error?.response?.statusText || fallbackMessage;
        $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(String(message));
    } catch (toastError) {
        // If anything goes wrong in error handling, show a safe fallback
        console.error('Error in showApiError:', toastError);
        $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error("An error occurred");
    }
};
const $77fa8ab1aa12d8fb$export$89ca83e968d729c5 = (message = "Operation completed successfully")=>{
    $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.success(message);
};
const $77fa8ab1aa12d8fb$export$8dbb9decd14e8789 = (error, fallbackMessage = "Something went wrong")=>{
    const message = typeof error === 'string' ? error : error?.message || fallbackMessage;
    $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(message);
};
const $77fa8ab1aa12d8fb$export$fcc5b2c64ff6ba6 = (message)=>{
    $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.error(message);
};
const $77fa8ab1aa12d8fb$export$3ddc711ac21275cd = (message)=>{
    $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.info(message);
};
const $77fa8ab1aa12d8fb$export$da2f4e8190fdb5e1 = (message)=>{
    $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17.warning(message);
};




function $9c0903e4def38d82$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 flex items-center justify-center bg-black/40 z-50",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col items-center space-y-3",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                className: "h-12 w-12 text-primary animate-spin drop-shadow-lg"
            })
        })
    });
}



parcelRequire("acw62");
/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c31db635520dc385$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-left", $c31db635520dc385$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-right", $7979593adeba180b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4551b311634241de$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m11 17-5-5 5-5",
            key: "13zhaf"
        }
    ],
    [
        "path",
        {
            d: "m18 17-5-5 5-5",
            key: "h8a8et"
        }
    ]
];
const $4551b311634241de$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-left", $4551b311634241de$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f09bbb993f3fef38$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 17 5-5-5-5",
            key: "xnjwq"
        }
    ],
    [
        "path",
        {
            d: "m13 17 5-5-5-5",
            key: "17xmmf"
        }
    ]
];
const $f09bbb993f3fef38$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-right", $f09bbb993f3fef38$export$3efd853dbb351e94);


function $26fc24463b599c87$export$2e2bcd8739ae039({ currentPage: currentPage = 1, totalPages: totalPages = 1, totalItems: totalItems = 0, itemsPerPage: itemsPerPage = 10, onPageChange: onPageChange, className: className = "" }) {
    if (totalPages <= 1) return null;
    const canPreviousPage = currentPage > 1;
    const canNextPage = currentPage < totalPages;
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `bg-white px-4 py-3 border-t border-gray-200 sm:px-6 ${className}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-center sm:text-left",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-700",
                        children: [
                            "Showing ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: startItem
                            }),
                            " to",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: endItem
                            }),
                            " of",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: totalItems
                            }),
                            " results"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px",
                        "aria-label": "Pagination",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>onPageChange(1),
                                disabled: !canPreviousPage,
                                className: "relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                title: "First Page",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "First"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4551b311634241de$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>onPageChange(currentPage - 1),
                                disabled: !canPreviousPage,
                                className: "relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                title: "Previous Page",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Previous"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                ]
                            }),
                            $26fc24463b599c87$var$getPageNumbers(currentPage, totalPages).map((pageNum, idx)=>pageNum === "..." ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700",
                                    children: "..."
                                }, `ellipsis-${idx}`) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>onPageChange(pageNum),
                                    className: `relative inline-flex items-center px-3 sm:px-4 py-2 border text-sm font-medium transition-colors ${currentPage === pageNum ? "z-10 bg-blue-600 border-blue-600 text-white" : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"}`,
                                    children: pageNum
                                }, pageNum)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>onPageChange(currentPage + 1),
                                disabled: !canNextPage,
                                className: "relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                title: "Next Page",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Next"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>onPageChange(totalPages),
                                disabled: !canNextPage,
                                className: "relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                title: "Last Page",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Last"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f09bbb993f3fef38$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/**
 * Helper function to generate page numbers with ellipsis
 * Optimized for mobile - shows fewer pages on small screens
 */ function $26fc24463b599c87$var$getPageNumbers(currentPage, totalPages) {
    const pages = [];
    // For mobile (fewer pages shown)
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
    const maxPagesToShow = isMobile ? 3 : 5;
    if (totalPages <= maxPagesToShow + 2) // Show all pages if total is small
    for(let i = 1; i <= totalPages; i++)pages.push(i);
    else {
        // Always show first page
        pages.push(1);
        if (currentPage <= 2) {
            // Near the beginning
            for(let i = 2; i <= Math.min(maxPagesToShow, totalPages - 1); i++)pages.push(i);
            if (maxPagesToShow < totalPages - 1) pages.push("...");
            pages.push(totalPages);
        } else if (currentPage >= totalPages - 1) {
            // Near the end
            pages.push("...");
            for(let i = Math.max(2, totalPages - maxPagesToShow + 1); i < totalPages; i++)pages.push(i);
            pages.push(totalPages);
        } else {
            // In the middle
            pages.push("...");
            // Show current page and neighbors
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);
            for(let i = start; i <= end; i++)pages.push(i);
            pages.push("...");
            pages.push(totalPages);
        }
    }
    return pages;
}


function $afdc4b2a62c9dd6f$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    // Modal state management
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    // Image viewer modal state
    const [imageViewerState, setImageViewerState] = (0, $acw62.useState)({
        open: false,
        banner: null
    });
    const { banners: banners = [], pagination: pagination, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.banner);
    console.log("ViewBannersPage - banners from state:", banners);
    console.log("ViewBannersPage - banners length:", banners?.length);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $lHUkp.fetchBanners)({
            page: backendPage,
            per_page: backendPageSize
        }));
    }, [
        dispatch,
        backendPage
    ]);
    const filteredBanners = banners.filter((banner)=>{
        const matchesSearch = !debouncedSearch || banner.headline && banner.headline.toLowerCase().includes(debouncedSearch.toLowerCase()) || banner.tagline && banner.tagline.toLowerCase().includes(debouncedSearch.toLowerCase());
        const matchesFilter = filterStatus === "all" || (banner.is_enabled ? "enabled" : "disabled") === filterStatus;
        return matchesSearch && matchesFilter;
    });
    const hasActiveClientFilters = debouncedSearch !== "" || filterStatus !== "all";
    // Client-side pagination
    // Banners has no server-side pagination so always use filtered count
    const totalRecords = hasActiveClientFilters ? filteredBanners.length : pagination?.total || filteredBanners.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedBanners = filteredBanners.slice(localStartIndex, localEndIndex);
    const getStatusBadge = (status)=>{
        const statusStyles = {
            enabled: "bg-green-100 text-green-800",
            disabled: "bg-red-100 text-red-800"
        };
        return statusStyles[status] || "bg-gray-100 text-gray-800";
    };
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    // Modal handlers
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "Banner"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (bannerData)=>{
        setModalLoading(true);
        try {
            const result = await dispatch((0, $lHUkp.updateBannerStatus)({
                uuid: bannerData?.id,
                status: bannerData?.is_enabled ? "disable" : "enable"
            }));
            if ((0, $lHUkp.updateBannerStatus).fulfilled.match(result)) {
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Status updated successfully");
                closeModal();
            } else {
                (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update status");
                setModalLoading(false);
            }
        } catch  {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update status");
            setModalLoading(false);
        }
    };
    const handleEditBanner = (banner)=>{
        navigate(`/banners/add?edit=${banner.id}`);
    };
    const handleViewBanner = (banner)=>{
        setImageViewerState({
            open: true,
            banner: banner
        });
    };
    const closeImageViewer = ()=>{
        setImageViewerState({
            open: false,
            banner: null
        });
    };
    const handleDeleteBanner = async (bannerData)=>{
        setModalLoading(true);
        try {
            // TODO: Implement banner delete API call
            console.log("Deleting banner:", bannerData.id);
            // await dispatch(deleteBanner({ uuid: bannerData.uuid }));
            // Simulate API call
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Banner deleted successfully");
            closeModal();
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to delete banner");
        }
    };
    // Function to trigger form submission from modal
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteBanner(modalState.data);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: "All Banners"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/banners/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New Banner"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search banners...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "enabled",
                                                children: "Enabled"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "disabled",
                                                children: "Disabled"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Image"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Headline"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Tagline"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Sequence"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "bg-white divide-y divide-gray-200",
                                children: paginatedBanners.length > 0 ? paginatedBanners.map((banner)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-20 h-12 rounded-lg overflow-hidden bg-gray-100 cursor-pointer hover:opacity-80 transition-opacity",
                                                    onClick: ()=>handleViewBanner(banner),
                                                    title: "Click to view full image",
                                                    children: banner.image_url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: banner.image_url,
                                                        alt: "Banner",
                                                        className: "w-full h-full object-cover"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-full h-full flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6 text-gray-400"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-sm font-medium text-gray-900",
                                                    children: banner.headline || "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-sm text-gray-500 max-w-xs truncate",
                                                    children: banner.tagline || "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-sm text-gray-900",
                                                    children: banner.sequence !== null ? banner.sequence : "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(banner.is_enabled ? "enabled" : "disabled")}`,
                                                    children: banner.is_enabled ? "Enabled" : "Disabled"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `banner-status-${banner.id}`,
                                                            checked: banner?.is_enabled,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, banner),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>handleViewBanner(banner),
                                                                    className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                                    title: "View Banner",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>handleEditBanner(banner),
                                                                    className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                    title: "Edit Banner",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, banner.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 6,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No banners found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" ? "Try adjusting your search or filter criteria" : "Get started by adding your first banner"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading,
                showActions: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
                open: imageViewerState.open,
                onOpenChange: closeImageViewer,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
                            className: "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                            className: "fixed left-1/2 top-1/2 z-50 w-[95vw] max-w-4xl max-h-[95vh] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white shadow-lg focus:outline-none overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center justify-between p-4 border-b border-gray-200",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-600"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
                                                    className: "text-lg font-semibold text-gray-900",
                                                    children: "Banner Details"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "rounded-md p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors",
                                                "aria-label": "Close",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-6",
                                    children: imageViewerState.banner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "max-w-full max-h-[60vh] overflow-hidden rounded-lg border border-gray-200",
                                                    children: imageViewerState.banner.image_url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: imageViewerState.banner.image_url,
                                                        alt: "Banner",
                                                        className: "max-w-full max-h-full object-contain"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "w-64 h-32 flex items-center justify-center bg-gray-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                                                className: "h-12 w-12 text-gray-400"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "ml-2 text-gray-500",
                                                                children: "No Image"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                                        children: "Headline"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-sm text-gray-900 bg-gray-50 p-3 rounded-md",
                                                                        children: imageViewerState.banner.headline || "No headline"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                                        children: "Tagline"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-sm text-gray-900 bg-gray-50 p-3 rounded-md",
                                                                        children: imageViewerState.banner.tagline || "No tagline"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                                        children: "Sequence"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-sm text-gray-900 bg-gray-50 p-3 rounded-md",
                                                                        children: imageViewerState.banner.sequence !== null ? imageViewerState.banner.sequence : "No sequence"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                                        children: "Status"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "bg-gray-50 p-3 rounded-md",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(imageViewerState.banner.is_enabled ? "enabled" : "disabled")}`,
                                                                            children: imageViewerState.banner.is_enabled ? "Enabled" : "Disabled"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex justify-end space-x-3 pt-4 border-t border-gray-200",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: ()=>{
                                                        closeImageViewer();
                                                        handleEditBanner(imageViewerState.banner);
                                                    },
                                                    className: "bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Edit Banner"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === 'object';
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $0d70f179cf56e662$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $0d70f179cf56e662$var$cloneObject(data) {
    if (data instanceof Date) return new Date(data);
    const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;
    if ($0d70f179cf56e662$var$isWeb && (data instanceof Blob || isFileListInstance)) return data;
    const isArray = Array.isArray(data);
    if (!isArray && !($0d70f179cf56e662$var$isObject(data) && $0d70f179cf56e662$var$isPlainObject(data))) return data;
    const copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
    return copy;
}
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = ($0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === 'function';
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
/**
 * Separate context for `control` to prevent unnecessary rerenders.
 * Internal hooks that only need control use this instead of full form context.
 */ const $0d70f179cf56e662$var$HookFormControlContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$0d70f179cf56e662$var$HookFormControlContext.displayName = 'HookFormControlContext';
/**
 * @internal Internal hook to access only control from context.
 */ const $0d70f179cf56e662$var$useFormControlContext = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormControlContext);
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $0d70f179cf56e662$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const formControl = $0d70f179cf56e662$var$useFormControlContext();
    const { control: control = formControl, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === 'string';
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return Object.is(object1, object2);
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return Object.is(object1.getTime(), object2.getTime());
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2, _internal_visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const formControl = $0d70f179cf56e662$var$useFormControlContext();
    const { control: control = formControl, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((values)=>{
        const formValues = $0d70f179cf56e662$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((values)=>{
        if (!disabled) {
            const formValues = $0d70f179cf56e662$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!$0d70f179cf56e662$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !$0d70f179cf56e662$var$deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            refreshValue();
        }
        return control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                refreshValue(formState.values);
            }
        });
    }, [
        control,
        exact,
        name,
        refreshValue
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // Cache the computed output to avoid duplicate calls within the same render
    // We include shouldReturnImmediate in deps to ensure proper recomputation
    const computedOutput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (disabled) return null;
        const nameChanged = !controlChanged && !$0d70f179cf56e662$var$deepEqual(prevName, name);
        const shouldReturnImmediate = controlChanged || nameChanged;
        return shouldReturnImmediate ? getCurrentOutput() : null;
    }, [
        disabled,
        controlChanged,
        name,
        prevName,
        getCurrentOutput
    ]);
    return computedOutput !== null ? computedOutput : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const formControl = $0d70f179cf56e662$var$useFormControlContext();
    const { name: name, disabled: disabled, control: control = formControl, shouldUnregister: shouldUnregister, defaultValue: defaultValue, exact: exact = true } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: exact
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: exact
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    const _previousNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $0d70f179cf56e662$var$getEventValue(event),
                name: name
            },
            type: $0d70f179cf56e662$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $0d70f179cf56e662$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((elm)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
        if (field && field._f && elm) field._f.ref = {
            focus: ()=>$0d70f179cf56e662$var$isFunction(elm.focus) && elm.focus(),
            select: ()=>$0d70f179cf56e662$var$isFunction(elm.select) && elm.select(),
            setCustomValidity: (message)=>$0d70f179cf56e662$var$isFunction(elm.setCustomValidity) && elm.setCustomValidity(message),
            reportValidity: ()=>$0d70f179cf56e662$var$isFunction(elm.reportValidity) && elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const previousName = _previousNameRef.current;
        if (previousName && previousName !== name && !isArrayField) control.unregister(previousName);
        control.register(name, {
            ..._props.current.rules,
            ...$0d70f179cf56e662$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        _previousNameRef.current = name;
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($0d70f179cf56e662$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $0d70f179cf56e662$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$0d70f179cf56e662$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, watch: watch, getValues: getValues, getFieldState: getFieldState, setError: setError, clearErrors: clearErrors, setValue: setValue, trigger: trigger, formState: formState, resetField: resetField, reset: reset, handleSubmit: handleSubmit, unregister: unregister, control: control, register: register, setFocus: setFocus, subscribe: subscribe } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
                watch: watch,
                getValues: getValues,
                getFieldState: getFieldState,
                setError: setError,
                clearErrors: clearErrors,
                setValue: setValue,
                trigger: trigger,
                formState: formState,
                resetField: resetField,
                reset: reset,
                handleSubmit: handleSubmit,
                unregister: unregister,
                control: control,
                register: register,
                setFocus: setFocus,
                subscribe: subscribe
            }), [
            clearErrors,
            control,
            formState,
            getFieldState,
            getValues,
            handleSubmit,
            register,
            reset,
            resetField,
            setError,
            setFocus,
            setValue,
            subscribe,
            trigger,
            unregister,
            watch
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormControlContext.Provider, {
        value: control
    }, children));
};
const $0d70f179cf56e662$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $0d70f179cf56e662$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
const $0d70f179cf56e662$export$6136af724020822e = ({ control: control, disabled: disabled, exact: exact, name: name, render: render })=>render($0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        disabled: disabled,
        exact: exact
    }));
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $0d70f179cf56e662$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $0d70f179cf56e662$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $0d70f179cf56e662$var$extractFormValues(fieldState, fieldValue);
            if ($0d70f179cf56e662$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === 'file';
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === 'radio';
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$isTraversable(value1) {
    return Array.isArray(value1) || $0d70f179cf56e662$var$isObject(value1) && !$0d70f179cf56e662$var$objectHasFunction(value1);
}
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        const value1 = data[key];
        if ($0d70f179cf56e662$var$isTraversable(value1)) {
            fields[key] = Array.isArray(value1) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(value1, fields[key]);
        } else if (!$0d70f179cf56e662$var$isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $0d70f179cf56e662$var$markFieldsDirty(formValues);
    for(const key in data){
        const value1 = data[key];
        if ($0d70f179cf56e662$var$isTraversable(value1)) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $0d70f179cf56e662$var$markFieldsDirty(value1, Array.isArray(value1) ? [] : {});
            else $0d70f179cf56e662$var$getDirtyFields(value1, $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else {
            const formValue = formValues[key];
            dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(value1, formValue);
        }
    }
    return dirtyFieldsFromValues;
}
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === '' ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
const $0d70f179cf56e662$var$ASYNC_FUNCTION = 'AsyncFunction';
var $0d70f179cf56e662$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($0d70f179cf56e662$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION || $0d70f179cf56e662$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION));
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) {
                if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $0d70f179cf56e662$var$getValidateError(result, ref, type = 'validate') {
    if ($0d70f179cf56e662$var$isString(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isString) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isString(result) ? result : '',
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $0d70f179cf56e662$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isString(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
        keepIsValid: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const defaultProxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _proxyFormState = {
        ...defaultProxyFormState
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (_state.keepIsValid) return;
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            let isValid;
            if (_options.resolver) {
                isValid = $0d70f179cf56e662$var$isEmptyObject((await _runSchema()).errors);
                _updateIsValidating();
            } else isValid = await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0d70f179cf56e662$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0d70f179cf56e662$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && !_state.action && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        _updateIsValidating(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $0d70f179cf56e662$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid || props.shouldUseNativeValidation) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                !$0d70f179cf56e662$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? '' : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $0d70f179cf56e662$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $0d70f179cf56e662$var$isObject(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $0d70f179cf56e662$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        if ($0d70f179cf56e662$var$isWatched(name, _names)) _subjects.state.next({
            ..._formState,
            name: name,
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
        else _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $0d70f179cf56e662$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $0d70f179cf56e662$var$deepEqual(fieldValue, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $0d70f179cf56e662$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = $0d70f179cf56e662$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($0d70f179cf56e662$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $0d70f179cf56e662$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: {
                ...defaultProxyFormState,
                ...props.formState
            }
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0d70f179cf56e662$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            const wasDisabled = _names.disabled.has(name);
            const isDisabled = !!disabled;
            const disabledStateChanged = wasDisabled !== isDisabled;
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            disabledStateChanged && _state.mount && !_state.action && _setValid();
        }
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled) || $0d70f179cf56e662$var$isBoolean(_options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $0d70f179cf56e662$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _updateIsValidating();
                _formState.errors = errors;
                fieldValues = $0d70f179cf56e662$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$0d70f179cf56e662$var$unset(fieldValues, name);
            $0d70f179cf56e662$var$unset(_formState.errors, 'root');
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0d70f179cf56e662$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck)){
                    const isDirty = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName);
                    const existingValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName);
                    const newValue = $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName);
                    if (isDirty && !$0d70f179cf56e662$var$isUndefined(existingValue)) $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, existingValue);
                    else if (!isDirty && !$0d70f179cf56e662$var$isUndefined(newValue)) setValue(fieldName, newValue);
                }
            } else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !$0d70f179cf56e662$var$isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _state.keepIsValid = !!keepStateOptions.keepIsValid;
        _state.action = false;
        // Clear errors synchronously to prevent validation errors on subsequent submissions
        // This fixes the issue where form.reset() causes validation errors on subsequent
        // submissions in Next.js 16 with Server Actions
        if (!keepStateOptions.keepErrors) _formState.errors = {};
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, {
            ..._options.resetOptions,
            ...keepStateOptions
        });
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) // Use setTimeout to ensure focus happens after any pending state updates
            // This fixes the issue where setFocus doesn't work immediately after setError
            setTimeout(()=>{
                fieldRef.focus();
                options.shouldSelect && $0d70f179cf56e662$var$isFunction(fieldRef.select) && fieldRef.select();
            });
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _updateIsValidating: _updateIsValidating,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $0d70f179cf56e662$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const formControl = $0d70f179cf56e662$var$useFormControlContext();
    const { control: control = formControl, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) && $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                control._updateIsValidating([
                    name
                ]);
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $0d70f179cf56e662$var$cloneObject(control._formValues)
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$0d70f179cf56e662$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $0d70f179cf56e662$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        var _a;
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$var$getProxyFormState(formState, control), [
        control,
        formState
    ]);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param name - Can be field name, array of field names, or undefined to watch the entire form
 * @param disabled - Disable subscription
 * @param exact - Whether to watch exact field names or not
 * @param defaultValue - The default value to use if the field is not yet set
 * @param compute - Function to compute derived values from watched fields
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $0d70f179cf56e662$export$4c68f1a79f88778c = (props)=>props.render($0d70f179cf56e662$export$3c773aa2b84f29e0({
        name: props.names,
        ...props
    }));



var $302743bfdc67c75e$var$t = function(e, t, i) {
    if (e && "reportValidity" in e) {
        var n = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(i, t);
        e.setCustomValidity(n && n.message || ""), e.reportValidity();
    }
}, $302743bfdc67c75e$export$6bd436d70894afff = function(r, e) {
    var i = function(i) {
        var n = e.fields[i];
        n && n.ref && "reportValidity" in n.ref ? $302743bfdc67c75e$var$t(n.ref, i, r) : n && n.refs && n.refs.forEach(function(e) {
            return $302743bfdc67c75e$var$t(e, i, r);
        });
    };
    for(var n in e.fields)i(n);
}, $302743bfdc67c75e$export$f0545b73a179e3a2 = function(t, n) {
    n.shouldUseNativeValidation && $302743bfdc67c75e$export$6bd436d70894afff(t, n);
    var a = {};
    for(var f in t){
        var s = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(n.fields, f), c = Object.assign(t[f] || {}, {
            ref: s && s.ref
        });
        if ($302743bfdc67c75e$var$o(n.names || Object.keys(t), f)) {
            var u = Object.assign({}, (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(a, f));
            (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(u, "root", c), (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(a, f, u);
        } else (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(a, f, c);
    }
    return a;
}, $302743bfdc67c75e$var$o = function(r, e) {
    var t = $302743bfdc67c75e$var$a(e);
    return r.some(function(r) {
        return $302743bfdc67c75e$var$a(r).match("^" + t + "\\.\\d+");
    });
};
function $302743bfdc67c75e$var$a(r) {
    return r.replace(/\]|\[/g, "");
}



function $0df32c3dd3ad0e0c$export$d55832dfcd4989a(o, n, s) {
    return void 0 === s && (s = {}), function(a, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (null != n && n.context, Promise.resolve(o["sync" === s.mode ? "validateSync" : "validate"](a, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $302743bfdc67c75e$export$6bd436d70894afff)({}, c), {
                            values: s.raw ? Object.assign({}, a) : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $302743bfdc67c75e$export$f0545b73a179e3a2)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, s = o && o[t.type];
                            e[t.path] = (0, $0d70f179cf56e662$export$b196c2a4f765bd30)(t.path, n, e, t.type, s ? [].concat(s, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
}


var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ''
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


var $d2ed6e977f19f182$exports = {};
const $d2ed6e977f19f182$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d2ed6e977f19f182$var$words = (str)=>str.match($d2ed6e977f19f182$var$reWords) || [];
const $d2ed6e977f19f182$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d2ed6e977f19f182$var$join = (str, d)=>$d2ed6e977f19f182$var$words(str).join(d).toLowerCase();
const $d2ed6e977f19f182$var$camelCase = (str)=>$d2ed6e977f19f182$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $d2ed6e977f19f182$var$pascalCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$camelCase(str));
const $d2ed6e977f19f182$var$snakeCase = (str)=>$d2ed6e977f19f182$var$join(str, '_');
const $d2ed6e977f19f182$var$kebabCase = (str)=>$d2ed6e977f19f182$var$join(str, '-');
const $d2ed6e977f19f182$var$sentenceCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$join(str, ' '));
const $d2ed6e977f19f182$var$titleCase = (str)=>$d2ed6e977f19f182$var$words(str).map($d2ed6e977f19f182$var$upperFirst).join(' ');
$d2ed6e977f19f182$exports = {
    words: $d2ed6e977f19f182$var$words,
    upperFirst: $d2ed6e977f19f182$var$upperFirst,
    camelCase: $d2ed6e977f19f182$var$camelCase,
    pascalCase: $d2ed6e977f19f182$var$pascalCase,
    snakeCase: $d2ed6e977f19f182$var$snakeCase,
    kebabCase: $d2ed6e977f19f182$var$kebabCase,
    sentenceCase: $d2ed6e977f19f182$var$sentenceCase,
    titleCase: $d2ed6e977f19f182$var$titleCase
};


var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $cda9d0e1103d595f$var$toString = Object.prototype.toString;
const $cda9d0e1103d595f$var$errorToString = Error.prototype.toString;
const $cda9d0e1103d595f$var$regExpToString = RegExp.prototype.toString;
const $cda9d0e1103d595f$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $cda9d0e1103d595f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $cda9d0e1103d595f$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $cda9d0e1103d595f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $cda9d0e1103d595f$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $cda9d0e1103d595f$var$symbolToString.call(val).replace($cda9d0e1103d595f$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $cda9d0e1103d595f$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $cda9d0e1103d595f$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $cda9d0e1103d595f$var$regExpToString.call(val);
    return null;
}
function $cda9d0e1103d595f$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $cda9d0e1103d595f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $cda9d0e1103d595f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $cda9d0e1103d595f$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $cda9d0e1103d595f$var$_Symbol$toStringTag, $cda9d0e1103d595f$var$_Symbol$hasInstance, $cda9d0e1103d595f$var$_Symbol$toStringTag2;
let $cda9d0e1103d595f$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$cda9d0e1103d595f$var$_Symbol$toStringTag = Symbol.toStringTag;
class $cda9d0e1103d595f$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $cda9d0e1103d595f$var$toArray(errorOrErrors).forEach((err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$cda9d0e1103d595f$var$_Symbol$hasInstance = Symbol.hasInstance;
$cda9d0e1103d595f$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $cda9d0e1103d595f$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($cda9d0e1103d595f$var$strReg, (_, key)=>$cda9d0e1103d595f$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $cda9d0e1103d595f$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cda9d0e1103d595f$export$2191b9da168c6cf0);
    }
    static [$cda9d0e1103d595f$var$_Symbol$hasInstance](inst) {
        return $cda9d0e1103d595f$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $cda9d0e1103d595f$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $cda9d0e1103d595f$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $cda9d0e1103d595f$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $cda9d0e1103d595f$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $cda9d0e1103d595f$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $cda9d0e1103d595f$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $cda9d0e1103d595f$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $cda9d0e1103d595f$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $cda9d0e1103d595f$export$2191b9da168c6cf0.formatError($cda9d0e1103d595f$var$mixed.notType, params);
    }
};
var $cda9d0e1103d595f$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $cda9d0e1103d595f$var$mixed,
    string: $cda9d0e1103d595f$var$string,
    number: $cda9d0e1103d595f$var$number,
    date: $cda9d0e1103d595f$var$date,
    object: $cda9d0e1103d595f$var$object,
    array: $cda9d0e1103d595f$var$array,
    boolean: $cda9d0e1103d595f$var$boolean,
    tuple: $cda9d0e1103d595f$var$tuple
});
const $cda9d0e1103d595f$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $cda9d0e1103d595f$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $cda9d0e1103d595f$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $cda9d0e1103d595f$var$prefixes = {
    context: '$',
    value: '.'
};
function $cda9d0e1103d595f$export$eff4d24c3ff7876e(key, options) {
    return new $cda9d0e1103d595f$var$Reference(key, options);
}
class $cda9d0e1103d595f$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $cda9d0e1103d595f$var$prefixes.context;
        this.isValue = this.key[0] === $cda9d0e1103d595f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $cda9d0e1103d595f$var$prefixes.context : this.isValue ? $cda9d0e1103d595f$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$cda9d0e1103d595f$var$Reference.prototype.__isYupRef = true;
const $cda9d0e1103d595f$var$isAbsent = (value)=>value == null;
function $cda9d0e1103d595f$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        const resolveOptions = {
            value: value,
            parent: parent,
            context: context
        };
        function createError(overrides = {}) {
            const nextParams = $cda9d0e1103d595f$var$resolveParams(Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params), resolveOptions);
            const error = new $cda9d0e1103d595f$export$2191b9da168c6cf0($cda9d0e1103d595f$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve (item) {
                return $cda9d0e1103d595f$var$resolveMaybeRef(item, resolveOptions);
            },
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $cda9d0e1103d595f$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
// Warning: mutates the input
function $cda9d0e1103d595f$var$resolveParams(params, options) {
    if (!params) return params;
    for (const key of Object.keys(params))params[key] = $cda9d0e1103d595f$var$resolveMaybeRef(params[key], options);
    return params;
}
function $cda9d0e1103d595f$var$resolveMaybeRef(item, options) {
    return $cda9d0e1103d595f$var$Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}
function $cda9d0e1103d595f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $cda9d0e1103d595f$export$cfedb76369cc7782(obj, path, value, context) {
    return $cda9d0e1103d595f$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $cda9d0e1103d595f$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($cda9d0e1103d595f$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $cda9d0e1103d595f$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $cda9d0e1103d595f$var$clone(src, seen = new Map()) {
    if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $cda9d0e1103d595f$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $cda9d0e1103d595f$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */ function $cda9d0e1103d595f$var$createStandardPath(path) {
    if (!(path != null && path.length)) return undefined;
    // Array to store the final path segments
    const segments = [];
    // Buffer for building the current segment
    let currentSegment = '';
    // Track if we're inside square brackets (array/property access)
    let inBrackets = false;
    // Track if we're inside quotes (for property names with special chars)
    let inQuotes = false;
    for(let i = 0; i < path.length; i++){
        const char = path[i];
        if (char === '[' && !inQuotes) {
            // When entering brackets, push any accumulated segment after splitting on dots
            if (currentSegment) {
                segments.push(...currentSegment.split('.').filter(Boolean));
                currentSegment = '';
            }
            inBrackets = true;
            continue;
        }
        if (char === ']' && !inQuotes) {
            if (currentSegment) {
                // Handle numeric indices (e.g. arr[0])
                if (/^\d+$/.test(currentSegment)) segments.push(currentSegment);
                else // Handle quoted property names (e.g. obj["foo.bar"])
                segments.push(currentSegment.replace(/^"|"$/g, ''));
                currentSegment = '';
            }
            inBrackets = false;
            continue;
        }
        if (char === '"') {
            // Toggle quote state for handling quoted property names
            inQuotes = !inQuotes;
            continue;
        }
        if (char === '.' && !inBrackets && !inQuotes) {
            // On dots outside brackets/quotes, push current segment
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = '';
            }
            continue;
        }
        currentSegment += char;
    }
    // Push any remaining segment after splitting on dots
    if (currentSegment) segments.push(...currentSegment.split('.').filter(Boolean));
    return segments;
}
function $cda9d0e1103d595f$var$createStandardIssues(error, parentPath) {
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.errors.map((err)=>({
            message: err,
            path: $cda9d0e1103d595f$var$createStandardPath(path)
        }));
}
function $cda9d0e1103d595f$var$issuesFromValidationError(error, parentPath) {
    var _error$inner;
    if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) return $cda9d0e1103d595f$var$createStandardIssues(error, parentPath);
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.inner.flatMap((err)=>$cda9d0e1103d595f$var$issuesFromValidationError(err, path));
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $cda9d0e1103d595f$var$ReferenceSet();
        this._blacklist = new $cda9d0e1103d595f$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $cda9d0e1103d595f$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $cda9d0e1103d595f$var$isAbsent(result)) return result;
            let formattedValue = $cda9d0e1103d595f$export$5790025c6e6c2ba6(value);
            let formattedResult = $cda9d0e1103d595f$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this, options), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $cda9d0e1103d595f$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $cda9d0e1103d595f$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $cda9d0e1103d595f$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $cda9d0e1103d595f$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $cda9d0e1103d595f$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $cda9d0e1103d595f$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $cda9d0e1103d595f$var$toArray(keys).map((key)=>new $cda9d0e1103d595f$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $cda9d0e1103d595f$var$Condition(deps, options) : $cda9d0e1103d595f$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $cda9d0e1103d595f$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $cda9d0e1103d595f$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.filter((n, idx, list)=>list.findIndex((c)=>c.OPTIONS.name === n.OPTIONS.name) === idx).map((fn)=>{
                const params = fn.OPTIONS.params && options ? $cda9d0e1103d595f$var$resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
                return {
                    name: fn.OPTIONS.name,
                    params: params
                };
            })
        };
        return description;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if (err instanceof $cda9d0e1103d595f$export$2191b9da168c6cf0) return {
                        issues: $cda9d0e1103d595f$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
// @ts-expect-error
$cda9d0e1103d595f$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $cda9d0e1103d595f$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.notOneOf;
const $cda9d0e1103d595f$var$returnsTrue = ()=>true;
function $cda9d0e1103d595f$export$9b30b6294c1449a8(spec) {
    return new $cda9d0e1103d595f$export$1e88358c94ddec71(spec);
}
class $cda9d0e1103d595f$export$1e88358c94ddec71 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $cda9d0e1103d595f$var$returnsTrue
        }, spec));
    }
}
$cda9d0e1103d595f$export$9b30b6294c1449a8.prototype = $cda9d0e1103d595f$export$1e88358c94ddec71.prototype;
function $cda9d0e1103d595f$export$87b259aa03e3d267() {
    return new $cda9d0e1103d595f$export$c7980688f11e1f49();
}
class $cda9d0e1103d595f$export$c7980688f11e1f49 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (this.spec.coerce && !this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$cda9d0e1103d595f$export$87b259aa03e3d267.prototype = $cda9d0e1103d595f$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $cda9d0e1103d595f$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $cda9d0e1103d595f$var$parseIsoDate(date) {
    const struct = $cda9d0e1103d595f$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $cda9d0e1103d595f$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $cda9d0e1103d595f$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $cda9d0e1103d595f$var$toNumber(regexResult[1]),
        month: $cda9d0e1103d595f$var$toNumber(regexResult[2], 1) - 1,
        day: $cda9d0e1103d595f$var$toNumber(regexResult[3], 1),
        hour: $cda9d0e1103d595f$var$toNumber(regexResult[4]),
        minute: $cda9d0e1103d595f$var$toNumber(regexResult[5]),
        second: $cda9d0e1103d595f$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $cda9d0e1103d595f$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $cda9d0e1103d595f$var$toNumber(regexResult[10]),
        minuteOffset: $cda9d0e1103d595f$var$toNumber(regexResult[11])
    };
}
function $cda9d0e1103d595f$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $cda9d0e1103d595f$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $cda9d0e1103d595f$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $cda9d0e1103d595f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $cda9d0e1103d595f$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $cda9d0e1103d595f$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $cda9d0e1103d595f$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $cda9d0e1103d595f$var$rIsoDateTime = new RegExp(`${$cda9d0e1103d595f$var$yearMonthDay}T${$cda9d0e1103d595f$var$hourMinuteSecond}(\\.\\d+)?${$cda9d0e1103d595f$var$zOrOffset}$`);
let $cda9d0e1103d595f$var$isTrimmed = (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.trim();
let $cda9d0e1103d595f$var$objStringTag = ({}).toString();
function $cda9d0e1103d595f$export$22b082955e083ec3() {
    return new $cda9d0e1103d595f$export$49bf8b2ede5138eb();
}
class $cda9d0e1103d595f$export$49bf8b2ede5138eb extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce || this.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $cda9d0e1103d595f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $cda9d0e1103d595f$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $cda9d0e1103d595f$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $cda9d0e1103d595f$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $cda9d0e1103d595f$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $cda9d0e1103d595f$var$string.email) {
        return this.matches($cda9d0e1103d595f$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $cda9d0e1103d595f$var$string.url) {
        return this.matches($cda9d0e1103d595f$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $cda9d0e1103d595f$var$string.uuid) {
        return this.matches($cda9d0e1103d595f$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($cda9d0e1103d595f$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $cda9d0e1103d595f$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $cda9d0e1103d595f$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $cda9d0e1103d595f$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $cda9d0e1103d595f$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $cda9d0e1103d595f$var$isTrimmed
        });
    }
    lowercase(message = $cda9d0e1103d595f$var$string.lowercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $cda9d0e1103d595f$var$string.uppercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$cda9d0e1103d595f$export$22b082955e083ec3.prototype = $cda9d0e1103d595f$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $cda9d0e1103d595f$var$isNaN$1 = (value)=>value != +value;
function $cda9d0e1103d595f$export$98e628dec113755e() {
    return new $cda9d0e1103d595f$export$f192ec5e9228ab19();
}
class $cda9d0e1103d595f$export$f192ec5e9228ab19 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$cda9d0e1103d595f$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (this.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $cda9d0e1103d595f$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $cda9d0e1103d595f$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $cda9d0e1103d595f$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $cda9d0e1103d595f$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $cda9d0e1103d595f$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $cda9d0e1103d595f$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$cda9d0e1103d595f$export$98e628dec113755e.prototype = $cda9d0e1103d595f$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $cda9d0e1103d595f$var$invalidDate = new Date('');
let $cda9d0e1103d595f$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $cda9d0e1103d595f$export$324d90190a8b822a() {
    return new $cda9d0e1103d595f$export$18ec3cc5a157503f();
}
class $cda9d0e1103d595f$export$18ec3cc5a157503f extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $cda9d0e1103d595f$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!this.spec.coerce || this.isType(value) || value === null) return value;
                value = $cda9d0e1103d595f$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$cda9d0e1103d595f$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $cda9d0e1103d595f$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
$cda9d0e1103d595f$export$324d90190a8b822a.prototype = $cda9d0e1103d595f$export$18ec3cc5a157503f.prototype;
$cda9d0e1103d595f$export$324d90190a8b822a.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
// @ts-expect-error
function $cda9d0e1103d595f$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($cda9d0e1103d595f$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}
function $cda9d0e1103d595f$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $cda9d0e1103d595f$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $cda9d0e1103d595f$var$findIndex(keys, a) - $cda9d0e1103d595f$var$findIndex(keys, b);
    };
}
const $cda9d0e1103d595f$var$parseJson = (value, _, schema)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return schema.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $cda9d0e1103d595f$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $cda9d0e1103d595f$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $cda9d0e1103d595f$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($cda9d0e1103d595f$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $cda9d0e1103d595f$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $0a34a21cae127bf5$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $0a34a21cae127bf5$exports.getter)((0, $0a34a21cae127bf5$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $cda9d0e1103d595f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $cda9d0e1103d595f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cda9d0e1103d595f$var$defaultSort = $cda9d0e1103d595f$var$sortByKeyOrder([]);
function $cda9d0e1103d595f$export$be5493f9613cbbe(spec) {
    return new $cda9d0e1103d595f$export$18b4fc70ec7eccf8(spec);
}
class $cda9d0e1103d595f$export$18b4fc70ec7eccf8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $cda9d0e1103d595f$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $cda9d0e1103d595f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            let inputValue = value[prop];
            if (field) {
                let fieldValue;
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $cda9d0e1103d595f$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(inputValue, innerOptions) : inputValue;
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = inputValue;
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== inputValue) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$cda9d0e1103d595f$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $cda9d0e1103d595f$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $cda9d0e1103d595f$var$sortFields(shape, excludedEdges);
        next._sortErrors = $cda9d0e1103d595f$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $cda9d0e1103d595f$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($cda9d0e1103d595f$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $cda9d0e1103d595f$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $d2ed6e977f19f182$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$be5493f9613cbbe.prototype = $cda9d0e1103d595f$export$18b4fc70ec7eccf8.prototype;
function $cda9d0e1103d595f$export$2f23118c22fb2630(type) {
    return new $cda9d0e1103d595f$export$4347112b8447a7d(type);
}
class $cda9d0e1103d595f$export$4347112b8447a7d extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`,
                parent: value,
                originalValue: v,
                value: v,
                index: idx
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $cda9d0e1103d595f$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $cda9d0e1103d595f$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $cda9d0e1103d595f$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $cda9d0e1103d595f$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$2f23118c22fb2630.prototype = $cda9d0e1103d595f$export$4347112b8447a7d.prototype;
// @ts-ignore
function $cda9d0e1103d595f$export$65e3907585753458(schemas) {
    return new $cda9d0e1103d595f$export$411c3b3687e8ecc8(schemas);
}
class $cda9d0e1103d595f$export$411c3b3687e8ecc8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`,
                parent: value,
                originalValue: value[idx],
                value: value[idx],
                index: idx
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$cda9d0e1103d595f$export$65e3907585753458.prototype = $cda9d0e1103d595f$export$411c3b3687e8ecc8.prototype;
function $cda9d0e1103d595f$export$488013bae63b21da(builder) {
    return new $cda9d0e1103d595f$export$71117d144d3091c9(builder);
}
function $cda9d0e1103d595f$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $cda9d0e1103d595f$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $cda9d0e1103d595f$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $cda9d0e1103d595f$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $cda9d0e1103d595f$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return {
                        issues: $cda9d0e1103d595f$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
function $cda9d0e1103d595f$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $cda9d0e1103d595f$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $cda9d0e1103d595f$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$cda9d0e1103d595f$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}






var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check", $8240f8fcfc513968$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-down", $4f88028b3cc726f6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b397e876e35a9277$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-up", $b397e876e35a9277$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plus", $dbde4c3396582d11$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// packages/core/number/src/number.ts
function $b488a2b318a95c87$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}




var $acw62 = parcelRequire("acw62");




"use client";
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $a9634733d4b9bce9$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const [collectionElement, setCollectionElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
        const composeRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const [element, setElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $a9634733d4b9bce9$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}




// packages/react/direction/src/direction.tsx

var $acw62 = parcelRequire("acw62");

var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;







var $acw62 = parcelRequire("acw62");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $10310cf078d13212$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return $10310cf078d13212$var$yAxisSides.has($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
const $10310cf078d13212$var$lrPlacement = [
    'left',
    'right'
];
const $10310cf078d13212$var$rlPlacement = [
    'right',
    'left'
];
const $10310cf078d13212$var$tbPlacement = [
    'top',
    'bottom'
];
const $10310cf078d13212$var$btPlacement = [
    'bottom',
    'top'
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        var _platform$detectOverf;
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: {
                ...platform,
                detectOverflow: (_platform$detectOverf = platform.detectOverflow) != null ? _platform$detectOverf : $973e4da43f2a375d$export$37b6bde19b108ecc
            },
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $10310cf078d13212$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $10310cf078d13212$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $238ac70369f38756$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$238ac70369f38756$var$invalidOverflowDisplayValues.has(display);
}
const $238ac70369f38756$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return $238ac70369f38756$var$tableElements.has($238ac70369f38756$export$651544f548703224(element));
}
const $238ac70369f38756$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return $238ac70369f38756$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $238ac70369f38756$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $238ac70369f38756$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $238ac70369f38756$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $238ac70369f38756$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $238ac70369f38756$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $238ac70369f38756$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return $238ac70369f38756$var$lastTraversableNodeNames.has($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $461947879dcdbcd4$var$SCROLLBAR_MAX = 25;
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $461947879dcdbcd4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $461947879dcdbcd4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $461947879dcdbcd4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $461947879dcdbcd4$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $23a8f689f1d4c3be$var$isClient = typeof document !== 'undefined';
var $23a8f689f1d4c3be$var$noop = function noop() {};
var $23a8f689f1d4c3be$var$index = $23a8f689f1d4c3be$var$isClient ? (0, $acw62.useLayoutEffect) : $23a8f689f1d4c3be$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const openRef = $23a8f689f1d4c3be$var$useLatestRef(open);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23a8f689f1d4c3be$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23a8f689f1d4c3be$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23a8f689f1d4c3be$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23a8f689f1d4c3be$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23a8f689f1d4c3be$export$346677f925de839c = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23a8f689f1d4c3be$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23a8f689f1d4c3be$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23a8f689f1d4c3be$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$23a8f689f1d4c3be$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


// src/arrow.tsx

var $acw62 = parcelRequire("acw62");
// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $00ce6114b7f71c4e$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $00ce6114b7f71c4e$export$250ffa63cdc0d034 = $00ce6114b7f71c4e$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $00ce6114b7f71c4e$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $00ce6114b7f71c4e$export$be92b6f5f03c0fe9 = $00ce6114b7f71c4e$export$250ffa63cdc0d034;



var $1002b17d420264b2$var$NAME = "Arrow";
var $1002b17d420264b2$export$21b07c8f274aebd5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $00ce6114b7f71c4e$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$1002b17d420264b2$export$21b07c8f274aebd5.displayName = $1002b17d420264b2$var$NAME;
var $1002b17d420264b2$export$be92b6f5f03c0fe9 = $1002b17d420264b2$export$21b07c8f274aebd5;




// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $11cc5513e4deecb5$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $11cc5513e4deecb5$export$250ffa63cdc0d034 = $11cc5513e4deecb5$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $11cc5513e4deecb5$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $11cc5513e4deecb5$export$be92b6f5f03c0fe9 = $11cc5513e4deecb5$export$250ffa63cdc0d034;






"use client";
var $a0ac11a1da65e329$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $a0ac11a1da65e329$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $a0ac11a1da65e329$var$POPPER_NAME = "Popper";
var [$a0ac11a1da65e329$var$createPopperContext, $a0ac11a1da65e329$export$722aac194ae923] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a0ac11a1da65e329$var$POPPER_NAME);
var [$a0ac11a1da65e329$var$PopperProvider, $a0ac11a1da65e329$var$usePopperContext] = $a0ac11a1da65e329$var$createPopperContext($a0ac11a1da65e329$var$POPPER_NAME);
var $a0ac11a1da65e329$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $acw62.useState(null);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$a0ac11a1da65e329$export$badac9ada3a0bdf9.displayName = $a0ac11a1da65e329$var$POPPER_NAME;
var $a0ac11a1da65e329$var$ANCHOR_NAME = "PopperAnchor";
var $a0ac11a1da65e329$export$ecd4e1ccab6ed6d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $a0ac11a1da65e329$var$usePopperContext($a0ac11a1da65e329$var$ANCHOR_NAME, __scopePopper);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const anchorRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef?.current || ref.current;
        if (previousAnchor !== anchorRef.current) context.onAnchorChange(anchorRef.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $11cc5513e4deecb5$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$a0ac11a1da65e329$export$ecd4e1ccab6ed6d.displayName = $a0ac11a1da65e329$var$ANCHOR_NAME;
var $a0ac11a1da65e329$var$CONTENT_NAME = "PopperContent";
var [$a0ac11a1da65e329$var$PopperContentProvider, $a0ac11a1da65e329$var$useContentContext] = $a0ac11a1da65e329$var$createPopperContext($a0ac11a1da65e329$var$CONTENT_NAME);
var $a0ac11a1da65e329$export$bc4ae5855d3c4fc = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $a0ac11a1da65e329$var$usePopperContext($a0ac11a1da65e329$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $acw62.useState(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $acw62.useState(null);
    const arrowSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($a0ac11a1da65e329$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $461947879dcdbcd4$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $23a8f689f1d4c3be$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $23a8f689f1d4c3be$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $23a8f689f1d4c3be$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $a0ac11a1da65e329$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $23a8f689f1d4c3be$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $a0ac11a1da65e329$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPlaced);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $acw62.useState();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $11cc5513e4deecb5$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$a0ac11a1da65e329$export$bc4ae5855d3c4fc.displayName = $a0ac11a1da65e329$var$CONTENT_NAME;
var $a0ac11a1da65e329$var$ARROW_NAME = "PopperArrow";
var $a0ac11a1da65e329$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $a0ac11a1da65e329$export$79d62cd4e10a3fd0 = $acw62.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $a0ac11a1da65e329$var$useContentContext($a0ac11a1da65e329$var$ARROW_NAME, __scopePopper);
    const baseSide = $a0ac11a1da65e329$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($1002b17d420264b2$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$a0ac11a1da65e329$export$79d62cd4e10a3fd0.displayName = $a0ac11a1da65e329$var$ARROW_NAME;
function $a0ac11a1da65e329$var$isNotNull(value) {
    return value !== null;
}
var $a0ac11a1da65e329$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $a0ac11a1da65e329$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $a0ac11a1da65e329$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $a0ac11a1da65e329$export$be92b6f5f03c0fe9 = $a0ac11a1da65e329$export$badac9ada3a0bdf9;
var $a0ac11a1da65e329$export$b688253958b8dfe7 = $a0ac11a1da65e329$export$ecd4e1ccab6ed6d;
var $a0ac11a1da65e329$export$7c6e2c02157bb7d2 = $a0ac11a1da65e329$export$bc4ae5855d3c4fc;
var $a0ac11a1da65e329$export$21b07c8f274aebd5 = $a0ac11a1da65e329$export$79d62cd4e10a3fd0;



// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $c4c5e54d84f6f930$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $c4c5e54d84f6f930$export$250ffa63cdc0d034 = $c4c5e54d84f6f930$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $c4c5e54d84f6f930$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $c4c5e54d84f6f930$export$be92b6f5f03c0fe9 = $c4c5e54d84f6f930$export$250ffa63cdc0d034;







// src/visually-hidden.tsx

var $acw62 = parcelRequire("acw62");
// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $649ac2fc868eefe0$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $649ac2fc868eefe0$export$250ffa63cdc0d034 = $649ac2fc868eefe0$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $649ac2fc868eefe0$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $649ac2fc868eefe0$export$be92b6f5f03c0fe9 = $649ac2fc868eefe0$export$250ffa63cdc0d034;



var $8d51f093cc1b6735$export$f23ec2f542b3b173 = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
});
var $8d51f093cc1b6735$var$NAME = "VisuallyHidden";
var $8d51f093cc1b6735$export$439d29a4e110a164 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $649ac2fc868eefe0$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            ...$8d51f093cc1b6735$export$f23ec2f542b3b173,
            ...props.style
        }
    });
});
$8d51f093cc1b6735$export$439d29a4e110a164.displayName = $8d51f093cc1b6735$var$NAME;
var $8d51f093cc1b6735$export$be92b6f5f03c0fe9 = $8d51f093cc1b6735$export$439d29a4e110a164;





"use client";
var $a53039b89a0365f7$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $a53039b89a0365f7$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $a53039b89a0365f7$var$SELECT_NAME = "Select";
var [$a53039b89a0365f7$var$Collection, $a53039b89a0365f7$var$useCollection, $a53039b89a0365f7$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($a53039b89a0365f7$var$SELECT_NAME);
var [$a53039b89a0365f7$var$createSelectContext, $a53039b89a0365f7$export$286727a75dc039bd] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a53039b89a0365f7$var$SELECT_NAME, [
    $a53039b89a0365f7$var$createCollectionScope,
    (0, $a0ac11a1da65e329$export$722aac194ae923)
]);
var $a53039b89a0365f7$var$usePopperScope = (0, $a0ac11a1da65e329$export$722aac194ae923)();
var [$a53039b89a0365f7$var$SelectProvider, $a53039b89a0365f7$var$useSelectContext] = $a53039b89a0365f7$var$createSelectContext($a53039b89a0365f7$var$SELECT_NAME);
var [$a53039b89a0365f7$var$SelectNativeOptionsProvider, $a53039b89a0365f7$var$useSelectNativeOptionsContext] = $a53039b89a0365f7$var$createSelectContext($a53039b89a0365f7$var$SELECT_NAME);
var $a53039b89a0365f7$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required, form: form } = props;
    const popperScope = $a53039b89a0365f7$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $acw62.useState(null);
    const [valueNode, setValueNode] = $acw62.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $acw62.useState(false);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $a53039b89a0365f7$var$SELECT_NAME
    });
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange,
        caller: $a53039b89a0365f7$var$SELECT_NAME
    });
    const triggerPointerDownPosRef = $acw62.useRef(null);
    const isFormControl = trigger ? form || !!trigger.closest("form") : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $acw62.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$var$SelectProvider, {
            required: required,
            scope: __scopeSelect,
            trigger: trigger,
            onTriggerChange: setTrigger,
            valueNode: valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren: valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
            value: value,
            onValueChange: setValue,
            open: open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef: triggerPointerDownPosRef,
            disabled: disabled,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: $acw62.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: $acw62.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children: children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$var$SelectBubbleInput, {
                    "aria-hidden": true,
                    required: required,
                    tabIndex: -1,
                    name: name,
                    autoComplete: autoComplete,
                    value: value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled: disabled,
                    form: form,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
$a53039b89a0365f7$export$ef9b1a59e592288f.displayName = $a53039b89a0365f7$var$SELECT_NAME;
var $a53039b89a0365f7$var$TRIGGER_NAME = "SelectTrigger";
var $a53039b89a0365f7$export$3ac1e88a1c0b9f1 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $a53039b89a0365f7$var$usePopperScope(__scopeSelect);
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $a53039b89a0365f7$var$useCollection(__scopeSelect);
    const pointerTypeRef = $acw62.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $a53039b89a0365f7$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $a53039b89a0365f7$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = (pointerEvent)=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
        if (pointerEvent) context.triggerPointerDownPosRef.current = {
            x: Math.round(pointerEvent.pageX),
            y: Math.round(pointerEvent.pageY)
        };
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $a53039b89a0365f7$var$shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
                if (pointerTypeRef.current !== "mouse") handleOpen(event);
            }),
            onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
                pointerTypeRef.current = event.pointerType;
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
                    handleOpen(event);
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($a53039b89a0365f7$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
$a53039b89a0365f7$export$3ac1e88a1c0b9f1.displayName = $a53039b89a0365f7$var$TRIGGER_NAME;
var $a53039b89a0365f7$var$VALUE_NAME = "SelectValue";
var $a53039b89a0365f7$export$e288731fd71264f0 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: $a53039b89a0365f7$var$shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: placeholder
        }) : children
    });
});
$a53039b89a0365f7$export$e288731fd71264f0.displayName = $a53039b89a0365f7$var$VALUE_NAME;
var $a53039b89a0365f7$var$ICON_NAME = "SelectIcon";
var $a53039b89a0365f7$export$99b400cabb58c515 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "\u25BC"
    });
});
$a53039b89a0365f7$export$99b400cabb58c515.displayName = $a53039b89a0365f7$var$ICON_NAME;
var $a53039b89a0365f7$var$PORTAL_NAME = "SelectPortal";
var $a53039b89a0365f7$export$b2af6c9944296213 = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $95d053caea9c023a$export$602eac185826482c), {
        asChild: true,
        ...props
    });
};
$a53039b89a0365f7$export$b2af6c9944296213.displayName = $a53039b89a0365f7$var$PORTAL_NAME;
var $a53039b89a0365f7$var$CONTENT_NAME = "SelectContent";
var $a53039b89a0365f7$export$c973a4b3cb86a03d = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $acw62.useState();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? $1u0KT.createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
$a53039b89a0365f7$export$c973a4b3cb86a03d.displayName = $a53039b89a0365f7$var$CONTENT_NAME;
var $a53039b89a0365f7$var$CONTENT_MARGIN = 10;
var [$a53039b89a0365f7$var$SelectContentProvider, $a53039b89a0365f7$var$useSelectContentContext] = $a53039b89a0365f7$var$createSelectContext($a53039b89a0365f7$var$CONTENT_NAME);
var $a53039b89a0365f7$var$CONTENT_IMPL_NAME = "SelectContentImpl";
var $a53039b89a0365f7$var$Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)("SelectContent.RemoveScroll");
var $a53039b89a0365f7$var$SelectContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: //
    // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, //
    ...contentProps } = props;
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $acw62.useState(null);
    const [viewport, setViewport] = $acw62.useState(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = $acw62.useState(null);
    const [selectedItemText, setSelectedItemText] = $acw62.useState(null);
    const getItems = $a53039b89a0365f7$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $acw62.useState(false);
    const firstValidItemFoundRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, [
        content
    ]);
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    const focusFirst = $acw62.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate?.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate?.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $acw62.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $acw62.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    $acw62.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
                    y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $acw62.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $a53039b89a0365f7$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $a53039b89a0365f7$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = $acw62.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $acw62.useCallback(()=>content?.focus(), [
        content
    ]);
    const itemTextRefCallback = $acw62.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $a53039b89a0365f7$var$SelectPopperPosition : $a53039b89a0365f7$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $a53039b89a0365f7$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
            as: $a53039b89a0365f7$var$Slot,
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
                    context.trigger?.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
$a53039b89a0365f7$var$SelectContentImpl.displayName = $a53039b89a0365f7$var$CONTENT_IMPL_NAME;
var $a53039b89a0365f7$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var $a53039b89a0365f7$var$SelectItemAlignedPosition = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $acw62.useState(null);
    const [content, setContent] = $acw62.useState(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $a53039b89a0365f7$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $acw62.useRef(false);
    const shouldRepositionRef = $acw62.useRef(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = $acw62.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $a53039b89a0365f7$var$CONTENT_MARGIN;
                const clampedLeft = (0, $b488a2b318a95c87$export$7d15b64cf5a3a4c4)(left, [
                    $a53039b89a0365f7$var$CONTENT_MARGIN,
                    // Prevents the content from going off the starting edge of the
                    // viewport. It may still go off the ending edge, but this can be
                    // controlled by the user since they may want to manage overflow in a
                    // specific way.
                    // https://github.com/radix-ui/primitives/issues/2049
                    Math.max($a53039b89a0365f7$var$CONTENT_MARGIN, rightEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $a53039b89a0365f7$var$CONTENT_MARGIN;
                const clampedRight = (0, $b488a2b318a95c87$export$7d15b64cf5a3a4c4)(right, [
                    $a53039b89a0365f7$var$CONTENT_MARGIN,
                    Math.max($a53039b89a0365f7$var$CONTENT_MARGIN, leftEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $a53039b89a0365f7$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $a53039b89a0365f7$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$a53039b89a0365f7$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced?.();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $acw62.useState();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $acw62.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem?.();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
$a53039b89a0365f7$var$SelectItemAlignedPosition.displayName = $a53039b89a0365f7$var$ITEM_ALIGNED_POSITION_NAME;
var $a53039b89a0365f7$var$POPPER_POSITION_NAME = "SelectPopperPosition";
var $a53039b89a0365f7$var$SelectPopperPosition = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $a53039b89a0365f7$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $a53039b89a0365f7$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$7c6e2c02157bb7d2, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$a53039b89a0365f7$var$SelectPopperPosition.displayName = $a53039b89a0365f7$var$POPPER_POSITION_NAME;
var [$a53039b89a0365f7$var$SelectViewportProvider, $a53039b89a0365f7$var$useSelectViewportContext] = $a53039b89a0365f7$var$createSelectContext($a53039b89a0365f7$var$CONTENT_NAME, {});
var $a53039b89a0365f7$var$VIEWPORT_NAME = "SelectViewport";
var $a53039b89a0365f7$export$9ed6e7b40248d36d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, nonce: nonce, ...viewportProps } = props;
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $a53039b89a0365f7$var$useSelectViewportContext($a53039b89a0365f7$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $acw62.useRef(0);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        // Viewport should only be scrollable in the vertical direction.
                        // This won't work in vertical writing modes, so we'll need to
                        // revisit this if/when that is supported
                        // https://developer.chrome.com/blog/vertical-form-controls
                        overflow: "hidden auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
                        if (shouldExpandOnScrollRef?.current && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $a53039b89a0365f7$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
$a53039b89a0365f7$export$9ed6e7b40248d36d.displayName = $a53039b89a0365f7$var$VIEWPORT_NAME;
var $a53039b89a0365f7$var$GROUP_NAME = "SelectGroup";
var [$a53039b89a0365f7$var$SelectGroupContextProvider, $a53039b89a0365f7$var$useSelectGroupContext] = $a53039b89a0365f7$var$createSelectContext($a53039b89a0365f7$var$GROUP_NAME);
var $a53039b89a0365f7$export$ee25a334c55de1f4 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$a53039b89a0365f7$export$ee25a334c55de1f4.displayName = $a53039b89a0365f7$var$GROUP_NAME;
var $a53039b89a0365f7$var$LABEL_NAME = "SelectLabel";
var $a53039b89a0365f7$export$f67338d29bd972f8 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $a53039b89a0365f7$var$useSelectGroupContext($a53039b89a0365f7$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
$a53039b89a0365f7$export$f67338d29bd972f8.displayName = $a53039b89a0365f7$var$LABEL_NAME;
var $a53039b89a0365f7$var$ITEM_NAME = "SelectItem";
var [$a53039b89a0365f7$var$SelectItemContextProvider, $a53039b89a0365f7$var$useSelectItemContext] = $a53039b89a0365f7$var$createSelectContext($a53039b89a0365f7$var$ITEM_NAME);
var $a53039b89a0365f7$export$13ef48a934230896 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$ITEM_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $acw62.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = $acw62.useState(false);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>contentContext.itemRefCallback?.(node, value, disabled));
    const textId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const pointerTypeRef = $acw62.useRef("touch");
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $acw62.useCallback((node)=>{
            setTextValue((prevTextValue)=>prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
                onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onClick, ()=>{
                    if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerUp, ()=>{
                    if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerDown, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                    if (disabled) contentContext.onItemLeave?.();
                    else if (pointerTypeRef.current === "mouse") event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
                    if (event.currentTarget === document.activeElement) contentContext.onItemLeave?.();
                }),
                onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
                    const isTypingAhead = contentContext.searchRef?.current !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($a53039b89a0365f7$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
$a53039b89a0365f7$export$13ef48a934230896.displayName = $a53039b89a0365f7$var$ITEM_NAME;
var $a53039b89a0365f7$var$ITEM_TEXT_NAME = "SelectItemText";
var $a53039b89a0365f7$export$3572fb0fb821ff49 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $a53039b89a0365f7$var$useSelectItemContext($a53039b89a0365f7$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $a53039b89a0365f7$var$useSelectNativeOptionsContext($a53039b89a0365f7$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $acw62.useState(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled));
    const textContent = itemTextNode?.textContent;
    const nativeOption = $acw62.useMemo(()=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? $1u0KT.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
$a53039b89a0365f7$export$3572fb0fb821ff49.displayName = $a53039b89a0365f7$var$ITEM_TEXT_NAME;
var $a53039b89a0365f7$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $a53039b89a0365f7$export$6b9198de19accfe6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $a53039b89a0365f7$var$useSelectItemContext($a53039b89a0365f7$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
$a53039b89a0365f7$export$6b9198de19accfe6.displayName = $a53039b89a0365f7$var$ITEM_INDICATOR_NAME;
var $a53039b89a0365f7$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $a53039b89a0365f7$export$d8117927658af6d7 = $acw62.forwardRef((props, forwardedRef)=>{
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $a53039b89a0365f7$var$useSelectViewportContext($a53039b89a0365f7$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $acw62.useState(false);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
$a53039b89a0365f7$export$d8117927658af6d7.displayName = $a53039b89a0365f7$var$SCROLL_UP_BUTTON_NAME;
var $a53039b89a0365f7$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $a53039b89a0365f7$export$ff951e476c12189 = $acw62.forwardRef((props, forwardedRef)=>{
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $a53039b89a0365f7$var$useSelectViewportContext($a53039b89a0365f7$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $acw62.useState(false);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
$a53039b89a0365f7$export$ff951e476c12189.displayName = $a53039b89a0365f7$var$SCROLL_DOWN_BUTTON_NAME;
var $a53039b89a0365f7$var$SelectScrollButtonImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $acw62.useRef(null);
    const getItems = $a53039b89a0365f7$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $acw62.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $acw62.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem?.ref.current?.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            contentContext.onItemLeave?.();
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var $a53039b89a0365f7$var$SEPARATOR_NAME = "SelectSeparator";
var $a53039b89a0365f7$export$eba4b1df07cb1d3 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
$a53039b89a0365f7$export$eba4b1df07cb1d3.displayName = $a53039b89a0365f7$var$SEPARATOR_NAME;
var $a53039b89a0365f7$var$ARROW_NAME = "SelectArrow";
var $a53039b89a0365f7$export$314f4cb8f8099628 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $a53039b89a0365f7$var$usePopperScope(__scopeSelect);
    const context = $a53039b89a0365f7$var$useSelectContext($a53039b89a0365f7$var$ARROW_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$useSelectContentContext($a53039b89a0365f7$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
$a53039b89a0365f7$export$314f4cb8f8099628.displayName = $a53039b89a0365f7$var$ARROW_NAME;
var $a53039b89a0365f7$var$BUBBLE_INPUT_NAME = "SelectBubbleInput";
var $a53039b89a0365f7$var$SelectBubbleInput = $acw62.forwardRef(({ __scopeSelect: __scopeSelect, value: value, ...props }, forwardedRef)=>{
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(value);
    $acw62.useEffect(()=>{
        const select = ref.current;
        if (!select) return;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c4c5e54d84f6f930$export$250ffa63cdc0d034).select, {
        ...props,
        style: {
            ...(0, $8d51f093cc1b6735$export$f23ec2f542b3b173),
            ...props.style
        },
        ref: composedRefs,
        defaultValue: value
    });
});
$a53039b89a0365f7$var$SelectBubbleInput.displayName = $a53039b89a0365f7$var$BUBBLE_INPUT_NAME;
function $a53039b89a0365f7$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
function $a53039b89a0365f7$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = $acw62.useRef("");
    const timerRef = $acw62.useRef(0);
    const handleTypeaheadSearch = $acw62.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $acw62.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $acw62.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function $a53039b89a0365f7$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $a53039b89a0365f7$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function $a53039b89a0365f7$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $a53039b89a0365f7$export$be92b6f5f03c0fe9 = $a53039b89a0365f7$export$ef9b1a59e592288f;
var $a53039b89a0365f7$export$41fb9f06171c75f4 = $a53039b89a0365f7$export$3ac1e88a1c0b9f1;
var $a53039b89a0365f7$export$4c8d1a57a761ef94 = $a53039b89a0365f7$export$e288731fd71264f0;
var $a53039b89a0365f7$export$f04a61298a47a40f = $a53039b89a0365f7$export$99b400cabb58c515;
var $a53039b89a0365f7$export$602eac185826482c = $a53039b89a0365f7$export$b2af6c9944296213;
var $a53039b89a0365f7$export$7c6e2c02157bb7d2 = $a53039b89a0365f7$export$c973a4b3cb86a03d;
var $a53039b89a0365f7$export$d5c6c08dc2d3ca7 = $a53039b89a0365f7$export$9ed6e7b40248d36d;
var $a53039b89a0365f7$export$eb2fcfdbd7ba97d4 = $a53039b89a0365f7$export$ee25a334c55de1f4;
var $a53039b89a0365f7$export$b04be29aa201d4f5 = $a53039b89a0365f7$export$f67338d29bd972f8;
var $a53039b89a0365f7$export$6d08773d2e66f8f2 = $a53039b89a0365f7$export$13ef48a934230896;
var $a53039b89a0365f7$export$d6e5bf9c43ea9319 = $a53039b89a0365f7$export$3572fb0fb821ff49;
var $a53039b89a0365f7$export$c3468e2714d175fa = $a53039b89a0365f7$export$6b9198de19accfe6;
var $a53039b89a0365f7$export$2f60d3ec9ad468f2 = $a53039b89a0365f7$export$d8117927658af6d7;
var $a53039b89a0365f7$export$bf1aedc3039c8d63 = $a53039b89a0365f7$export$ff951e476c12189;
var $a53039b89a0365f7$export$1ff3c3f08ae963c0 = $a53039b89a0365f7$export$eba4b1df07cb1d3;
var $a53039b89a0365f7$export$21b07c8f274aebd5 = $a53039b89a0365f7$export$314f4cb8f8099628;



var $acw62 = parcelRequire("acw62");







// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $22c4362955498ca2$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $22c4362955498ca2$export$250ffa63cdc0d034 = $22c4362955498ca2$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $22c4362955498ca2$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $22c4362955498ca2$export$be92b6f5f03c0fe9 = $22c4362955498ca2$export$250ffa63cdc0d034;



"use client";
var $99e5d66a1fc753c6$var$CHECKBOX_NAME = "Checkbox";
var [$99e5d66a1fc753c6$var$createCheckboxContext, $99e5d66a1fc753c6$export$b566c4ff5488ea01] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($99e5d66a1fc753c6$var$CHECKBOX_NAME);
var [$99e5d66a1fc753c6$var$CheckboxProviderImpl, $99e5d66a1fc753c6$var$useCheckboxContext] = $99e5d66a1fc753c6$var$createCheckboxContext($99e5d66a1fc753c6$var$CHECKBOX_NAME);
function $99e5d66a1fc753c6$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $99e5d66a1fc753c6$var$CHECKBOX_NAME
    });
    const [control, setControl] = $acw62.useState(null);
    const [bubbleInput, setBubbleInput] = $acw62.useState(null);
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: $99e5d66a1fc753c6$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $99e5d66a1fc753c6$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $99e5d66a1fc753c6$var$TRIGGER_NAME = "CheckboxTrigger";
var $99e5d66a1fc753c6$export$1386466acbe59ca2 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef)=>{
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $acw62.useRef(checked);
    $acw62.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $22c4362955498ca2$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $99e5d66a1fc753c6$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onClick, (event)=>{
            setChecked((prevChecked)=>$99e5d66a1fc753c6$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$99e5d66a1fc753c6$export$1386466acbe59ca2.displayName = $99e5d66a1fc753c6$var$TRIGGER_NAME;
var $99e5d66a1fc753c6$export$48513f6b9f8ce62d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
});
$99e5d66a1fc753c6$export$48513f6b9f8ce62d.displayName = $99e5d66a1fc753c6$var$CHECKBOX_NAME;
var $99e5d66a1fc753c6$var$INDICATOR_NAME = "CheckboxIndicator";
var $99e5d66a1fc753c6$export$59aad738f51d1c05 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || $99e5d66a1fc753c6$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $22c4362955498ca2$export$250ffa63cdc0d034).span, {
            "data-state": $99e5d66a1fc753c6$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$99e5d66a1fc753c6$export$59aad738f51d1c05.displayName = $99e5d66a1fc753c6$var$INDICATOR_NAME;
var $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $99e5d66a1fc753c6$export$493083511fc9f964 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(control);
    $acw62.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
            setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $acw62.useRef($99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $22c4362955498ca2$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$99e5d66a1fc753c6$export$493083511fc9f964.displayName = $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME;
function $99e5d66a1fc753c6$var$isFunction(value) {
    return typeof value === "function";
}
function $99e5d66a1fc753c6$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $99e5d66a1fc753c6$var$getState(checked) {
    return $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}



var $acw62 = parcelRequire("acw62");



// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $9e8f54b32c958b8a$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $9e8f54b32c958b8a$export$250ffa63cdc0d034 = $9e8f54b32c958b8a$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $9e8f54b32c958b8a$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $9e8f54b32c958b8a$export$be92b6f5f03c0fe9 = $9e8f54b32c958b8a$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");





// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $576e67707dc01225$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $576e67707dc01225$export$250ffa63cdc0d034 = $576e67707dc01225$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $576e67707dc01225$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $576e67707dc01225$export$be92b6f5f03c0fe9 = $576e67707dc01225$export$250ffa63cdc0d034;






"use client";
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$8699f7c8af148338 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$0483c88073bf4923$export$8699f7c8af148338.displayName = $0483c88073bf4923$var$GROUP_NAME;
var $0483c88073bf4923$var$RovingFocusGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $0483c88073bf4923$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $576e67707dc01225$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$ab9df7c53fe8454 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    $acw62.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $576e67707dc01225$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
$0483c88073bf4923$export$ab9df7c53fe8454.displayName = $0483c88073bf4923$var$ITEM_NAME;
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
var $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;








"use client";
var $6e3785e657478a72$var$RADIO_NAME = "Radio";
var [$6e3785e657478a72$var$createRadioContext, $6e3785e657478a72$var$createRadioScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($6e3785e657478a72$var$RADIO_NAME);
var [$6e3785e657478a72$var$RadioProvider, $6e3785e657478a72$var$useRadioContext] = $6e3785e657478a72$var$createRadioContext($6e3785e657478a72$var$RADIO_NAME);
var $6e3785e657478a72$var$Radio = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, form: form, ...radioProps } = props;
    const [button, setButton] = $acw62.useState(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($6e3785e657478a72$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9e8f54b32c958b8a$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "radio",
                "aria-checked": checked,
                "data-state": $6e3785e657478a72$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...radioProps,
                ref: composedRefs,
                onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    if (!checked) onCheck?.();
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($6e3785e657478a72$var$RadioBubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$6e3785e657478a72$var$Radio.displayName = $6e3785e657478a72$var$RADIO_NAME;
var $6e3785e657478a72$var$INDICATOR_NAME = "RadioIndicator";
var $6e3785e657478a72$var$RadioIndicator = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $6e3785e657478a72$var$useRadioContext($6e3785e657478a72$var$INDICATOR_NAME, __scopeRadio);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.checked,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9e8f54b32c958b8a$export$250ffa63cdc0d034).span, {
            "data-state": $6e3785e657478a72$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef
        })
    });
});
$6e3785e657478a72$var$RadioIndicator.displayName = $6e3785e657478a72$var$INDICATOR_NAME;
var $6e3785e657478a72$var$BUBBLE_INPUT_NAME = "RadioBubbleInput";
var $6e3785e657478a72$var$RadioBubbleInput = $acw62.forwardRef(({ __scopeRadio: __scopeRadio, control: control, checked: checked, bubbles: bubbles = true, ...props }, forwardedRef)=>{
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(ref, forwardedRef);
    const prevChecked = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(control);
    $acw62.useEffect(()=>{
        const input = ref.current;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9e8f54b32c958b8a$export$250ffa63cdc0d034).input, {
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
});
$6e3785e657478a72$var$RadioBubbleInput.displayName = $6e3785e657478a72$var$BUBBLE_INPUT_NAME;
function $6e3785e657478a72$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $6e3785e657478a72$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var $6e3785e657478a72$var$RADIO_GROUP_NAME = "RadioGroup";
var [$6e3785e657478a72$var$createRadioGroupContext, $6e3785e657478a72$export$c547093f11b76da2] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($6e3785e657478a72$var$RADIO_GROUP_NAME, [
    (0, $0483c88073bf4923$export$c7109489551a4f4),
    $6e3785e657478a72$var$createRadioScope
]);
var $6e3785e657478a72$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var $6e3785e657478a72$var$useRadioScope = $6e3785e657478a72$var$createRadioScope();
var [$6e3785e657478a72$var$RadioGroupProvider, $6e3785e657478a72$var$useRadioGroupContext] = $6e3785e657478a72$var$createRadioGroupContext($6e3785e657478a72$var$RADIO_GROUP_NAME);
var $6e3785e657478a72$export$a98f0dcb43a68a25 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $6e3785e657478a72$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? null,
        onChange: onValueChange,
        caller: $6e3785e657478a72$var$RADIO_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($6e3785e657478a72$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9e8f54b32c958b8a$export$250ffa63cdc0d034).div, {
                role: "radiogroup",
                "aria-required": required,
                "aria-orientation": orientation,
                "data-disabled": disabled ? "" : void 0,
                dir: direction,
                ...groupProps,
                ref: forwardedRef
            })
        })
    });
});
$6e3785e657478a72$export$a98f0dcb43a68a25.displayName = $6e3785e657478a72$var$RADIO_GROUP_NAME;
var $6e3785e657478a72$var$ITEM_NAME = "RadioGroupItem";
var $6e3785e657478a72$export$9f866c100ef519e4 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $6e3785e657478a72$var$useRadioGroupContext($6e3785e657478a72$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $6e3785e657478a72$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $6e3785e657478a72$var$useRadioScope(__scopeRadioGroup);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if ($6e3785e657478a72$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !isDisabled,
        active: checked,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($6e3785e657478a72$var$Radio, {
            disabled: isDisabled,
            required: context.required,
            checked: checked,
            ...radioScope,
            ...itemProps,
            name: context.name,
            ref: composedRefs,
            onCheck: ()=>context.onValueChange(itemProps.value),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)((event)=>{
                if (event.key === "Enter") event.preventDefault();
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>{
                if (isArrowKeyPressedRef.current) ref.current?.click();
            })
        })
    });
});
$6e3785e657478a72$export$9f866c100ef519e4.displayName = $6e3785e657478a72$var$ITEM_NAME;
var $6e3785e657478a72$var$INDICATOR_NAME2 = "RadioGroupIndicator";
var $6e3785e657478a72$export$5fb54c671a65c88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $6e3785e657478a72$var$useRadioScope(__scopeRadioGroup);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($6e3785e657478a72$var$RadioIndicator, {
        ...radioScope,
        ...indicatorProps,
        ref: forwardedRef
    });
});
$6e3785e657478a72$export$5fb54c671a65c88.displayName = $6e3785e657478a72$var$INDICATOR_NAME2;
var $6e3785e657478a72$export$be92b6f5f03c0fe9 = $6e3785e657478a72$export$a98f0dcb43a68a25;
var $6e3785e657478a72$export$6d08773d2e66f8f2 = $6e3785e657478a72$export$9f866c100ef519e4;
var $6e3785e657478a72$export$adb584737d712b70 = $6e3785e657478a72$export$5fb54c671a65c88;



var $acw62 = parcelRequire("acw62");


// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $d7c103ab5acf82e5$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $d7c103ab5acf82e5$export$250ffa63cdc0d034 = $d7c103ab5acf82e5$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $d7c103ab5acf82e5$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $d7c103ab5acf82e5$export$be92b6f5f03c0fe9 = $d7c103ab5acf82e5$export$250ffa63cdc0d034;



"use client";
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$bea8ebba691c5813 = $acw62.forwardRef((props, forwardedRef)=>{
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed, setPressed] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed ?? false,
        caller: $62b265af90252982$var$NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d7c103ab5acf82e5$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
});
$62b265af90252982$export$bea8ebba691c5813.displayName = $62b265af90252982$var$NAME;
var $62b265af90252982$export$be92b6f5f03c0fe9 = $62b265af90252982$export$bea8ebba691c5813;



var $acw62 = parcelRequire("acw62");




// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $03b33fdb9adb443d$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $03b33fdb9adb443d$export$250ffa63cdc0d034 = $03b33fdb9adb443d$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $03b33fdb9adb443d$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $03b33fdb9adb443d$export$be92b6f5f03c0fe9 = $03b33fdb9adb443d$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");












// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $3a849823db0e7dc9$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $3a849823db0e7dc9$export$250ffa63cdc0d034 = $3a849823db0e7dc9$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $3a849823db0e7dc9$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $3a849823db0e7dc9$export$be92b6f5f03c0fe9 = $3a849823db0e7dc9$export$250ffa63cdc0d034;








"use client";
var $82110f2367303f9b$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $82110f2367303f9b$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $82110f2367303f9b$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $82110f2367303f9b$var$FIRST_LAST_KEYS = [
    ...$82110f2367303f9b$var$FIRST_KEYS,
    ...$82110f2367303f9b$var$LAST_KEYS
];
var $82110f2367303f9b$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$82110f2367303f9b$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$82110f2367303f9b$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var $82110f2367303f9b$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var $82110f2367303f9b$var$MENU_NAME = "Menu";
var [$82110f2367303f9b$var$Collection, $82110f2367303f9b$var$useCollection, $82110f2367303f9b$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($82110f2367303f9b$var$MENU_NAME);
var [$82110f2367303f9b$var$createMenuContext, $82110f2367303f9b$export$4027731b685e72eb] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($82110f2367303f9b$var$MENU_NAME, [
    $82110f2367303f9b$var$createCollectionScope,
    (0, $a0ac11a1da65e329$export$722aac194ae923),
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
var $82110f2367303f9b$var$usePopperScope = (0, $a0ac11a1da65e329$export$722aac194ae923)();
var $82110f2367303f9b$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var [$82110f2367303f9b$var$MenuProvider, $82110f2367303f9b$var$useMenuContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$MENU_NAME);
var [$82110f2367303f9b$var$MenuRootProvider, $82110f2367303f9b$var$useMenuRootContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$MENU_NAME);
var $82110f2367303f9b$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    const [content, setContent] = $acw62.useState(null);
    const isUsingKeyboardRef = $acw62.useRef(false);
    const handleOpenChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    $acw62.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuRootProvider, {
                scope: __scopeMenu,
                onClose: $acw62.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef: isUsingKeyboardRef,
                dir: direction,
                modal: modal,
                children: children
            })
        })
    });
};
$82110f2367303f9b$export$d9b273488cd8ce6f.displayName = $82110f2367303f9b$var$MENU_NAME;
var $82110f2367303f9b$var$ANCHOR_NAME = "MenuAnchor";
var $82110f2367303f9b$export$9fa5ebd18bee4d43 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$9fa5ebd18bee4d43.displayName = $82110f2367303f9b$var$ANCHOR_NAME;
var $82110f2367303f9b$var$PORTAL_NAME = "MenuPortal";
var [$82110f2367303f9b$var$PortalProvider, $82110f2367303f9b$var$usePortalContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$PORTAL_NAME, {
    forceMount: void 0
});
var $82110f2367303f9b$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $95d053caea9c023a$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$82110f2367303f9b$export$793392f970497feb.displayName = $82110f2367303f9b$var$PORTAL_NAME;
var $82110f2367303f9b$var$CONTENT_NAME = "MenuContent";
var [$82110f2367303f9b$var$MenuContentProvider, $82110f2367303f9b$var$useMenuContentContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$CONTENT_NAME);
var $82110f2367303f9b$export$479f0f2f71193efe = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$usePortalContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var $82110f2367303f9b$var$MenuRootContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $82110f2367303f9b$var$MenuRootContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $82110f2367303f9b$var$Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)("MenuContent.ScrollLock");
var $82110f2367303f9b$var$MenuContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $82110f2367303f9b$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = $acw62.useState(null);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = $acw62.useRef(0);
    const searchRef = $acw62.useRef("");
    const pointerGraceTimerRef = $acw62.useRef(0);
    const pointerGraceIntentRef = $acw62.useRef(null);
    const pointerDirRef = $acw62.useRef("right");
    const lastPointerXRef = $acw62.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039) : $acw62.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: $82110f2367303f9b$var$Slot,
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = items.find((item)=>item.ref.current === currentItem)?.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $82110f2367303f9b$var$getNextMatch(values, search, currentMatch);
        const newItem = items.find((item)=>item.textValue === nextMatch)?.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    $acw62.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = $acw62.useCallback((event)=>{
        const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
        return isMovingTowards && $82110f2367303f9b$var$isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: $acw62.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: $acw62.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: $acw62.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: $acw62.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    contentRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: disableOutsidePointerEvents,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: onFocusOutside,
                    onInteractOutside: onInteractOutside,
                    onDismiss: onDismiss,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop: loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$7c6e2c02157bb7d2, {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": $82110f2367303f9b$var$getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!$82110f2367303f9b$var$FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if ($82110f2367303f9b$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                $82110f2367303f9b$var$focusFirst(candidateNodes);
                            }),
                            onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
$82110f2367303f9b$export$479f0f2f71193efe.displayName = $82110f2367303f9b$var$CONTENT_NAME;
var $82110f2367303f9b$var$GROUP_NAME = "MenuGroup";
var $82110f2367303f9b$export$22a631d1f72787bb = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$22a631d1f72787bb.displayName = $82110f2367303f9b$var$GROUP_NAME;
var $82110f2367303f9b$var$LABEL_NAME = "MenuLabel";
var $82110f2367303f9b$export$dd37bec0e8a99143 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$dd37bec0e8a99143.displayName = $82110f2367303f9b$var$LABEL_NAME;
var $82110f2367303f9b$var$ITEM_NAME = "MenuItem";
var $82110f2367303f9b$var$ITEM_SELECT = "menu.itemSelect";
var $82110f2367303f9b$export$2ce376c2cc3355c8 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = $acw62.useRef(null);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$useMenuContentContext($82110f2367303f9b$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = $acw62.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($82110f2367303f9b$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($82110f2367303f9b$var$ITEM_SELECT, (event)=>onSelect?.(event), {
                once: true
            });
            (0, $3a849823db0e7dc9$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            props.onPointerDown?.(event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($82110f2367303f9b$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
$82110f2367303f9b$export$2ce376c2cc3355c8.displayName = $82110f2367303f9b$var$ITEM_NAME;
var $82110f2367303f9b$var$MenuItemImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $82110f2367303f9b$var$useMenuContentContext($82110f2367303f9b$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = $acw62.useState(false);
    const [textContent, setTextContent] = $acw62.useState("");
    $acw62.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) setTextContent((menuItem.textContent ?? "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerLeave, $82110f2367303f9b$var$whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var $82110f2367303f9b$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $82110f2367303f9b$export$f6f243521332502d = $acw62.forwardRef((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ce376c2cc3355c8, {
            role: "menuitemcheckbox",
            "aria-checked": $82110f2367303f9b$var$isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": $82110f2367303f9b$var$getCheckedState(checked),
            onSelect: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange?.($82110f2367303f9b$var$isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$82110f2367303f9b$export$f6f243521332502d.displayName = $82110f2367303f9b$var$CHECKBOX_ITEM_NAME;
var $82110f2367303f9b$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var [$82110f2367303f9b$var$RadioGroupProvider, $82110f2367303f9b$var$useRadioGroupContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var $82110f2367303f9b$export$ea2200c9eee416b3 = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onValueChange);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$22a631d1f72787bb, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$82110f2367303f9b$export$ea2200c9eee416b3.displayName = $82110f2367303f9b$var$RADIO_GROUP_NAME;
var $82110f2367303f9b$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $82110f2367303f9b$export$69bd225e9817f6d0 = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $82110f2367303f9b$var$useRadioGroupContext($82110f2367303f9b$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ce376c2cc3355c8, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": $82110f2367303f9b$var$getCheckedState(checked),
            onSelect: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>context.onValueChange?.(value), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$82110f2367303f9b$export$69bd225e9817f6d0.displayName = $82110f2367303f9b$var$RADIO_ITEM_NAME;
var $82110f2367303f9b$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [$82110f2367303f9b$var$ItemIndicatorProvider, $82110f2367303f9b$var$useItemIndicatorContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$ITEM_INDICATOR_NAME, {
    checked: false
});
var $82110f2367303f9b$export$a2593e23056970a3 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $82110f2367303f9b$var$useItemIndicatorContext($82110f2367303f9b$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || $82110f2367303f9b$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": $82110f2367303f9b$var$getCheckedState(indicatorContext.checked)
        })
    });
});
$82110f2367303f9b$export$a2593e23056970a3.displayName = $82110f2367303f9b$var$ITEM_INDICATOR_NAME;
var $82110f2367303f9b$var$SEPARATOR_NAME = "MenuSeparator";
var $82110f2367303f9b$export$1cec7dcdd713e220 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$1cec7dcdd713e220.displayName = $82110f2367303f9b$var$SEPARATOR_NAME;
var $82110f2367303f9b$var$ARROW_NAME = "MenuArrow";
var $82110f2367303f9b$export$bcdda4773debf5fa = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$bcdda4773debf5fa.displayName = $82110f2367303f9b$var$ARROW_NAME;
var $82110f2367303f9b$var$SUB_NAME = "MenuSub";
var [$82110f2367303f9b$var$MenuSubProvider, $82110f2367303f9b$var$useMenuSubContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$SUB_NAME);
var $82110f2367303f9b$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$SUB_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = $acw62.useState(null);
    const [content, setContent] = $acw62.useState(null);
    const handleOpenChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onOpenChange);
    $acw62.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a0ac11a1da65e329$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
                triggerId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
                trigger: trigger,
                onTriggerChange: setTrigger,
                children: children
            })
        })
    });
};
$82110f2367303f9b$export$71bdb9d1e2909932.displayName = $82110f2367303f9b$var$SUB_NAME;
var $82110f2367303f9b$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $82110f2367303f9b$export$5fbbb3ba7297405f = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$useMenuSubContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$useMenuContentContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = $acw62.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = $acw62.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    $acw62.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    $acw62.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$9fa5ebd18bee4d43, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": $82110f2367303f9b$var$getOpenState(context.open),
            ...props,
            ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                props.onClick?.(event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerLeave, $82110f2367303f9b$var$whenMouse((event)=>{
                clearOpenTimer();
                const contentRect = context.content?.getBoundingClientRect();
                if (contentRect) {
                    const side = context.content?.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side: side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if ($82110f2367303f9b$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    context.onOpenChange(true);
                    context.content?.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
$82110f2367303f9b$export$5fbbb3ba7297405f.displayName = $82110f2367303f9b$var$SUB_TRIGGER_NAME;
var $82110f2367303f9b$var$SUB_CONTENT_NAME = "MenuSubContent";
var $82110f2367303f9b$export$e7142ab31822bde6 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$usePortalContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$useMenuSubContext($82110f2367303f9b$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = $82110f2367303f9b$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            context.onOpenChange(false);
                            subContext.trigger?.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
$82110f2367303f9b$export$e7142ab31822bde6.displayName = $82110f2367303f9b$var$SUB_CONTENT_NAME;
function $82110f2367303f9b$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $82110f2367303f9b$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $82110f2367303f9b$var$getCheckedState(checked) {
    return $82110f2367303f9b$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $82110f2367303f9b$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $82110f2367303f9b$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function $82110f2367303f9b$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $82110f2367303f9b$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $82110f2367303f9b$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $82110f2367303f9b$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $82110f2367303f9b$var$isPointInPolygon(cursorPos, area);
}
function $82110f2367303f9b$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $82110f2367303f9b$export$be92b6f5f03c0fe9 = $82110f2367303f9b$export$d9b273488cd8ce6f;
var $82110f2367303f9b$export$b688253958b8dfe7 = $82110f2367303f9b$export$9fa5ebd18bee4d43;
var $82110f2367303f9b$export$602eac185826482c = $82110f2367303f9b$export$793392f970497feb;
var $82110f2367303f9b$export$7c6e2c02157bb7d2 = $82110f2367303f9b$export$479f0f2f71193efe;
var $82110f2367303f9b$export$eb2fcfdbd7ba97d4 = $82110f2367303f9b$export$22a631d1f72787bb;
var $82110f2367303f9b$export$b04be29aa201d4f5 = $82110f2367303f9b$export$dd37bec0e8a99143;
var $82110f2367303f9b$export$6d08773d2e66f8f2 = $82110f2367303f9b$export$2ce376c2cc3355c8;
var $82110f2367303f9b$export$16ce288f89fa631c = $82110f2367303f9b$export$f6f243521332502d;
var $82110f2367303f9b$export$a98f0dcb43a68a25 = $82110f2367303f9b$export$ea2200c9eee416b3;
var $82110f2367303f9b$export$371ab307eab489c0 = $82110f2367303f9b$export$69bd225e9817f6d0;
var $82110f2367303f9b$export$c3468e2714d175fa = $82110f2367303f9b$export$a2593e23056970a3;
var $82110f2367303f9b$export$1ff3c3f08ae963c0 = $82110f2367303f9b$export$1cec7dcdd713e220;
var $82110f2367303f9b$export$21b07c8f274aebd5 = $82110f2367303f9b$export$bcdda4773debf5fa;
var $82110f2367303f9b$export$d7a01e11500dfb6f = $82110f2367303f9b$export$71bdb9d1e2909932;
var $82110f2367303f9b$export$2ea8a7a591ac5eac = $82110f2367303f9b$export$5fbbb3ba7297405f;
var $82110f2367303f9b$export$6d4de93b380beddf = $82110f2367303f9b$export$e7142ab31822bde6;




"use client";
var $a51a7192f883dda1$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var [$a51a7192f883dda1$var$createDropdownMenuContext, $a51a7192f883dda1$export$c0623cd925aeb687] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a51a7192f883dda1$var$DROPDOWN_MENU_NAME, [
    (0, $82110f2367303f9b$export$4027731b685e72eb)
]);
var $a51a7192f883dda1$var$useMenuScope = (0, $82110f2367303f9b$export$4027731b685e72eb)();
var [$a51a7192f883dda1$var$DropdownMenuProvider, $a51a7192f883dda1$var$useDropdownMenuContext] = $a51a7192f883dda1$var$createDropdownMenuContext($a51a7192f883dda1$var$DROPDOWN_MENU_NAME);
var $a51a7192f883dda1$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $a51a7192f883dda1$var$DROPDOWN_MENU_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$be92b6f5f03c0fe9, {
            ...menuScope,
            open: open,
            onOpenChange: setOpen,
            dir: dir,
            modal: modal,
            children: children
        })
    });
};
$a51a7192f883dda1$export$e44a253a59704894.displayName = $a51a7192f883dda1$var$DROPDOWN_MENU_NAME;
var $a51a7192f883dda1$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $a51a7192f883dda1$export$d2469213b3befba9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $a51a7192f883dda1$var$useDropdownMenuContext($a51a7192f883dda1$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$b688253958b8dfe7, {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03b33fdb9adb443d$export$250ffa63cdc0d034).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            ...triggerProps,
            ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
            onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
$a51a7192f883dda1$export$d2469213b3befba9.displayName = $a51a7192f883dda1$var$TRIGGER_NAME;
var $a51a7192f883dda1$var$PORTAL_NAME = "DropdownMenuPortal";
var $a51a7192f883dda1$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$602eac185826482c, {
        ...menuScope,
        ...portalProps
    });
};
$a51a7192f883dda1$export$cd369b4d4d54efc9.displayName = $a51a7192f883dda1$var$PORTAL_NAME;
var $a51a7192f883dda1$var$CONTENT_NAME = "DropdownMenuContent";
var $a51a7192f883dda1$export$6e76d93a37c01248 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $a51a7192f883dda1$var$useDropdownMenuContext($a51a7192f883dda1$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$7c6e2c02157bb7d2, {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$a51a7192f883dda1$export$6e76d93a37c01248.displayName = $a51a7192f883dda1$var$CONTENT_NAME;
var $a51a7192f883dda1$var$GROUP_NAME = "DropdownMenuGroup";
var $a51a7192f883dda1$export$246bebaba3a2f70e = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$eb2fcfdbd7ba97d4, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$246bebaba3a2f70e.displayName = $a51a7192f883dda1$var$GROUP_NAME;
var $a51a7192f883dda1$var$LABEL_NAME = "DropdownMenuLabel";
var $a51a7192f883dda1$export$76e48c5b57f24495 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$b04be29aa201d4f5, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$76e48c5b57f24495.displayName = $a51a7192f883dda1$var$LABEL_NAME;
var $a51a7192f883dda1$var$ITEM_NAME = "DropdownMenuItem";
var $a51a7192f883dda1$export$ed97964d1871885d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$6d08773d2e66f8f2, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$ed97964d1871885d.displayName = $a51a7192f883dda1$var$ITEM_NAME;
var $a51a7192f883dda1$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $a51a7192f883dda1$export$53a69729da201fa9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$16ce288f89fa631c, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$53a69729da201fa9.displayName = $a51a7192f883dda1$var$CHECKBOX_ITEM_NAME;
var $a51a7192f883dda1$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $a51a7192f883dda1$export$3323ad73d55f587e = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$a98f0dcb43a68a25, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$3323ad73d55f587e.displayName = $a51a7192f883dda1$var$RADIO_GROUP_NAME;
var $a51a7192f883dda1$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $a51a7192f883dda1$export$e4f69b41b1637536 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$371ab307eab489c0, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$e4f69b41b1637536.displayName = $a51a7192f883dda1$var$RADIO_ITEM_NAME;
var $a51a7192f883dda1$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $a51a7192f883dda1$export$42355ae145153fb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$c3468e2714d175fa, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$42355ae145153fb6.displayName = $a51a7192f883dda1$var$INDICATOR_NAME;
var $a51a7192f883dda1$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $a51a7192f883dda1$export$da160178fd3bc7e9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$1ff3c3f08ae963c0, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$da160178fd3bc7e9.displayName = $a51a7192f883dda1$var$SEPARATOR_NAME;
var $a51a7192f883dda1$var$ARROW_NAME = "DropdownMenuArrow";
var $a51a7192f883dda1$export$34b8980744021ec5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$21b07c8f274aebd5, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$34b8980744021ec5.displayName = $a51a7192f883dda1$var$ARROW_NAME;
var $a51a7192f883dda1$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: "DropdownMenuSub"
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$d7a01e11500dfb6f, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
var $a51a7192f883dda1$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $a51a7192f883dda1$export$21dcb7ec56f874cf = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ea8a7a591ac5eac, {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$21dcb7ec56f874cf.displayName = $a51a7192f883dda1$var$SUB_TRIGGER_NAME;
var $a51a7192f883dda1$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $a51a7192f883dda1$export$f34ec8bc2482cc5f = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$6d4de93b380beddf, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$a51a7192f883dda1$export$f34ec8bc2482cc5f.displayName = $a51a7192f883dda1$var$SUB_CONTENT_NAME;
var $a51a7192f883dda1$export$be92b6f5f03c0fe9 = $a51a7192f883dda1$export$e44a253a59704894;
var $a51a7192f883dda1$export$41fb9f06171c75f4 = $a51a7192f883dda1$export$d2469213b3befba9;
var $a51a7192f883dda1$export$602eac185826482c = $a51a7192f883dda1$export$cd369b4d4d54efc9;
var $a51a7192f883dda1$export$7c6e2c02157bb7d2 = $a51a7192f883dda1$export$6e76d93a37c01248;
var $a51a7192f883dda1$export$eb2fcfdbd7ba97d4 = $a51a7192f883dda1$export$246bebaba3a2f70e;
var $a51a7192f883dda1$export$b04be29aa201d4f5 = $a51a7192f883dda1$export$76e48c5b57f24495;
var $a51a7192f883dda1$export$6d08773d2e66f8f2 = $a51a7192f883dda1$export$ed97964d1871885d;
var $a51a7192f883dda1$export$16ce288f89fa631c = $a51a7192f883dda1$export$53a69729da201fa9;
var $a51a7192f883dda1$export$a98f0dcb43a68a25 = $a51a7192f883dda1$export$3323ad73d55f587e;
var $a51a7192f883dda1$export$371ab307eab489c0 = $a51a7192f883dda1$export$e4f69b41b1637536;
var $a51a7192f883dda1$export$c3468e2714d175fa = $a51a7192f883dda1$export$42355ae145153fb6;
var $a51a7192f883dda1$export$1ff3c3f08ae963c0 = $a51a7192f883dda1$export$da160178fd3bc7e9;
var $a51a7192f883dda1$export$21b07c8f274aebd5 = $a51a7192f883dda1$export$34b8980744021ec5;
var $a51a7192f883dda1$export$d7a01e11500dfb6f = $a51a7192f883dda1$export$2f307d81a64f5442;
var $a51a7192f883dda1$export$2ea8a7a591ac5eac = $a51a7192f883dda1$export$21dcb7ec56f874cf;
var $a51a7192f883dda1$export$6d4de93b380beddf = $a51a7192f883dda1$export$f34ec8bc2482cc5f;



var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();



const $0c417c97818a47bb$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $0c417c97818a47bb$export$8cc09085015f0dc7(file, path, h) {
    const f = $0c417c97818a47bb$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $0c417c97818a47bb$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $0c417c97818a47bb$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $0c417c97818a47bb$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $0c417c97818a47bb$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $0c417c97818a47bb$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}


const $5cf572b3062ef12c$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $5cf572b3062ef12c$export$a36e16046ae8f1bb(evt) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if ($5cf572b3062ef12c$var$isObject(evt) && $5cf572b3062ef12c$var$isDataTransfer(evt.dataTransfer)) return $5cf572b3062ef12c$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($5cf572b3062ef12c$var$isChangeEvt(evt)) return $5cf572b3062ef12c$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $5cf572b3062ef12c$var$getFsHandleFiles(evt);
        return [];
    });
}
function $5cf572b3062ef12c$var$isDataTransfer(value) {
    return $5cf572b3062ef12c$var$isObject(value);
}
function $5cf572b3062ef12c$var$isChangeEvt(value) {
    return $5cf572b3062ef12c$var$isObject(value) && $5cf572b3062ef12c$var$isObject(value.target);
}
function $5cf572b3062ef12c$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $5cf572b3062ef12c$var$getInputFiles(evt) {
    return $5cf572b3062ef12c$var$fromList(evt.target.files).map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $5cf572b3062ef12c$var$getFsHandleFiles(handles) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file));
    });
}
function $5cf572b3062ef12c$var$getDataTransferFiles(dt, type) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $5cf572b3062ef12c$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($5cf572b3062ef12c$var$toFilePromises));
            return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$flatten(files));
        }
        return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$fromList(dt.files).map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file)));
    });
}
function $5cf572b3062ef12c$var$noIgnoredFiles(files) {
    return files.filter((file)=>$5cf572b3062ef12c$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $5cf572b3062ef12c$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $5cf572b3062ef12c$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $5cf572b3062ef12c$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $5cf572b3062ef12c$var$fromDirEntry(entry);
    return $5cf572b3062ef12c$var$fromDataTransferItem(item, entry);
}
function $5cf572b3062ef12c$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $5cf572b3062ef12c$var$flatten(files) : [
                files
            ]
        ], []);
}
function $5cf572b3062ef12c$var$fromDataTransferItem(item, entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $5cf572b3062ef12c$var$fromEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $5cf572b3062ef12c$var$fromDirEntry(entry) : $5cf572b3062ef12c$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $5cf572b3062ef12c$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($5cf572b3062ef12c$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $5cf572b3062ef12c$var$fromFileEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$var$accepts = typeof (0, $000a86df99a95c54$export$2e2bcd8739ae039) === "function" ? (0, $000a86df99a95c54$export$2e2bcd8739ae039) : (0, $000a86df99a95c54$export$2e2bcd8739ae039).default; // Error codes
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
};
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $aaac53b849ab07d4$export$2a44042abbda425f(file) {
    return file.type === "" && typeof file.getAsFile === "function";
}
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $aaac53b849ab07d4$var$accepts(file, accept) || $aaac53b849ab07d4$export$2a44042abbda425f(file);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 


var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $5cf572b3062ef12c$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {boolean} isDragGlobal Files are being dragged anywhere on the document
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    isDragGlobal: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $aaac53b849ab07d4$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var globalDragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Track global drag state for document-level drag events
    (0, $acw62.useEffect)(function() {
        var onDocumentDragEnter = function onDocumentDragEnter(event) {
            globalDragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(globalDragTargetsRef.current), [
                event.target
            ]);
            if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) dispatch({
                isDragGlobal: true,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragLeave = function onDocumentDragLeave(event) {
            // Only deactivate once we've left all children
            globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function(el) {
                return el !== event.target && el !== null;
            });
            if (globalDragTargetsRef.current.length > 0) return;
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragEnd = function onDocumentDragEnd() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDropGlobal = function onDocumentDropGlobal() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        document.addEventListener("dragenter", onDocumentDragEnter, false);
        document.addEventListener("dragleave", onDocumentDragLeave, false);
        document.addEventListener("dragend", onDocumentDragEnd, false);
        document.addEventListener("drop", onDocumentDropGlobal, false);
        return function() {
            document.removeEventListener("dragenter", onDocumentDragEnter);
            document.removeEventListener("dragleave", onDocumentDragLeave);
            document.removeEventListener("dragend", onDocumentDragEnd);
            document.removeEventListener("drop", onDocumentDropGlobal);
        };
    }, [
        rootRef
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $aaac53b849ab07d4$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $aaac53b849ab07d4$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "setDragGlobal":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragGlobal: action.isDragGlobal
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}




var $439a5f313b2b0ed7$var$U = 1, $439a5f313b2b0ed7$var$Y = .9, $439a5f313b2b0ed7$var$H = .8, $439a5f313b2b0ed7$var$J = .17, $439a5f313b2b0ed7$var$p = .1, $439a5f313b2b0ed7$var$u = .999, $439a5f313b2b0ed7$var$$ = .9999;
var $439a5f313b2b0ed7$var$k = .99, $439a5f313b2b0ed7$var$m = /[\\\/_+.#"@\[\(\{&]/, $439a5f313b2b0ed7$var$B = /[\\\/_+.#"@\[\(\{&]/g, $439a5f313b2b0ed7$var$K = /[\s-]/, $439a5f313b2b0ed7$var$X = /[\s-]/g;
function $439a5f313b2b0ed7$var$G(_, C, h, P, A, f, O) {
    if (f === C.length) return A === _.length ? $439a5f313b2b0ed7$var$U : $439a5f313b2b0ed7$var$k;
    var T = `${A},${f}`;
    if (O[T] !== void 0) return O[T];
    for(var L = P.charAt(f), c = h.indexOf(L, A), S = 0, E, N, R, M; c >= 0;)E = $439a5f313b2b0ed7$var$G(_, C, h, P, c + 1, f + 1, O), E > S && (c === A ? E *= $439a5f313b2b0ed7$var$U : $439a5f313b2b0ed7$var$m.test(_.charAt(c - 1)) ? (E *= $439a5f313b2b0ed7$var$H, R = _.slice(A, c - 1).match($439a5f313b2b0ed7$var$B), R && A > 0 && (E *= Math.pow($439a5f313b2b0ed7$var$u, R.length))) : $439a5f313b2b0ed7$var$K.test(_.charAt(c - 1)) ? (E *= $439a5f313b2b0ed7$var$Y, M = _.slice(A, c - 1).match($439a5f313b2b0ed7$var$X), M && A > 0 && (E *= Math.pow($439a5f313b2b0ed7$var$u, M.length))) : (E *= $439a5f313b2b0ed7$var$J, A > 0 && (E *= Math.pow($439a5f313b2b0ed7$var$u, c - A))), _.charAt(c) !== C.charAt(f) && (E *= $439a5f313b2b0ed7$var$$)), (E < $439a5f313b2b0ed7$var$p && h.charAt(c - 1) === P.charAt(f + 1) || P.charAt(f + 1) === P.charAt(f) && h.charAt(c - 1) !== P.charAt(f)) && (N = $439a5f313b2b0ed7$var$G(_, C, h, P, c + 1, f + 2, O), N * $439a5f313b2b0ed7$var$p > E && (E = N * $439a5f313b2b0ed7$var$p)), E > S && (S = E), c = h.indexOf(L, c + 1);
    return O[T] = S, S;
}
function $439a5f313b2b0ed7$var$D(_) {
    return _.toLowerCase().replace($439a5f313b2b0ed7$var$X, " ");
}
function $439a5f313b2b0ed7$export$407448d2b89b1813(_, C, h) {
    return _ = h && h.length > 0 ? `${_ + " " + h.join(" ")}` : _, $439a5f313b2b0ed7$var$G(_, C, $439a5f313b2b0ed7$var$D(_), $439a5f313b2b0ed7$var$D(C), 0, 0, {});
}




var $acw62 = parcelRequire("acw62");
// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// src/slot.tsx

var $acw62 = parcelRequire("acw62");


var $6830440b411b8a29$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $6830440b411b8a29$var$use = $acw62[" use ".trim().toString()];
function $6830440b411b8a29$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
function $6830440b411b8a29$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $6830440b411b8a29$var$REACT_LAZY_TYPE && "_payload" in element && $6830440b411b8a29$var$isPromiseLike(element._payload);
}
// @__NO_SIDE_EFFECTS__
function $6830440b411b8a29$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $6830440b411b8a29$var$createSlotClone(ownerName);
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        if ($6830440b411b8a29$var$isLazyComponent(children) && typeof $6830440b411b8a29$var$use === "function") children = $6830440b411b8a29$var$use(children._payload);
        const childrenArray = $acw62.Children.toArray(children);
        const slottable = childrenArray.find($6830440b411b8a29$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                    return $acw62.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $6830440b411b8a29$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $6830440b411b8a29$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $6830440b411b8a29$var$createSlotClone(ownerName) {
    const SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        if ($6830440b411b8a29$var$isLazyComponent(children) && typeof $6830440b411b8a29$var$use === "function") children = $6830440b411b8a29$var$use(children._payload);
        if ($acw62.isValidElement(children)) {
            const childrenRef = $6830440b411b8a29$var$getElementRef(children);
            const props2 = $6830440b411b8a29$var$mergeProps(slotProps, children.props);
            if (children.type !== $acw62.Fragment) props2.ref = forwardedRef ? (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $acw62.cloneElement(children, props2);
        }
        return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $6830440b411b8a29$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $6830440b411b8a29$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $6830440b411b8a29$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $6830440b411b8a29$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $6830440b411b8a29$export$bf68c29d8281d0f7("Slottable");
function $6830440b411b8a29$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $6830440b411b8a29$var$SLOTTABLE_IDENTIFIER;
}
function $6830440b411b8a29$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $6830440b411b8a29$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



var $dc7d5df3de21cdcb$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $6830440b411b8a29$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;




"use client";
var $029fa791b9a726ee$var$N = '[cmdk-group=""]', $029fa791b9a726ee$var$Y = '[cmdk-group-items=""]', $029fa791b9a726ee$var$be = '[cmdk-group-heading=""]', $029fa791b9a726ee$var$le = '[cmdk-item=""]', $029fa791b9a726ee$var$ce = `${$029fa791b9a726ee$var$le}:not([aria-disabled="true"])`, $029fa791b9a726ee$var$Z = "cmdk-item-select", $029fa791b9a726ee$var$T = "data-value", $029fa791b9a726ee$export$3f6f640afaf1ec43 = (r, o, n)=>(0, $439a5f313b2b0ed7$export$407448d2b89b1813)(r, o, n), $029fa791b9a726ee$var$ue = $acw62.createContext(void 0), $029fa791b9a726ee$var$K = ()=>$acw62.useContext($029fa791b9a726ee$var$ue), $029fa791b9a726ee$var$de = $acw62.createContext(void 0), $029fa791b9a726ee$var$ee = ()=>$acw62.useContext($029fa791b9a726ee$var$de), $029fa791b9a726ee$var$fe = $acw62.createContext(void 0), $029fa791b9a726ee$export$6def88b96ee4affb = $acw62.forwardRef((r, o)=>{
    let n = $029fa791b9a726ee$var$L(()=>{
        var e, a;
        return {
            search: "",
            value: (a = (e = r.value) != null ? e : r.defaultValue) != null ? a : "",
            selectedItemId: void 0,
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        };
    }), u = $029fa791b9a726ee$var$L(()=>new Set), c = $029fa791b9a726ee$var$L(()=>new Map), d = $029fa791b9a726ee$var$L(()=>new Map), f = $029fa791b9a726ee$var$L(()=>new Set), p = $029fa791b9a726ee$var$pe(r), { label: b, children: m, value: R, onValueChange: x, filter: C, shouldFilter: S, loop: A, disablePointerSelection: ge = !1, vimBindings: j = !0, ...O } = r, $ = (0, $11885ec535b13ccc$export$f680877a34711e37)(), q = (0, $11885ec535b13ccc$export$f680877a34711e37)(), _ = (0, $11885ec535b13ccc$export$f680877a34711e37)(), I = $acw62.useRef(null), v = $029fa791b9a726ee$var$ke();
    $029fa791b9a726ee$var$k(()=>{
        if (R !== void 0) {
            let e = R.trim();
            n.current.value = e, E.emit();
        }
    }, [
        R
    ]), $029fa791b9a726ee$var$k(()=>{
        v(6, ne);
    }, []);
    let E = $acw62.useMemo(()=>({
            subscribe: (e)=>(f.current.add(e), ()=>f.current.delete(e)),
            snapshot: ()=>n.current,
            setState: (e, a, s)=>{
                var i, l, g, y;
                if (!Object.is(n.current[e], a)) {
                    if (n.current[e] = a, e === "search") J(), z(), v(1, W);
                    else if (e === "value") {
                        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
                            let h = document.getElementById(_);
                            h ? h.focus() : (i = document.getElementById($)) == null || i.focus();
                        }
                        if (v(7, ()=>{
                            var h;
                            n.current.selectedItemId = (h = M()) == null ? void 0 : h.id, E.emit();
                        }), s || v(5, ne), ((l = p.current) == null ? void 0 : l.value) !== void 0) {
                            let h = a != null ? a : "";
                            (y = (g = p.current).onValueChange) == null || y.call(g, h);
                            return;
                        }
                    }
                    E.emit();
                }
            },
            emit: ()=>{
                f.current.forEach((e)=>e());
            }
        }), []), U = $acw62.useMemo(()=>({
            value: (e, a, s)=>{
                var i;
                a !== ((i = d.current.get(e)) == null ? void 0 : i.value) && (d.current.set(e, {
                    value: a,
                    keywords: s
                }), n.current.filtered.items.set(e, te(a, s)), v(2, ()=>{
                    z(), E.emit();
                }));
            },
            item: (e, a)=>(u.current.add(e), a && (c.current.has(a) ? c.current.get(a).add(e) : c.current.set(a, new Set([
                    e
                ]))), v(3, ()=>{
                    J(), z(), n.current.value || W(), E.emit();
                }), ()=>{
                    d.current.delete(e), u.current.delete(e), n.current.filtered.items.delete(e);
                    let s = M();
                    v(4, ()=>{
                        J(), (s == null ? void 0 : s.getAttribute("id")) === e && W(), E.emit();
                    });
                }),
            group: (e)=>(c.current.has(e) || c.current.set(e, new Set), ()=>{
                    d.current.delete(e), c.current.delete(e);
                }),
            filter: ()=>p.current.shouldFilter,
            label: b || r["aria-label"],
            getDisablePointerSelection: ()=>p.current.disablePointerSelection,
            listId: $,
            inputId: _,
            labelId: q,
            listInnerRef: I
        }), []);
    function te(e, a) {
        var i, l;
        let s = (l = (i = p.current) == null ? void 0 : i.filter) != null ? l : $029fa791b9a726ee$export$3f6f640afaf1ec43;
        return e ? s(e, n.current.search, a) : 0;
    }
    function z() {
        if (!n.current.search || p.current.shouldFilter === !1) return;
        let e = n.current.filtered.items, a = [];
        n.current.filtered.groups.forEach((i)=>{
            let l = c.current.get(i), g = 0;
            l.forEach((y)=>{
                let h = e.get(y);
                g = Math.max(h, g);
            }), a.push([
                i,
                g
            ]);
        });
        let s = I.current;
        V().sort((i, l)=>{
            var h, F;
            let g = i.getAttribute("id"), y = l.getAttribute("id");
            return ((h = e.get(y)) != null ? h : 0) - ((F = e.get(g)) != null ? F : 0);
        }).forEach((i)=>{
            let l = i.closest($029fa791b9a726ee$var$Y);
            l ? l.appendChild(i.parentElement === l ? i : i.closest(`${$029fa791b9a726ee$var$Y} > *`)) : s.appendChild(i.parentElement === s ? i : i.closest(`${$029fa791b9a726ee$var$Y} > *`));
        }), a.sort((i, l)=>l[1] - i[1]).forEach((i)=>{
            var g;
            let l = (g = I.current) == null ? void 0 : g.querySelector(`${$029fa791b9a726ee$var$N}[${$029fa791b9a726ee$var$T}="${encodeURIComponent(i[0])}"]`);
            l == null || l.parentElement.appendChild(l);
        });
    }
    function W() {
        let e = V().find((s)=>s.getAttribute("aria-disabled") !== "true"), a = e == null ? void 0 : e.getAttribute($029fa791b9a726ee$var$T);
        E.setState("value", a || void 0);
    }
    function J() {
        var a, s, i, l;
        if (!n.current.search || p.current.shouldFilter === !1) {
            n.current.filtered.count = u.current.size;
            return;
        }
        n.current.filtered.groups = new Set;
        let e = 0;
        for (let g of u.current){
            let y = (s = (a = d.current.get(g)) == null ? void 0 : a.value) != null ? s : "", h = (l = (i = d.current.get(g)) == null ? void 0 : i.keywords) != null ? l : [], F = te(y, h);
            n.current.filtered.items.set(g, F), F > 0 && e++;
        }
        for (let [g, y] of c.current)for (let h of y)if (n.current.filtered.items.get(h) > 0) {
            n.current.filtered.groups.add(g);
            break;
        }
        n.current.filtered.count = e;
    }
    function ne() {
        var a, s, i;
        let e = M();
        e && (((a = e.parentElement) == null ? void 0 : a.firstChild) === e && ((i = (s = e.closest($029fa791b9a726ee$var$N)) == null ? void 0 : s.querySelector($029fa791b9a726ee$var$be)) == null || i.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function M() {
        var e;
        return (e = I.current) == null ? void 0 : e.querySelector(`${$029fa791b9a726ee$var$le}[aria-selected="true"]`);
    }
    function V() {
        var e;
        return Array.from(((e = I.current) == null ? void 0 : e.querySelectorAll($029fa791b9a726ee$var$ce)) || []);
    }
    function X(e) {
        let s = V()[e];
        s && E.setState("value", s.getAttribute($029fa791b9a726ee$var$T));
    }
    function Q(e) {
        var g;
        let a = M(), s = V(), i = s.findIndex((y)=>y === a), l = s[i + e];
        (g = p.current) != null && g.loop && (l = i + e < 0 ? s[s.length - 1] : i + e === s.length ? s[0] : s[i + e]), l && E.setState("value", l.getAttribute($029fa791b9a726ee$var$T));
    }
    function re(e) {
        let a = M(), s = a == null ? void 0 : a.closest($029fa791b9a726ee$var$N), i;
        for(; s && !i;)s = e > 0 ? $029fa791b9a726ee$var$we(s, $029fa791b9a726ee$var$N) : $029fa791b9a726ee$var$De(s, $029fa791b9a726ee$var$N), i = s == null ? void 0 : s.querySelector($029fa791b9a726ee$var$ce);
        i ? E.setState("value", i.getAttribute($029fa791b9a726ee$var$T)) : Q(e);
    }
    let oe = ()=>X(V().length - 1), ie = (e)=>{
        e.preventDefault(), e.metaKey ? oe() : e.altKey ? re(1) : Q(1);
    }, se = (e)=>{
        e.preventDefault(), e.metaKey ? X(0) : e.altKey ? re(-1) : Q(-1);
    };
    return $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: o,
        tabIndex: -1,
        ...O,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var s;
            (s = O.onKeyDown) == null || s.call(O, e);
            let a = e.nativeEvent.isComposing || e.keyCode === 229;
            if (!(e.defaultPrevented || a)) switch(e.key){
                case "n":
                case "j":
                    j && e.ctrlKey && ie(e);
                    break;
                case "ArrowDown":
                    ie(e);
                    break;
                case "p":
                case "k":
                    j && e.ctrlKey && se(e);
                    break;
                case "ArrowUp":
                    se(e);
                    break;
                case "Home":
                    e.preventDefault(), X(0);
                    break;
                case "End":
                    e.preventDefault(), oe();
                    break;
                case "Enter":
                    {
                        e.preventDefault();
                        let i = M();
                        if (i) {
                            let l = new Event($029fa791b9a726ee$var$Z);
                            i.dispatchEvent(l);
                        }
                    }
            }
        }
    }, $acw62.createElement("label", {
        "cmdk-label": "",
        htmlFor: U.inputId,
        id: U.labelId,
        style: $029fa791b9a726ee$var$Te
    }, b), $029fa791b9a726ee$var$B(r, (e)=>$acw62.createElement($029fa791b9a726ee$var$de.Provider, {
            value: E
        }, $acw62.createElement($029fa791b9a726ee$var$ue.Provider, {
            value: U
        }, e))));
}), $029fa791b9a726ee$export$b9b346a733d36f61 = $acw62.forwardRef((r, o)=>{
    var _, I;
    let n = (0, $11885ec535b13ccc$export$f680877a34711e37)(), u = $acw62.useRef(null), c = $acw62.useContext($029fa791b9a726ee$var$fe), d = $029fa791b9a726ee$var$K(), f = $029fa791b9a726ee$var$pe(r), p = (I = (_ = f.current) == null ? void 0 : _.forceMount) != null ? I : c == null ? void 0 : c.forceMount;
    $029fa791b9a726ee$var$k(()=>{
        if (!p) return d.item(n, c == null ? void 0 : c.id);
    }, [
        p
    ]);
    let b = $029fa791b9a726ee$var$ve(n, u, [
        r.value,
        r.children,
        u
    ], r.keywords), m = $029fa791b9a726ee$var$ee(), R = $029fa791b9a726ee$export$606184d999862dff((v)=>v.value && v.value === b.current), x = $029fa791b9a726ee$export$606184d999862dff((v)=>p || d.filter() === !1 ? !0 : v.search ? v.filtered.items.get(n) > 0 : !0);
    $acw62.useEffect(()=>{
        let v = u.current;
        if (!(!v || r.disabled)) return v.addEventListener($029fa791b9a726ee$var$Z, C), ()=>v.removeEventListener($029fa791b9a726ee$var$Z, C);
    }, [
        x,
        r.onSelect,
        r.disabled
    ]);
    function C() {
        var v, E;
        S(), (E = (v = f.current).onSelect) == null || E.call(v, b.current);
    }
    function S() {
        m.setState("value", b.current, !0);
    }
    if (!x) return null;
    let { disabled: A, value: ge, onSelect: j, forceMount: O, keywords: $, ...q } = r;
    return $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(u, o),
        ...q,
        id: n,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": !!A,
        "aria-selected": !!R,
        "data-disabled": !!A,
        "data-selected": !!R,
        onPointerMove: A || d.getDisablePointerSelection() ? void 0 : S,
        onClick: A ? void 0 : C
    }, r.children);
}), $029fa791b9a726ee$export$c157b9873a7a0fbd = $acw62.forwardRef((r, o)=>{
    let { heading: n, children: u, forceMount: c, ...d } = r, f = (0, $11885ec535b13ccc$export$f680877a34711e37)(), p = $acw62.useRef(null), b = $acw62.useRef(null), m = (0, $11885ec535b13ccc$export$f680877a34711e37)(), R = $029fa791b9a726ee$var$K(), x = $029fa791b9a726ee$export$606184d999862dff((S)=>c || R.filter() === !1 ? !0 : S.search ? S.filtered.groups.has(f) : !0);
    $029fa791b9a726ee$var$k(()=>R.group(f), []), $029fa791b9a726ee$var$ve(f, p, [
        r.value,
        r.heading,
        b
    ]);
    let C = $acw62.useMemo(()=>({
            id: f,
            forceMount: c
        }), [
        c
    ]);
    return $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(p, o),
        ...d,
        "cmdk-group": "",
        role: "presentation",
        hidden: x ? void 0 : !0
    }, n && $acw62.createElement("div", {
        ref: b,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: m
    }, n), $029fa791b9a726ee$var$B(r, (S)=>$acw62.createElement("div", {
            "cmdk-group-items": "",
            role: "group",
            "aria-labelledby": n ? m : void 0
        }, $acw62.createElement($029fa791b9a726ee$var$fe.Provider, {
            value: C
        }, S))));
}), $029fa791b9a726ee$export$ace649eed6990b42 = $acw62.forwardRef((r, o)=>{
    let { alwaysRender: n, ...u } = r, c = $acw62.useRef(null), d = $029fa791b9a726ee$export$606184d999862dff((f)=>!f.search);
    return !n && !d ? null : $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(c, o),
        ...u,
        "cmdk-separator": "",
        role: "separator"
    });
}), $029fa791b9a726ee$export$ebdebb88e46df62a = $acw62.forwardRef((r, o)=>{
    let { onValueChange: n, ...u } = r, c = r.value != null, d = $029fa791b9a726ee$var$ee(), f = $029fa791b9a726ee$export$606184d999862dff((m)=>m.search), p = $029fa791b9a726ee$export$606184d999862dff((m)=>m.selectedItemId), b = $029fa791b9a726ee$var$K();
    return $acw62.useEffect(()=>{
        r.value != null && d.setState("search", r.value);
    }, [
        r.value
    ]), $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).input, {
        ref: o,
        ...u,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": b.listId,
        "aria-labelledby": b.labelId,
        "aria-activedescendant": p,
        id: b.inputId,
        type: "text",
        value: c ? r.value : f,
        onChange: (m)=>{
            c || d.setState("search", m.target.value), n == null || n(m.target.value);
        }
    });
}), $029fa791b9a726ee$export$9cffcb65e9381872 = $acw62.forwardRef((r, o)=>{
    let { children: n, label: u = "Suggestions", ...c } = r, d = $acw62.useRef(null), f = $acw62.useRef(null), p = $029fa791b9a726ee$export$606184d999862dff((m)=>m.selectedItemId), b = $029fa791b9a726ee$var$K();
    return $acw62.useEffect(()=>{
        if (f.current && d.current) {
            let m = f.current, R = d.current, x, C = new ResizeObserver(()=>{
                x = requestAnimationFrame(()=>{
                    let S = m.offsetHeight;
                    R.style.setProperty("--cmdk-list-height", S.toFixed(1) + "px");
                });
            });
            return C.observe(m), ()=>{
                cancelAnimationFrame(x), C.unobserve(m);
            };
        }
    }, []), $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(d, o),
        ...c,
        "cmdk-list": "",
        role: "listbox",
        tabIndex: -1,
        "aria-activedescendant": p,
        "aria-label": u,
        id: b.listId
    }, $029fa791b9a726ee$var$B(r, (m)=>$acw62.createElement("div", {
            ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(f, b.listInnerRef),
            "cmdk-list-sizer": ""
        }, m)));
}), $029fa791b9a726ee$export$98f0540b5c04f3e8 = $acw62.forwardRef((r, o)=>{
    let { open: n, onOpenChange: u, overlayClassName: c, contentClassName: d, container: f, ...p } = r;
    return $acw62.createElement($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
        open: n,
        onOpenChange: u
    }, $acw62.createElement($eeaeb48e23f662e7$export$602eac185826482c, {
        container: f
    }, $acw62.createElement($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
        "cmdk-overlay": "",
        className: c
    }), $acw62.createElement($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
        "aria-label": r.label,
        "cmdk-dialog": "",
        className: d
    }, $acw62.createElement($029fa791b9a726ee$export$6def88b96ee4affb, {
        ref: o,
        ...p
    }))));
}), $029fa791b9a726ee$export$f1753c65029fce09 = $acw62.forwardRef((r, o)=>$029fa791b9a726ee$export$606184d999862dff((u)=>u.filtered.count === 0) ? $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: o,
        ...r,
        "cmdk-empty": "",
        role: "presentation"
    }) : null), $029fa791b9a726ee$export$8980984ffcab084a = $acw62.forwardRef((r, o)=>{
    let { progress: n, children: u, label: c = "Loading...", ...d } = r;
    return $acw62.createElement((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ref: o,
        ...d,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": n,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": c
    }, $029fa791b9a726ee$var$B(r, (f)=>$acw62.createElement("div", {
            "aria-hidden": !0
        }, f)));
}), $029fa791b9a726ee$export$cc7e12c76513e857 = Object.assign($029fa791b9a726ee$export$6def88b96ee4affb, {
    List: $029fa791b9a726ee$export$9cffcb65e9381872,
    Item: $029fa791b9a726ee$export$b9b346a733d36f61,
    Input: $029fa791b9a726ee$export$ebdebb88e46df62a,
    Group: $029fa791b9a726ee$export$c157b9873a7a0fbd,
    Separator: $029fa791b9a726ee$export$ace649eed6990b42,
    Dialog: $029fa791b9a726ee$export$98f0540b5c04f3e8,
    Empty: $029fa791b9a726ee$export$f1753c65029fce09,
    Loading: $029fa791b9a726ee$export$8980984ffcab084a
});
function $029fa791b9a726ee$var$we(r, o) {
    let n = r.nextElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.nextElementSibling;
    }
}
function $029fa791b9a726ee$var$De(r, o) {
    let n = r.previousElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.previousElementSibling;
    }
}
function $029fa791b9a726ee$var$pe(r) {
    let o = $acw62.useRef(r);
    return $029fa791b9a726ee$var$k(()=>{
        o.current = r;
    }), o;
}
var $029fa791b9a726ee$var$k = typeof window == "undefined" ? $acw62.useEffect : $acw62.useLayoutEffect;
function $029fa791b9a726ee$var$L(r) {
    let o = $acw62.useRef();
    return o.current === void 0 && (o.current = r()), o;
}
function $029fa791b9a726ee$export$606184d999862dff(r) {
    let o = $029fa791b9a726ee$var$ee(), n = ()=>r(o.snapshot());
    return $acw62.useSyncExternalStore(o.subscribe, n, n);
}
function $029fa791b9a726ee$var$ve(r, o, n, u = []) {
    let c = $acw62.useRef(), d = $029fa791b9a726ee$var$K();
    return $029fa791b9a726ee$var$k(()=>{
        var b;
        let f = (()=>{
            var m;
            for (let R of n){
                if (typeof R == "string") return R.trim();
                if (typeof R == "object" && "current" in R) return R.current ? (m = R.current.textContent) == null ? void 0 : m.trim() : c.current;
            }
        })(), p = u.map((m)=>m.trim());
        d.value(r, f, p), (b = o.current) == null || b.setAttribute($029fa791b9a726ee$var$T, f), c.current = f;
    }), c;
}
var $029fa791b9a726ee$var$ke = ()=>{
    let [r, o] = $acw62.useState(), n = $029fa791b9a726ee$var$L(()=>new Map);
    return $029fa791b9a726ee$var$k(()=>{
        n.current.forEach((u)=>u()), n.current = new Map;
    }, [
        r
    ]), (u, c)=>{
        n.current.set(u, c), o({});
    };
};
function $029fa791b9a726ee$var$Me(r) {
    let o = r.type;
    return typeof o == "function" ? o(r.props) : "render" in o ? o.render(r.props) : r;
}
function $029fa791b9a726ee$var$B({ asChild: r, children: o }, n) {
    return r && $acw62.isValidElement(o) ? $acw62.cloneElement($029fa791b9a726ee$var$Me(o), {
        ref: o.ref
    }, n(o.props.children)) : n(o);
}
var $029fa791b9a726ee$var$Te = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};


// Helper: normalize options to { value, label }
const $5b936de565d5e0d9$var$normalizeOptions = (options = [])=>options.map((opt)=>typeof opt === "string" ? {
            value: opt,
            label: opt
        } : opt);
const $5b936de565d5e0d9$export$a455218a85c89869 = ({ label: label, required: required, error: error, hint: hint, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "block text-sm font-medium text-text-primary mb-1",
                children: [
                    label,
                    " ",
                    required && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-error",
                        children: "*"
                    })
                ]
            }),
            children,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-error text-sm mt-1",
                children: error
            }) : hint ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-text-tertiary text-xs mt-1",
                children: hint
            }) : null
        ]
    });
const $5b936de565d5e0d9$export$2c73285ae9390cec = ({ type: type = "text", label: label, error: error, hint: hint, required: required, className: className = "", numbersOnly: numbersOnly = false, ...props })=>{
    // Add handler for keypress
    const handleKeyPress = (event)=>{
        if (numbersOnly) // Allow only numbers and control keys (backspace, delete, arrows etc)
        {
            if (!/[0-9]/.test(event.key) && event.key.length === 1) event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
            type: type,
            inputMode: numbersOnly ? "numeric" : "text",
            pattern: numbersOnly ? "[0-9]*" : undefined,
            onKeyPress: handleKeyPress,
            className: `w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary transition-colors ${error ? "border-error" : "border-border-medium"} bg-bg-primary text-text-primary ${className}`,
            ...props
        })
    });
};
const $5b936de565d5e0d9$export$301bf6213f61d17f = ({ label: label, error: error, hint: hint, required: required, className: className = "", rows: rows = 3, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
            rows: rows,
            className: `w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary transition-colors ${error ? "border-error" : "border-border-medium"} bg-bg-primary text-text-primary ${className}`,
            ...props
        })
    });
const $5b936de565d5e0d9$export$ad2d04c8e5b15ad7 = ({ label: label, error: error, hint: hint, required: required, className: className = "", multiple: multiple = false, accept: accept, onChange: onChange, value: value })=>{
    const fileInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Handle file selection
    const handleFileChange = (e)=>{
        const files = e.target.files;
        if (multiple) onChange?.(files);
        else onChange?.(files?.[0] || null);
    };
    // Show selected files info
    const renderFileInfo = ()=>{
        if (!value) return null;
        const clearFiles = ()=>{
            onChange?.(multiple ? null : null);
            if (fileInputRef.current) fileInputRef.current.value = "";
        };
        if (multiple && value instanceof FileList) {
            const fileCount = value.length;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 space-y-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-sm text-text-tertiary",
                        children: [
                            fileCount,
                            " file",
                            fileCount !== 1 ? "s" : "",
                            " selected"
                        ]
                    }),
                    Array.from(value).map((file, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-sm text-text-secondary bg-surface-50 px-2 py-1 rounded flex items-center justify-between",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    file.name,
                                    " (",
                                    (file.size / 1024).toFixed(1),
                                    " KB)"
                                ]
                            })
                        }, index)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: clearFiles,
                        className: "text-sm text-error hover:text-error-600 underline",
                        children: "Clear Files"
                    })
                ]
            });
        }
        if (!multiple && value instanceof File) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mt-2 space-y-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-sm text-text-tertiary",
                    children: "1 file selected"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-sm text-text-secondary bg-surface-50 px-2 py-1 rounded flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            value.name,
                            " (",
                            (value.size / 1024).toFixed(1),
                            " KB)"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: clearFiles,
                    className: "text-sm text-error hover:text-error-600 underline",
                    children: "Clear File"
                })
            ]
        });
        return null;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: fileInputRef,
                type: "file",
                multiple: multiple,
                accept: accept,
                onChange: handleFileChange,
                className: `w-full border rounded-md px-3 py-2 focus:outline-none transition-colors ${error ? "border-error" : "border-border-medium"} bg-bg-primary text-text-primary ${className}`
            }),
            renderFileInfo()
        ]
    });
};
const $5b936de565d5e0d9$export$94195a47b94ed396 = ({ label: label, checked: checked, onChange: onChange, disabled: disabled, className: className = "" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: `inline-flex items-center space-x-2 cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$48513f6b9f8ce62d, {
                checked: Boolean(checked),
                onCheckedChange: (val)=>{
                    onChange?.(val === true);
                },
                disabled: disabled,
                className: "h-5 w-5 rounded border border-gray-400  flex items-center justify-center  data-[state=checked]:bg-blue-600  data-[state=checked]:border-blue-600",
                children: checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$59aad738f51d1c05, {
                    className: "flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 text-white"
                    })
                })
            }),
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-sm text-text-primary select-none",
                children: label
            })
        ]
    });
const $5b936de565d5e0d9$export$81e0b04a08224b5 = ({ label: label, value: value = [], onChange: onChange, options: options = [], error: error, hint: hint, required: required })=>{
    const opts = $5b936de565d5e0d9$var$normalizeOptions(options);
    const current = Array.isArray(value) ? value : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "grid grid-cols-2 md:grid-cols-4 gap-2",
            children: opts.map((opt)=>{
                const checked = current.includes(opt.value);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "inline-flex items-center space-x-2 cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$48513f6b9f8ce62d, {
                            checked: checked,
                            onCheckedChange: (isChecked)=>{
                                if (isChecked) onChange?.([
                                    ...current,
                                    opt.value
                                ]); // add
                                else onChange?.(current.filter((v)=>v !== opt.value)); // remove
                            },
                            className: "h-5 w-5 rounded border border-gray-400  flex items-center justify-center  data-[state=checked]:bg-blue-600  data-[state=checked]:border-blue-600",
                            children: checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$59aad738f51d1c05, {
                                className: "flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 text-white"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm text-text-primary",
                            children: opt.label
                        })
                    ]
                }, opt.value);
            })
        })
    });
};
const $5b936de565d5e0d9$export$a314277471067e8a = ({ label: label, value: value, onChange: onChange, options: options = [], error: error, hint: hint, required: required, className: className = "" })=>{
    const opts = $5b936de565d5e0d9$var$normalizeOptions(options);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6e3785e657478a72$export$be92b6f5f03c0fe9, {
            value: value,
            onValueChange: (val)=>onChange?.(val),
            className: `grid grid-cols-1 sm:grid-cols-2 gap-2 ${className}`,
            children: opts.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "inline-flex items-center space-x-2 cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6e3785e657478a72$export$6d08773d2e66f8f2, {
                            value: opt.value,
                            className: "h-4 w-4 rounded-full border border-border-medium data-[state=checked]:border-primary data-[state=checked]:ring-4 data-[state=checked]:ring-primary-100 transition-colors"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm text-text-primary",
                            children: opt.label
                        })
                    ]
                }, opt.value))
        })
    });
};
const $5b936de565d5e0d9$export$f91e8bfeb5571984 = ({ label: label, pressed: pressed, onPressedChange: onPressedChange, className: className = "" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `inline-flex items-center space-x-3 ${className}`,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-sm text-text-primary",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($62b265af90252982$export$be92b6f5f03c0fe9, {
                pressed: Boolean(pressed),
                onPressedChange: (p)=>onPressedChange?.(Boolean(p)),
                className: `inline-flex items-center justify-center rounded-md border px-3 py-1.5 text-sm transition-colors ${pressed ? "bg-primary border-primary text-white" : "bg-bg-primary border-border-medium text-text-primary hover:bg-surface-50"}`,
                "aria-label": label || "Toggle",
                children: pressed ? "On" : "Off"
            })
        ]
    });
const $5b936de565d5e0d9$export$d55b50a564d0b931 = ({ label: label, value: value, onChange: onChange, options: options = [], placeholder: placeholder = "Select an option", error: error, hint: hint, required: required, disabled: disabled = false })=>{
    const opts = $5b936de565d5e0d9$var$normalizeOptions(options);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$be92b6f5f03c0fe9, {
            value: value,
            onValueChange: (val)=>onChange?.(val),
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$41fb9f06171c75f4, {
                    className: `w-full inline-flex items-center justify-between rounded-md border px-3 py-2 text-left text-sm transition-colors ${error ? "border-red-500" : "border-gray-300 "} ${disabled ? "opacity-50 cursor-not-allowed bg-gray-50" : "bg-white"} text-gray-700 `,
                    "aria-label": placeholder,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$4c8d1a57a761ef94, {
                            placeholder: placeholder
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$f04a61298a47a40f, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-500 "
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$602eac185826482c, {
                    container: document.body,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$7c6e2c02157bb7d2, {
                        className: "overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg z-[99999]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$2f60d3ec9ad468f2, {
                                className: "flex items-center justify-center py-1 text-gray-500 ",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$d5c6c08dc2d3ca7, {
                                className: "p-1",
                                children: opts.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                        value: opt.value,
                                        className: "relative flex cursor-pointer select-none items-center rounded px-2 py-2 text-sm text-gray-700  outline-none data-[highlighted]:bg-blue-50  transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$d6e5bf9c43ea9319, {
                                                children: opt.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$c3468e2714d175fa, {
                                                className: "absolute right-2 inline-flex items-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4 text-blue-600 "
                                                })
                                            })
                                        ]
                                    }, opt.value))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$bf1aedc3039c8d63, {
                                className: "flex items-center justify-center py-1 text-gray-500 ",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $5b936de565d5e0d9$export$4efd8d874a0cb609 = ({ label: label, value: value = [], onChange: onChange, options: options = [], placeholder: placeholder = "Select options", error: error, hint: hint, required: required, disabled: disabled = false })=>{
    const opts = $5b936de565d5e0d9$var$normalizeOptions(options);
    const current = Array.isArray(value) ? value : [];
    const triggerRef = (0, $acw62.useRef)(null);
    const [menuWidth, setMenuWidth] = (0, $acw62.useState)(undefined);
    const [open, setOpen] = (0, $acw62.useState)(false);
    // Match width of trigger
    (0, $acw62.useLayoutEffect)(()=>{
        if (triggerRef.current) setMenuWidth(triggerRef.current.offsetWidth);
    }, [
        triggerRef.current,
        open
    ]);
    const toggle = (val, checked)=>{
        const next = checked ? [
            ...current,
            val
        ] : current.filter((v)=>v !== val);
        onChange?.(next);
    };
    const selectedLabels = opts.filter((o)=>current.includes(o.value)).map((o)=>o.label);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$be92b6f5f03c0fe9, {
            open: open,
            onOpenChange: setOpen,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$41fb9f06171c75f4, {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        ref: triggerRef,
                        type: "button",
                        disabled: disabled,
                        className: `w-full inline-flex items-center justify-between rounded-md border px-3 py-2 text-left text-sm transition-colors ${error ? "border-red-500" : "border-gray-300"} ${disabled ? "opacity-50 cursor-not-allowed bg-gray-50" : "bg-white"} text-gray-700`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate",
                                children: selectedLabels.length > 0 ? selectedLabels.join(", ") : placeholder
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-500"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$602eac185826482c, {
                    container: document.body,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$7c6e2c02157bb7d2, {
                        side: "bottom",
                        align: "start",
                        avoidCollisions: false,
                        className: "rounded-md border border-gray-200 bg-white p-1 shadow-md z-[99999] max-h-[300px] overflow-y-auto",
                        sideOffset: 6,
                        style: {
                            width: menuWidth
                        },
                        onCloseAutoFocus: (e)=>e.preventDefault(),
                        children: opts.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$16ce288f89fa631c, {
                                checked: current.includes(opt.value),
                                onCheckedChange: (checked)=>toggle(opt.value, checked),
                                onSelect: (event)=>event.preventDefault(),
                                className: "relative flex cursor-pointer select-none items-center rounded px-2 py-2 text-sm text-gray-700 outline-none data-[highlighted]:bg-blue-50 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$c3468e2714d175fa, {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 text-blue-600 mr-2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: opt.label
                                    })
                                ]
                            }, opt.value))
                    })
                })
            ]
        })
    });
};
const $5b936de565d5e0d9$export$d0b89778d85285fc = ({ label: label, value: value = [], onChange: onChange, placeholder: placeholder = "Type and press Enter to add tags", error: error, hint: hint, required: required })=>{
    const [inputValue, setInputValue] = (0, $acw62.useState)("");
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            if (inputValue.trim()) {
                const newTag = inputValue.trim();
                if (!value.includes(newTag)) onChange?.([
                    ...value,
                    newTag
                ]);
                setInputValue("");
            }
        } else if (e.key === "Backspace" && !inputValue && value.length > 0) // Remove last tag when backspace is pressed on empty input
        onChange?.(value.slice(0, -1));
    };
    const removeTag = (tagToRemove)=>{
        onChange?.(value.filter((tag)=>tag !== tagToRemove));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `min-h-[38px] w-full border rounded-md px-2 py-1 focus-within:ring-2 focus-within:ring-primary transition-colors flex flex-wrap gap-2 items-center ${error ? "border-error" : "border-border-medium"}`,
            children: [
                value.map((tag)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1 bg-primary-100 text-primary-700 px-2 py-0.5 rounded-md text-sm",
                        children: [
                            tag,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>removeTag(tag),
                                className: "hover:text-error-600 focus:outline-none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "h-3 w-3"
                                })
                            })
                        ]
                    }, tag)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "text",
                    value: inputValue,
                    onChange: (e)=>setInputValue(e.target.value),
                    onKeyDown: handleKeyDown,
                    placeholder: value.length === 0 ? placeholder : "",
                    className: "flex-1 min-w-[120px] outline-none bg-transparent text-sm py-1"
                })
            ]
        })
    });
};
const $5b936de565d5e0d9$export$ea84111f9d4d896 = ({ label: label, value: value = [], onChange: onChange, options: options = [], placeholder: placeholder = "Select or type to add...", error: error, hint: hint, required: required })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [inputValue, setInputValue] = (0, $acw62.useState)("");
    const [opts, setOpts] = (0, $acw62.useState)($5b936de565d5e0d9$var$normalizeOptions(options));
    const current = Array.isArray(value) ? value : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b936de565d5e0d9$export$a455218a85c89869, {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
            open: open,
            onOpenChange: setOpen,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$41fb9f06171c75f4, {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `min-h-[38px] w-full border rounded-md px-2 py-1 cursor-pointer
              ${error ? "border-error" : "border-border-medium"}
              hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary
            `,
                        children: current.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-wrap gap-1",
                            children: current.map((item)=>{
                                const opt = opts.find((o)=>o.value === item);
                                const label = opt ? opt.label : item;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "bg-secondary-dark focus:outline-none inline-flex items-center gap-1  text-white p-2 rounded text-sm",
                                    children: [
                                        label,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                onChange?.(current.filter((i)=>i !== item));
                                            },
                                            className: "",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            })
                                        })
                                    ]
                                }, item);
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-text-tertiary text-sm",
                            children: placeholder
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
                    container: document.body,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
                            className: "fixed inset-0 bg-black/50"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                            className: "fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[450px] translate-x-[-50%] translate-y-[-50%] rounded-md bg-white p-4 shadow-lg z-[99999]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
                                    className: "text-lg font-medium mb-2",
                                    children: "Select Services"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $029fa791b9a726ee$export$cc7e12c76513e857), {
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex items-center border-b pb-4 mb-4",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $029fa791b9a726ee$export$cc7e12c76513e857).Input, {
                                                value: inputValue,
                                                onValueChange: setInputValue,
                                                placeholder: "Search or add custom value...",
                                                className: "w-full outline-none text-sm"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $029fa791b9a726ee$export$cc7e12c76513e857).List, {
                                            className: "max-h-[300px] overflow-auto",
                                            children: [
                                                opts.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $029fa791b9a726ee$export$cc7e12c76513e857).Item, {
                                                        value: opt.value,
                                                        onSelect: (selected)=>{
                                                            const exists = current.includes(selected);
                                                            const next = exists ? current.filter((v)=>v !== selected) : [
                                                                ...current,
                                                                selected
                                                            ];
                                                            onChange?.(next);
                                                        },
                                                        className: `flex items-center gap-2 px-2 py-1.5 text-sm rounded cursor-pointer
                      ${current.includes(opt.value) ? "bg-primary-100 text-primary" : "hover:bg-surface-100"}
                    `,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "w-4 h-4 border rounded flex items-center justify-center",
                                                                children: current.includes(opt.value) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                    className: "h-3 w-3"
                                                                })
                                                            }),
                                                            opt.label
                                                        ]
                                                    }, opt.value)),
                                                inputValue.trim() && !opts.find((o)=>o.value === inputValue.trim()) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $029fa791b9a726ee$export$cc7e12c76513e857).Item, {
                                                    value: inputValue.trim(),
                                                    onSelect: (selected)=>{
                                                        if (!current.includes(selected)) {
                                                            onChange?.([
                                                                ...current,
                                                                selected
                                                            ]);
                                                            setOpts([
                                                                ...opts,
                                                                {
                                                                    value: selected,
                                                                    label: selected
                                                                }
                                                            ]);
                                                        }
                                                        setInputValue("");
                                                    },
                                                    className: "flex items-center gap-2 px-2 py-1.5 text-sm rounded cursor-pointer hover:bg-surface-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }),
                                                        'Add "',
                                                        inputValue.trim(),
                                                        '"'
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $5b936de565d5e0d9$export$2e2bcd8739ae039 = {
    Field: $5b936de565d5e0d9$export$a455218a85c89869,
    TextField: $5b936de565d5e0d9$export$2c73285ae9390cec,
    TextAreaField: $5b936de565d5e0d9$export$301bf6213f61d17f,
    FileField: $5b936de565d5e0d9$export$ad2d04c8e5b15ad7,
    CheckboxField: $5b936de565d5e0d9$export$94195a47b94ed396,
    CheckboxGroupField: $5b936de565d5e0d9$export$81e0b04a08224b5,
    RadioGroupField: $5b936de565d5e0d9$export$a314277471067e8a,
    ToggleField: $5b936de565d5e0d9$export$f91e8bfeb5571984,
    SelectField: $5b936de565d5e0d9$export$d55b50a564d0b931,
    MultiSelectField: $5b936de565d5e0d9$export$4efd8d874a0cb609,
    TagsField: $5b936de565d5e0d9$export$d0b89778d85285fc,
    ComboboxField: $5b936de565d5e0d9$export$ea84111f9d4d896
};



// src/aspect-ratio.tsx

var $acw62 = parcelRequire("acw62");


var $466d6ee780dbf5d6$var$NAME = "AspectRatio";
var $466d6ee780dbf5d6$export$e840e8869344ca38 = $acw62.forwardRef((props, forwardedRef)=>{
    const { ratio: ratio = 1, style: style, ...aspectRatioProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            // ensures inner element is contained
            position: "relative",
            // ensures padding bottom trick maths works
            width: "100%",
            paddingBottom: `${100 / ratio}%`
        },
        "data-radix-aspect-ratio-wrapper": "",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            ...aspectRatioProps,
            ref: forwardedRef,
            style: {
                ...style,
                // ensures children expand in ratio
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        })
    });
});
$466d6ee780dbf5d6$export$e840e8869344ca38.displayName = $466d6ee780dbf5d6$var$NAME;
var $466d6ee780dbf5d6$export$be92b6f5f03c0fe9 = $466d6ee780dbf5d6$export$e840e8869344ca38;



/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f68e7f5ef2ab511$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v12",
            key: "1x0j5s"
        }
    ],
    [
        "path",
        {
            d: "m17 8-5-5-5 5",
            key: "7q97r8"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ]
];
const $4f68e7f5ef2ab511$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("upload", $4f68e7f5ef2ab511$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");


const $e49ca7aad3643dc7$export$3019c26e674dcdde = ({ label: label, error: error, hint: hint, required: required, value: value, onChange: onChange, maxFiles: maxFiles = 5 })=>{
    const onDrop = (0, $acw62.useCallback)((acceptedFiles)=>{
        onChange(acceptedFiles);
    }, [
        onChange
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        accept: {
            "image/*": [
                ".jpeg",
                ".jpg",
                ".png",
                ".webp"
            ]
        },
        maxFiles: maxFiles
    });
    // Add the return statement here
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5b936de565d5e0d9$export$a455218a85c89869), {
        label: label,
        error: error,
        hint: hint,
        required: required,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...getRootProps(),
                className: `border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors
          ${isDragActive ? "border-primary bg-primary-50" : "border-border-medium hover:border-primary"}
        `,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        ...getInputProps()
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-2 py-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                className: "mx-auto h-12 w-12 text-text-secondary"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-sm text-text-secondary",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-primary",
                                        children: "Click to upload"
                                    }),
                                    " or drag and drop",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "PNG, JPG, JPEG up to ",
                                    maxFiles,
                                    " files"
                                ]
                            })
                        ]
                    })
                ]
            }),
            value && value.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4",
                children: Array.from(value).map((file, index)=>// <Dialog.Root key={index}>
                    //   <Dialog.Trigger asChild>
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative group cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($466d6ee780dbf5d6$export$be92b6f5f03c0fe9, {
                                ratio: 1,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: file instanceof File ? URL.createObjectURL(file) : file.preview || file,
                                    alt: `Preview ${index + 1}`,
                                    className: "w-full h-full object-cover rounded-lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    const newFiles = Array.from(value).filter((_, i)=>i !== index);
                                    onChange(newFiles);
                                },
                                className: "absolute top-2 right-2 bg-error hover:bg-error-600 text-white p-1.5 rounded-full opacity-100 transition-opacity",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            })
                        ]
                    }, index))
            })
        ]
    });
};




var $lHUkp = parcelRequire("lHUkp");

// Validation schema based on API requirements
const $46e407298bd610e0$var$createBannerSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    image: $cda9d0e1103d595f$export$9b30b6294c1449a8().test("required", "Banner image is required", (value)=>{
        return value && value.length > 0;
    }).test("fileSize", "Image size must be less than 10MB", (value)=>{
        if (!value) return true;
        return Array.from(value).every((file)=>{
            // Skip size check for existing images (they don't have size property)
            if (file.existing) return true;
            return file.size <= 10485760; // 10MB
        });
    }).test("fileType", "Only JPEG, PNG, JPG, WEBP files are allowed", (value)=>{
        if (!value) return true;
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "image/webp"
        ];
        return Array.from(value).every((file)=>{
            // Skip type check for existing images
            if (file.existing) return true;
            return allowedTypes.includes(file.type);
        });
    }).required("Banner image is required"),
    headline: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Headline must be less than 255 characters").nullable(),
    tagline: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Tagline must be less than 255 characters").nullable(),
    sequence: $cda9d0e1103d595f$export$98e628dec113755e().typeError("Sequence must be a number").min(0, "Sequence must be 0 or greater").required("Sequence is required"),
    is_enabled: $cda9d0e1103d595f$export$87b259aa03e3d267().default(true)
});
// Edit mode schema - image is optional
const $46e407298bd610e0$var$editBannerSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    image: $cda9d0e1103d595f$export$9b30b6294c1449a8().test("fileSize", "Image size must be less than 10MB", (value)=>{
        if (!value || value.length === 0) return true;
        return Array.from(value).every((file)=>{
            // Skip size check for existing images (they don't have size property)
            if (file.existing) return true;
            return file.size <= 10485760; // 10MB
        });
    }).test("fileType", "Only JPEG, PNG, JPG, WEBP files are allowed", (value)=>{
        if (!value || value.length === 0) return true;
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "image/webp"
        ];
        return Array.from(value).every((file)=>{
            // Skip type check for existing images
            if (file.existing) return true;
            return allowedTypes.includes(file.type);
        });
    }).nullable(),
    headline: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Headline must be less than 255 characters").nullable(),
    tagline: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Tagline must be less than 255 characters").nullable(),
    sequence: $cda9d0e1103d595f$export$98e628dec113755e().typeError("Sequence must be a number").min(0, "Sequence must be 0 or greater").required("Sequence is required"),
    is_enabled: $cda9d0e1103d595f$export$87b259aa03e3d267().default(true)
});
const $46e407298bd610e0$var$defaultValues = {
    image: null,
    headline: "",
    tagline: "",
    sequence: "",
    is_enabled: true
};
const $46e407298bd610e0$var$AddBannerPage = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editBannerId = searchParams.get("edit");
    const isEditMode = Boolean(editBannerId);
    const { bannerCreateStatus: bannerCreateStatus, bannerUpdateStatus: bannerUpdateStatus, banner: banner, bannerFetchStatus: bannerFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.banner);
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        mode: "onSubmit",
        defaultValues: $46e407298bd610e0$var$defaultValues,
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)(isEditMode ? $46e407298bd610e0$var$editBannerSchema : $46e407298bd610e0$var$createBannerSchema)
    });
    const { control: control, handleSubmit: handleSubmit, register: register, reset: reset, formState: { errors: errors } } = methods;
    // Reset statuses on unmount
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $lHUkp.resetBannerStatuses)());
        };
    }, [
        dispatch
    ]);
    // Handle create success/failure
    (0, $acw62.useEffect)(()=>{
        if (bannerCreateStatus === "success") {
            reset($46e407298bd610e0$var$defaultValues);
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Banner added successfully");
            dispatch((0, $lHUkp.resetBannerStatuses)());
            navigate("/banners");
        } else if (bannerCreateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to create banner");
    }, [
        bannerCreateStatus,
        navigate,
        reset,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (bannerUpdateStatus === "success") {
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Banner updated successfully");
            dispatch((0, $lHUkp.resetBannerStatuses)());
            navigate("/banners");
        } else if (bannerUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update banner");
    }, [
        bannerUpdateStatus,
        navigate,
        dispatch
    ]);
    // Fetch banner data if in edit mode
    (0, $acw62.useEffect)(()=>{
        if (isEditMode && editBannerId) dispatch((0, $lHUkp.fetchBannerById)(editBannerId));
    }, [
        dispatch,
        isEditMode,
        editBannerId
    ]);
    // Populate form with banner data when in edit mode
    (0, $acw62.useEffect)(()=>{
        if (isEditMode && banner && bannerFetchStatus === "success") {
            const formData = {
                image: banner.image_url ? [
                    {
                        preview: banner.image_url,
                        existing: true,
                        id: banner.id
                    }
                ] : null,
                headline: banner.headline || "",
                tagline: banner.tagline || "",
                sequence: banner.sequence?.toString() || "",
                is_enabled: Boolean(banner.is_enabled)
            };
            reset(formData);
        }
    }, [
        isEditMode,
        banner,
        bannerFetchStatus,
        reset
    ]);
    const buildBannerFormData = (bannerData)=>{
        const formData = new FormData();
        // Handle image upload
        if (bannerData.image && bannerData.image.length > 0) {
            const imageFile = bannerData.image[0];
            // Only append new image files (not existing ones)
            if (imageFile instanceof File) formData.append("image", imageFile);
            else if (imageFile && typeof imageFile === 'object' && !imageFile.existing) // Handle case where it might be wrapped in an object
            {
                if (imageFile.file) formData.append("image", imageFile.file);
            }
        // Skip existing images - they don't need to be sent in edit mode
        }
        // Add other fields
        if (bannerData.headline) formData.append("headline", bannerData.headline);
        if (bannerData.tagline) formData.append("tagline", bannerData.tagline);
        if (bannerData.sequence !== "" && bannerData.sequence !== null && bannerData.sequence !== undefined) formData.append("sequence", bannerData.sequence);
        formData.append("is_enabled", bannerData.is_enabled ? 1 : 0);
        return formData;
    };
    const onSubmit = (data)=>{
        console.log("Form data before building FormData:", data);
        const formData = buildBannerFormData(data);
        // Debug: Log FormData contents
        console.log("FormData contents:");
        for (let [key, value] of formData.entries())console.log(key, value);
        if (isEditMode) dispatch((0, $lHUkp.updateBanner)({
            uuid: editBannerId,
            data: formData
        }));
        else dispatch((0, $lHUkp.createBanner)(formData));
    };
    // Show loader while fetching banner data in edit mode
    if (isEditMode && bannerFetchStatus === "loading") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {});
    // Show error if banner not found in edit mode
    if (isEditMode && bannerFetchStatus === "failed") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-2xl mx-auto theme-card rounded-lg p-6 text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-xl font-bold text-red-600 mb-2",
                children: "Banner Not Found"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-600 mb-4",
                children: "The banner you're trying to edit could not be found."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>navigate("/banners"),
                className: "bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700",
                children: "Back to Banners"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-2xl mx-auto",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "theme-card rounded-lg p-6",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-2xl font-bold text-gray-900",
                                children: isEditMode ? "Edit Banner" : "Add New Banner"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 mt-1",
                                children: isEditMode ? "Update banner information" : "Fill in the details to add a new banner"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    control: control,
                                    name: "image",
                                    render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e49ca7aad3643dc7$export$3019c26e674dcdde), {
                                            label: "Banner Image",
                                            required: !isEditMode,
                                            value: field.value,
                                            onChange: (files)=>field.onChange(files),
                                            hint: isEditMode ? "Upload new banner image to replace existing (JPEG, PNG, JPG, WEBP - Max 10MB) - Optional" : "Upload banner image (JPEG, PNG, JPG, WEBP - Max 10MB)",
                                            maxFiles: 1,
                                            error: errors?.image?.message
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                    label: "Headline",
                                    placeholder: "Enter banner headline (optional)",
                                    ...register("headline"),
                                    error: errors?.headline?.message
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                                    label: "Tagline",
                                    rows: 3,
                                    placeholder: "Enter banner tagline (optional)",
                                    ...register("tagline"),
                                    error: errors?.tagline?.message
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                    label: "Sequence",
                                    type: "number",
                                    min: 0,
                                    required: true,
                                    placeholder: "Enter display sequence",
                                    ...register("sequence"),
                                    error: errors?.sequence?.message
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    control: control,
                                    name: "is_enabled",
                                    render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                            label: "Enable Banner",
                                            checked: Boolean(field.value),
                                            onChange: field.onChange
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-8 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>navigate("/banners"),
                                className: "theme-button-secondary px-4 py-2 rounded-md transition-colors",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                disabled: bannerCreateStatus === "loading" || bannerUpdateStatus === "loading",
                                className: "bg-success text-white px-4 py-2 rounded-md hover:bg-success-600 transition-colors disabled:opacity-50",
                                children: bannerCreateStatus === "loading" || bannerUpdateStatus === "loading" ? "Saving..." : isEditMode ? "Update Banner" : "Save Banner"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $46e407298bd610e0$export$2e2bcd8739ae039 = $46e407298bd610e0$var$AddBannerPage;




var $acw62 = parcelRequire("acw62");



var $ivNbC = parcelRequire("ivNbC");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $056e74b7b26d3329$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye-off", $056e74b7b26d3329$export$3efd853dbb351e94);


var $3ca410114d3f7f6f$exports = {};
$3ca410114d3f7f6f$exports = import.meta.resolve("dqqFO");


function $e415fc81efb69301$export$2e2bcd8739ae039() {
    const logo = new URL($3ca410114d3f7f6f$exports);
    const [email, setEmail] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsSubmitting(true);
        dispatch((0, $03cf4384aa5e191c$export$3ac708362c1f96eb)(true));
        try {
            const res = await (0, $ivNbC.http).post("/dashboard/auth/login", {
                email: email,
                password: password
            });
            const mobileFromResponse = res?.data?.user?.mobile || "";
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Redirecting to OTP verification...");
            navigate("/verify-otp", {
                state: {
                    mobile: mobileFromResponse
                }
            });
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(err, "Login failed. Please check credentials.");
        } finally{
            setIsSubmitting(false);
            dispatch((0, $03cf4384aa5e191c$export$3ac708362c1f96eb)(false));
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full justify-center flex-col flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: logo,
                            alt: "Logo",
                            className: "w-48"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-6 text-center",
                            children: "Login"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "email",
                                    className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    placeholder: "admin@admin.com",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowPassword(!showPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    "Processing..."
                                ]
                            }) : "Continue"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-center mt-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>navigate("/forgot-password"),
                        className: "text-blue-600 hover:text-blue-700 text-sm",
                        children: "Forgot Password?"
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $ivNbC = parcelRequire("ivNbC");



function $c2062adef70ab299$export$2e2bcd8739ae039() {
    const logo = new URL($3ca410114d3f7f6f$exports);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const mobileFromState = location?.state?.mobile || "";
    const [digits, setDigits] = (0, $acw62.useState)([
        "",
        "",
        "",
        "",
        "",
        ""
    ]);
    const [mobile, setMobile] = (0, $acw62.useState)(mobileFromState);
    const inputsRef = (0, $acw62.useRef)([]);
    const code = (0, $acw62.useMemo)(()=>digits.join(""), [
        digits
    ]);
    const handleChange = (index, value)=>{
        if (!/^\d?$/.test(value)) return; // only digits
        const next = [
            ...digits
        ];
        next[index] = value;
        setDigits(next);
        if (value && index < 5) inputsRef.current[index + 1]?.focus();
    };
    const handleKeyDown = (index, e)=>{
        if (e.key === "Backspace" && !digits[index] && index > 0) inputsRef.current[index - 1]?.focus();
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (code.length !== 6) {
            (0, $77fa8ab1aa12d8fb$export$fcc5b2c64ff6ba6)("Please enter the 6-digit OTP.");
            return;
        }
        setIsSubmitting(true);
        dispatch((0, $03cf4384aa5e191c$export$3ac708362c1f96eb)(true));
        try {
            const res = await (0, $ivNbC.http).post("/dashboard/auth/verify-otp", {
                mobile: mobile ? Number(mobile) : undefined,
                otp: code
            });
            const { success: success, data: data } = res || {};
            if (success && data?.token) {
                dispatch((0, $03cf4384aa5e191c$export$3a6cdb4d139acb5f)({
                    token: data.token,
                    user: data.user || null
                }));
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("OTP verified successfully! Welcome to dashboard.");
                navigate("/", {
                    replace: true
                });
                return;
            }
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Invalid response from server.");
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(err, "OTP verification failed. Please try again.");
        } finally{
            setIsSubmitting(false);
            dispatch((0, $03cf4384aa5e191c$export$3ac708362c1f96eb)(false));
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full justify-center flex-col flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: logo,
                            alt: "Logo",
                            className: "w-48"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-6 text-center",
                            children: "Login"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-gray-600 mb-6 text-center",
                    children: [
                        "Enter the 6-digit code sent to ",
                        mobile || "your mobile"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Mobile"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "tel",
                                    className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    value: mobile,
                                    onChange: (e)=>setMobile(e.target.value),
                                    placeholder: "9876543210",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex justify-between gap-2",
                            children: digits.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    inputMode: "numeric",
                                    maxLength: 1,
                                    className: "w-12 h-12 text-center text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    value: digits[i],
                                    onChange: (e)=>handleChange(i, e.target.value),
                                    onKeyDown: (e)=>handleKeyDown(i, e),
                                    ref: (el)=>inputsRef.current[i] = el,
                                    autoFocus: i === 0
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    "Verifying..."
                                ]
                            }) : "Verify"
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-left", $7b20c5205e441d74$export$3efd853dbb351e94);


function $d5b99c7796d428bb$export$2e2bcd8739ae039() {
    const [currentPassword, setCurrentPassword] = (0, $acw62.useState)("");
    const [newPassword, setNewPassword] = (0, $acw62.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const [showCurrentPassword, setShowCurrentPassword] = (0, $acw62.useState)(false);
    const [showNewPassword, setShowNewPassword] = (0, $acw62.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { isLoading: isLoading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "New passwords do not match");
            return;
        }
        if (newPassword.length < 6) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Password must be at least 6 characters");
            return;
        }
        if (currentPassword === newPassword) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "New password must be different from current password");
            return;
        }
        try {
            await dispatch((0, $03cf4384aa5e191c$export$905471c51c0d384d)({
                current_password: currentPassword,
                new_password: newPassword,
                new_password_confirmation: confirmPassword
            })).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Password updated successfully!");
            navigate("/");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(error, "Failed to update password");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "max-w-2xl mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2",
                            children: "Change Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-600",
                            children: "Update your account password"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Current Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showCurrentPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: currentPassword,
                                            onChange: (e)=>setCurrentPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowCurrentPassword(!showCurrentPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showCurrentPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "New Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showNewPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: newPassword,
                                            onChange: (e)=>setNewPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowNewPassword(!showNewPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showNewPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Confirm New Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showConfirmPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: confirmPassword,
                                            onChange: (e)=>setConfirmPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowConfirmPassword(!showConfirmPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showConfirmPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex space-x-3 pt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/"),
                                    className: "flex-1 bg-gray-200 text-gray-700 rounded-md px-4 py-2 hover:bg-gray-300 transition-colors flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 mr-2"
                                        }),
                                        "Cancel"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    disabled: isLoading,
                                    className: "flex-1 bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                                    children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        className: "opacity-25",
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10",
                                                        stroke: "currentColor",
                                                        strokeWidth: "4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        className: "opacity-75",
                                                        fill: "currentColor",
                                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    })
                                                ]
                                            }),
                                            "Updating..."
                                        ]
                                    }) : "Update Password"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $ivNbC = parcelRequire("ivNbC");


var $2OTVO = parcelRequire("2OTVO");



var $acw62 = parcelRequire("acw62");


var $2OTVO = parcelRequire("2OTVO");
// Secure storage key
const $425c27a02c51b625$var$SUBSCRIPTION_KEY = "business_subscription";
const $425c27a02c51b625$export$378fe387778fca13 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { user: user, isAuthenticated: isAuthenticated } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const { dashboard: dashboard } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    const [subscriptionType, setSubscriptionType] = (0, $acw62.useState)(null);
    // Secure function to get cached subscription data
    const getCachedSubscription = (0, $acw62.useCallback)(()=>{
        try {
            const cachedData = localStorage.getItem($425c27a02c51b625$var$SUBSCRIPTION_KEY);
            if (!cachedData) return null;
            return JSON.parse(cachedData);
        } catch (error) {
            console.error("Error reading cached subscription:", error);
            localStorage.removeItem($425c27a02c51b625$var$SUBSCRIPTION_KEY);
            return null;
        }
    }, []);
    // Secure function to cache subscription data
    const cacheSubscription = (0, $acw62.useCallback)((data)=>{
        try {
            localStorage.setItem($425c27a02c51b625$var$SUBSCRIPTION_KEY, JSON.stringify(data));
        } catch (error) {
            console.error("Error caching subscription:", error);
        }
    }, []);
    // Function to fetch subscription data
    const fetchSubscriptionData = (0, $acw62.useCallback)(async (force = false)=>{
        if (!isAuthenticated || user?.role !== "business") return null;
        // Check cache first unless forced
        if (!force) {
            const cached = getCachedSubscription();
            if (cached) {
                setSubscriptionType(cached.subscription);
                return cached;
            }
        }
        try {
            const result = await dispatch((0, $2OTVO.getBusinessDashboard)());
            if (result.type === "businessOwner/getBusinessDashboard/fulfilled") {
                const dashboardData = result.payload?.data;
                const businessData = dashboardData?.business;
                if (businessData) {
                    const subscriptionData = {
                        subscription: businessData.subscription,
                        businessName: businessData.name,
                        businessUuid: businessData.uuid,
                        lastUpdated: new Date().toISOString()
                    };
                    cacheSubscription(subscriptionData);
                    setSubscriptionType(businessData.subscription);
                    return subscriptionData;
                }
            }
        } catch (error) {
            console.error("Error fetching subscription data:", error);
        }
        return null;
    }, [
        dispatch,
        isAuthenticated,
        user?.role,
        getCachedSubscription,
        cacheSubscription
    ]);
    // Initialize subscription data on mount or when auth state changes
    (0, $acw62.useEffect)(()=>{
        if (isAuthenticated && user?.role === "business") {
            const cached = getCachedSubscription();
            if (cached) setSubscriptionType(cached.subscription);
            else fetchSubscriptionData();
        } else {
            setSubscriptionType(null);
            localStorage.removeItem($425c27a02c51b625$var$SUBSCRIPTION_KEY);
        }
    }, [
        isAuthenticated,
        user?.role,
        getCachedSubscription,
        fetchSubscriptionData
    ]);
    // Update subscription when dashboard data changes
    (0, $acw62.useEffect)(()=>{
        if (dashboard?.business?.subscription) {
            const newSubscription = dashboard.business.subscription;
            if (newSubscription !== subscriptionType) {
                setSubscriptionType(newSubscription);
                const subscriptionData = {
                    subscription: newSubscription,
                    businessName: dashboard.business.name,
                    businessUuid: dashboard.business.uuid,
                    lastUpdated: new Date().toISOString()
                };
                cacheSubscription(subscriptionData);
            }
        }
    }, [
        dashboard,
        subscriptionType,
        cacheSubscription
    ]);
    // Return premium status and fetch function
    return {
        isPremium: subscriptionType === "Premium",
        fetchSubscriptionData: fetchSubscriptionData
    };
};
var $425c27a02c51b625$export$2e2bcd8739ae039 = $425c27a02c51b625$export$378fe387778fca13;



function $0580f20f003de903$export$2e2bcd8739ae039() {
    const logo = new URL($3ca410114d3f7f6f$exports);
    const [mobile, setMobile] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { fetchSubscriptionData: fetchSubscriptionData } = (0, $425c27a02c51b625$export$2e2bcd8739ae039)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsSubmitting(true);
        dispatch((0, $03cf4384aa5e191c$export$3ac708362c1f96eb)(true));
        try {
            const res = await (0, $ivNbC.http).post("/dashboard/auth/business/login", {
                mobile: mobile,
                password: password
            });
            const { data: data } = res;
            const { token: token, user: user, is_reset_password_after_login: is_reset_password_after_login } = data;
            // Set role from API response (normalize to lowercase for consistency)
            const userWithRole = {
                ...user,
                role: user?.role?.name?.toLowerCase() || "business",
                is_reset_password_after_login: is_reset_password_after_login
            };
            // Always set credentials on successful login
            dispatch((0, $03cf4384aa5e191c$export$3a6cdb4d139acb5f)({
                token: token,
                user: userWithRole
            }));
            // Fetch business details and subscription data after successful login
            try {
                const businessDetailsResult = await dispatch((0, $2OTVO.getBusinessDetails)());
                if (businessDetailsResult.type === "businessOwner/getBusinessDetails/fulfilled") {
                    const businessData = businessDetailsResult.payload?.data;
                    if (businessData?.uuid) {
                        // Update user with business_id
                        const userWithBusinessId = {
                            ...userWithRole,
                            business_id: businessData.uuid,
                            business_name: businessData.business_name
                        };
                        dispatch((0, $03cf4384aa5e191c$export$3a6cdb4d139acb5f)({
                            token: token,
                            user: userWithBusinessId
                        }));
                    }
                }
                // Fetch subscription data after setting credentials
                await fetchSubscriptionData(true); // Force fresh fetch on login
            } catch (businessErr) {
                console.warn("Failed to fetch business details or subscription:", businessErr);
            // Continue with login even if business details fetch fails
            }
            // Check if password reset is required after login
            if (is_reset_password_after_login) {
                // User needs to change password - redirect to first-time change password page
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Please update your password");
                navigate("/business/first-change-password");
            } else {
                // User can proceed directly to dashboard
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Login successful - Business!");
                navigate("/business/dashboard");
            }
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(err, "Login failed. Please check credentials.");
        } finally{
            setIsSubmitting(false);
            dispatch((0, $03cf4384aa5e191c$export$3ac708362c1f96eb)(false));
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full justify-center flex-col flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: logo,
                            alt: "Logo",
                            className: "w-48"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2 text-center",
                            children: "Business Login"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-600 text-center mb-6",
                            children: "Enter your credentials to access your account"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Mobile Number"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "tel",
                                    className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    value: mobile,
                                    onChange: (e)=>{
                                        const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                        if (value.length <= 10) setMobile(value);
                                    },
                                    onKeyPress: (e)=>{
                                        // Only allow digits
                                        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') e.preventDefault();
                                    },
                                    placeholder: "9876543210",
                                    minLength: 10,
                                    maxLength: 10,
                                    pattern: "[0-9]{10}",
                                    inputMode: "numeric",
                                    required: true
                                }),
                                mobile.length > 0 && mobile.length < 10 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-red-500 text-xs mt-1",
                                    children: "Mobile number must be exactly 10 digits"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowPassword(!showPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    "Processing..."
                                ]
                            }) : "Login"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-center mt-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>navigate("/forgot-password"),
                        className: "text-blue-600 hover:text-blue-700 text-sm",
                        children: "Forgot Password?"
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");






function $bdd3dfc62704f8ef$export$2e2bcd8739ae039() {
    const logo = new URL($3ca410114d3f7f6f$exports);
    const [newPassword, setNewPassword] = (0, $acw62.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const [showNewPassword, setShowNewPassword] = (0, $acw62.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { passwordChangeStatus: passwordChangeStatus, isAuthenticated: isAuthenticated, user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    // Redirect if user is not authenticated or doesn't need to change password (first-time)
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated) navigate("/login", {
            replace: true
        });
        else if (user && !user.is_reset_password_after_login) // User doesn't need first-time password change, redirect to dashboard
        navigate("/business/dashboard", {
            replace: true
        });
    }, [
        isAuthenticated,
        user,
        navigate
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $03cf4384aa5e191c$export$c9fd3cd3e28a71a9)());
        };
    }, [
        dispatch
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Passwords do not match");
            return;
        }
        if (newPassword.length < 6) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Password must be at least 6 characters");
            return;
        }
        try {
            await dispatch((0, $03cf4384aa5e191c$export$a3e7cd82d8aa2d0)({
                new_password: newPassword,
                new_password_confirmation: confirmPassword
            })).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Password updated successfully! Please login again.");
            // Redirect to business login after clearing cache
            navigate("/login");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update password");
        }
    };
    const isSubmitting = passwordChangeStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full justify-center flex-col flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: logo,
                            alt: "Logo",
                            className: "w-48"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2 text-center",
                            children: "Change Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-600 mb-6 text-center",
                            children: "Please update your password to continue"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "New Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showNewPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: newPassword,
                                            onChange: (e)=>setNewPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowNewPassword(!showNewPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showNewPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Confirm Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showConfirmPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: confirmPassword,
                                            onChange: (e)=>setConfirmPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowConfirmPassword(!showConfirmPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showConfirmPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    "Updating..."
                                ]
                            }) : "Update Password"
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");





function $6c1aeecd666e9e58$export$2e2bcd8739ae039() {
    const [currentPassword, setCurrentPassword] = (0, $acw62.useState)("");
    const [newPassword, setNewPassword] = (0, $acw62.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const [showCurrentPassword, setShowCurrentPassword] = (0, $acw62.useState)(false);
    const [showNewPassword, setShowNewPassword] = (0, $acw62.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { isLoading: isLoading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "New passwords do not match");
            return;
        }
        if (newPassword.length < 6) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Password must be at least 6 characters");
            return;
        }
        if (currentPassword === newPassword) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "New password must be different from current password");
            return;
        }
        try {
            await dispatch((0, $03cf4384aa5e191c$export$5fa854eef0f83a6a)({
                current_password: currentPassword,
                new_password: newPassword,
                new_password_confirmation: confirmPassword
            })).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Password updated successfully! Please login again.");
            // Redirect to business login after clearing cache
            navigate("/login");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(error, "Failed to update password");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "max-w-2xl mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2",
                            children: "Change Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-600",
                            children: "Update your business account password"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Current Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showCurrentPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: currentPassword,
                                            onChange: (e)=>setCurrentPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowCurrentPassword(!showCurrentPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showCurrentPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "New Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showNewPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: newPassword,
                                            onChange: (e)=>setNewPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowNewPassword(!showNewPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showNewPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Confirm New Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showConfirmPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: confirmPassword,
                                            onChange: (e)=>setConfirmPassword(e.target.value),
                                            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowConfirmPassword(!showConfirmPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showConfirmPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex space-x-3 pt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/business/dashboard"),
                                    className: "flex-1 bg-gray-200 text-gray-700 rounded-md px-4 py-2 hover:bg-gray-300 transition-colors flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 mr-2"
                                        }),
                                        "Cancel"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    disabled: isLoading,
                                    className: "flex-1 bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                                    children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        className: "opacity-25",
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10",
                                                        stroke: "currentColor",
                                                        strokeWidth: "4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        className: "opacity-75",
                                                        fill: "currentColor",
                                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    })
                                                ]
                                            }),
                                            "Updating..."
                                        ]
                                    }) : "Update Password"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $ivNbC = parcelRequire("ivNbC");


function $5093fb378d234caa$export$2e2bcd8739ae039() {
    const logo = new URL($3ca410114d3f7f6f$exports);
    const [mobile, setMobile] = (0, $acw62.useState)("");
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // Validate mobile number
        if (!/^[0-9]{10}$/.test(mobile)) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Please enter a valid 10-digit mobile number");
            return;
        }
        setIsSubmitting(true);
        try {
            await (0, $ivNbC.http).post("/dashboard/auth/forgot-password", {
                mobile: mobile
            });
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("OTP sent successfully to your mobile number");
            navigate("/reset-password", {
                state: {
                    mobile: mobile
                }
            });
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(err, "Failed to send OTP. Please try again.");
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full justify-center flex-col flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: logo,
                            alt: "Logo",
                            className: "w-48"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2 text-center",
                            children: "Forgot Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-600 text-center mb-6",
                            children: "Enter your mobile number to receive an OTP"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Mobile Number"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "tel",
                                    className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    value: mobile,
                                    onChange: (e)=>setMobile(e.target.value),
                                    placeholder: "Enter 10-digit mobile number",
                                    maxLength: 10,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    "Sending OTP..."
                                ]
                            }) : "Send OTP"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-center mt-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>navigate("/login"),
                                className: "text-blue-600 hover:text-blue-700 text-sm",
                                children: "Back to Login"
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $ivNbC = parcelRequire("ivNbC");



function $c197229f57811059$export$2e2bcd8739ae039() {
    const logo = new URL($3ca410114d3f7f6f$exports);
    const [otp, setOtp] = (0, $acw62.useState)("");
    const [newPassword, setNewPassword] = (0, $acw62.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $acw62.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const mobile = location.state?.mobile;
    (0, $acw62.useEffect)(()=>{
        if (!mobile) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Mobile number is required");
            navigate("/forgot-password");
        }
    }, [
        mobile,
        navigate
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // Validate OTP
        if (!/^[0-9]{6}$/.test(otp)) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Please enter a valid 6-digit OTP");
            return;
        }
        // Validate password length
        if (newPassword.length < 6) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Password must be at least 6 characters");
            return;
        }
        // Validate password match
        if (newPassword !== confirmPassword) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Passwords do not match");
            return;
        }
        setIsSubmitting(true);
        try {
            await (0, $ivNbC.http).post("/dashboard/auth/reset-password", {
                mobile: mobile,
                otp: otp,
                new_password: newPassword,
                new_password_confirmation: confirmPassword
            });
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Password reset successfully. You can now login with your new password.");
            navigate("/login");
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(err, "Failed to reset password. Please check your OTP.");
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleResendOtp = async ()=>{
        try {
            await (0, $ivNbC.http).post("/dashboard/auth/forgot-password", {
                mobile: mobile
            });
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("OTP resent successfully");
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(err, "Failed to resend OTP");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md bg-white rounded-lg shadow p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full justify-center flex-col flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: logo,
                            alt: "Logo",
                            className: "w-48"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2 text-center",
                            children: "Reset Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-gray-600 text-center mb-6",
                            children: [
                                "Enter the OTP sent to ",
                                mobile
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "OTP"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                    value: otp,
                                    onChange: (e)=>setOtp(e.target.value),
                                    placeholder: "Enter 6-digit OTP",
                                    maxLength: 6,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "New Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: newPassword,
                                            onChange: (e)=>setNewPassword(e.target.value),
                                            placeholder: "Enter new password (min 6 characters)",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowPassword(!showPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Confirm Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: showConfirmPassword ? "text" : "password",
                                            className: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            value: confirmPassword,
                                            onChange: (e)=>setConfirmPassword(e.target.value),
                                            placeholder: "Confirm new password",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowConfirmPassword(!showConfirmPassword),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2",
                                            children: showConfirmPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    "Resetting Password..."
                                ]
                            }) : "Reset Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-center mt-4 space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: handleResendOtp,
                                    className: "text-blue-600 hover:text-blue-700 text-sm",
                                    children: "Resend OTP"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>navigate("/login"),
                                        className: "text-gray-600 hover:text-gray-700 text-sm",
                                        children: "Back to Login"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");


function $25248a71699946fb$export$2e2bcd8739ae039() {
    const { isAuthenticated: isAuthenticated, user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (!isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true,
        state: {
            from: location
        }
    });
    // If user is business, redirect to business dashboard
    if (user?.role === "business") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/business/dashboard",
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {});
}



parcelRequire("acw62");


function $ad8b30ddf8aa3463$export$2e2bcd8739ae039() {
    const { isAuthenticated: isAuthenticated, user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    if (isAuthenticated) {
        // Redirect based on user role
        if (user?.role === "business") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
            to: "/business/dashboard",
            replace: true
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
            to: "/",
            replace: true
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {});
}



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e20ffdae2aa9b33f$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $e20ffdae2aa9b33f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lock", $e20ffdae2aa9b33f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5473793717b51056$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("log-out", $5473793717b51056$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b66c39b6083b2b9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 18h16",
            key: "19g7jn"
        }
    ],
    [
        "path",
        {
            d: "M4 6h16",
            key: "1o0s65"
        }
    ]
];
const $4b66c39b6083b2b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("menu", $4b66c39b6083b2b9$export$3efd853dbb351e94);




var $6J3qC = parcelRequire("6J3qC");


var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $224502d93617e0e1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
];
const $224502d93617e0e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("building-2", $224502d93617e0e1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1299b0a605d22052$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
];
const $1299b0a605d22052$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("credit-card", $1299b0a605d22052$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-text", $adb270212de20834$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bee7e1f6335e67ab$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
            key: "5wwlr5"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "1d0kgt"
        }
    ]
];
const $bee7e1f6335e67ab$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("house", $bee7e1f6335e67ab$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c978075baab28645$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
            key: "1r0f0z"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ]
];
const $c978075baab28645$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("map-pin", $c978075baab28645$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $437c67a40c1b8279$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
            key: "1a0edw"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ]
];
const $437c67a40c1b8279$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("package", $437c67a40c1b8279$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8872a1d80d2463f9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
];
const $8872a1d80d2463f9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("tag", $8872a1d80d2463f9$export$3efd853dbb351e94);



const $0d4cd184186b22d4$var$logo = new URL($3ca410114d3f7f6f$exports);
const $0d4cd184186b22d4$var$Sidebar = ({ isOpen: isOpen, onToggle: onToggle })=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    // Check if any child item is active to determine if parent should be expanded
    const isChildActive = (children)=>{
        if (!children) return false;
        return children.some((child)=>{
            if (child.href === location.pathname) return true;
            if (child.children) return isChildActive(child.children);
            return false;
        });
    };
    const navigationItems = [
        {
            id: "dashboard",
            label: "Dashboard",
            icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
            href: "/"
        },
        {
            id: "shop",
            label: "Business",
            icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
            children: [
                {
                    id: "view-shops",
                    label: "View Business",
                    icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                    href: "/business"
                },
                {
                    id: "add-shop",
                    label: "Add Business",
                    icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                    href: "/business/add"
                }
            ]
        },
        {
            id: "customers",
            label: "Customers",
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            href: "/customers"
        },
        {
            id: "categories",
            label: "Categories",
            icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
            children: [
                {
                    id: "categories-group",
                    label: "Categories",
                    icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
                    isGroup: true,
                    children: [
                        {
                            id: "view-categories",
                            label: "View Categories",
                            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                            href: "/categories"
                        },
                        {
                            id: "add-category",
                            label: "Add Category",
                            icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                            href: "/categories/add"
                        }
                    ]
                },
                {
                    id: "subcategories-group",
                    label: "SubCategories",
                    icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
                    isGroup: true,
                    children: [
                        {
                            id: "view-subcategories",
                            label: "View SubCategories",
                            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                            href: "/sub-categories"
                        },
                        {
                            id: "add-subcategory",
                            label: "Add SubCategory",
                            icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                            href: "/sub-categories/add"
                        }
                    ]
                },
                {
                    id: "services-group",
                    label: "Services",
                    icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
                    isGroup: true,
                    children: [
                        {
                            id: "view-services",
                            label: "View Services",
                            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                            href: "/category-services"
                        },
                        {
                            id: "add-service",
                            label: "Add Service",
                            icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                            href: "/category-services/add"
                        }
                    ]
                }
            ]
        },
        {
            id: "locations",
            label: "Locations",
            icon: (0, $c978075baab28645$export$2e2bcd8739ae039),
            children: [
                {
                    id: "states-group",
                    label: "States",
                    icon: (0, $c978075baab28645$export$2e2bcd8739ae039),
                    isGroup: true,
                    children: [
                        {
                            id: "view-states",
                            label: "View States",
                            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                            href: "/states"
                        },
                        {
                            id: "add-state",
                            label: "Add State",
                            icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                            href: "/states/add"
                        }
                    ]
                },
                {
                    id: "districts-group",
                    label: "Districts",
                    icon: (0, $c978075baab28645$export$2e2bcd8739ae039),
                    isGroup: true,
                    children: [
                        {
                            id: "view-districts",
                            label: "View Districts",
                            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                            href: "/districts"
                        },
                        {
                            id: "add-district",
                            label: "Add District",
                            icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                            href: "/districts/add"
                        }
                    ]
                },
                {
                    id: "talukas-group",
                    label: "Talukas",
                    icon: (0, $c978075baab28645$export$2e2bcd8739ae039),
                    isGroup: true,
                    children: [
                        {
                            id: "view-talukas",
                            label: "View Talukas",
                            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                            href: "/talukas"
                        },
                        {
                            id: "add-taluka",
                            label: "Add Taluka",
                            icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                            href: "/talukas/add"
                        }
                    ]
                }
            ]
        },
        {
            id: "banner",
            label: "Banner",
            icon: (0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039),
            children: [
                {
                    id: "view-banners",
                    label: "View Banners",
                    icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                    href: "/banners"
                },
                {
                    id: "add-banner",
                    label: "Add Banner",
                    icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                    href: "/banners/add"
                }
            ]
        },
        {
            id: "subscription-packages",
            label: "Subscription Packages",
            icon: (0, $437c67a40c1b8279$export$2e2bcd8739ae039),
            children: [
                {
                    id: "view-packages",
                    label: "View Packages",
                    icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                    href: "/subscription-packages"
                },
                {
                    id: "add-package",
                    label: "Add Package",
                    icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                    href: "/subscription-packages/add"
                }
            ]
        },
        {
            id: "payment-modes",
            label: "Payment Modes",
            icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
            children: [
                {
                    id: "view-payment-modes",
                    label: "View Payment Modes",
                    icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                    href: "/payment-modes"
                },
                {
                    id: "add-payment-mode",
                    label: "Add Payment Mode",
                    icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                    href: "/payment-modes/add"
                }
            ]
        },
        {
            id: "company-details",
            label: "Company Details",
            icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039),
            href: "/company-details"
        },
        {
            id: "commission-payments",
            label: "Commission Payments",
            icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
            href: "/commission-payments"
        },
        {
            id: "reports",
            label: "Reports",
            icon: (0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039),
            children: [
                {
                    id: "business-reports",
                    label: "View Reports",
                    icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
                    href: "/reports"
                },
                {
                    id: "all-invoices",
                    label: "All Invoices",
                    icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                    href: "/invoices"
                }
            ]
        }
    ];
    // Initialize expanded items based on active child items
    const getInitialExpandedItems = ()=>{
        const expanded = [];
        const checkAndExpand = (items, parentId = null)=>{
            items.forEach((item)=>{
                if (item.children) {
                    if (isChildActive(item.children)) {
                        expanded.push(item.id);
                        if (parentId) expanded.push(parentId);
                    }
                    checkAndExpand(item.children, item.id);
                }
            });
        };
        checkAndExpand(navigationItems);
        return expanded;
    };
    const [expandedItems, setExpandedItems] = (0, $acw62.useState)(()=>getInitialExpandedItems());
    // Update expanded items when location changes
    (0, $acw62.useEffect)(()=>{
        setExpandedItems(getInitialExpandedItems());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
    const toggleExpanded = (itemId)=>{
        setExpandedItems((prev)=>prev.includes(itemId) ? prev.filter((id)=>id !== itemId) : [
                ...prev,
                itemId
            ]);
    };
    const handleItemClick = (item)=>{
        if (item.children) toggleExpanded(item.id);
        else if (item.href) {
            navigate(item.href);
            // Close sidebar on mobile after navigation
            if (onToggle) onToggle();
        }
    };
    const handleChildClick = (child)=>{
        if (child.children) toggleExpanded(child.id);
        else if (child.href) {
            navigate(child.href);
            // Close sidebar on mobile after navigation
            if (onToggle) onToggle();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                className: `theme-sidebar fixed lg:static inset-y-0 left-0 z-40 w-64 transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "h-full flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between h-[85px] px-6 border-b border-sidebar-border",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center space-x-3 cursor-pointer",
                                    onClick: ()=>navigate("/"),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: $0d4cd184186b22d4$var$logo,
                                        alt: "Logo",
                                        className: "w-32"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onToggle,
                                    className: "lg:hidden p-2 rounded-md bg-card-bg border border-card-border text-text-primary hover:bg-surface-50 transition-colors",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                            className: "flex-1 px-4 py-6 overflow-y-auto scrollbar-hide",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-2",
                                children: navigationItems.map((item)=>{
                                    const IconComponent = item.icon;
                                    const isActive = location.pathname === item.href;
                                    const hasChildren = item.children && item.children.length > 0;
                                    const isExpanded = expandedItems.includes(item.id);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: ()=>handleItemClick(item),
                                                className: `w-full flex items-center justify-between px-4 py-3 text-left rounded-lg transition-colors duration-200 ${isActive && !hasChildren ? "theme-sidebar-active" : "text-text-secondary hover:bg-surface-50 hover:text-text-primary"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconComponent, {
                                                                className: `h-5 w-5 ${isActive && !hasChildren ? "text-white" : "text-text-tertiary"}`
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-medium",
                                                                children: item.label
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex items-center space-x-2",
                                                        children: hasChildren ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                            className: `h-4 w-4 text-text-tertiary transform transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                            className: `h-4 w-4 text-text-tertiary ${isActive ? "text-white" : ""}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            hasChildren && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `ml-4 mt-2 overflow-hidden transition-all duration-200 ${isExpanded ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"}`,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    className: "space-y-1 border-l-2 border-border-light p-2",
                                                    children: item.children.map((child)=>{
                                                        const ChildIconComponent = child.icon;
                                                        const isChildActive = location.pathname === child.href;
                                                        const hasNestedChildren = child.children && child.children.length > 0;
                                                        const isChildExpanded = expandedItems.includes(child.id);
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            className: "m-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    onClick: ()=>handleChildClick(child),
                                                                    className: `w-full flex items-center justify-between px-3 py-2 text-left rounded-md transition-colors duration-200 ${isChildActive && !hasNestedChildren ? "theme-sidebar-active" : "text-text-secondary hover:bg-surface-50 hover:text-text-primary"}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "flex items-center space-x-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ChildIconComponent, {
                                                                                    className: `h-4 w-4 ${isChildActive && !hasNestedChildren ? "text-white" : "text-text-tertiary"}`
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "text-sm font-medium",
                                                                                    children: child.label
                                                                                })
                                                                            ]
                                                                        }),
                                                                        hasNestedChildren && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                            className: `h-3 w-3 text-text-tertiary transform transition-transform duration-200 ${isChildExpanded ? "rotate-180" : ""}`
                                                                        })
                                                                    ]
                                                                }),
                                                                hasNestedChildren && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: `ml-4 mt-1 overflow-hidden transition-all duration-200 ${isChildExpanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                        className: "space-y-1 border-l-2 border-border-light pl-2",
                                                                        children: child.children.map((nestedChild)=>{
                                                                            const NestedIconComponent = nestedChild.icon;
                                                                            const isNestedActive = location.pathname === nestedChild.href;
                                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                className: "m-1",
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                                    onClick: ()=>{
                                                                                        navigate(nestedChild.href);
                                                                                        if (onToggle) onToggle();
                                                                                    },
                                                                                    className: `w-full flex items-center space-x-2 px-2 py-1.5 text-left rounded-md transition-colors duration-200 ${isNestedActive ? "theme-sidebar-active" : "text-text-secondary hover:bg-surface-50 hover:text-text-primary"}`,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NestedIconComponent, {
                                                                                            className: `h-3 w-3 ${isNestedActive ? "text-white" : "text-text-tertiary"}`
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "text-xs font-medium",
                                                                                            children: nestedChild.label
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, nestedChild.id);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, child.id);
                                                    })
                                                })
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-4 border-t border-sidebar-border",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-xs text-text-tertiary text-center",
                                children: "\xa9 2025 Connectri"
                            })
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "fixed inset-0 bg-black/50 z-30 lg:hidden",
                    onClick: onToggle
                })
            })
        ]
    });
};
var $0d4cd184186b22d4$export$2e2bcd8739ae039 = $0d4cd184186b22d4$var$Sidebar;


const $071e43f2dfcf420e$var$Layout = ({ children: children })=>{
    const [isProfileOpen, setIsProfileOpen] = (0, $acw62.useState)(false);
    const [isSidebarOpen, setIsSidebarOpen] = (0, $acw62.useState)(false);
    const profileRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const { loading: loading, message: message, error: error } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.utility);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (profileRef.current && !profileRef.current.contains(event.target)) setIsProfileOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (message) {
            alert(message);
            dispatch((0, $6J3qC.clearMessage)());
        }
        if (error) {
            alert(`Error: ${error}`);
            dispatch((0, $6J3qC.clearMessage)());
        }
    }, [
        message,
        error,
        dispatch
    ]);
    const handleLogout = ()=>{
        dispatch((0, $03cf4384aa5e191c$export$a0973bcfe11b05c9)());
        navigate("/admin/auth/login");
    };
    const getUserInitials = ()=>{
        if (!user?.name) return "U";
        return user.name.split(" ").map((n)=>n[0]).join("").toUpperCase().slice(0, 2);
    };
    const toggleSidebar = ()=>{
        setIsSidebarOpen(!isSidebarOpen);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-screen bg-bg-primary",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d4cd184186b22d4$export$2e2bcd8739ae039), {
                isOpen: isSidebarOpen,
                onToggle: toggleSidebar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 flex flex-col overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "theme-header flex items-center justify-between px-6 py-4 border-b border-header-border",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: toggleSidebar,
                                        className: "lg:hidden p-2 rounded-md bg-card-bg border border-card-border text-text-primary hover:bg-surface-50 transition-colors",
                                        children: isSidebarOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        onClick: ()=>navigate("/"),
                                        className: "text-lg font-semibold text-text-primary cursor-pointer hover:opacity-80 transition-opacity",
                                        children: "Admin"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex items-center space-x-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    ref: profileRef,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: ()=>setIsProfileOpen(!isProfileOpen),
                                            className: "flex items-center space-x-3 p-2 rounded-lg hover:bg-surface-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm font-medium",
                                                    children: getUserInitials()
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm font-medium text-text-primary",
                                                            children: user?.name || "User"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-text-secondary",
                                                            children: user?.email || "user@example.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        isProfileOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white border border-gray-200 z-50",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "py-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "px-4 py-3 border-b border-gray-200",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: user?.name || "User"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-gray-500 truncate",
                                                                children: user?.email || "user@example.com"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: ()=>{
                                                            navigate("/change-password");
                                                            setIsProfileOpen(false);
                                                        },
                                                        className: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Change Password"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "border-t border-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            onClick: handleLogout,
                                                            className: "w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Logout"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "flex-1 overflow-auto bg-bg-secondary p-6",
                        children: children
                    })
                ]
            })
        ]
    });
};
var $071e43f2dfcf420e$export$2e2bcd8739ae039 = $071e43f2dfcf420e$var$Layout;


function $48d716d2db5c5c8d$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const getActiveItem = ()=>{
        const pathMap = {
            "/": "dashboard",
            "/shops": "view-shops",
            "/shops/add": "add-shop",
            "/banners": "view-banners",
            "/banners/add": "add-banner"
        };
        return pathMap[location.pathname] || "dashboard";
    };
    const handleNavigate = (itemId, href)=>{
        navigate(href);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $071e43f2dfcf420e$export$2e2bcd8739ae039), {
        activeItem: getActiveItem(),
        onNavigate: handleNavigate,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
}



parcelRequire("acw62");


function $0c35ec894696d9aa$export$2e2bcd8739ae039() {
    const { isAuthenticated: isAuthenticated, user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (!isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true,
        state: {
            from: location
        }
    });
    // Check if user has business role
    if (user?.role !== "business") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/admin/auth/login",
        replace: true
    });
    // Check if user needs to reset password and is not already on the change password page
    if (user?.is_reset_password_after_login && location.pathname !== "/business/first-change-password") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/business/first-change-password",
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {});
}



parcelRequire("acw62");


function $7759d308bfd5bce4$export$2e2bcd8739ae039() {
    const { isAuthenticated: isAuthenticated, user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    if (isAuthenticated && user?.role === "business") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/business/dashboard",
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {});
}



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $6J3qC = parcelRequire("6J3qC");


var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $94f7f4722a3e5887$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
            key: "3c2336"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "M9 9h.01",
            key: "1q5me6"
        }
    ],
    [
        "path",
        {
            d: "M15 15h.01",
            key: "lqbp3k"
        }
    ]
];
const $94f7f4722a3e5887$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("badge-percent", $94f7f4722a3e5887$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clock", $200392fae49ddb7e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("settings", $da03c070d837b197$export$3efd853dbb351e94);




const $b333572f0cd8dc08$var$logo = new URL($3ca410114d3f7f6f$exports);
const $b333572f0cd8dc08$var$BusinessSidebar = ({ isOpen: isOpen, onToggle: onToggle })=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [isDesktop, setIsDesktop] = (0, $acw62.useState)(window.innerWidth >= 1024);
    const { isPremium: isPremium } = (0, $425c27a02c51b625$export$2e2bcd8739ae039)();
    // Handle window resize
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            setIsDesktop(window.innerWidth >= 1024);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    // Check if any child item is active to determine if parent should be expanded
    const isChildActive = (children)=>{
        if (!children) return false;
        return children.some((child)=>{
            if (child.href === location.pathname) return true;
            if (child.children) return isChildActive(child.children);
            return false;
        });
    };
    const navigationItems = [
        {
            id: "dashboard",
            label: "Dashboard",
            icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
            href: "/business/dashboard"
        },
        // Only show Transactions tab for Premium users
        ...isPremium ? [
            {
                id: "transactions",
                label: "Transactions",
                icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
                children: [
                    {
                        id: "new-transaction",
                        label: "New Transaction",
                        icon: (0, $dbde4c3396582d11$export$2e2bcd8739ae039),
                        href: "/business/transactions"
                    },
                    {
                        id: "transaction-history",
                        label: "Transaction History",
                        icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
                        href: "/business/transactions/history"
                    }
                ]
            }
        ] : [],
        {
            id: "discount",
            label: "Discount",
            icon: (0, $94f7f4722a3e5887$export$2e2bcd8739ae039),
            href: "/business/discount"
        },
        {
            id: "reports",
            label: "Reports",
            icon: (0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039),
            href: "/business/reports"
        },
        ...isPremium ? [
            {
                id: "invoices",
                label: "Invoices",
                icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                href: "/business/invoices"
            }
        ] : [],
        {
            id: "settings",
            label: "Profile",
            icon: (0, $da03c070d837b197$export$2e2bcd8739ae039),
            href: "/business/settings"
        }
    ];
    // Initialize expanded items based on active child items
    const getInitialExpandedItems = ()=>{
        const expanded = [];
        const checkAndExpand = (items, parentId = null)=>{
            items.forEach((item)=>{
                if (item.children) {
                    if (isChildActive(item.children)) {
                        expanded.push(item.id);
                        if (parentId) expanded.push(parentId);
                    }
                    checkAndExpand(item.children, item.id);
                }
            });
        };
        checkAndExpand(navigationItems);
        return expanded;
    };
    const [expandedItems, setExpandedItems] = (0, $acw62.useState)(()=>getInitialExpandedItems());
    // Update expanded items when location changes
    (0, $acw62.useEffect)(()=>{
        setExpandedItems(getInitialExpandedItems());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
    const toggleExpanded = (itemId)=>{
        setExpandedItems((prev)=>prev.includes(itemId) ? prev.filter((id)=>id !== itemId) : [
                ...prev,
                itemId
            ]);
    };
    const handleItemClick = (item)=>{
        // If item has children, toggle expansion
        if (item.children) toggleExpanded(item.id);
        // If item has href, navigate to it
        if (item.href) {
            navigate(item.href);
            // Close sidebar on mobile after navigation
            if (onToggle && !isDesktop) onToggle();
        }
    };
    const handleChildClick = (child)=>{
        if (child.href) {
            navigate(child.href);
            // Close sidebar on mobile after navigation
            if (onToggle && !isDesktop) onToggle();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                className: `theme-sidebar fixed lg:static inset-y-0 left-0 z-40 w-64 transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "h-full flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between h-[85px] px-6 border-b border-sidebar-border",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center space-x-3 cursor-pointer",
                                    onClick: ()=>navigate("/business/dashboard"),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: $b333572f0cd8dc08$var$logo,
                                        alt: "Logo",
                                        className: "w-32"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onToggle,
                                    className: "lg:hidden p-2 rounded-md bg-card-bg border border-card-border text-text-primary hover:bg-surface-50 transition-colors",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                            className: "flex-1 px-4 py-6 overflow-y-auto scrollbar-hide",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-2",
                                children: navigationItems.map((item)=>{
                                    const IconComponent = item.icon;
                                    const isActive = location.pathname === item.href;
                                    const hasChildren = item.children && item.children.length > 0;
                                    const isExpanded = expandedItems.includes(item.id);
                                    const hasActiveChild = hasChildren && isChildActive(item.children);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: ()=>handleItemClick(item),
                                                className: `w-full flex items-center justify-between px-4 py-3 text-left rounded-lg transition-colors duration-200 ${isActive && !hasChildren || hasActiveChild ? "theme-sidebar-active" : "text-text-secondary hover:bg-surface-50 hover:text-text-primary"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconComponent, {
                                                                className: `h-5 w-5 ${isActive && !hasChildren || hasActiveChild ? "text-white" : "text-text-tertiary"}`
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-medium",
                                                                children: item.label
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex items-center space-x-2",
                                                        children: hasChildren ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                            className: `h-4 w-4 text-text-tertiary transform transition-transform duration-200 ${isExpanded ? "rotate-180" : ""} ${hasActiveChild ? "text-white" : ""}`
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                            className: `h-4 w-4 text-text-tertiary ${isActive ? "text-white" : ""}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            hasChildren && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `ml-4 mt-2 overflow-hidden transition-all duration-200 ${isExpanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    className: "space-y-1 border-l-2 border-border-light p-2",
                                                    children: item.children.map((child)=>{
                                                        const ChildIconComponent = child.icon;
                                                        const isChildActive = location.pathname === child.href;
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                onClick: ()=>handleChildClick(child),
                                                                className: `w-full flex items-center space-x-3 px-3 py-2 text-left rounded-md transition-colors duration-200 ${isChildActive ? "theme-sidebar-active" : "text-text-secondary hover:bg-surface-50 hover:text-text-primary"}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ChildIconComponent, {
                                                                        className: `h-4 w-4 ${isChildActive ? "text-white" : "text-text-tertiary"}`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-sm font-medium",
                                                                        children: child.label
                                                                    })
                                                                ]
                                                            })
                                                        }, child.id);
                                                    })
                                                })
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-4 border-t border-sidebar-border",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-xs text-text-tertiary text-center",
                                children: "\xa9 2025 Connectri"
                            })
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "fixed inset-0 bg-black/50 z-30 lg:hidden",
                    onClick: onToggle
                })
            })
        ]
    });
};
var $b333572f0cd8dc08$export$2e2bcd8739ae039 = $b333572f0cd8dc08$var$BusinessSidebar;


const $e2ff0ad7c5320675$var$BusinessLayout = ({ children: children })=>{
    const [isProfileOpen, setIsProfileOpen] = (0, $acw62.useState)(false);
    const [isSidebarOpen, setIsSidebarOpen] = (0, $acw62.useState)(window.innerWidth >= 1024); // Open by default on desktop
    const profileRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const { loading: loading, message: message, error: error } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.utility);
    // Handle window resize to manage sidebar state
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth >= 1024) setIsSidebarOpen(true); // Keep open on desktop
            else setIsSidebarOpen(false); // Close on mobile
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (profileRef.current && !profileRef.current.contains(event.target)) setIsProfileOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (message) {
            alert(message);
            dispatch((0, $6J3qC.clearMessage)());
        }
        if (error) {
            alert(`Error: ${error}`);
            dispatch((0, $6J3qC.clearMessage)());
        }
    }, [
        message,
        error,
        dispatch
    ]);
    const handleLogout = ()=>{
        dispatch((0, $03cf4384aa5e191c$export$a0973bcfe11b05c9)());
        navigate("/login");
    };
    const getUserInitials = ()=>{
        if (!user?.name) return "B";
        return user.name.split(" ").map((n)=>n[0]).join("").toUpperCase().slice(0, 2);
    };
    const toggleSidebar = ()=>{
        setIsSidebarOpen(!isSidebarOpen);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-screen bg-bg-primary",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b333572f0cd8dc08$export$2e2bcd8739ae039), {
                isOpen: isSidebarOpen,
                onToggle: toggleSidebar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 flex flex-col overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "theme-header flex items-center justify-between px-6 py-4 border-b border-header-border",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: toggleSidebar,
                                        className: "lg:hidden p-2 rounded-md bg-card-bg border border-card-border text-text-primary hover:bg-surface-50 transition-colors",
                                        children: isSidebarOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        onClick: ()=>navigate("/business/dashboard"),
                                        className: "text-lg font-semibold text-text-primary cursor-pointer hover:opacity-80 transition-opacity",
                                        children: user?.name || "Business User"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex items-center space-x-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    ref: profileRef,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>setIsProfileOpen(!isProfileOpen),
                                            className: "flex items-center space-x-3 p-2 rounded-lg hover:bg-surface-50 transition-colors",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm font-medium",
                                                children: getUserInitials()
                                            })
                                        }),
                                        isProfileOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white border border-gray-200 z-50",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "py-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "px-4 py-3 border-b border-gray-200",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: user?.name || "Business User"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-gray-500 truncate",
                                                                children: user?.mobile || user?.email || ""
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: ()=>{
                                                            navigate("/business/change-password");
                                                            setIsProfileOpen(false);
                                                        },
                                                        className: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Change Password"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "border-t border-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            onClick: handleLogout,
                                                            className: "w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Logout"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "flex-1 overflow-auto bg-bg-secondary p-6",
                        children: children
                    })
                ]
            })
        ]
    });
};
var $e2ff0ad7c5320675$export$2e2bcd8739ae039 = $e2ff0ad7c5320675$var$BusinessLayout;


function $0e2f4a9eb275a3c8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2ff0ad7c5320675$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
}




/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3f86240925e7a9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check-big", $e3f86240925e7a9e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $52885985d1db6c06$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "2",
            y2: "22",
            key: "7eqyqh"
        }
    ],
    [
        "path",
        {
            d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
            key: "1b0p4s"
        }
    ]
];
const $52885985d1db6c06$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("dollar-sign", $52885985d1db6c06$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ddb0f78d8b840c54$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
            key: "qn84l0"
        }
    ],
    [
        "path",
        {
            d: "M13 5v2",
            key: "dyzc3o"
        }
    ],
    [
        "path",
        {
            d: "M13 17v2",
            key: "1ont0d"
        }
    ],
    [
        "path",
        {
            d: "M13 11v2",
            key: "1wjjxi"
        }
    ]
];
const $ddb0f78d8b840c54$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ticket", $ddb0f78d8b840c54$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");


var $2OTVO = parcelRequire("2OTVO");

const $da7b4283927b4388$export$cc5db778aa9a4a94 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { dashboard: dashboard, dashboardLoading: dashboardLoading, dashboardError: dashboardError } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    const [filter, setFilter] = (0, $acw62.useState)("TODAY");
    const [customDates, setCustomDates] = (0, $acw62.useState)({
        from: "",
        to: ""
    });
    // Initial load on mount only
    (0, $acw62.useEffect)(()=>{
        fetchDashboard("TODAY");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fetchDashboard = (0, $acw62.useCallback)(async (currentFilter, currentDates)=>{
        const token = localStorage.getItem("authToken");
        if (!token) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Authentication required. Please login again.");
            return;
        }
        try {
            const filterToUse = currentFilter || filter;
            const datesToUse = currentDates || customDates;
            const params = {
                filter: filterToUse
            };
            if (filterToUse === "CUSTOM" && datesToUse.from && datesToUse.to) {
                params.from = datesToUse.from;
                params.to = datesToUse.to;
            }
            await dispatch((0, $2OTVO.getBusinessDashboard)(params));
        } catch (error) {
            console.error("Dashboard fetch error:", error);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to load dashboard data");
        }
    }, [
        dispatch,
        filter,
        customDates
    ]);
    const updateFilter = (0, $acw62.useCallback)((newFilter)=>{
        setFilter(newFilter);
    }, []);
    const updateCustomDates = (0, $acw62.useCallback)((dates)=>{
        setCustomDates(dates);
    }, []);
    const onApplyFilter = (0, $acw62.useCallback)(()=>{
        fetchDashboard(filter, customDates);
    }, [
        fetchDashboard,
        filter,
        customDates
    ]);
    const refreshDashboard = (0, $acw62.useCallback)(()=>{
        fetchDashboard(filter, customDates);
    }, [
        fetchDashboard,
        filter,
        customDates
    ]);
    return {
        dashboard: dashboard,
        loading: dashboardLoading,
        error: dashboardError,
        filter: filter,
        customDates: customDates,
        updateFilter: updateFilter,
        updateCustomDates: updateCustomDates,
        onApplyFilter: onApplyFilter,
        refreshDashboard: refreshDashboard
    };
};





/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9e50e5a44fb11e0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-right", $f9e50e5a44fb11e0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $44f0dae468c97d23$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
            key: "1yiouv"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "6",
            key: "1vp47v"
        }
    ]
];
const $44f0dae468c97d23$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("award", $44f0dae468c97d23$export$3efd853dbb351e94);


const $1c962c7a27024be0$var$DashboardContentWithOverlay = ({ stats: stats, financialStats: financialStats, businessInfo: businessInfo, showOverlay: showOverlay = false })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 ${showOverlay ? 'filter blur-sm' : ''}`,
                children: stats.map((stat, index)=>{
                    const Icon = stat.icon;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `theme-card rounded-lg p-6 ${stat.bgColor}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex items-center justify-between mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `${stat.iconBg} p-3 rounded-lg`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                        className: `h-6 w-6 ${stat.textColor}`
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-sm font-medium text-gray-600 mb-1",
                                children: stat.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `text-3xl font-bold ${stat.textColor}`,
                                children: stat.value
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6 ${showOverlay ? 'filter blur-sm' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "theme-card rounded-lg p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-lg font-bold text-gray-900",
                                        children: "Financial Insights"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-gray-400"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between p-4 bg-green-50 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-green-700",
                                                        children: "Net Earnings"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xl font-bold text-green-600",
                                                        children: financialStats.net_earnings.formatted
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bg-green-100 p-2 rounded-full",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-green-600"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between p-4 bg-red-50 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-red-700",
                                                        children: "Platform Commission"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-lg font-bold text-red-600",
                                                        children: financialStats.platform_commission.formatted
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bg-red-100 p-2 rounded-full",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-red-600"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between p-4 bg-purple-50 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-purple-700",
                                                        children: "Customer Discount"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-lg font-bold text-purple-600",
                                                        children: financialStats.customer_savings.formatted
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bg-purple-100 p-2 rounded-full",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-purple-600"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/business/transactions/history"),
                                className: "w-full mt-4 text-blue-600 hover:text-blue-700 font-medium text-sm flex items-center justify-center space-x-2 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "View Transaction History"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "theme-card rounded-lg p-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-lg font-bold text-gray-900 mb-4",
                                    children: "Quick Actions"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3",
                                    children: [
                                        businessInfo.is_premium ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: ()=>navigate("/business/transactions"),
                                                    className: "w-full flex items-center justify-between p-4 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center space-x-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddb0f78d8b840c54$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-blue-600"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-medium text-gray-900",
                                                                    children: "New Transaction"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-blue-600"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: ()=>navigate("/business/discount"),
                                                    className: "w-full flex items-center justify-between p-4 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center space-x-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-orange-600"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-medium text-gray-900",
                                                                    children: "Manage Discount"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-orange-600"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/business/discount"),
                                            className: "w-full flex items-center justify-between p-4 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors text-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-orange-600"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-medium text-gray-900",
                                                            children: "Manage Discount"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-orange-600"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/business/settings"),
                                            className: "w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors text-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44f0dae468c97d23$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-600"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-medium text-gray-900",
                                                            children: "Business Settings"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-600"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            showOverlay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-center p-8 bg-white rounded-lg shadow-xl border border-gray-200 max-w-md mx-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                            className: "h-16 w-16 text-gray-500 mx-auto mb-4"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-xl font-bold text-gray-900 mb-2",
                            children: "Premium Features Locked"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-600 mb-6",
                            children: "Unlock advanced analytics, transaction management, and detailed insights with Premium subscription"
                        })
                    ]
                })
            })
        ]
    });
};
var $1c962c7a27024be0$export$2e2bcd8739ae039 = $1c962c7a27024be0$var$DashboardContentWithOverlay;





var $acw62 = parcelRequire("acw62");
const $dec79b05ad1d6a85$var$FILTER_OPTIONS = [
    {
        value: "TODAY",
        label: "Today"
    },
    {
        value: "THIS_WEEK",
        label: "This Week"
    },
    {
        value: "THIS_MONTH",
        label: "This Month"
    },
    {
        value: "LAST_MONTH",
        label: "Last Month"
    },
    {
        value: "THIS_YEAR",
        label: "This Year"
    },
    {
        value: "CUSTOM",
        label: "Custom Dates"
    }
];
function $dec79b05ad1d6a85$export$2e2bcd8739ae039({ selectedFilter: selectedFilter = "TODAY", onFilterChange: onFilterChange, customDates: customDates = {
    from: "",
    to: ""
}, onCustomDatesChange: onCustomDatesChange, onApplyFilter: onApplyFilter }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [showCustom, setShowCustom] = (0, $acw62.useState)(selectedFilter === "CUSTOM");
    const handleFilterSelect = (value)=>{
        setIsOpen(false);
        setShowCustom(value === "CUSTOM");
        onFilterChange(value);
    };
    const handleCustomDateChange = (type, value)=>{
        const updated = {
            ...customDates,
            [type]: value
        };
        onCustomDatesChange(updated);
    };
    const isFilterDisabled = selectedFilter === "CUSTOM" && (!customDates.from || !customDates.to);
    const selectedLabel = $dec79b05ad1d6a85$var$FILTER_OPTIONS.find((opt)=>opt.value === selectedFilter)?.label || "Select Filter";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col sm:flex-row gap-2 items-start sm:items-end",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative flex-1 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>setIsOpen(!isOpen),
                                className: "w-full flex items-center justify-between gap-2 px-3 py-2 border border-gray-300 rounded text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "truncate",
                                        children: selectedLabel
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: `h-4 w-4 text-gray-500 flex-shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`
                                    })
                                ]
                            }),
                            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg z-20 min-w-[160px]",
                                children: $dec79b05ad1d6a85$var$FILTER_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>handleFilterSelect(option.value),
                                        className: `w-full text-left px-3 py-2 hover:bg-gray-50 transition-colors text-sm font-medium border-l-2 ${selectedFilter === option.value ? "bg-blue-50 text-blue-600 border-blue-600" : "text-gray-700 border-transparent"}`,
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: onApplyFilter,
                        disabled: isFilterDisabled,
                        className: `flex items-center justify-center gap-1.5 px-3 py-2 rounded text-xs font-medium whitespace-nowrap transition-colors flex-shrink-0 ${isFilterDisabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "hidden sm:inline",
                                children: "Apply"
                            })
                        ]
                    })
                ]
            }),
            showCustom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col sm:flex-row gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-xs font-medium text-gray-600 mb-1",
                                children: "From Date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "date",
                                value: customDates.from,
                                onChange: (e)=>handleCustomDateChange("from", e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-xs font-medium text-gray-600 mb-1",
                                children: "To Date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "date",
                                value: customDates.to,
                                onChange: (e)=>handleCustomDateChange("to", e.target.value),
                                min: customDates.from,
                                className: "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $fd10028b55710d0f$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { dashboard: dashboard, loading: loading, refreshDashboard: refreshDashboard, filter: filter, customDates: customDates, updateFilter: updateFilter, updateCustomDates: updateCustomDates, onApplyFilter: onApplyFilter } = (0, $da7b4283927b4388$export$cc5db778aa9a4a94)();
    const { isPremium: isPremium } = (0, $425c27a02c51b625$export$2e2bcd8739ae039)();
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center min-h-[400px]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center space-x-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-gray-600",
                    children: "Loading dashboard..."
                })
            ]
        })
    });
    if (!dashboard) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center min-h-[400px]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 mb-4",
                    children: "Failed to load dashboard data"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: refreshDashboard,
                    className: "theme-button-primary px-4 py-2 rounded-lg",
                    children: "Try Again"
                })
            ]
        })
    });
    // Map API response structure to component expectations
    const businessInfo = {
        business_name: dashboard.business?.name || 'Business',
        is_premium: isPremium,
        subscription_package: dashboard.business?.subscription || 'Basic'
    };
    const transactionStats = {
        total_transactions: dashboard.statistics?.total_transactions || 0,
        fulfilled_transactions: dashboard.statistics?.total_transactions || 0,
        pending_transactions: 0,
        success_rate: dashboard.statistics?.total_transactions > 0 ? 100 : 0 // Assuming 100% success rate
    };
    const financialStats = {
        total_revenue: {
            formatted: `\u{20B9}${dashboard.statistics?.total_revenue?.toLocaleString() || '0'}`
        },
        net_earnings: {
            formatted: `\u{20B9}${dashboard.statistics?.net_earnings?.toLocaleString() || '0'}`
        },
        average_transaction_value: {
            formatted: `\u{20B9}${dashboard.statistics?.average_transaction?.toLocaleString() || '0'}`
        },
        customer_savings: {
            formatted: `\u{20B9}${dashboard.statistics?.customer_savings?.toLocaleString() || '0'}`
        },
        platform_commission: {
            formatted: `\u{20B9}${dashboard.statistics?.platform_commission?.toLocaleString() || '0'}`
        }
    };
    const reportPeriod = {
        period_label: `${dashboard.period?.type || 'Month'} (${dashboard.period?.start_date || ''} to ${dashboard.period?.end_date || ''})`
    };
    const stats = [
        // {
        //   label: "Total Transactions",
        //   value: transactionStats.total_transactions,
        //   icon: Ticket,
        //   color: "blue",
        //   bgColor: "bg-blue-50",
        //   textColor: "text-blue-600",
        //   iconBg: "bg-blue-100",
        // },
        {
            label: "Completed",
            value: transactionStats.fulfilled_transactions,
            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
            color: "green",
            bgColor: "bg-green-50",
            textColor: "text-green-600",
            iconBg: "bg-green-100"
        },
        // {
        //   label: "Pending",
        //   value: transactionStats.pending_transactions,
        //   icon: Clock,
        //   color: "yellow",
        //   bgColor: "bg-yellow-50",
        //   textColor: "text-yellow-600",
        //   iconBg: "bg-yellow-100",
        // },
        {
            label: "Total Revenue",
            value: financialStats.total_revenue.formatted,
            icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
            color: "green",
            bgColor: "bg-green-50",
            textColor: "text-green-600",
            iconBg: "bg-green-100"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "theme-card rounded-lg p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex items-center gap-2 text-gray-600 mb-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs font-medium uppercase whitespace-nowrap",
                            children: "Filter by Date:"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec79b05ad1d6a85$export$2e2bcd8739ae039), {
                        selectedFilter: filter,
                        onFilterChange: updateFilter,
                        customDates: customDates,
                        onCustomDatesChange: updateCustomDates,
                        onApplyFilter: onApplyFilter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "theme-card rounded-lg p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col space-y-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: [
                                            "Welcome back, ",
                                            businessInfo.business_name,
                                            "!"
                                        ]
                                    }),
                                    businessInfo.is_premium && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800",
                                        children: businessInfo.subscription_package
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: refreshDashboard,
                                    className: "p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    })
                                }),
                                businessInfo.is_premium ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: ()=>navigate("/business/transactions"),
                                    className: "theme-button-gradient px-6 py-3 rounded-lg flex items-center space-x-2 hover:shadow-lg transition-all w-fit",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddb0f78d8b840c54$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "New Transaction"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: ()=>navigate("/business/discount"),
                                    className: "bg-gray-800 hover:bg-gray-900 text-white px-6 py-3 rounded-lg flex items-center space-x-2 hover:shadow-lg transition-all w-fit",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Manage Discount"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c962c7a27024be0$export$2e2bcd8739ae039), {
                stats: stats,
                financialStats: financialStats,
                businessInfo: businessInfo,
                showOverlay: !businessInfo.is_premium
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b51f4920eac1ba0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
];
const $9b51f4920eac1ba0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("globe", $9b51f4920eac1ba0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6fe951f3901e9a6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const $d6fe951f3901e9a6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("mail", $d6fe951f3901e9a6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $970c5cdf933ea69e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const $970c5cdf933ea69e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("phone", $970c5cdf933ea69e$export$3efd853dbb351e94);



var $2OTVO = parcelRequire("2OTVO");


var $acw62 = parcelRequire("acw62");







var $2OTVO = parcelRequire("2OTVO");

// Validation schemas
const $d703a0ed9d34ad39$var$businessDetailsSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    business_name: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Business name must be less than 255 characters").nullable(),
    about_business: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    address: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    whatsapp_number: $cda9d0e1103d595f$export$22b082955e083ec3().max(15, "WhatsApp number must be max 15 digits").nullable(),
    website: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().url("Enter a valid URL"),
    email: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().email("Enter a valid email"),
    business_location_map: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    latitude: $cda9d0e1103d595f$export$98e628dec113755e().transform((value, originalValue)=>{
        return originalValue === '' ? null : value;
    }).min(-90).max(90).nullable(),
    longitude: $cda9d0e1103d595f$export$98e628dec113755e().transform((value, originalValue)=>{
        return originalValue === '' ? null : value;
    }).min(-180).max(180).nullable(),
    pincode: $cda9d0e1103d595f$export$22b082955e083ec3().max(6, "Pincode must be max 6 digits").nullable(),
    contact_numbers: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable(),
    payment_modes: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable(),
    business_timings: $cda9d0e1103d595f$export$be5493f9613cbbe().nullable(),
    services: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable()
});
const $d703a0ed9d34ad39$var$discountSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    discount_text: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Discount text must be less than 255 characters").nullable(),
    fixed_discount: $cda9d0e1103d595f$export$98e628dec113755e().min(0, "Must be 0 or more").nullable(),
    customer_discount: $cda9d0e1103d595f$export$98e628dec113755e().min(0, "Must be 0 or more").nullable(),
    company_commission: $cda9d0e1103d595f$export$98e628dec113755e().min(0, "Must be 0 or more").nullable()
});
const $d703a0ed9d34ad39$var$gallerySchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    gallery: $cda9d0e1103d595f$export$9b30b6294c1449a8().nullable(),
    remove_images: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable()
});
// Custom Services Checkbox Component
const $d703a0ed9d34ad39$var$ServicesCheckboxGroup = ({ label: label, value: value = [], onChange: onChange, options: options = [], loading: loading = false, error: error, hint: hint })=>{
    const [showAddNew, setShowAddNew] = (0, $acw62.useState)(false);
    const [newServiceName, setNewServiceName] = (0, $acw62.useState)("");
    // Handle service selection
    const handleServiceToggle = (serviceValue)=>{
        const newValue = value.includes(serviceValue) ? value.filter((v)=>v !== serviceValue) : [
            ...value,
            serviceValue
        ];
        onChange(newValue);
    };
    // Handle adding new service
    const handleAddNewService = ()=>{
        const trimmedName = newServiceName.trim();
        if (trimmedName && !value.includes(trimmedName)) {
            // Check if it matches any existing service name (case insensitive)
            const existingService = options.find((opt)=>opt.label.toLowerCase() === trimmedName.toLowerCase());
            if (existingService) // If it matches an existing service, use the existing service's name
            onChange([
                ...value,
                existingService.value
            ]);
            else // If it's truly new, add it as a custom service
            onChange([
                ...value,
                trimmedName
            ]);
            setNewServiceName("");
            setShowAddNew(false);
        }
    };
    // Get custom services (services that are selected but not in options)
    const customServices = value.filter((val)=>!options.some((opt)=>opt.value === val));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "block text-sm font-medium text-gray-700 mb-3",
                children: label
            }),
            loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center py-4 text-gray-500",
                children: "Loading services..."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pb-4 border-b border-gray-200",
                        children: !showAddNew ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setShowAddNew(true),
                            className: "flex items-center text-sm text-blue-600 hover:text-blue-800 font-medium transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 mr-2"
                                }),
                                "Add Custom Service"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-xs text-gray-500 mb-2",
                                    children: "Services for hospitality-lodging category. Check existing services or add custom ones."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col sm:flex-row gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: newServiceName,
                                            onChange: (e)=>setNewServiceName(e.target.value),
                                            onKeyDown: (e)=>{
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleAddNewService();
                                                } else if (e.key === 'Escape') {
                                                    e.preventDefault();
                                                    setShowAddNew(false);
                                                    setNewServiceName("");
                                                }
                                            },
                                            placeholder: "Enter service name",
                                            className: "flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                            autoFocus: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: handleAddNewService,
                                                    disabled: !newServiceName.trim(),
                                                    className: "px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                    children: "Add"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        setShowAddNew(false);
                                                        setNewServiceName("");
                                                    },
                                                    className: "px-4 py-2 bg-gray-300 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-400 transition-colors",
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    options.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                className: "text-sm font-medium text-gray-600 mb-3",
                                children: "Available Services"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3",
                                children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex items-center space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: value.includes(option.value),
                                                onChange: ()=>handleServiceToggle(option.value),
                                                className: "h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-gray-700 flex-1 leading-tight",
                                                children: option.label
                                            })
                                        ]
                                    }, option.value))
                            })
                        ]
                    }),
                    customServices.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                className: "text-sm font-medium text-gray-600 mb-3",
                                children: "Custom Services"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3",
                                children: customServices.map((service)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex items-center space-x-3 p-3 border border-blue-200 bg-blue-50 rounded-lg hover:bg-blue-100 cursor-pointer transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: true,
                                                onChange: ()=>handleServiceToggle(service),
                                                className: "h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-blue-700 flex-1 leading-tight",
                                                children: service
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xs text-blue-500 font-medium",
                                                children: "(Custom)"
                                            })
                                        ]
                                    }, service))
                            })
                        ]
                    }),
                    options.length === 0 && customServices.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-center py-8 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm",
                                children: "No services available for this category."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs mt-1",
                                children: "You can add custom services using the button above."
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-red-500 text-sm mt-2",
                children: error
            }) : hint ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-500 text-xs mt-2",
                children: hint
            }) : null
        ]
    });
};
const $d703a0ed9d34ad39$export$ff60d44178f0c8d7 = ({ data: data, onSave: onSave, loading: loading = false, paymentModes: paymentModes = [] })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { services: services, servicesLoading: servicesLoading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    const allDays = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ];
    // Get category slug from business data
    const [categorySlug, setCategorySlug] = (0, $acw62.useState)(null);
    // Initialize business timings with 2 slots per day
    const initializeTimings = (businessData)=>{
        const existingTimings = businessData?.business_timings || {};
        const timings = {};
        allDays.forEach((day)=>{
            const daySlots = existingTimings[day] || [];
            timings[day] = [
                daySlots[0] || {
                    open: '',
                    close: ''
                },
                daySlots[1] || {
                    open: '',
                    close: ''
                }
            ];
        });
        return timings;
    };
    // Filter payment modes to only include valid ones from the API
    const filterValidPaymentModes = (modes)=>{
        if (!Array.isArray(modes)) return [];
        const validModeNames = paymentModes.map((pm)=>pm.name);
        return modes.filter((mode)=>validModeNames.includes(mode));
    };
    // Extract selected service names from business data
    const getSelectedServices = (businessData)=>{
        if (!businessData?.services || !Array.isArray(businessData.services)) return [];
        return businessData.services.map((service)=>service.name);
    };
    // Fetch services when component mounts
    (0, $acw62.useEffect)(()=>{
        // Get category slug from business data
        const slug = data?.category?.slug;
        if (slug) {
            setCategorySlug(slug);
            dispatch((0, $2OTVO.fetchServicesBySlug)(slug));
        } else console.log('No category slug found in business data:', data);
    }, [
        dispatch,
        data
    ]);
    const { register: register, control: control, handleSubmit: handleSubmit, setValue: setValue, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($d703a0ed9d34ad39$var$businessDetailsSchema),
        defaultValues: {
            business_name: data?.business_name || "",
            about_business: data?.about_business || "",
            address: data?.address || "",
            whatsapp_number: data?.whatsapp_number || "",
            website: data?.website || "",
            email: data?.email || "",
            business_location_map: data?.business_location_map || "",
            latitude: data?.latitude || null,
            longitude: data?.longitude || null,
            pincode: data?.pincode?.toString() || "",
            contact_numbers: Array.isArray(data?.contact_numbers) ? data.contact_numbers : [
                ""
            ],
            payment_modes: filterValidPaymentModes(data?.payment_modes),
            business_timings: initializeTimings(data),
            services: getSelectedServices(data)
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            business_name: data?.business_name || "",
            about_business: data?.about_business || "",
            address: data?.address || "",
            whatsapp_number: data?.whatsapp_number || "",
            website: data?.website || "",
            email: data?.email || "",
            business_location_map: data?.business_location_map || "",
            latitude: data?.latitude || null,
            longitude: data?.longitude || null,
            pincode: data?.pincode?.toString() || "",
            contact_numbers: Array.isArray(data?.contact_numbers) ? data.contact_numbers : [
                ""
            ],
            payment_modes: filterValidPaymentModes(data?.payment_modes),
            business_timings: initializeTimings(data),
            services: getSelectedServices(data)
        });
    }, [
        data,
        reset,
        paymentModes
    ]);
    const { fields: contactNumbers, append: appendContactNumber, remove: removeContactNumber } = (0, $0d70f179cf56e662$export$310131896651d559)({
        name: "contact_numbers",
        control: control
    });
    (0, $acw62.useEffect)(()=>{
        if (contactNumbers.length === 0) appendContactNumber("");
    }, [
        contactNumbers.length,
        appendContactNumber
    ]);
    const getGoogleMapsUrl = (lat, lng)=>{
        return `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    };
    const handleGetLocation = ()=>{
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser");
            return;
        }
        navigator.geolocation.getCurrentPosition((position)=>{
            const { latitude: latitude, longitude: longitude } = position.coords;
            const mapUrl = getGoogleMapsUrl(latitude, longitude);
            setValue("business_location_map", mapUrl);
            setValue("latitude", latitude);
            setValue("longitude", longitude);
        }, (error)=>{
            console.error("Error getting location:", error);
            alert("Unable to retrieve your location. Please check your browser permissions.");
        });
    };
    const onSubmit = (formData)=>{
        console.log('BusinessOwnerEditForm - Raw form data:', formData);
        const cleanedData = {};
        if (formData.business_name && formData.business_name.trim() !== '') cleanedData.business_name = formData.business_name;
        if (formData.about_business !== undefined) cleanedData.about_business = formData.about_business;
        if (formData.address && formData.address.trim() !== '') cleanedData.address = formData.address;
        if (formData.whatsapp_number && formData.whatsapp_number.trim() !== '') cleanedData.whatsapp_number = formData.whatsapp_number;
        if (formData.website && formData.website.trim() !== '') cleanedData.website = formData.website;
        if (formData.email && formData.email.trim() !== '') cleanedData.email = formData.email;
        if (formData.business_location_map && formData.business_location_map.trim() !== '') cleanedData.business_location_map = formData.business_location_map;
        if (typeof formData.latitude === 'number' && !isNaN(formData.latitude)) cleanedData.latitude = formData.latitude;
        if (typeof formData.longitude === 'number' && !isNaN(formData.longitude)) cleanedData.longitude = formData.longitude;
        if (formData.pincode && formData.pincode.trim() !== '') cleanedData.pincode = formData.pincode;
        if (formData.contact_numbers && formData.contact_numbers.length > 0) {
            const filteredNumbers = formData.contact_numbers.filter((num)=>num && num.trim() !== '');
            if (filteredNumbers.length > 0) cleanedData.contact_numbers = filteredNumbers;
        }
        // Add payment modes if selected (same as admin)
        if (formData.payment_modes && formData.payment_modes.length > 0) cleanedData.payment_modes = formData.payment_modes;
        // Format business timings
        const formattedTimings = {};
        allDays.forEach((day)=>{
            const daySlots = formData.business_timings[day] || [];
            const validSlots = daySlots.filter((slot)=>slot.open && slot.close);
            if (validSlots.length > 0) formattedTimings[day] = validSlots;
            else formattedTimings[day] = [];
        });
        cleanedData.business_timings = formattedTimings;
        // Add services if selected
        if (formData.services && formData.services.length > 0) cleanedData.services = formData.services;
        console.log('BusinessOwnerEditForm - Cleaned data:', cleanedData);
        onSave(cleanedData);
    };
    const activePaymentModes = paymentModes.filter((pm)=>pm.status);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Business Details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update your business information"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-medium text-gray-800",
                        children: "Basic Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Business Name",
                        readOnly: true,
                        disabled: true,
                        placeholder: "Enter business name",
                        ...register("business_name"),
                        error: errors?.business_name?.message
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500",
                        children: "Business name cannot be changed"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                        label: "About Business",
                        rows: 3,
                        placeholder: "Describe your business...",
                        ...register("about_business"),
                        error: errors?.about_business?.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-medium text-gray-800",
                        children: "Contact Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700",
                                        children: "Contact Numbers"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>appendContactNumber(""),
                                        className: "text-blue-600 text-sm hover:text-blue-800",
                                        children: "+ Add Number"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-2",
                                children: contactNumbers.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                placeholder: "10-digit number",
                                                inputMode: "numeric",
                                                pattern: "[0-9]*",
                                                maxLength: 10,
                                                ...register(`contact_numbers.${index}`),
                                                error: errors?.contact_numbers?.[index]?.message
                                            }),
                                            contactNumbers.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>removeContactNumber(index),
                                                className: "text-red-600 text-sm hover:text-red-800 px-3 py-2 border border-red-300 rounded",
                                                children: "Remove"
                                            })
                                        ]
                                    }, field.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "WhatsApp Number",
                                placeholder: "Enter WhatsApp number",
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                maxLength: 15,
                                ...register("whatsapp_number"),
                                error: errors?.whatsapp_number?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "Email",
                                placeholder: "example@domain.com",
                                ...register("email"),
                                error: errors?.email?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "Website",
                                placeholder: "https://example.com",
                                ...register("website"),
                                error: errors?.website?.message
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-medium text-gray-800",
                        children: "Location Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                        label: "Address",
                        rows: 3,
                        placeholder: "Enter full address",
                        ...register("address"),
                        error: errors?.address?.message
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Pincode",
                        placeholder: "6-digit pincode",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 6,
                        ...register("pincode"),
                        error: errors?.pincode?.message
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700",
                                        children: "Business Location Map URL"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: handleGetLocation,
                                        className: "text-blue-600 text-sm hover:text-blue-800 flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "h-4 w-4",
                                                viewBox: "0 0 20 20",
                                                fill: "currentColor",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                                                    clipRule: "evenodd"
                                                })
                                            }),
                                            "Get Current Location"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                placeholder: "https://maps.google.com/...",
                                ...register("business_location_map"),
                                error: errors?.business_location_map?.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        ...register("latitude", {
                            setValueAs: (v)=>v === "" || v === null || v === undefined ? null : parseFloat(v)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        ...register("longitude", {
                            setValueAs: (v)=>v === "" || v === null || v === undefined ? null : parseFloat(v)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Payment Modes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "payment_modes",
                        defaultValue: [],
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$81e0b04a08224b5), {
                                value: field.value,
                                onChange: field.onChange,
                                options: activePaymentModes.map((pm)=>({
                                        label: pm.name,
                                        value: pm.name
                                    })),
                                error: errors?.payment_modes?.message
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    control: control,
                    name: "services",
                    defaultValue: [],
                    render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d703a0ed9d34ad39$var$ServicesCheckboxGroup, {
                            label: "Services",
                            value: field.value,
                            onChange: field.onChange,
                            options: services.map((service)=>({
                                    label: service.name,
                                    value: service.name
                                })),
                            loading: servicesLoading,
                            error: errors?.services?.message,
                            hint: categorySlug ? `Services for ${categorySlug} category. Check existing services or add custom ones.` : "Check existing services or add custom services"
                        })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-3",
                        children: "Business Timings (Shift-wise)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-xs text-gray-500 mb-3",
                        children: "Configure up to 2 shifts per day. Leave empty if closed."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-4 max-h-96 overflow-y-auto",
                        children: allDays.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border rounded-lg p-3 bg-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm font-semibold text-gray-700 mb-2 capitalize",
                                        children: day
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Slot 1"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.0.open`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Open",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.0.close`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Close",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Slot 2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.1.open`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Open",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.1.close`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Close",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, day))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $d703a0ed9d34ad39$export$db637c5f4e99fd4b = ({ data: data, onSave: onSave, loading: loading = false })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, watch: watch, setValue: setValue, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($d703a0ed9d34ad39$var$discountSchema),
        defaultValues: {
            discount_text: data?.active_discount?.discount_text || "",
            fixed_discount: data?.active_discount?.fixed_discount || "",
            customer_discount: data?.active_discount?.customer_discount || "",
            company_commission: data?.active_discount?.company_commission || ""
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            discount_text: data?.active_discount?.discount_text || "",
            fixed_discount: data?.active_discount?.fixed_discount || "",
            customer_discount: data?.active_discount?.customer_discount || "",
            company_commission: data?.active_discount?.company_commission || ""
        });
    }, [
        data,
        reset
    ]);
    // COMMENTED OUT - Auto-calculation of fixed discount
    // const customerDiscount = watch("customer_discount");
    // const companyCommission = watch("company_commission");
    // useEffect(() => {
    //   const customer = parseFloat(customerDiscount) || 0;
    //   const company = parseFloat(companyCommission) || 0;
    //   const total = customer + company;
    //   setValue("fixed_discount", total > 0 ? total : "");
    // }, [customerDiscount, companyCommission, setValue]);
    const onSubmit = (formData)=>{
        const cleanedData = {};
        // Only discount_text is needed
        if (formData.discount_text && formData.discount_text.trim() !== '') cleanedData.discount_text = formData.discount_text;
        // COMMENTED OUT - All percentage fields
        // if (formData.fixed_discount !== undefined && formData.fixed_discount !== null && formData.fixed_discount !== '') {
        //   cleanedData.fixed_discount = formData.fixed_discount;
        // }
        // if (formData.customer_discount !== undefined && formData.customer_discount !== null && formData.customer_discount !== '') {
        //   cleanedData.customer_discount = formData.customer_discount;
        // }
        // if (formData.company_commission !== undefined && formData.company_commission !== null && formData.company_commission !== '') {
        //   cleanedData.company_commission = formData.company_commission;
        // }
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Discount Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update discount offer text displayed to customers"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                    label: "Discount Text",
                    placeholder: "e.g., Flat 10% off on all items",
                    maxLength: 32,
                    ...register("discount_text"),
                    error: errors?.discount_text?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $d703a0ed9d34ad39$export$c52012d7bf9476cf = ({ data: data, onSave: onSave, loading: loading = false })=>{
    const [existingImages, setExistingImages] = (0, $acw62.useState)(data?.gallery_images || []);
    const [newImages, setNewImages] = (0, $acw62.useState)([]);
    const [imagesToRemove, setImagesToRemove] = (0, $acw62.useState)([]);
    const handleRemoveExistingImage = (imageUuid)=>{
        setExistingImages((prev)=>prev.filter((img)=>img.uuid !== imageUuid));
        setImagesToRemove((prev)=>[
                ...prev,
                imageUuid
            ]);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        const cleanedData = {
            gallery: newImages || [],
            remove_images: imagesToRemove || []
        };
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Gallery Images"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Manage business gallery photos (max 5 images)"
                    })
                ]
            }),
            existingImages.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Current Images"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4",
                        children: existingImages.map((img)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "aspect-square",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: img.image,
                                            alt: "Gallery",
                                            className: "w-full h-full object-cover rounded-lg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>handleRemoveExistingImage(img.uuid),
                                        className: "absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600 transition-colors",
                                        children: "\xd7"
                                    })
                                ]
                            }, img.uuid))
                    })
                ]
            }),
            existingImages.length < 5 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e49ca7aad3643dc7$export$3019c26e674dcdde), {
                    label: existingImages.length > 0 ? "Add More Images" : "Add New Images",
                    value: newImages,
                    onChange: setNewImages,
                    hint: `Drop up to ${5 - existingImages.length} images or click to browse`,
                    maxFiles: 5 - existingImages.length
                })
            }),
            existingImages.length >= 5 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center py-4 text-gray-500",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Maximum of 5 images allowed. Remove some existing images to add new ones."
                })
            }),
            existingImages.length === 0 && (!newImages || newImages.length === 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center py-8 text-gray-500",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "No gallery images found. Add some images to showcase your business."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};





function $60254a0300f25c2f$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { business: business, loading: loading, updateStatus: updateStatus, updateError: updateError, services: services, paymentModes: paymentModes = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        section: null,
        loading: false
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $2OTVO.getBusinessDetails)());
        dispatch((0, $2OTVO.fetchBusinessOwnerPaymentModes)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (updateStatus === "success") {
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Business updated successfully");
            setModalState({
                open: false,
                type: null,
                section: null,
                loading: false
            });
            dispatch((0, $2OTVO.resetUpdateStatus)());
            dispatch((0, $2OTVO.getBusinessDetails)());
        } else if (updateStatus === "failed") {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, updateError);
            setModalState((prev)=>({
                    ...prev,
                    loading: false
                }));
            dispatch((0, $2OTVO.resetUpdateStatus)());
        }
    }, [
        updateStatus,
        updateError,
        dispatch
    ]);
    const openModal = (section)=>{
        setModalState({
            open: true,
            type: (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM,
            section: section,
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            section: null,
            loading: false
        });
    };
    const handleSaveBusinessDetails = async (data)=>{
        setModalState((prev)=>({
                ...prev,
                loading: true
            }));
        await dispatch((0, $2OTVO.updateBusinessDetails)(data));
    };
    const handleSaveGallery = async (data)=>{
        setModalState((prev)=>({
                ...prev,
                loading: true
            }));
        await dispatch((0, $2OTVO.updateBusinessGallery)(data));
    };
    if (loading && !business) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-between items-center mb-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: "Business Settings"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mt-1",
                                    children: "Manage your business profile and settings"
                                })
                            ]
                        })
                    }),
                    business ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border rounded-lg p-4 bg-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between items-center mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-semibold text-gray-800",
                                                children: "Business Details"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>openModal("business_details"),
                                                className: "text-blue-600 hover:text-blue-800 p-2 rounded hover:bg-blue-50",
                                                title: "Edit Business Details",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-medium text-gray-700 mb-2",
                                                children: "Basic Information"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Business Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.business_name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "About"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.about_business || "Not provided"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-medium text-gray-700 mb-2",
                                                children: "Contact Information"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-sm text-gray-600 flex items-center gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    }),
                                                                    " Contact Numbers"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.contact_numbers?.join(", ") || "Not provided"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-sm text-gray-600 flex items-center gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    }),
                                                                    " WhatsApp"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.whatsapp_number || "Not provided"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-sm text-gray-600 flex items-center gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    }),
                                                                    " Email"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.email || "Not provided"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-sm text-gray-600 flex items-center gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    }),
                                                                    " Website"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.website || "Not provided"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-medium text-gray-700 mb-2",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Address"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.address || "Not provided"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Pincode"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-medium",
                                                                children: business.pincode || "Not provided"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-medium text-gray-700 mb-2",
                                                children: "Payment Modes"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-wrap gap-2",
                                                children: business.payment_modes && business.payment_modes.length > 0 ? business.payment_modes.map((mode, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm",
                                                        children: mode
                                                    }, index)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-500 text-sm",
                                                    children: "No payment modes set"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-medium text-gray-700 mb-2",
                                                children: "Services"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-wrap gap-2",
                                                children: business.services && business.services.length > 0 ? business.services.map((service)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm",
                                                        children: service.name
                                                    }, service.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-500 text-sm",
                                                    children: "No services set"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-medium text-gray-700 mb-2",
                                                children: "Business Timings"
                                            }),
                                            business.business_timings && Object.keys(business.business_timings).length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "space-y-2",
                                                children: Object.entries(business.business_timings).map(([day, slots])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-medium capitalize",
                                                                children: day
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-600",
                                                                children: slots && slots.length > 0 ? slots.map((slot)=>`${slot.open} - ${slot.close}`).join(", ") : "Closed"
                                                            })
                                                        ]
                                                    }, day))
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-gray-500 text-sm",
                                                children: "No timings set"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border rounded-lg p-4 bg-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between items-center mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-semibold text-gray-800",
                                                children: "Gallery"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>openModal("gallery"),
                                                className: "text-blue-600 hover:text-blue-800 p-2 rounded hover:bg-blue-50",
                                                title: "Edit Gallery",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4",
                                        children: business.gallery_images && business.gallery_images.length > 0 ? business.gallery_images.map((img)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "aspect-square",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: img.image,
                                                    alt: "Gallery",
                                                    className: "w-full h-full object-cover rounded-lg border"
                                                })
                                            }, img.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-gray-500 text-sm col-span-full",
                                            children: "No images uploaded"
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-center py-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-500",
                            children: "No business details found"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: business,
                loading: modalState.loading,
                showActions: false,
                size: "large",
                children: [
                    modalState.section === "business_details" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d703a0ed9d34ad39$export$ff60d44178f0c8d7), {
                        data: business,
                        onSave: handleSaveBusinessDetails,
                        loading: modalState.loading,
                        paymentModes: paymentModes
                    }),
                    modalState.section === "gallery" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d703a0ed9d34ad39$export$c52012d7bf9476cf), {
                        data: business,
                        onSave: handleSaveGallery,
                        loading: modalState.loading
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



var $2OTVO = parcelRequire("2OTVO");





function $5d7fa548309cba8a$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { isPremium: isPremium } = (0, $425c27a02c51b625$export$2e2bcd8739ae039)();
    const { business: business, loading: loading, updateStatus: updateStatus, updateError: updateError } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        loading: false
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $2OTVO.getBusinessDetails)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (updateStatus === "success") {
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Discount updated successfully");
            setModalState({
                open: false,
                type: null,
                loading: false
            });
            dispatch((0, $2OTVO.resetUpdateStatus)());
            dispatch((0, $2OTVO.getBusinessDetails)());
        } else if (updateStatus === "failed") {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, updateError);
            setModalState((prev)=>({
                    ...prev,
                    loading: false
                }));
            dispatch((0, $2OTVO.resetUpdateStatus)());
        }
    }, [
        updateStatus,
        updateError,
        dispatch
    ]);
    const openModal = ()=>{
        setModalState({
            open: true,
            type: (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM,
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            loading: false
        });
    };
    const handleSaveDiscount = async (data)=>{
        setModalState((prev)=>({
                ...prev,
                loading: true
            }));
        await dispatch((0, $2OTVO.updateBusinessDiscount)(data));
    };
    if (loading && !business) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-between items-center mb-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: "Discount Information"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mt-1",
                                    children: "Manage your business discount settings and offers"
                                })
                            ]
                        })
                    }),
                    business ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "border rounded-lg p-6 bg-gray-50",
                            children: [
                                !isPremium && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex justify-between items-center mb-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: openModal,
                                        className: "theme-button-gradient w-full px-4 py-2 rounded-lg flex items-center space-x-2 hover:shadow-lg transition-all",
                                        title: "Edit Discount",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Edit Discount"
                                            })
                                        ]
                                    })
                                }),
                                business.active_discount ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-white p-4 rounded-lg border",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-sm text-gray-600 flex items-center gap-2 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }),
                                                        " Discount Text"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-lg text-gray-900",
                                                    children: business.active_discount.discount_text
                                                })
                                            ]
                                        }),
                                        isPremium && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-white p-4 rounded-lg border",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-600 mb-2",
                                                        children: "Total Discount Offered"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "font-semibold text-2xl text-blue-600",
                                                        children: [
                                                            business.active_discount.fixed_discount,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center py-12",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                            className: "h-16 w-16 text-gray-300 mx-auto mb-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-lg font-medium text-gray-900 mb-2",
                                            children: "No Active Discount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-gray-500 mb-6",
                                            children: "Set up your discount information to start offering deals to customers"
                                        }),
                                        !isPremium && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: openModal,
                                            className: "theme-button-gradient px-6 py-3 rounded-lg flex items-center space-x-2 mx-auto hover:shadow-lg transition-all",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Set Up Discount"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-center py-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-500",
                            children: "No business details found"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: business,
                loading: modalState.loading,
                showActions: false,
                size: "large",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d703a0ed9d34ad39$export$db637c5f4e99fd4b), {
                    data: business,
                    onSave: handleSaveDiscount,
                    loading: modalState.loading
                })
            })
        ]
    });
}



/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f4e23b961d77b488$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
            key: "3c2336"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f4e23b961d77b488$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("badge-check", $f4e23b961d77b488$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $beb58fc2118025b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
];
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar-days", $beb58fc2118025b6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $26cec67c26de53a9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M8 13h2",
            key: "yr2amv"
        }
    ],
    [
        "path",
        {
            d: "M14 13h2",
            key: "un5t4a"
        }
    ],
    [
        "path",
        {
            d: "M8 17h2",
            key: "2yhykz"
        }
    ],
    [
        "path",
        {
            d: "M14 17h2",
            key: "10kma7"
        }
    ]
];
const $26cec67c26de53a9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-spreadsheet", $26cec67c26de53a9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cab856bf30f1b37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
            key: "q3az6g"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 17.5v-11",
            key: "1jc1ny"
        }
    ]
];
const $cab856bf30f1b37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("receipt", $cab856bf30f1b37f$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



var $2OTVO = parcelRequire("2OTVO");

const $0d0192423c73d709$var$MONTHS = [
    {
        value: 1,
        label: "January"
    },
    {
        value: 2,
        label: "February"
    },
    {
        value: 3,
        label: "March"
    },
    {
        value: 4,
        label: "April"
    },
    {
        value: 5,
        label: "May"
    },
    {
        value: 6,
        label: "June"
    },
    {
        value: 7,
        label: "July"
    },
    {
        value: 8,
        label: "August"
    },
    {
        value: 9,
        label: "September"
    },
    {
        value: 10,
        label: "October"
    },
    {
        value: 11,
        label: "November"
    },
    {
        value: 12,
        label: "December"
    }
];
// Get current date in UTC to avoid timezone issues
const $0d0192423c73d709$var$now = new Date();
const $0d0192423c73d709$var$currentYear = $0d0192423c73d709$var$now.getFullYear();
const $0d0192423c73d709$var$currentMonth = $0d0192423c73d709$var$now.getMonth() + 1; // 1-based
// Generate year options from 2024 to current year
const $0d0192423c73d709$var$YEARS = Array.from({
    length: $0d0192423c73d709$var$currentYear - 2023
}, (_, i)=>$0d0192423c73d709$var$currentYear - i);
// Helper to check if a month/year is in the future
const $0d0192423c73d709$var$isMonthDisabled = (year, month)=>{
    return year > $0d0192423c73d709$var$currentYear || year === $0d0192423c73d709$var$currentYear && month > $0d0192423c73d709$var$currentMonth;
};
// Helper to get available months for a given year
const $0d0192423c73d709$var$getAvailableMonths = (year)=>{
    if (year < $0d0192423c73d709$var$currentYear) // Past years: all 12 months available
    return $0d0192423c73d709$var$MONTHS;
    else if (year === $0d0192423c73d709$var$currentYear) // Current year: only months up to current month
    return $0d0192423c73d709$var$MONTHS.filter((m)=>m.value <= $0d0192423c73d709$var$currentMonth);
    // Future years: no months available
    return [];
};
const $0d0192423c73d709$export$f2910d59c1f7d1f8 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { report: report, reportLoading: reportLoading, reportError: reportError, exportLoading: exportLoading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    // Helper function to get default date range for a month
    const getDefaultDateRange = (year, month)=>{
        // Create dates using UTC to avoid timezone issues
        const monthStart = new Date(Date.UTC(year, month - 1, 1));
        const monthEnd = new Date(Date.UTC(year, month, 0));
        // Format as YYYY-MM-DD (using UTC to avoid timezone offset)
        const formatUTC = (date)=>{
            const y = date.getUTCFullYear();
            const m = String(date.getUTCMonth() + 1).padStart(2, '0');
            const d = String(date.getUTCDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };
        return {
            from_date: formatUTC(monthStart),
            to_date: formatUTC(monthEnd)
        };
    };
    const defaultDateRange = getDefaultDateRange($0d0192423c73d709$var$currentYear, $0d0192423c73d709$var$currentMonth);
    const pageFromUrl = parseInt(searchParams.get("page") || "1", 10);
    const [filters, setFilters] = (0, $acw62.useState)({
        year: $0d0192423c73d709$var$currentYear,
        month: $0d0192423c73d709$var$currentMonth,
        from_date: defaultDateRange.from_date,
        to_date: defaultDateRange.to_date,
        page: pageFromUrl,
        per_page: 15
    });
    // Sync filters.page when URL changes externally
    (0, $acw62.useEffect)(()=>{
        if (pageFromUrl !== filters.page) setFilters((prev)=>({
                ...prev,
                page: pageFromUrl
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageFromUrl
    ]);
    // Fetch report whenever filters change
    (0, $acw62.useEffect)(()=>{
        fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.year,
        filters.month,
        filters.from_date,
        filters.to_date,
        filters.page,
        filters.per_page
    ]);
    const fetchReport = (0, $acw62.useCallback)(async ()=>{
        try {
            await dispatch((0, $2OTVO.getTransactionSummaryReport)({
                year: filters.year,
                month: filters.month,
                from_date: filters.from_date,
                to_date: filters.to_date,
                page: filters.page,
                per_page: filters.per_page
            }));
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to load report");
        }
    }, [
        dispatch,
        filters
    ]);
    const updateFilter = (0, $acw62.useCallback)((key, value)=>{
        setFilters((prev)=>{
            const updated = {
                ...prev,
                [key]: value,
                // Reset to page 1 whenever year/month/date changes
                ...key === "year" || key === "month" || key === "from_date" || key === "to_date" ? {
                    page: 1
                } : {}
            };
            // When year or month changes, auto-update date range to full month
            if (key === "year" || key === "month") {
                const newYear = key === "year" ? value : updated.year;
                const newMonth = key === "month" ? value : updated.month;
                const newDateRange = getDefaultDateRange(newYear, newMonth);
                updated.from_date = newDateRange.from_date;
                updated.to_date = newDateRange.to_date;
            }
            // Validate date range is within the selected month
            if (key === "from_date" || key === "to_date") {
                const monthStart = new Date(Date.UTC(updated.year, updated.month - 1, 1));
                const monthEnd = new Date(Date.UTC(updated.year, updated.month, 0));
                // Parse dates safely
                const parseUTCDate = (dateStr)=>{
                    const [y, m, d] = dateStr.split('-').map(Number);
                    return new Date(Date.UTC(y, m - 1, d));
                };
                const formatUTCDate = (date)=>{
                    const y = date.getUTCFullYear();
                    const m = String(date.getUTCMonth() + 1).padStart(2, '0');
                    const d = String(date.getUTCDate()).padStart(2, '0');
                    return `${y}-${m}-${d}`;
                };
                const fromDateObj = parseUTCDate(updated.from_date);
                const toDateObj = parseUTCDate(updated.to_date);
                // Clamp from_date to month start if it's before
                if (fromDateObj < monthStart) updated.from_date = formatUTCDate(monthStart);
                // Clamp to_date to month end if it's after
                if (toDateObj > monthEnd) updated.to_date = formatUTCDate(monthEnd);
            }
            return updated;
        });
        // Sync page to URL
        if (key === "year" || key === "month" || key === "from_date" || key === "to_date") setSearchParams({
            page: "1"
        });
    }, [
        setSearchParams
    ]);
    const handlePageChange = (0, $acw62.useCallback)((page)=>{
        setFilters((prev)=>({
                ...prev,
                page: page
            }));
        setSearchParams({
            page: String(page)
        });
    }, [
        setSearchParams
    ]);
    // Trigger browser download from a blob URL
    const triggerDownload = (blobUrl, filename)=>{
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    };
    const handleExportXlsx = (0, $acw62.useCallback)(async ()=>{
        try {
            const result = await dispatch((0, $2OTVO.exportReportXlsx)({
                year: filters.year,
                month: filters.month,
                from_date: filters.from_date,
                to_date: filters.to_date
            }));
            if ((0, $2OTVO.exportReportXlsx).fulfilled.match(result)) {
                triggerDownload(result.payload.blobUrl, result.payload.filename);
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("XLSX downloaded successfully");
            } else (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Failed to export XLSX");
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to export XLSX");
        }
    }, [
        dispatch,
        filters.year,
        filters.month,
        filters.from_date,
        filters.to_date
    ]);
    const handleExportPdf = (0, $acw62.useCallback)(async ()=>{
        try {
            const result = await dispatch((0, $2OTVO.exportReportPdf)({
                year: filters.year,
                month: filters.month,
                from_date: filters.from_date,
                to_date: filters.to_date
            }));
            if ((0, $2OTVO.exportReportPdf).fulfilled.match(result)) {
                triggerDownload(result.payload.blobUrl, result.payload.filename);
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("PDF downloaded successfully");
            } else (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Failed to export PDF");
        } catch (err) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to export PDF");
        }
    }, [
        dispatch,
        filters.year,
        filters.month,
        filters.from_date,
        filters.to_date
    ]);
    // Derived summary totals from the current page data
    const summaryTotals = (0, $acw62.useCallback)(()=>{
        const transactions = Array.isArray(report?.data) ? report.data : [];
        return {
            totalBillAmount: transactions.reduce((sum, t)=>sum + (t.bill_amount || 0), 0),
            totalCustomerDiscount: transactions.reduce((sum, t)=>sum + (t.customer_discount || 0), 0),
            totalPlatformCommission: transactions.reduce((sum, t)=>sum + (t.platform_commission || 0), 0),
            totalFinalAmount: transactions.reduce((sum, t)=>sum + (t.final_amount || 0), 0),
            totalCount: report?.pagination?.total || transactions.length
        };
    }, [
        report
    ]);
    const selectedMonthLabel = $0d0192423c73d709$var$MONTHS.find((m)=>m.value === filters.month)?.label || "";
    return {
        report: // Data
        report,
        transactions: Array.isArray(report?.data) ? report.data : [],
        pagination: report?.pagination || null,
        filter: report?.filter || null,
        stats: report?.stats || null,
        summaryTotals: summaryTotals(),
        // State
        loading: reportLoading,
        error: reportError,
        exportLoading: exportLoading,
        filters: // Filters
        filters,
        updateFilter: updateFilter,
        handlePageChange: handlePageChange,
        selectedMonthLabel: selectedMonthLabel,
        MONTHS: // Constants
        $0d0192423c73d709$var$MONTHS,
        YEARS: $0d0192423c73d709$var$YEARS,
        isMonthDisabled: // Helpers
        $0d0192423c73d709$var$isMonthDisabled,
        getAvailableMonths: $0d0192423c73d709$var$getAvailableMonths,
        handleExportXlsx: // Actions
        handleExportXlsx,
        handleExportPdf: handleExportPdf,
        refreshReport: fetchReport
    };
};
var $0d0192423c73d709$export$2e2bcd8739ae039 = $0d0192423c73d709$export$f2910d59c1f7d1f8;





var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30050f52d874b8f2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $30050f52d874b8f2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar", $30050f52d874b8f2$export$3efd853dbb351e94);


function $10480bbe50d1925d$export$2e2bcd8739ae039({ year: year, month: month, fromDate: fromDate, toDate: toDate, onFromDateChange: onFromDateChange, onToDateChange: onToDateChange }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [tempFromDate, setTempFromDate] = (0, $acw62.useState)(fromDate);
    const [tempToDate, setTempToDate] = (0, $acw62.useState)(toDate);
    const [selectionPhase, setSelectionPhase] = (0, $acw62.useState)("from"); // "from" or "to"
    const [hoveredDay, setHoveredDay] = (0, $acw62.useState)(null);
    const monthStart = new Date(Date.UTC(year, month - 1, 1));
    const monthEnd = new Date(Date.UTC(year, month, 0));
    const daysInMonth = monthEnd.getUTCDate();
    const firstDayOfWeek = monthStart.getUTCDay();
    const parseDate = (dateStr)=>{
        if (!dateStr) return null;
        const [y, m, d] = dateStr.split("-").map(Number);
        return new Date(Date.UTC(y, m - 1, d));
    };
    const formatDate = (date)=>{
        const y = date.getUTCFullYear();
        const m = String(date.getUTCMonth() + 1).padStart(2, "0");
        const d = String(date.getUTCDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };
    const fromDateObj = parseDate(tempFromDate);
    const toDateObj = parseDate(tempToDate);
    const isDayInRange = (day)=>{
        if (!fromDateObj || !toDateObj) return false;
        const dayDate = new Date(Date.UTC(year, month - 1, day));
        return dayDate >= fromDateObj && dayDate <= toDateObj;
    };
    const isDayEdge = (day)=>{
        if (!fromDateObj || !toDateObj) return false;
        const dayDate = new Date(Date.UTC(year, month - 1, day));
        return formatDate(dayDate) === formatDate(fromDateObj) || formatDate(dayDate) === formatDate(toDateObj);
    };
    const isDayHovered = (day)=>{
        if (!hoveredDay || !fromDateObj) return false;
        if (selectionPhase !== "to") return false;
        const fromDay = fromDateObj.getUTCDate();
        const minDay = Math.min(fromDay, day);
        const maxDay = Math.max(fromDay, day);
        return hoveredDay >= minDay && hoveredDay <= maxDay;
    };
    const handleDayClick = (day)=>{
        const clickedDate = new Date(Date.UTC(year, month - 1, day));
        const clickedDateStr = formatDate(clickedDate);
        if (selectionPhase === "from") {
            setTempFromDate(clickedDateStr);
            setSelectionPhase("to");
        } else // In "to" phase - just update, don't close
        if (clickedDate < fromDateObj) {
            // User clicked before from date, swap
            setTempFromDate(clickedDateStr);
            setTempToDate(tempFromDate);
            setSelectionPhase("from");
        } else // Normal: clicked after or on from date
        setTempToDate(clickedDateStr);
    };
    const handleApply = ()=>{
        onFromDateChange(tempFromDate);
        onToDateChange(tempToDate);
        setIsOpen(false);
        setSelectionPhase("from");
    };
    const handleCancel = ()=>{
        setTempFromDate(fromDate);
        setTempToDate(toDate);
        setSelectionPhase("from");
        setIsOpen(false);
    };
    // Sync when external dates change
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) {
            setTempFromDate(fromDate);
            setTempToDate(toDate);
            setSelectionPhase("from");
        }
    }, [
        fromDate,
        toDate,
        isOpen
    ]);
    const daysCells = [];
    // Empty cells
    for(let i = 0; i < firstDayOfWeek; i++)daysCells.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "aspect-square"
    }, `empty-${i}`));
    // Day cells
    for(let day = 1; day <= daysInMonth; day++){
        const isInRange = isDayInRange(day);
        const isEdge = isDayEdge(day);
        const isHovered = isDayHovered(day);
        daysCells.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            onClick: ()=>handleDayClick(day),
            onMouseEnter: ()=>setHoveredDay(day),
            onMouseLeave: ()=>setHoveredDay(null),
            className: `aspect-square rounded text-xs font-medium flex items-center justify-center transition-colors cursor-pointer ${isEdge ? "bg-blue-600 text-white" : isInRange || isHovered ? "bg-blue-100 text-blue-900" : "text-gray-700 hover:bg-gray-100"}`,
            children: day
        }, day));
    }
    const monthName = new Date(Date.UTC(year, month - 1)).toLocaleString("en-US", {
        month: "long"
    });
    const weekDays = [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: ()=>setIsOpen(!isOpen),
                className: "flex items-center gap-2 px-3 py-2 border border-gray-300 rounded text-xs font-medium bg-white hover:bg-gray-50 transition-colors whitespace-nowrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 text-gray-500 flex-shrink-0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-gray-700 hidden sm:inline",
                        children: [
                            tempFromDate,
                            " \u2192 ",
                            tempToDate
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-gray-700 sm:hidden",
                        children: [
                            tempFromDate?.split("-")[2],
                            " - ",
                            tempToDate?.split("-")[2]
                        ]
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute top-full left-0 mt-2 z-[9999] bg-white border border-gray-200 rounded shadow-2xl p-3 w-72 sm:w-80",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-2 gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-sm font-semibold text-gray-900",
                                        children: [
                                            monthName,
                                            " ",
                                            year
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs text-gray-500 text-right",
                                        children: selectionPhase === "from" ? "Start" : "End"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-xs text-gray-600 bg-blue-50 p-2 rounded",
                                children: tempFromDate && tempToDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "From:"
                                        }),
                                        " ",
                                        tempFromDate,
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "To:"
                                        }),
                                        " ",
                                        tempToDate
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Click to select dates"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-7 gap-0.5 mb-2",
                                children: weekDays.map((day, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "aspect-square flex items-center justify-center text-xs font-semibold text-gray-500",
                                        children: day
                                    }, idx))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-7 gap-0.5",
                                children: daysCells
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2 justify-end border-t border-gray-200 pt-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: handleCancel,
                                className: "px-3 py-1.5 text-xs rounded border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: handleApply,
                                disabled: !tempFromDate || !tempToDate,
                                className: "px-3 py-1.5 text-xs rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                children: "Apply"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// ─── helpers ────────────────────────────────────────────────────────────────
const $26b735d7a7eaab51$var$formatCurrency = (amount)=>new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount || 0);
const $26b735d7a7eaab51$var$formatDate = (dateString)=>new Date(dateString).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
// ─── sub-components ─────────────────────────────────────────────────────────
function $26b735d7a7eaab51$var$SummaryCard({ icon: Icon, label: label, value: value, iconBg: iconBg, textColor: textColor }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "theme-card rounded-lg p-5 flex items-start space-x-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${iconBg} p-3 rounded-lg flex-shrink-0`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    className: `h-6 w-6 ${textColor}`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 font-medium line-clamp-2",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `text-lg font-bold ${textColor} line-clamp-2 mt-1`,
                        children: value
                    })
                ]
            })
        ]
    });
}
function $26b735d7a7eaab51$var$SettlementBadge({ status: status }) {
    const isSettled = status === "Settled";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold border
        ${isSettled ? "bg-green-50 text-green-700 border-green-200" : "bg-yellow-50 text-yellow-700 border-yellow-200"}`,
        children: [
            isSettled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e23b961d77b488$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5"
            }),
            status
        ]
    });
}
function $26b735d7a7eaab51$export$2e2bcd8739ae039() {
    const { transactions: transactions, pagination: pagination, filter: filter, stats: stats, summaryTotals: summaryTotals, loading: loading, error: error, exportLoading: exportLoading, filters: filters, updateFilter: updateFilter, handlePageChange: handlePageChange, selectedMonthLabel: selectedMonthLabel, MONTHS: MONTHS, YEARS: YEARS, getAvailableMonths: getAvailableMonths, handleExportXlsx: handleExportXlsx, handleExportPdf: handleExportPdf, refreshReport: refreshReport } = (0, $0d0192423c73d709$export$f2910d59c1f7d1f8)();
    // ── summary cards config ────────────────────────────────────────────────
    const cards = [
        {
            icon: (0, $cab856bf30f1b37f$export$2e2bcd8739ae039),
            label: "Total Transactions",
            value: stats?.total_transactions || 0,
            iconBg: "bg-blue-100",
            textColor: "text-blue-600"
        },
        {
            icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
            label: "Total Revenue",
            value: $26b735d7a7eaab51$var$formatCurrency(stats?.total_revenue || 0),
            iconBg: "bg-purple-100",
            textColor: "text-purple-600"
        },
        {
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            label: "Customer Savings",
            value: $26b735d7a7eaab51$var$formatCurrency(stats?.customer_savings || 0),
            iconBg: "bg-green-100",
            textColor: "text-green-600"
        },
        {
            icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
            label: "Platform Commission",
            value: $26b735d7a7eaab51$var$formatCurrency(stats?.platform_commission || 0),
            iconBg: "bg-orange-100",
            textColor: "text-orange-600"
        },
        {
            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
            label: "Net Earnings",
            value: $26b735d7a7eaab51$var$formatCurrency(stats?.net_earnings || 0),
            iconBg: "bg-emerald-100",
            textColor: "text-emerald-600"
        }
    ];
    // ── render ──────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "theme-card rounded-lg p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "bg-blue-100 p-2 rounded-lg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                    className: "h-7 w-7 text-blue-600"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Reports"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500",
                                        children: "Monthly transaction summary & financials"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4",
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($26b735d7a7eaab51$var$SummaryCard, {
                        ...card
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "theme-card rounded-lg overflow-visible",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-4 sm:px-6 py-4 border-b border-gray-200 relative z-10",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-gray-600 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 flex-shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs font-medium uppercase whitespace-nowrap",
                                        children: "Filter by:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-2 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: filters.year,
                                        onChange: (e)=>{
                                            const newYear = Number(e.target.value);
                                            updateFilter("year", newYear);
                                            const availableMonths = getAvailableMonths(newYear);
                                            if (!availableMonths.find((m)=>m.value === filters.month)) updateFilter("month", availableMonths[availableMonths.length - 1].value);
                                        },
                                        className: "flex-1 sm:flex-none px-3 py-2 border border-gray-300 rounded text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white",
                                        children: YEARS.map((y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: y,
                                                children: y
                                            }, y))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: filters.month,
                                        onChange: (e)=>updateFilter("month", Number(e.target.value)),
                                        className: "flex-1 sm:flex-none px-3 py-2 border border-gray-300 rounded text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white",
                                        children: getAvailableMonths(filters.year).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: m.value,
                                                children: m.label
                                            }, m.value))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex-1 sm:flex-none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10480bbe50d1925d$export$2e2bcd8739ae039), {
                                            year: filters.year,
                                            month: filters.month,
                                            fromDate: filters.from_date,
                                            toDate: filters.to_date,
                                            onFromDateChange: (date)=>updateFilter("from_date", date),
                                            onToDateChange: (date)=>updateFilter("to_date", date)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap gap-2 items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>{
                                            const monthStart = new Date(Date.UTC(filters.year, filters.month - 1, 1));
                                            const monthEnd = new Date(Date.UTC(filters.year, filters.month, 0));
                                            const fromDateStr = `${monthStart.getUTCFullYear()}-${String(monthStart.getUTCMonth() + 1).padStart(2, '0')}-${String(monthStart.getUTCDate()).padStart(2, '0')}`;
                                            const toDateStr = `${monthEnd.getUTCFullYear()}-${String(monthEnd.getUTCMonth() + 1).padStart(2, '0')}-${String(monthEnd.getUTCDate()).padStart(2, '0')}`;
                                            updateFilter("from_date", fromDateStr);
                                            updateFilter("to_date", toDateStr);
                                        },
                                        className: "px-3 py-2 rounded border border-gray-300 text-xs font-medium text-gray-600 hover:bg-gray-50 transition-colors",
                                        children: "Reset"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 ml-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: handleExportXlsx,
                                                disabled: exportLoading || loading || transactions.length === 0,
                                                className: "flex items-center gap-1.5 px-3 py-2 rounded border border-green-600 text-green-700 hover:bg-green-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs font-medium",
                                                children: [
                                                    exportLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 animate-spin"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26cec67c26de53a9$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "hidden sm:inline",
                                                        children: "Excel"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: handleExportPdf,
                                                disabled: exportLoading || loading || transactions.length === 0,
                                                className: "flex items-center gap-1.5 px-3 py-2 rounded border border-red-500 text-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs font-medium",
                                                children: [
                                                    exportLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 animate-spin"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "hidden sm:inline",
                                                        children: "PDF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: refreshReport,
                                                disabled: loading,
                                                title: "Refresh",
                                                className: "p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors disabled:opacity-50",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                    className: `h-4 w-4 ${loading ? "animate-spin" : ""}`
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-6 py-3 border-b border-gray-200 bg-gray-50",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "text-base font-semibold text-gray-900",
                            children: [
                                "Transaction Details",
                                pagination && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "ml-2 text-sm font-normal text-gray-500",
                                    children: [
                                        "(",
                                        pagination.total,
                                        " total)"
                                    ]
                                })
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center py-16 gap-3 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 animate-spin text-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Loading report\u2026"
                            })
                        ]
                    }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-red-400"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600",
                                children: "Failed to load report data."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: refreshReport,
                                className: "theme-button-primary px-4 py-2 rounded-lg text-sm",
                                children: "Try Again"
                            })
                        ]
                    }) : transactions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                className: "h-12 w-12 text-gray-300"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-gray-500 font-medium",
                                children: [
                                    "No transactions for ",
                                    selectedMonthLabel,
                                    " ",
                                    filters.year
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400 text-sm",
                                children: "Try selecting a different month or year."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-50 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: [
                                            "#",
                                            "Reference ID",
                                            "Customer",
                                            "Mobile",
                                            "Bill Amount",
                                            "Customer Discount",
                                            "Final Amount",
                                            "Date & Time",
                                            "Platform Commission",
                                            "Settlement"
                                        ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                                children: col
                                            }, col))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-100",
                                    children: transactions.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                    children: t.sl_no
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-mono text-xs text-blue-700 bg-blue-50 px-2 py-0.5 rounded",
                                                        children: t.reference_id
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-medium text-gray-800 whitespace-nowrap",
                                                    children: t.customer_name || "N/A"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 font-mono",
                                                    children: t.mobile
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-semibold text-gray-900 whitespace-nowrap",
                                                    children: $26b735d7a7eaab51$var$formatCurrency(t.bill_amount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "px-4 py-3 whitespace-nowrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-green-700 font-medium",
                                                            children: $26b735d7a7eaab51$var$formatCurrency(t.customer_discount)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-xs text-gray-400 ml-1",
                                                            children: [
                                                                "(",
                                                                t.bill_amount ? (t.customer_discount / t.bill_amount * 100).toFixed(1) : 0,
                                                                "%)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-bold text-emerald-700 whitespace-nowrap",
                                                    children: $26b735d7a7eaab51$var$formatCurrency(t.final_amount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-500 whitespace-nowrap text-xs",
                                                    children: $26b735d7a7eaab51$var$formatDate(t.date_time)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "px-4 py-3 whitespace-nowrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-orange-600 font-medium",
                                                            children: $26b735d7a7eaab51$var$formatCurrency(t.platform_commission)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-xs text-gray-400 ml-1",
                                                            children: [
                                                                "(",
                                                                t.bill_amount ? (t.platform_commission / t.bill_amount * 100).toFixed(1) : 0,
                                                                "%)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($26b735d7a7eaab51$var$SettlementBadge, {
                                                        status: t.settlement_status
                                                    })
                                                })
                                            ]
                                        }, t.reference_id))
                                }),
                                transactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tfoot", {
                                    className: "bg-gray-50 border-t-2 border-gray-300",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 4,
                                                className: "px-4 py-3 text-sm font-semibold text-gray-700",
                                                children: "Page Total"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-gray-900 whitespace-nowrap",
                                                children: $26b735d7a7eaab51$var$formatCurrency(summaryTotals.totalBillAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-green-700 whitespace-nowrap",
                                                children: $26b735d7a7eaab51$var$formatCurrency(summaryTotals.totalCustomerDiscount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-emerald-700 whitespace-nowrap",
                                                children: $26b735d7a7eaab51$var$formatCurrency(summaryTotals.totalFinalAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-orange-600 whitespace-nowrap",
                                                children: $26b735d7a7eaab51$var$formatCurrency(summaryTotals.totalPlatformCommission)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 1
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    pagination && pagination.last_page > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                        currentPage: pagination.current_page,
                        totalPages: pagination.last_page,
                        totalItems: pagination.total,
                        itemsPerPage: pagination.per_page,
                        onPageChange: handlePageChange
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d252ca8c87a49232$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const $d252ca8c87a49232$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("download", $d252ca8c87a49232$export$3efd853dbb351e94);



var $2OTVO = parcelRequire("2OTVO");

// ─── helpers ─────────────────────────────────────────────────────────────────
const $bceb295920399bcc$var$fmtDate = (dateString)=>{
    if (!dateString) return "\u2014";
    return new Date(dateString).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};
function $bceb295920399bcc$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const { invoicePaidMonths: invoicePaidMonths, invoiceLoading: invoiceLoading, invoiceError: invoiceError, invoiceDownloadingMap: invoiceDownloadingMap } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.businessOwner);
    const businessUuid = user?.business_id || "";
    // ── fetch paid months ──────────────────────────────────────────────────────
    const fetchPaidMonths = (0, $acw62.useCallback)(()=>{
        dispatch((0, $2OTVO.getBusinessInvoicePaidMonths)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchPaidMonths();
    }, [
        fetchPaidMonths
    ]);
    // ── download invoice ───────────────────────────────────────────────────────
    const handleDownload = (0, $acw62.useCallback)(async (month, year, monthName)=>{
        if (!businessUuid) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Business not found");
            return;
        }
        const result = await dispatch((0, $2OTVO.downloadBusinessInvoice)({
            businessUuid: businessUuid,
            month: month,
            year: year,
            monthName: monthName
        }));
        if ((0, $2OTVO.downloadBusinessInvoice).fulfilled.match(result)) {
            // Trigger browser download
            const { blobUrl: blobUrl, filename: filename } = result.payload;
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Invoice downloaded successfully");
        } else (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Failed to download invoice");
    }, [
        dispatch,
        businessUuid
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-purple-100 p-2 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 sm:h-7 sm:w-7 text-purple-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-xl sm:text-2xl font-bold text-gray-900",
                                            children: "Invoices"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs sm:text-sm text-gray-500",
                                            children: "Download commission invoices for paid months"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: fetchPaidMonths,
                            disabled: invoiceLoading,
                            className: "self-end sm:self-auto p-2 text-gray-400 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors disabled:opacity-40",
                            title: "Refresh",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                className: `h-5 w-5 ${invoiceLoading ? "animate-spin" : ""}`
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden",
                children: invoiceLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-center py-16 gap-3 text-gray-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 animate-spin text-purple-500"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Loading invoices\u2026"
                        })
                    ]
                }) : invoiceError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-center justify-center py-16 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                            className: "h-10 w-10 text-red-400"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-600",
                            children: invoiceError
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: fetchPaidMonths,
                            className: "px-4 py-2 bg-purple-600 text-white rounded-lg text-sm hover:bg-purple-700 transition-colors",
                            children: "Try Again"
                        })
                    ]
                }) : invoicePaidMonths.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-center justify-center py-16 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                            className: "h-12 w-12 text-gray-300"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-500 font-medium",
                            children: "No invoices available"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-400 text-sm",
                            children: "Invoices will appear here once commission payments are settled."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50 border-b border-gray-200",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: [
                                        "#",
                                        "Period",
                                        "Paid At",
                                        "Action"
                                    ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                            children: col
                                        }, col))
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "bg-white divide-y divide-gray-100",
                                children: invoicePaidMonths.map((item, idx)=>{
                                    const key = `${item.month}-${item.year}`;
                                    const isDownloading = invoiceDownloadingMap[key] || false;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                children: idx + 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 text-purple-500"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-semibold text-gray-900",
                                                            children: item.formatted || `${item.month_name} ${item.year}`
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 text-gray-500 text-xs whitespace-nowrap",
                                                children: $bceb295920399bcc$var$fmtDate(item.paid_at)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: ()=>handleDownload(item.month, item.year, item.month_name),
                                                    disabled: isDownloading,
                                                    className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-purple-50 text-purple-700 border border-purple-200 hover:bg-purple-100 transition-colors disabled:opacity-50",
                                                    children: [
                                                        isDownloading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                            className: "h-3.5 w-3.5 animate-spin"
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                                            className: "h-3.5 w-3.5"
                                                        }),
                                                        isDownloading ? "Downloading\u2026" : "Download Invoice"
                                                    ]
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




const $909de5d73872fc47$export$9a192650aaa62462 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const { currentTransaction: currentTransaction, transactionSummary: transactionSummary, customer: customer, loading: loading, summaryLoading: summaryLoading, customerLoading: customerLoading, error: error, customerError: customerError } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.transaction);
    const [step, setStep] = (0, $acw62.useState)(1); // 1: customer search + amount entry, 2: review, 3: summary
    const [formData, setFormData] = (0, $acw62.useState)({
        mobile: "",
        billableAmount: ""
    });
    // Business modal states
    const [showConfirmModal, setShowConfirmModal] = (0, $acw62.useState)(false);
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    // Track the last searched mobile number to prevent duplicate API calls
    const lastSearchedMobile = (0, $acw62.useRef)("");
    const searchTimeoutRef = (0, $acw62.useRef)(null);
    // Check for existing transaction UUID in URL params
    (0, $acw62.useEffect)(()=>{
        const uuid = searchParams.get('uuid');
        if (uuid) loadExistingTransaction(uuid);
    }, [
        searchParams
    ]);
    const loadExistingTransaction = async (uuid)=>{
        try {
            const result = await dispatch((0, $3b948c371c69daa7$export$a1b16a49f384bd24)(uuid));
            if ((0, $3b948c371c69daa7$export$a1b16a49f384bd24).fulfilled.match(result)) {
                const transaction = result.payload.data || result.payload;
                // For business users, show summary step directly
                if (user?.role === "business") {
                    setStep(3);
                    return;
                }
                // For admin users, continue with old flow
                setFormData({
                    mobile: transaction.mobile || transaction.customer?.mobile || "",
                    billableAmount: transaction.financial_summary?.billable_amount?.amount || transaction.billable_amount || ""
                });
                transaction.customer;
                setStep(2);
                setSearchParams({});
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Transaction loaded successfully!");
            }
        } catch (error) {
            console.log('Load existing transaction error:', error);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to load transaction");
            setSearchParams({});
        }
    };
    // Cleanup on unmount
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $3b948c371c69daa7$export$54fb1287c4db1608)());
            dispatch((0, $3b948c371c69daa7$export$7bac06fd394c3d08)());
            dispatch((0, $3b948c371c69daa7$export$f6b9da1d372ccd93)());
            // Clear any pending timeouts
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        };
    }, [
        dispatch
    ]);
    // Handle errors - don't show toast for customer errors, they'll be shown inline
    (0, $acw62.useEffect)(()=>{
        if (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error);
            dispatch((0, $3b948c371c69daa7$export$a15ba4bdf59dacc9)());
        }
    }, [
        error,
        dispatch
    ]);
    // Clear customer data when mobile number changes significantly
    (0, $acw62.useEffect)(()=>{
        if (formData.mobile !== lastSearchedMobile.current && customer && formData.mobile.length < 10) {
            dispatch((0, $3b948c371c69daa7$export$f6b9da1d372ccd93)());
            // Reset step to 1 if we're on step 2 and mobile is changed
            if (step === 2) setStep(1);
        }
    }, [
        formData.mobile,
        customer,
        dispatch,
        step
    ]);
    // Debug logging
    (0, $acw62.useEffect)(()=>{
        console.log('Customer state changed:', customer);
        console.log('Current step:', step);
        console.log('Customer loading:', customerLoading);
        console.log('Customer error:', customerError);
    }, [
        customer,
        step,
        customerLoading,
        customerError
    ]);
    const handleCustomerSearch = async (e)=>{
        e.preventDefault();
        const mobile = formData.mobile.trim();
        if (!mobile || mobile.length !== 10) return;
        // Prevent duplicate searches for the same mobile number
        if (mobile === lastSearchedMobile.current && customerLoading) return;
        // Clear any existing timeout
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        // Set a small delay to prevent rapid successive calls
        searchTimeoutRef.current = setTimeout(async ()=>{
            lastSearchedMobile.current = mobile;
            try {
                const result = await dispatch((0, $3b948c371c69daa7$export$cde0caff919b1ea0)(mobile));
                console.log('Customer search result:', result);
                if ((0, $3b948c371c69daa7$export$cde0caff919b1ea0).fulfilled.match(result)) {
                    console.log('Customer found successfully');
                    (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Customer found successfully!");
                // Don't change step - customer found, now show amount field in same step
                } else if ((0, $3b948c371c69daa7$export$cde0caff919b1ea0).rejected.match(result)) console.log('Customer search failed:', result.payload);
            } catch (error) {
                console.log('Customer search error:', error);
            }
        }, 300); // 300ms delay to prevent rapid calls
    };
    const handleInitiateTransaction = async (e)=>{
        e.preventDefault();
        // For business users, open confirmation modal instead of direct transaction
        if (user?.role === "business") {
            const mobile = formData.mobile.trim();
            const amount = parseFloat(formData.billableAmount);
            if (!mobile || mobile.length !== 10) {
                (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)("Please enter a valid 10-digit mobile number");
                return;
            }
            if (!amount || amount <= 0) {
                (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)("Please enter a valid bill amount");
                return;
            }
            setShowConfirmModal(true);
            return;
        }
        // Admin flow - continue with old logic
        if (!formData.billableAmount || parseFloat(formData.billableAmount) <= 0) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Please enter a valid amount");
            return;
        }
        const businessId = user?.business_id || localStorage.getItem('business_id');
        if (!businessId) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Business details not found. Please login again.");
            return;
        }
        const transactionData = {
            business_id: businessId,
            mobile: formData.mobile,
            billable_amount: parseFloat(formData.billableAmount)
        };
        try {
            const result = await dispatch((0, $3b948c371c69daa7$export$d0cfa7ae02a67905)(transactionData));
            if ((0, $3b948c371c69daa7$export$d0cfa7ae02a67905).fulfilled.match(result)) {
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Transaction initiated successfully!");
                setStep(2);
            }
        } catch (error) {
            console.log('Transaction initiation error:', error);
        }
    };
    // Business transaction creation (for modal confirmation)
    const handleCreateTransaction = async (confirmData)=>{
        try {
            const transactionData = {
                business_id: user?.business_id,
                mobile: confirmData.mobile,
                billable_amount: confirmData.billable_amount,
                customer_name: confirmData.customer_name
            };
            const result = await dispatch((0, $3b948c371c69daa7$export$714aebfec8ead7f0)(transactionData)).unwrap();
            setShowConfirmModal(false);
            // For business users, fetch the transaction summary and show step 3
            if (result?.uuid) {
                setSearchParams({
                    uuid: result.uuid
                });
                await dispatch((0, $3b948c371c69daa7$export$a1b16a49f384bd24)(result.uuid));
                setStep(3); // Show summary step
            }
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Transaction created successfully!");
        } catch (error) {
            console.error('Transaction creation failed:', error);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(error);
        }
    };
    const handleFulfill = async ()=>{
        if (!currentTransaction?.uuid) return;
        try {
            const result = await dispatch((0, $3b948c371c69daa7$export$1c890677793f064d)({
                uuid: currentTransaction.uuid,
                data: {}
            }));
            if ((0, $3b948c371c69daa7$export$1c890677793f064d).fulfilled.match(result)) {
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Transaction completed successfully!");
                // Fetch transaction summary and show summary step
                await dispatch((0, $3b948c371c69daa7$export$a1b16a49f384bd24)(currentTransaction.uuid));
                setStep(3);
            }
        } catch (error) {
            console.log('Transaction fulfill error:', error);
        }
    };
    const handleCancel = async ()=>{
        if (!currentTransaction?.uuid) return;
        try {
            const result = await dispatch((0, $3b948c371c69daa7$export$589e52a10659e1d0)(currentTransaction.uuid));
            if ((0, $3b948c371c69daa7$export$589e52a10659e1d0).fulfilled.match(result)) {
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Transaction cancelled successfully");
                // Fetch transaction summary and show summary step
                await dispatch((0, $3b948c371c69daa7$export$a1b16a49f384bd24)(currentTransaction.uuid));
                setStep(3);
            }
        } catch (error) {
            console.log('Transaction cancel error:', error);
        }
    };
    const handleReset = ()=>{
        setStep(1);
        setFormData({
            mobile: "",
            billableAmount: ""
        });
        lastSearchedMobile.current = "";
        // Reset modal states
        setShowConfirmModal(false);
        setShowSuccessModal(false);
        // Clear any pending timeouts
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        dispatch((0, $3b948c371c69daa7$export$54fb1287c4db1608)());
        dispatch((0, $3b948c371c69daa7$export$7bac06fd394c3d08)());
        dispatch((0, $3b948c371c69daa7$export$f6b9da1d372ccd93)());
        dispatch((0, $3b948c371c69daa7$export$a15ba4bdf59dacc9)());
        // Clear URL params
        setSearchParams({});
    };
    return {
        step: // State
        step,
        formData: formData,
        currentTransaction: currentTransaction,
        transactionSummary: transactionSummary,
        customer: customer,
        loading: loading,
        summaryLoading: summaryLoading,
        customerLoading: customerLoading,
        customerError: customerError,
        showConfirmModal: // Business modal states
        showConfirmModal,
        showSuccessModal: showSuccessModal,
        setFormData: // Actions
        setFormData,
        handleCustomerSearch: handleCustomerSearch,
        handleInitiateTransaction: handleInitiateTransaction,
        handleCreateTransaction: handleCreateTransaction,
        handleFulfill: handleFulfill,
        handleCancel: handleCancel,
        handleReset: handleReset,
        setShowConfirmModal: // Modal controls
        setShowConfirmModal,
        setShowSuccessModal: setShowSuccessModal
    };
};




function $2613fbca97a30302$export$2e2bcd8739ae039({ currentTransaction: currentTransaction, onReset: onReset }) {
    const isCompleted = currentTransaction?.status === 'FULFILLED' || currentTransaction?.status === 'CANCELLED';
    const isPending = currentTransaction?.status === 'INITIATED';
    const getHeaderText = ()=>{
        if (isCompleted) return 'Transaction Completed';
        if (isPending) return 'Continue Transaction';
        return 'New Transaction';
    };
    const getSubText = ()=>{
        if (isCompleted) return 'Transaction has been processed successfully';
        if (isPending) return 'Complete or cancel this pending transaction';
        return 'Process customer transactions and apply discounts';
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "theme-card rounded-lg p-4 md:p-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center space-x-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "bg-primary-light p-2 rounded-lg",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 md:h-8 md:w-8 text-primary"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-xl md:text-2xl font-bold text-gray-900",
                                    children: getHeaderText()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm md:text-base text-gray-600 mt-1",
                                    children: getSubText()
                                }),
                                isPending && (currentTransaction?.reference_id || currentTransaction?.uuid) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-xs text-blue-600 mt-1 font-mono",
                                    children: [
                                        "ID: ",
                                        (currentTransaction.reference_id || currentTransaction.uuid).substring(0, 8),
                                        "..."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isCompleted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: onReset,
                    className: "theme-button-primary px-4 py-2 text-sm rounded-lg w-full sm:w-auto",
                    children: "New Transaction"
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");

function $963013378ba5bdaf$export$2e2bcd8739ae039({ step: step, formData: formData, customer: customer, customerLoading: customerLoading, customerError: customerError, loading: loading, onFormChange: onFormChange, onSubmit: onSubmit, onAmountSubmit: onAmountSubmit }) {
    const isCompleted = step > 1;
    const lastMobileRef = (0, $acw62.useRef)("");
    // Auto-search when mobile number reaches 10 digits
    (0, $acw62.useEffect)(()=>{
        const mobile = formData.mobile;
        // Only search if:
        // 1. We're on step 1
        // 2. Mobile is exactly 10 digits
        // 3. Not currently loading
        // 4. No customer found yet
        // 5. Mobile number has changed from last search
        if (step === 1 && mobile.length === 10 && !customerLoading && !customer && mobile !== lastMobileRef.current) {
            lastMobileRef.current = mobile;
            const syntheticEvent = {
                preventDefault: ()=>{}
            };
            onSubmit(syntheticEvent);
        }
        // Reset last mobile if mobile is cleared or changed significantly
        if (mobile.length < 10) lastMobileRef.current = "";
    }, [
        formData.mobile,
        step,
        onSubmit,
        customerLoading,
        customer
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "theme-card rounded-lg p-4 md:p-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center space-x-3 mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `p-2 rounded-lg ${isCompleted ? 'bg-green-100' : 'bg-blue-100'}`,
                        children: isCompleted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-green-600"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-blue-600"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-semibold text-gray-900",
                                children: isCompleted ? 'Transaction Details' : 'New Transaction'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-600",
                                children: isCompleted ? 'Transaction initiated successfully' : customer ? 'Customer found! Enter the transaction amount' : 'Enter customer\'s mobile number to search'
                            })
                        ]
                    }),
                    isCompleted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ml-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800",
                            children: "Completed"
                        })
                    })
                ]
            }),
            step === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Customer Mobile Number"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "tel",
                                        value: formData.mobile,
                                        onChange: (e)=>{
                                            const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                            if (value.length <= 10) onFormChange({
                                                ...formData,
                                                mobile: value
                                            });
                                        },
                                        onKeyPress: (e)=>{
                                            // Only allow digits
                                            if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') e.preventDefault();
                                        },
                                        className: "w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors",
                                        placeholder: "Enter 10-digit mobile number",
                                        maxLength: "10",
                                        pattern: "[0-9]{10}",
                                        inputMode: "numeric",
                                        required: true
                                    })
                                ]
                            }),
                            formData.mobile.length > 0 && formData.mobile.length < 10 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-red-500 text-xs mt-1",
                                children: "Mobile number must be exactly 10 digits"
                            }),
                            formData.mobile.length === 10 && customerLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-blue-500 text-xs mt-1 flex items-center space-x-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Searching for customer..."
                                    })
                                ]
                            })
                        ]
                    }),
                    customerError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg border border-red-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm",
                                children: customerError
                            })
                        ]
                    }),
                    customer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-green-50 rounded-lg p-4 border border-green-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-2 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-green-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-green-800 font-medium",
                                        children: "Customer Found"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-green-700",
                                                children: "Mobile Number"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-medium text-green-900",
                                                children: formData.mobile
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-green-700",
                                                children: "Customer Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-medium text-green-900",
                                                children: customer.name
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    customer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: onAmountSubmit,
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-2",
                                        children: "Transaction Amount (\u20B9)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                step: "0.01",
                                                min: "0",
                                                value: formData.billableAmount,
                                                onChange: (e)=>onFormChange({
                                                        ...formData,
                                                        billableAmount: e.target.value
                                                    }),
                                                className: "w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors",
                                                placeholder: "Enter amount",
                                                required: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                disabled: loading || !formData.billableAmount,
                                className: "w-full theme-button-gradient py-3 flex items-center justify-center space-x-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Proceed to Review"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gray-50 rounded-lg p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "Mobile Number"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-medium text-gray-900",
                                        children: formData.mobile
                                    })
                                ]
                            }),
                            customer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-600",
                                            children: "Customer Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-medium text-gray-900",
                                            children: customer.name
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-t pt-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-600",
                                    children: "Transaction Amount:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "font-medium text-gray-900",
                                    children: [
                                        "\u20B9",
                                        formData.billableAmount
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




function $1ae733b888397251$export$2e2bcd8739ae039({ step: step, currentTransaction: currentTransaction, loading: loading, onFulfill: onFulfill, onCancel: onCancel }) {
    if (step < 2 || !currentTransaction) return null;
    const getStatusConfig = ()=>{
        switch(currentTransaction.status){
            case 'FULFILLED':
                return {
                    bgColor: 'bg-green-100',
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-green-600"
                    }),
                    description: 'Transaction completed successfully',
                    badgeColor: 'bg-green-100 text-green-800',
                    badgeText: 'Completed'
                };
            case 'CANCELLED':
                return {
                    bgColor: 'bg-red-100',
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-red-600"
                    }),
                    description: 'Transaction was cancelled',
                    badgeColor: 'bg-red-100 text-red-800',
                    badgeText: 'Cancelled'
                };
            default:
                return {
                    bgColor: 'bg-blue-100',
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-blue-600"
                    }),
                    description: 'Review transaction details and choose action',
                    badgeColor: null,
                    badgeText: null
                };
        }
    };
    const statusConfig = getStatusConfig();
    const isCompleted = currentTransaction.status === 'FULFILLED' || currentTransaction.status === 'CANCELLED';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "theme-card rounded-lg p-4 md:p-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center space-x-3 mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `p-2 rounded-lg ${statusConfig.bgColor}`,
                        children: statusConfig.icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-semibold text-gray-900",
                                children: "Step 2: Transaction Review"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-600",
                                children: statusConfig.description
                            })
                        ]
                    }),
                    isCompleted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ml-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `inline-flex px-2 py-1 text-xs font-semibold rounded-full ${statusConfig.badgeColor}`,
                            children: statusConfig.badgeText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-50 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "font-semibold text-gray-900 mb-4",
                                children: "Transaction Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Reference ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-mono text-sm text-gray-900 break-all",
                                                children: currentTransaction.reference_id || currentTransaction.uuid
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `inline-flex px-2 py-1 text-xs font-semibold rounded-full ${currentTransaction.status === 'FULFILLED' ? 'bg-green-100 text-green-800' : currentTransaction.status === 'CANCELLED' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'}`,
                                                children: currentTransaction.status_label
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Customer"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-medium text-gray-900",
                                                children: currentTransaction.customer?.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: currentTransaction.customer?.mobile || currentTransaction.mobile
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Date & Time"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-900",
                                                children: new Date(currentTransaction.created_at).toLocaleString('en-IN')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-blue-50 rounded-lg p-4 border border-blue-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-lg font-semibold text-blue-900",
                                    children: "Billable Amount:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-2xl font-bold text-blue-600",
                                    children: currentTransaction.financial_summary?.billable_amount?.formatted || `\u{20B9}${parseFloat(currentTransaction.billable_amount || 0).toLocaleString('en-IN')}`
                                })
                            ]
                        })
                    }),
                    currentTransaction.business && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-50 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "font-semibold text-gray-900 mb-2",
                                children: "Business Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-medium text-gray-900",
                                children: currentTransaction.business.business_name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-600",
                                children: currentTransaction.business.address
                            })
                        ]
                    }),
                    currentTransaction.status === 'FULFILLED' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-green-50 border border-green-200 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-green-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-green-800 font-medium",
                                        children: "Transaction Completed Successfully"
                                    })
                                ]
                            }),
                            currentTransaction.fulfilled_at && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-green-700 mt-2",
                                children: [
                                    "Completed at: ",
                                    new Date(currentTransaction.fulfilled_at).toLocaleString('en-IN')
                                ]
                            })
                        ]
                    }),
                    currentTransaction.status === 'CANCELLED' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-red-50 border border-red-200 rounded-lg p-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-red-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-800 font-medium",
                                    children: "Transaction was cancelled"
                                })
                            ]
                        })
                    }),
                    currentTransaction.status === 'INITIATED' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-3 pt-4 border-t",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onFulfill,
                                disabled: loading,
                                className: "w-full sm:flex-1 theme-button-gradient py-3 px-6 flex items-center justify-center space-x-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Deal"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: onCancel,
                                disabled: loading,
                                className: "w-full sm:w-auto px-6 py-3 border border-red-300 text-red-700 rounded-lg hover:bg-red-50 flex items-center justify-center space-x-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $3d32c26fc21fc037$export$2e2bcd8739ae039({ step: step, transactionSummary: transactionSummary, summaryLoading: summaryLoading, onReset: onReset }) {
    if (step !== 3) return null;
    if (summaryLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 max-w-md mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center justify-center py-6 sm:py-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-6 h-6 sm:w-8 sm:h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ml-3 text-gray-600 text-sm sm:text-base",
                    children: "Loading transaction summary..."
                })
            ]
        })
    });
    if (!transactionSummary) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 max-w-md mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center py-6 sm:py-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "h-10 w-10 sm:h-12 sm:w-12 text-red-500 mx-auto mb-3 sm:mb-4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "text-base sm:text-lg font-semibold text-gray-900 mb-2",
                    children: "Unable to load transaction summary"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base px-2",
                    children: "There was an error loading the transaction details."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: onReset,
                    className: "theme-button-gradient px-4 sm:px-6 py-2 sm:py-2 rounded-lg text-sm sm:text-base min-h-[44px] touch-manipulation",
                    children: "Start New Transaction"
                })
            ]
        })
    });
    const isCompleted = transactionSummary.status === 'FULFILLED';
    const isCancelled = transactionSummary.status === 'CANCELLED';
    // For cancelled transactions, show simple message
    if (isCancelled) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 max-w-md mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center py-6 sm:py-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "h-12 w-12 sm:h-16 sm:w-16 text-red-500 mx-auto mb-3 sm:mb-4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "text-xl sm:text-2xl font-bold text-gray-900 mb-2",
                    children: "Transaction Cancelled"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base px-2",
                    children: "The transaction has been cancelled."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    onClick: onReset,
                    className: "theme-button-gradient px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg flex items-center space-x-2 mx-auto min-h-[44px] touch-manipulation",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 sm:h-5 sm:w-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm sm:text-base",
                            children: "Start New Transaction"
                        })
                    ]
                })
            ]
        })
    });
    // For completed transactions, show the simple success design
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-gradient-to-b from-green-500 to-green-600 rounded-lg p-3 sm:p-4 md:p-6 text-white max-w-sm sm:max-w-md mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-center mb-4 sm:mb-6 md:mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-lg sm:text-xl md:text-2xl font-light mb-3 sm:mb-4 md:mb-6",
                        children: "Deal Successful!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "relative mx-auto mb-3 sm:mb-4 md:mb-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white rounded-full flex items-center justify-center mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "absolute inset-0 rounded-full",
                                    children: [
                                        ...Array(12)
                                    ].map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 bg-green-500 rounded-full",
                                            style: {
                                                top: '50%',
                                                left: '50%',
                                                transform: `translate(-50%, -50%) rotate(${i * 30}deg) translateY(-28px)`,
                                                animationDelay: `${i * 0.1}s`
                                            }
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-green-500 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 sm:h-6 sm:w-6 md:h-8 md:w-8 text-white"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3 sm:mb-4 md:mb-6 px-1 sm:px-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-base sm:text-lg md:text-xl font-medium leading-tight",
                                children: transactionSummary.business?.business_name || 'Business Name'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-green-100 text-xs sm:text-sm mt-1 leading-relaxed",
                                children: transactionSummary.business?.address || 'Address'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-green-100 text-xs sm:text-sm space-y-1 mb-4 sm:mb-6 md:mb-8 px-1 sm:px-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "leading-relaxed",
                                children: [
                                    "On ",
                                    new Date(transactionSummary.created_at).toLocaleDateString('en-IN', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                    }),
                                    " at ",
                                    new Date(transactionSummary.created_at).toLocaleTimeString('en-IN', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "font-mono text-xs sm:text-sm",
                                children: [
                                    "Reference Id: ",
                                    transactionSummary.reference_id
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-2xl p-3 sm:p-4 md:p-6 text-gray-900 mb-4 sm:mb-6 mx-1 sm:mx-2 md:mx-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3 sm:space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-sm sm:text-base md:text-lg font-semibold",
                                    children: "Bill Amount :"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-sm sm:text-base md:text-lg font-semibold",
                                    children: transactionSummary.financial_summary?.billable_amount?.formatted || `\u{20B9}${parseFloat(transactionSummary.billable_amount || 0).toLocaleString('en-IN')}`
                                })
                            ]
                        }),
                        transactionSummary.financial_summary?.customer_savings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center text-green-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs sm:text-sm flex-shrink-0 pr-2",
                                    children: "Discount to Customer:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-right flex-shrink-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-xs sm:text-sm font-medium block",
                                        children: [
                                            "- ",
                                            transactionSummary.financial_summary.customer_savings.formatted
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "bg-green-500 text-white rounded-full py-3 sm:py-3 md:py-4 px-4 sm:px-6 text-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-sm sm:text-base font-semibold",
                                children: [
                                    "Total Payable ",
                                    transactionSummary.financial_summary?.final_amount?.formatted || transactionSummary.financial_summary?.billable_amount?.formatted || `\u{20B9}${parseFloat(transactionSummary.billable_amount || 0).toLocaleString('en-IN')}`
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center px-1 sm:px-2 md:px-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    onClick: onReset,
                    className: "bg-white text-green-600 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors flex items-center space-x-2 mx-auto min-h-[44px] touch-manipulation text-sm sm:text-base",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 sm:h-5 sm:w-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Start New Transaction"
                        })
                    ]
                })
            })
        ]
    });
}




function $303b428645e01f8f$export$2e2bcd8739ae039({ step: step, currentTransaction: currentTransaction }) {
    // Don't show progress on step 3 (summary step)
    if (step === 3) return null;
    const getStepStatus = (stepNumber)=>{
        if (step > stepNumber) return 'completed';
        if (step === stepNumber) return 'current';
        return 'pending';
    };
    const getStepConfig = (stepNumber, status)=>{
        if (status === 'completed') return {
            bgColor: 'bg-green-500 text-white',
            textColor: 'text-gray-900 font-medium',
            icon: "\u2713",
            label: 'Completed'
        };
        if (status === 'current') return {
            bgColor: 'bg-blue-500 text-white',
            textColor: 'text-gray-900 font-medium',
            icon: stepNumber.toString(),
            label: 'In Progress'
        };
        return {
            bgColor: 'bg-gray-300 text-gray-600',
            textColor: 'text-gray-600',
            icon: stepNumber.toString(),
            label: null
        };
    };
    const steps = [
        {
            number: 1,
            title: 'Find Customer & Enter Amount'
        },
        {
            number: 2,
            title: 'Review and Complete Transaction'
        }
    ];
    // Special handling for step 2 completion
    const step2Status = step >= 2 ? currentTransaction?.status === 'FULFILLED' || currentTransaction?.status === 'CANCELLED' ? 'completed' : 'current' : 'pending';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "theme-card rounded-lg p-4 md:p-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-start space-x-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-blue-100 p-2 rounded-lg flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "font-semibold text-gray-900 mb-3",
                            children: "Transaction Progress"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "space-y-3",
                            children: steps.map((stepItem)=>{
                                const status = stepItem.number === 2 ? step2Status : getStepStatus(stepItem.number);
                                const config = getStepConfig(stepItem.number, status);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold ${config.bgColor}`,
                                            children: config.icon
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: `text-sm ${config.textColor}`,
                                            children: stepItem.title
                                        }),
                                        config.label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: `text-xs font-medium ${config.label === 'Completed' ? 'text-green-600' : 'text-blue-600'}`,
                                            children: config.label
                                        })
                                    ]
                                }, stepItem.number);
                            })
                        })
                    ]
                })
            ]
        })
    });
}







function $3d98f708848f1f0f$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
                    className: "fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                    className: "fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white shadow-lg focus:outline-none p-6 sm:w-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "rounded-md p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors",
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: children
                        })
                    ]
                })
            ]
        })
    });
}


function $2ef805d206b59656$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, customer: customer, formData: formData, onConfirm: onConfirm, loading: loading = false }) {
    const handleConfirm = ()=>{
        if (onConfirm) onConfirm({
            customer_name: customer?.name || "Guest Customer",
            mobile: formData.mobile,
            billable_amount: parseFloat(formData.billableAmount)
        });
    };
    const handleCancel = ()=>{
        onOpenChange(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d98f708848f1f0f$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: "",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mx-auto mb-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-20 h-20 bg-gradient-to-br from-green-400 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44f0dae468c97d23$export$2e2bcd8739ae039), {
                            className: "h-10 w-10 text-white"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-4 mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center py-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-700 font-medium",
                                    children: "Bill Amount:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-lg font-bold",
                                    children: formData.billableAmount ? `\u{20B9}${parseFloat(formData.billableAmount).toLocaleString('en-IN')}` : "\u20B90"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center py-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-700 font-medium",
                                    children: "Customer Name:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-900 font-medium",
                                    children: customer?.name || "Guest Customer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center py-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-700 font-medium",
                                    children: "Mobile Number:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-900 font-medium",
                                    children: formData.mobile || 'N/A'
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleConfirm,
                            disabled: loading,
                            className: "w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-medium py-3 px-6 rounded-lg transition-colors",
                            children: loading ? "Processing..." : "Deal Now"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleCancel,
                            disabled: loading,
                            className: "w-full text-gray-500 hover:text-gray-700 disabled:text-gray-300 font-medium py-2 transition-colors",
                            children: "No, thanks"
                        })
                    ]
                })
            ]
        })
    });
}




function $ccda6e9e6d9a7533$export$2e2bcd8739ae039({ currentTransaction: currentTransaction, step: step, onReset: onReset }) {
    const isCompleted = currentTransaction?.status === 'FULFILLED' || currentTransaction?.status === 'CANCELLED';
    // Don't show on step 4 (summary step has its own button)
    if (!isCompleted || step === 4) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "theme-card rounded-lg p-4 md:p-6 text-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            onClick: onReset,
            className: "theme-button-gradient px-6 py-3 rounded-lg flex items-center justify-center space-x-2 mx-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                    className: "h-5 w-5"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Start New Transaction"
                })
            ]
        })
    });
}



function $4d7116f15adf22f5$export$2e2bcd8739ae039() {
    const { user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const { step: step, formData: formData, currentTransaction: currentTransaction, transactionSummary: transactionSummary, customer: customer, loading: loading, summaryLoading: summaryLoading, customerLoading: customerLoading, customerError: customerError, showConfirmModal: showConfirmModal, showSuccessModal: showSuccessModal, setFormData: setFormData, handleCustomerSearch: handleCustomerSearch, handleInitiateTransaction: handleInitiateTransaction, handleCreateTransaction: handleCreateTransaction, handleFulfill: handleFulfill, handleCancel: handleCancel, handleReset: handleReset, setShowConfirmModal: setShowConfirmModal, setShowSuccessModal: setShowSuccessModal } = (0, $909de5d73872fc47$export$9a192650aaa62462)();
    const isBusinessUser = user?.role === "business";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "p-4 md:p-6 overflow-y-auto",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-4xl mx-auto space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2613fbca97a30302$export$2e2bcd8739ae039), {
                        currentTransaction: currentTransaction,
                        onReset: handleReset
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $963013378ba5bdaf$export$2e2bcd8739ae039), {
                        step: step,
                        formData: formData,
                        customer: customer,
                        customerLoading: customerLoading,
                        customerError: customerError,
                        loading: loading,
                        onFormChange: setFormData,
                        onSubmit: handleCustomerSearch,
                        onAmountSubmit: handleInitiateTransaction
                    }),
                    isBusinessUser && step === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d32c26fc21fc037$export$2e2bcd8739ae039), {
                        step: step,
                        transactionSummary: transactionSummary,
                        summaryLoading: summaryLoading,
                        onReset: handleReset
                    }),
                    !isBusinessUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ae733b888397251$export$2e2bcd8739ae039), {
                                step: step,
                                currentTransaction: currentTransaction,
                                loading: loading,
                                onFulfill: handleFulfill,
                                onCancel: handleCancel
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d32c26fc21fc037$export$2e2bcd8739ae039), {
                                step: step,
                                transactionSummary: transactionSummary,
                                summaryLoading: summaryLoading,
                                onReset: handleReset
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $303b428645e01f8f$export$2e2bcd8739ae039), {
                                step: step,
                                currentTransaction: currentTransaction
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccda6e9e6d9a7533$export$2e2bcd8739ae039), {
                        currentTransaction: currentTransaction || transactionSummary,
                        step: step,
                        onReset: handleReset
                    }),
                    isBusinessUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ef805d206b59656$export$2e2bcd8739ae039), {
                            open: showConfirmModal,
                            onOpenChange: setShowConfirmModal,
                            customer: customer,
                            formData: formData,
                            onConfirm: handleCreateTransaction,
                            loading: loading
                        })
                    })
                ]
            })
        })
    });
}



/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-x", $839eea37a960d2b1$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




const $427ef751d3f7b307$export$eaffe3535a5f75b0 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { transactionHistory: transactionHistory, historyMeta: historyMeta, historyLoading: historyLoading, error: error } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.transaction);
    const [filters, setFilters] = (0, $acw62.useState)({
        filter: "TODAY",
        customDates: {
            from: "",
            to: ""
        },
        status: "all",
        search: "",
        page: 1,
        per_page: 15
    });
    // Initial fetch on mount with TODAY filter
    (0, $acw62.useEffect)(()=>{
        fetchTransactions(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync URL params with filters for page changes only
    (0, $acw62.useEffect)(()=>{
        const currentPage = parseInt(searchParams.get("page") || "1", 10);
        if (currentPage !== filters.page) {
            const updatedFilters = {
                ...filters,
                page: currentPage
            };
            setFilters(updatedFilters);
            fetchTransactions(updatedFilters);
        }
    }, [
        searchParams
    ]);
    // Handle errors
    (0, $acw62.useEffect)(()=>{
        if (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error);
            dispatch((0, $3b948c371c69daa7$export$a15ba4bdf59dacc9)());
        }
    }, [
        error,
        dispatch
    ]);
    // Cleanup on unmount
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $3b948c371c69daa7$export$3601c8ba53819021)());
        };
    }, [
        dispatch
    ]);
    const fetchTransactions = (0, $acw62.useCallback)(async (filtersToUse)=>{
        const filtersParam = filtersToUse || filters;
        // Don't fetch if CUSTOM filter is selected but dates are incomplete
        if (filtersParam.filter === "CUSTOM" && (!filtersParam.customDates.from || !filtersParam.customDates.to)) return;
        const params = {};
        // Add filter parameter
        if (filtersParam.filter) {
            params.filter = filtersParam.filter;
            if (filtersParam.filter === "CUSTOM" && filtersParam.customDates.from && filtersParam.customDates.to) {
                params.from = filtersParam.customDates.from;
                params.to = filtersParam.customDates.to;
            }
        }
        if (filtersParam.status !== "all") params.status = filtersParam.status.toUpperCase();
        if (filtersParam.search.trim()) params.search = filtersParam.search.trim();
        // Use server-side pagination
        params.page = filtersParam.page;
        params.per_page = filtersParam.per_page;
        try {
            await dispatch((0, $3b948c371c69daa7$export$2a40d6cb698b9f3)(params));
        } catch (error) {
            console.log('Transaction history fetch error:', error);
        }
    }, [
        dispatch,
        filters
    ]);
    const updateFilter = (key, value)=>{
        let newFilters;
        if (key === 'customDates') // For customDates, update the nested object
        newFilters = {
            ...filters,
            customDates: value
        };
        else if (key === 'page') // For page changes, don't reset page
        newFilters = {
            ...filters,
            [key]: value
        };
        else // For other filter changes, reset to page 1
        newFilters = {
            ...filters,
            [key]: value,
            page: 1
        };
        setFilters(newFilters);
    };
    const resetFilters = ()=>{
        setFilters({
            filter: "TODAY",
            customDates: {
                from: "",
                to: ""
            },
            status: "all",
            search: "",
            page: 1,
            per_page: 15
        });
    };
    const onApplyFilter = (0, $acw62.useCallback)(()=>{
        // Reset page to 1 when applying new filter
        const filtersToApply = {
            ...filters,
            page: 1
        };
        setFilters(filtersToApply);
        fetchTransactions(filtersToApply);
    }, [
        filters,
        fetchTransactions
    ]);
    const refreshTransactions = ()=>{
        fetchTransactions(filters);
    };
    // Calculate stats from current transactions
    const getStats = ()=>{
        const total = historyMeta?.total || transactionHistory.length;
        const fulfilled = transactionHistory.filter((t)=>t.settlement_status === 'Settled').length;
        const cancelled = 0;
        const initiated = 0;
        const totalRevenue = transactionHistory.reduce((sum, t)=>sum + parseFloat(t.final_amount || 0), 0);
        const totalDiscounts = transactionHistory.reduce((sum, t)=>sum + (parseFloat(t.customer_discount || 0) + parseFloat(t.platform_commission || 0)), 0);
        return {
            total: total,
            fulfilled: fulfilled,
            cancelled: cancelled,
            initiated: initiated,
            totalRevenue: totalRevenue,
            totalDiscounts: totalDiscounts
        };
    };
    return {
        // State
        transactions: transactionHistory,
        meta: historyMeta,
        loading: historyLoading,
        filters: filters,
        stats: getStats(),
        updateFilter: // Actions
        updateFilter,
        resetFilters: resetFilters,
        refreshTransactions: refreshTransactions,
        fetchTransactions: fetchTransactions,
        onApplyFilter: onApplyFilter
    };
};






var $acw62 = parcelRequire("acw62");

function $f5c2221eee2caf74$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, transaction: transaction, loading: loading }) {
    // Handle ESC key press
    (0, $acw62.useEffect)(()=>{
        const handleEscKey = (event)=>{
            if (event.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }
        return ()=>{
            document.removeEventListener('keydown', handleEscKey);
            document.body.style.overflow = 'unset';
        };
    }, [
        isOpen,
        onClose
    ]);
    if (!isOpen) return null;
    // Normalize transaction data - handle both summary format and history format
    const normalizeTransaction = (txn)=>{
        if (!txn) return null;
        // If it's already in summary format, return as is
        if (txn.financial_summary || txn.business_earnings) return txn;
        // If it's in history format, normalize it
        return {
            uuid: txn.uuid,
            reference_id: txn.reference_id,
            mobile: txn.transaction_details?.mobile || txn.mobile,
            status: txn.transaction_details?.status,
            status_label: txn.transaction_details?.status_label,
            created_at: txn.transaction_details?.created_at || txn.date_time,
            fulfilled_at: txn.transaction_details?.fulfilled_at,
            customer: txn.customer_info ? {
                name: txn.customer_info.name,
                mobile: txn.customer_info.mobile
            } : txn.customer_name ? {
                name: txn.customer_name,
                mobile: txn.mobile
            } : null,
            financial_summary: txn.financial_details ? {
                billable_amount: txn.financial_details.billable_amount,
                customer_savings: txn.financial_details.customer_discount,
                platform_commission: txn.financial_details.company_commission,
                final_amount: txn.financial_details.final_amount
            } : txn.bill_amount ? {
                billable_amount: {
                    formatted: `\u{20B9}${txn.bill_amount.toLocaleString('en-IN')}`
                },
                customer_savings: {
                    formatted: `\u{20B9}${(txn.customer_discount || 0).toLocaleString('en-IN')}`
                },
                platform_commission: {
                    formatted: `\u{20B9}${(txn.platform_commission || 0).toLocaleString('en-IN')}`
                },
                final_amount: {
                    formatted: `\u{20B9}${txn.final_amount.toLocaleString('en-IN')}`
                }
            } : null,
            discount_details: txn.discount_info ? {
                discount_text: txn.discount_info.discount_text,
                discount_id: txn.discount_info.discount_id
            } : null,
            business_earnings: txn.calculations ? {
                gross_amount: txn.financial_details?.billable_amount?.amount || '0',
                customer_discount_given: txn.calculations.savings_for_customer,
                platform_commission_paid: txn.calculations.commission_to_platform,
                net_received: txn.calculations.earnings_for_business
            } : null
        };
    };
    const normalizedTransaction = normalizeTransaction(transaction);
    const getStatusIcon = (status)=>{
        switch(status){
            case 'FULFILLED':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-green-600"
                });
            case 'CANCELLED':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-red-600"
                });
            case 'INITIATED':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-blue-600"
                });
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-gray-600"
                });
        }
    };
    const getStatusColor = (status)=>{
        switch(status){
            case 'FULFILLED':
                return 'text-green-600 bg-green-50 border-green-200';
            case 'CANCELLED':
                return 'text-red-600 bg-red-50 border-red-200';
            case 'INITIATED':
                return 'text-blue-600 bg-blue-50 border-blue-200';
            default:
                return 'text-gray-600 bg-gray-50 border-gray-200';
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        onClick: (e)=>{
            // Close modal when clicking on backdrop
            if (e.target === e.currentTarget) onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-lg shadow-xl max-w-4xl w-[calc(100%-2rem)] max-h-[92vh] sm:max-h-[90vh] overflow-hidden sm:w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between p-4 sm:p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-lg sm:text-xl font-semibold text-gray-900",
                            children: "Transaction Details"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transition-colors min-h-[44px] min-w-[44px] touch-manipulation",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "h-5 w-5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-4 sm:p-6 overflow-y-auto max-h-[calc(92vh-140px)] sm:max-h-[calc(90vh-120px)]",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center py-8 sm:py-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {
                                size: "lg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-3 text-gray-600 text-sm sm:text-base",
                                children: "Loading transaction details..."
                            })
                        ]
                    }) : !normalizedTransaction ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-center py-8 sm:py-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 sm:h-12 sm:w-12 text-red-500 mx-auto mb-3 sm:mb-4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-base sm:text-lg font-semibold text-gray-900 mb-2",
                                children: "Unable to load transaction details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 text-sm sm:text-base px-2",
                                children: "There was an error loading the transaction information."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4 sm:space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mb-3 sm:mb-4",
                                        children: getStatusIcon(normalizedTransaction.status)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-xl sm:text-2xl font-bold text-gray-900 mb-2",
                                        children: [
                                            "Transaction ",
                                            normalizedTransaction.status_label || normalizedTransaction.status
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `inline-flex px-3 py-1 text-xs sm:text-sm font-semibold rounded-full border ${getStatusColor(normalizedTransaction.status)}`,
                                        children: normalizedTransaction.status_label || normalizedTransaction.status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-gray-50 rounded-lg p-3 sm:p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "font-semibold text-gray-900 mb-3 text-sm sm:text-base",
                                        children: "Transaction Information"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: "Reference ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-mono text-xs sm:text-sm text-blue-700 bg-blue-50 px-2 py-1 rounded inline-block",
                                                        children: normalizedTransaction.reference_id || 'N/A'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: "Mobile Number"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-900",
                                                        children: normalizedTransaction.mobile || 'N/A'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: "Created At"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-900",
                                                        children: formatDate(normalizedTransaction.created_at)
                                                    })
                                                ]
                                            }),
                                            normalizedTransaction.fulfilled_at && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: normalizedTransaction.status === 'FULFILLED' ? 'Completed At' : 'Updated At'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-900",
                                                        children: formatDate(normalizedTransaction.fulfilled_at)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            normalizedTransaction.customer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-blue-50 rounded-lg p-3 sm:p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "font-semibold text-blue-900 mb-3 text-sm sm:text-base",
                                        children: "Customer Information"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-blue-700",
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-medium text-blue-900 text-sm sm:text-base",
                                                        children: normalizedTransaction.customer.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-blue-700",
                                                        children: "Mobile"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-blue-900",
                                                        children: normalizedTransaction.customer.mobile
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            normalizedTransaction.financial_summary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-green-50 rounded-lg p-3 sm:p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "font-semibold text-green-900 mb-3 text-sm sm:text-base",
                                        children: "Financial Summary"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 sm:space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-green-700 text-xs sm:text-sm",
                                                        children: "Billable Amount:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-green-900 text-sm sm:text-base",
                                                        children: normalizedTransaction.financial_summary.billable_amount.formatted
                                                    })
                                                ]
                                            }),
                                            normalizedTransaction.financial_summary.customer_savings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-green-700 text-xs sm:text-sm",
                                                        children: "Customer Savings:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-medium text-green-600 text-sm sm:text-base",
                                                        children: [
                                                            "-",
                                                            normalizedTransaction.financial_summary.customer_savings.formatted
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "border-t border-green-200 pt-2 sm:pt-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex justify-between items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-base sm:text-lg font-semibold text-green-900",
                                                            children: "Final Amount:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-lg sm:text-xl font-bold text-green-600",
                                                            children: normalizedTransaction.financial_summary.final_amount.formatted
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            normalizedTransaction.business && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-gray-50 rounded-lg p-3 sm:p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "font-semibold text-gray-900 mb-3 text-sm sm:text-base",
                                        children: "Business Information"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: "Business Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-medium text-gray-900 text-sm sm:text-base",
                                                        children: normalizedTransaction.business.business_name
                                                    })
                                                ]
                                            }),
                                            normalizedTransaction.business.address && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: "Address"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-900",
                                                        children: normalizedTransaction.business.address
                                                    })
                                                ]
                                            }),
                                            normalizedTransaction.business.whatsapp_number && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-600",
                                                        children: "WhatsApp"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs sm:text-sm text-gray-900",
                                                        children: normalizedTransaction.business.whatsapp_number
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex justify-end p-4 sm:p-6 border-t border-gray-200",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: onClose,
                        className: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors min-h-[44px] touch-manipulation",
                        children: "Close"
                    })
                })
            ]
        })
    });
}





function $e8f8f8678902f50b$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { transactionSummary: transactionSummary, summaryLoading: summaryLoading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.transaction);
    const { transactions: transactions, meta: meta, loading: loading, filters: filters, stats: stats, updateFilter: updateFilter, resetFilters: resetFilters, refreshTransactions: refreshTransactions, onApplyFilter: onApplyFilter } = (0, $427ef751d3f7b307$export$eaffe3535a5f75b0)();
    const [modalOpen, setModalOpen] = (0, $acw62.useState)(false);
    const [selectedTransactionId, setSelectedTransactionId] = (0, $acw62.useState)(null);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = filters.per_page || 15;
    const handlePageChange = (page)=>{
        updateFilter('page', page);
        navigate(`?page=${page}`);
    };
    // Client-side date filtering is now done by backend via filter parameter
    // No need for client-side date filtering anymore
    // Use server-side pagination metadata
    const totalRecords = meta?.total || 0;
    const totalPages = meta?.last_page || 1;
    const validPage = Math.min(Math.max(1, currentPage), totalPages);
    // For display, use the transactions from current page (already paginated from server)
    const paginatedTransactions = transactions;
    const handleViewTransaction = async (transactionUuid)=>{
        setSelectedTransactionId(transactionUuid);
        setModalOpen(true);
        // Fetch detailed transaction data
        await dispatch((0, $3b948c371c69daa7$export$a1b16a49f384bd24)(transactionUuid));
    };
    const handleContinueTransaction = (transactionUuid)=>{
        navigate(`/business/transactions?uuid=${transactionUuid}`);
    };
    const handleCloseModal = ()=>{
        setModalOpen(false);
        setSelectedTransactionId(null);
    };
    const getStatusIcon = (status)=>{
        switch(status){
            case 'FULFILLED':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-green-600"
                });
            case 'CANCELLED':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-red-600"
                });
            case 'INITIATED':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-blue-600"
                });
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-gray-600"
                });
        }
    };
    const getStatusColor = (status)=>{
        switch(status){
            case 'FULFILLED':
                return 'text-green-600 bg-green-50 border-green-200';
            case 'CANCELLED':
                return 'text-red-600 bg-red-50 border-red-200';
            case 'INITIATED':
                return 'text-blue-600 bg-blue-50 border-blue-200';
            default:
                return 'text-gray-600 bg-gray-50 border-gray-200';
        }
    };
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };
    const formatDate = (dateString)=>{
        return new Date(dateString).toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    const getTransactionAmount = (transaction)=>{
        return parseFloat(transaction.bill_amount || 0);
    };
    const getFinalAmount = (transaction)=>{
        return parseFloat(transaction.final_amount || 0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "theme-card rounded-lg p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                    className: "h-8 w-8 text-blue-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-2xl font-bold text-gray-900",
                                            children: "Transaction History"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-gray-600 mt-1",
                                            children: "View and manage all your transactions"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center space-x-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: refreshTransactions,
                                disabled: loading,
                                className: "p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg disabled:opacity-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                    className: `h-5 w-5 ${loading ? 'animate-spin' : ''}`
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "theme-card rounded-lg p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-600",
                                            children: "Total Transactions"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-2xl font-bold text-gray-900",
                                            children: stats.total
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-blue-100 p-3 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 text-blue-600"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "theme-card rounded-lg p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-600",
                                            children: "Total Revenue"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-2xl font-bold text-green-600",
                                            children: formatCurrency(stats.totalRevenue)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-green-100 p-3 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 text-green-600"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "theme-card rounded-lg p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex items-center gap-2 text-gray-600 mb-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs font-medium uppercase whitespace-nowrap",
                            children: "Filter by Date:"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec79b05ad1d6a85$export$2e2bcd8739ae039), {
                        selectedFilter: filters.filter,
                        onFilterChange: (value)=>updateFilter('filter', value),
                        customDates: filters.customDates,
                        onCustomDatesChange: (value)=>updateFilter('customDates', value),
                        onApplyFilter: onApplyFilter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "theme-card rounded-lg p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                            className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            placeholder: "Search by customer, mobile, or transaction ID...",
                            value: filters.search,
                            onChange: (e)=>updateFilter('search', e.target.value),
                            className: "pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "theme-card rounded-lg overflow-hidden",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-center py-12",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "ml-3 text-gray-600",
                            children: "Loading transactions..."
                        })
                    ]
                }) : paginatedTransactions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-center py-12",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                            className: "h-12 w-12 mx-auto mb-4 text-gray-300"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-500",
                            children: "No transactions found for the selected filters."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50 border-b border-gray-200",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "#"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Reference ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Customer"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Mobile"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Bill Amount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Customer Discount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Final Amount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Platform Commission"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Settlement"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "bg-white divide-y divide-gray-200",
                                children: paginatedTransactions.map((transaction, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-400 font-mono text-xs whitespace-nowrap",
                                                children: idx + 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-mono text-xs text-blue-700 bg-blue-50 px-2 py-0.5 rounded",
                                                    children: transaction.reference_id
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-800 whitespace-nowrap",
                                                children: transaction.customer_name || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-600 font-mono whitespace-nowrap",
                                                children: transaction.mobile || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-semibold text-gray-900 whitespace-nowrap",
                                                children: formatCurrency(getTransactionAmount(transaction))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "px-6 py-4 whitespace-nowrap",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-green-700 font-medium",
                                                        children: formatCurrency(transaction.customer_discount || 0)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs text-gray-400 ml-1",
                                                        children: [
                                                            "(",
                                                            transaction.bill_amount ? ((transaction.customer_discount || 0) / transaction.bill_amount * 100).toFixed(1) : 0,
                                                            "%)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-bold text-emerald-700 whitespace-nowrap",
                                                children: formatCurrency(getFinalAmount(transaction))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500 whitespace-nowrap text-xs",
                                                children: formatDate(transaction.date_time)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "px-6 py-4 whitespace-nowrap",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-orange-600 font-medium",
                                                        children: formatCurrency(transaction.platform_commission || 0)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs text-gray-400 ml-1",
                                                        children: [
                                                            "(",
                                                            transaction.bill_amount ? ((transaction.platform_commission || 0) / transaction.bill_amount * 100).toFixed(1) : 0,
                                                            "%)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "inline-flex px-2 py-1 text-xs font-semibold rounded-full border bg-green-50 text-green-600 border-green-200",
                                                    children: transaction.settlement_status || 'Pending'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm font-medium",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: ()=>handleViewTransaction(transaction.uuid),
                                                    className: "text-blue-600 hover:text-blue-900 flex items-center space-x-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "View"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, transaction.uuid))
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: validPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5c2221eee2caf74$export$2e2bcd8739ae039), {
                isOpen: modalOpen,
                onClose: handleCloseModal,
                transaction: transactionSummary,
                loading: summaryLoading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $16a4254ed68deb70$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $16a4254ed68deb70$export$250ffa63cdc0d034 = $16a4254ed68deb70$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $16a4254ed68deb70$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $16a4254ed68deb70$export$be92b6f5f03c0fe9 = $16a4254ed68deb70$export$250ffa63cdc0d034;





"use client";
var $d03a4306ca42645f$var$COLLAPSIBLE_NAME = "Collapsible";
var [$d03a4306ca42645f$var$createCollapsibleContext, $d03a4306ca42645f$export$952b32dcbe73087a] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($d03a4306ca42645f$var$COLLAPSIBLE_NAME);
var [$d03a4306ca42645f$var$CollapsibleProvider, $d03a4306ca42645f$var$useCollapsibleContext] = $d03a4306ca42645f$var$createCollapsibleContext($d03a4306ca42645f$var$COLLAPSIBLE_NAME);
var $d03a4306ca42645f$export$6eb0f7ddcda6131f = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, open: openProp, defaultOpen: defaultOpen, disabled: disabled, onOpenChange: onOpenChange, ...collapsibleProps } = props;
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $d03a4306ca42645f$var$COLLAPSIBLE_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($d03a4306ca42645f$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $16a4254ed68deb70$export$250ffa63cdc0d034).div, {
            "data-state": $d03a4306ca42645f$var$getState(open),
            "data-disabled": disabled ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
        })
    });
});
$d03a4306ca42645f$export$6eb0f7ddcda6131f.displayName = $d03a4306ca42645f$var$COLLAPSIBLE_NAME;
var $d03a4306ca42645f$var$TRIGGER_NAME = "CollapsibleTrigger";
var $d03a4306ca42645f$export$c135dce7b15bbbdc = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, ...triggerProps } = props;
    const context = $d03a4306ca42645f$var$useCollapsibleContext($d03a4306ca42645f$var$TRIGGER_NAME, __scopeCollapsible);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $16a4254ed68deb70$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $d03a4306ca42645f$var$getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$d03a4306ca42645f$export$c135dce7b15bbbdc.displayName = $d03a4306ca42645f$var$TRIGGER_NAME;
var $d03a4306ca42645f$var$CONTENT_NAME = "CollapsibleContent";
var $d03a4306ca42645f$export$aadde00976f34151 = $acw62.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $d03a4306ca42645f$var$useCollapsibleContext($d03a4306ca42645f$var$CONTENT_NAME, props.__scopeCollapsible);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: ({ present: present })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($d03a4306ca42645f$var$CollapsibleContentImpl, {
                ...contentProps,
                ref: forwardedRef,
                present: present
            })
    });
});
$d03a4306ca42645f$export$aadde00976f34151.displayName = $d03a4306ca42645f$var$CONTENT_NAME;
var $d03a4306ca42645f$var$CollapsibleContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, present: present, children: children, ...contentProps } = props;
    const context = $d03a4306ca42645f$var$useCollapsibleContext($d03a4306ca42645f$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = $acw62.useState(present);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = $acw62.useRef(0);
    const height = heightRef.current;
    const widthRef = $acw62.useRef(0);
    const width = widthRef.current;
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = $acw62.useRef(isOpen);
    const originalStylesRef = $acw62.useRef(void 0);
    $acw62.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            };
            node.style.transitionDuration = "0s";
            node.style.animationName = "none";
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width;
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    }, [
        context.open,
        present
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $16a4254ed68deb70$export$250ffa63cdc0d034).div, {
        "data-state": $d03a4306ca42645f$var$getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        id: context.contentId,
        hidden: !isOpen,
        ...contentProps,
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
            ...props.style
        },
        children: isOpen && children
    });
});
function $d03a4306ca42645f$var$getState(open) {
    return open ? "open" : "closed";
}
var $d03a4306ca42645f$export$be92b6f5f03c0fe9 = $d03a4306ca42645f$export$6eb0f7ddcda6131f;
var $d03a4306ca42645f$export$41fb9f06171c75f4 = $d03a4306ca42645f$export$c135dce7b15bbbdc;
var $d03a4306ca42645f$export$7c6e2c02157bb7d2 = $d03a4306ca42645f$export$aadde00976f34151;







var $i32x1 = parcelRequire("i32x1");

var $bVR6A = parcelRequire("bVR6A");



var $acw62 = parcelRequire("acw62");
function $9818bc4b6c0da160$export$2e2bcd8739ae039({ type: type, data: data, onSave: onSave, onCancel: onCancel, loading: loading = false }) {
    const [formData, setFormData] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        if (data && type) switch(type){
            case 'contact':
                setFormData({
                    contact_numbers: data.contact_numbers || [],
                    email: data.email || '',
                    website: data.website || '',
                    pincode: data.pincode || ''
                });
                break;
            case 'discount':
                setFormData({
                    discount_text: data.active_discount?.discount_text || '',
                    fixed_discount: data.active_discount?.fixed_discount || '',
                    customer_discount: data.active_discount?.customer_discount || '',
                    company_commission: data.active_discount?.company_commission || ''
                });
                break;
            case 'timings':
                setFormData(data.shop_timings || {});
                break;
            case 'gallery':
                setFormData({
                    gallery_images: data.gallery_images || []
                });
                break;
            default:
                setFormData({});
        }
    }, [
        data,
        type
    ]);
    const handleInputChange = (field, value)=>{
        setFormData((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const handleContactNumbersChange = (value)=>{
        const numbers = value.split(',').map((num)=>num.trim()).filter((num)=>num);
        setFormData((prev)=>({
                ...prev,
                contact_numbers: numbers
            }));
    };
    const handleTimingChange = (day, field, value)=>{
        setFormData((prev)=>({
                ...prev,
                [day]: {
                    ...prev[day],
                    [field]: value
                }
            }));
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSave(formData);
    };
    const renderContactForm = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Contact Numbers (comma separated)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: formData.contact_numbers?.join(', ') || '',
                            onChange: (e)=>handleContactNumbersChange(e.target.value),
                            placeholder: "e.g., 1234567890, 0987654321",
                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "email",
                            value: formData.email || '',
                            onChange: (e)=>handleInputChange('email', e.target.value),
                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Website"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "url",
                            value: formData.website || '',
                            onChange: (e)=>handleInputChange('website', e.target.value),
                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Pincode"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: formData.pincode || '',
                            onChange: (e)=>handleInputChange('pincode', e.target.value),
                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        })
                    ]
                })
            ]
        });
    const renderDiscountForm = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Discount Text"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: formData.discount_text || '',
                            onChange: (e)=>handleInputChange('discount_text', e.target.value),
                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Fixed Discount (%)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "number",
                                    value: formData.fixed_discount || '',
                                    onChange: (e)=>handleInputChange('fixed_discount', e.target.value),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Customer Discount (%)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "number",
                                    value: formData.customer_discount || '',
                                    onChange: (e)=>handleInputChange('customer_discount', e.target.value),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Company Commission (%)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "number",
                                    value: formData.company_commission || '',
                                    onChange: (e)=>handleInputChange('company_commission', e.target.value),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    const renderTimingsForm = ()=>{
        const days = [
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday'
        ];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "space-y-3",
            children: days.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center space-x-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-20 text-sm font-medium capitalize",
                            children: day.slice(0, 3)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "time",
                                    value: formData[day]?.open || '',
                                    onChange: (e)=>handleTimingChange(day, 'open', e.target.value),
                                    className: "px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-gray-500",
                                    children: "to"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "time",
                                    value: formData[day]?.close || '',
                                    onChange: (e)=>handleTimingChange(day, 'close', e.target.value),
                                    className: "px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                })
                            ]
                        })
                    ]
                }, day))
        });
    };
    const renderGalleryForm = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Gallery Images"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "file",
                            multiple: true,
                            accept: "image/*",
                            onChange: (e)=>{
                                // Handle file upload logic here
                                console.log('Files selected:', e.target.files);
                            },
                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "grid grid-cols-4 gap-2",
                    children: formData.gallery_images?.map((img, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: img.image,
                                    alt: `Gallery ${index + 1}`,
                                    className: "w-full h-20 object-cover rounded"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        const newImages = formData.gallery_images.filter((_, i)=>i !== index);
                                        setFormData((prev)=>({
                                                ...prev,
                                                gallery_images: newImages
                                            }));
                                    },
                                    className: "absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs",
                                    children: "\xd7"
                                })
                            ]
                        }, index))
                })
            ]
        });
    const getFormTitle = ()=>{
        switch(type){
            case 'contact':
                return 'Edit Contact Information';
            case 'discount':
                return 'Edit Discount Settings';
            case 'timings':
                return 'Edit Shop Timings';
            case 'gallery':
                return 'Edit Gallery Images';
            default:
                return 'Edit';
        }
    };
    const renderForm = ()=>{
        switch(type){
            case 'contact':
                return renderContactForm();
            case 'discount':
                return renderDiscountForm();
            case 'timings':
                return renderTimingsForm();
            case 'gallery':
                return renderGalleryForm();
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "Unknown form type"
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                renderForm(),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-end space-x-2 pt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onCancel,
                            disabled: loading,
                            className: "rounded border px-4 py-2 text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: loading,
                            className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                            children: loading ? 'Saving...' : 'Save Changes'
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");






var $bVR6A = parcelRequire("bVR6A");
// Validation schemas for each modal type
const $48f24ed007e08f6c$var$contactSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    contact_numbers: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3().max(10, "Contact number must be max 10 digits")).nullable(),
    whatsapp: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().max(10, "WhatsApp number must be max 10 digits"),
    email: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().email("Enter a valid email"),
    website: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().url("Enter a valid URL")
});
const $48f24ed007e08f6c$var$discountSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    discount_text: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "Discount text must be less than 255 characters").nullable(),
    fixed_discount: $cda9d0e1103d595f$export$98e628dec113755e().min(0, "Must be 0 or more").nullable(),
    customer_discount: $cda9d0e1103d595f$export$98e628dec113755e().min(0, "Must be 0 or more").nullable(),
    company_commission: $cda9d0e1103d595f$export$98e628dec113755e().min(0, "Must be 0 or more").nullable()
});
const $48f24ed007e08f6c$var$gallerySchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    gallery: $cda9d0e1103d595f$export$9b30b6294c1449a8().nullable(),
    remove_images: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable()
});
const $48f24ed007e08f6c$var$businessInfoSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    business_name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Business name is required").max(20, "Business name cannot exceed 20 characters"),
    about_business: $cda9d0e1103d595f$export$22b082955e083ec3().max(255, "About business must be less than 255 characters").nullable(),
    username: $cda9d0e1103d595f$export$22b082955e083ec3().required("Mobile number is required").matches(/^[0-9]+$/, "Mobile number must contain only digits").min(10, "Mobile number must be exactly 10 digits").max(10, "Mobile number must be exactly 10 digits"),
    is_trending: $cda9d0e1103d595f$export$87b259aa03e3d267(),
    is_recently_added: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
const $48f24ed007e08f6c$var$businessSettingsSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    subscription_package_id: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    payment_modes: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable(),
    business_timings: $cda9d0e1103d595f$export$be5493f9613cbbe().nullable()
});
const $48f24ed007e08f6c$var$locationSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    state_id: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    district_id: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    taluka_id: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    address: $cda9d0e1103d595f$export$22b082955e083ec3().max(500, "Address must be less than 500 characters").nullable(),
    pincode: $cda9d0e1103d595f$export$22b082955e083ec3().max(6, "Pincode must be max 6 digits").nullable(),
    business_location_map: $cda9d0e1103d595f$export$22b082955e083ec3().url("Enter a valid URL").nullable(),
    latitude: $cda9d0e1103d595f$export$98e628dec113755e().transform((value, originalValue)=>{
        return originalValue === '' ? null : value;
    }).min(-90).max(90).nullable(),
    longitude: $cda9d0e1103d595f$export$98e628dec113755e().transform((value, originalValue)=>{
        return originalValue === '' ? null : value;
    }).min(-180).max(180).nullable()
});
const $48f24ed007e08f6c$var$categoriesServicesSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    category_id: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    sub_categories: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable(),
    services: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable()
});
const $48f24ed007e08f6c$export$bb0a7a5dca73e018 = ({ data: data, onSave: onSave, loading: loading = false })=>{
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($48f24ed007e08f6c$var$contactSchema),
        defaultValues: {
            contact_numbers: Array.isArray(data?.contact_numbers) ? data.contact_numbers.filter(Boolean) : [
                data?.contact_numbers || ""
            ].filter(Boolean).length > 0 ? [
                data?.contact_numbers
            ] : [
                ""
            ],
            email: data?.email || "",
            website: data?.website || "",
            whatsapp: data?.whatsapp_number || data?.whatsapp || ""
        }
    });
    // Reset form when data changes
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            contact_numbers: Array.isArray(data?.contact_numbers) ? data.contact_numbers.filter(Boolean) : [
                data?.contact_numbers || ""
            ].filter(Boolean).length > 0 ? [
                data?.contact_numbers
            ] : [
                ""
            ],
            email: data?.email || "",
            website: data?.website || "",
            whatsapp: data?.whatsapp_number || data?.whatsapp || ""
        });
    }, [
        data,
        reset
    ]);
    const { fields: contactNumbers, append: appendContactNumber, remove: removeContactNumber } = (0, $0d70f179cf56e662$export$310131896651d559)({
        name: "contact_numbers",
        control: control
    });
    (0, $acw62.useEffect)(()=>{
        if (contactNumbers.length === 0) appendContactNumber("");
    }, [
        contactNumbers.length,
        appendContactNumber
    ]);
    const onSubmit = (formData)=>{
        // Clean and validate contact numbers
        const cleanedData = {};
        if (formData.contact_numbers && formData.contact_numbers.length > 0) {
            const filteredNumbers = formData.contact_numbers.filter((num)=>num && num.trim() !== '');
            if (filteredNumbers.length > 0) cleanedData.contact_numbers = filteredNumbers;
        }
        if (formData.whatsapp && formData.whatsapp.trim() !== '') cleanedData.whatsapp = formData.whatsapp;
        if (formData.email && formData.email.trim() !== '') cleanedData.email = formData.email;
        if (formData.website && formData.website.trim() !== '') cleanedData.website = formData.website;
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Contact Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update business contact details"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-between mb-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    "Contact Numbers ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-red-500",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>appendContactNumber(""),
                                className: "text-blue-600 text-sm hover:text-blue-800",
                                children: "+ Add Number"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-2",
                        children: contactNumbers.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                        placeholder: "10-digit number",
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                        maxLength: 10,
                                        ...register(`contact_numbers.${index}`),
                                        error: errors?.contact_numbers?.[index]?.message
                                    }),
                                    contactNumbers.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>removeContactNumber(index),
                                        className: "text-red-600 text-sm hover:text-red-800 px-3 py-2 border border-red-300 rounded",
                                        children: "Remove"
                                    })
                                ]
                            }, field.id))
                    }),
                    errors?.contact_numbers && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.contact_numbers.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "WhatsApp Number",
                        placeholder: "10-digit number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 10,
                        ...register("whatsapp"),
                        error: errors?.whatsapp?.message
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Email",
                        placeholder: "example@domain.com",
                        ...register("email"),
                        error: errors?.email?.message
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Website",
                        placeholder: "https://example.com",
                        ...register("website"),
                        error: errors?.website?.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $48f24ed007e08f6c$export$3ed9e6b84623644d = ({ data: data, onSave: onSave, loading: loading = false })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, watch: watch, setValue: setValue, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($48f24ed007e08f6c$var$discountSchema),
        defaultValues: {
            discount_text: data?.active_discount?.discount_text || "",
            fixed_discount: data?.active_discount?.fixed_discount || "",
            customer_discount: data?.active_discount?.customer_discount || "",
            company_commission: data?.active_discount?.company_commission || ""
        }
    });
    // Check if business is Premium - check both subscription_package.name and mode
    const isPremium = data?.subscription_package?.name === "Premium" || data?.mode === "Premium";
    // Reset form when data changes
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            discount_text: data?.active_discount?.discount_text || "",
            fixed_discount: data?.active_discount?.fixed_discount || "",
            customer_discount: data?.active_discount?.customer_discount || "",
            company_commission: data?.active_discount?.company_commission || ""
        });
    }, [
        data,
        reset
    ]);
    // Watch customer discount and company commission to auto-calculate fixed discount
    const customerDiscount = watch("customer_discount");
    const companyCommission = watch("company_commission");
    (0, $acw62.useEffect)(()=>{
        if (isPremium) {
            const customer = parseFloat(customerDiscount) || 0;
            const company = parseFloat(companyCommission) || 0;
            const total = customer + company;
            setValue("fixed_discount", total > 0 ? total : "");
        }
    }, [
        customerDiscount,
        companyCommission,
        isPremium,
        setValue
    ]);
    const onSubmit = (formData)=>{
        // Clean and validate discount data
        const cleanedData = {};
        if (formData.discount_text && formData.discount_text.trim() !== '') cleanedData.discount_text = formData.discount_text;
        if (formData.fixed_discount !== undefined && formData.fixed_discount !== null && formData.fixed_discount !== '') cleanedData.fixed_discount = formData.fixed_discount;
        if (formData.customer_discount !== undefined && formData.customer_discount !== null && formData.customer_discount !== '') cleanedData.customer_discount = formData.customer_discount;
        // Only include company_commission if Premium
        if (isPremium && formData.company_commission !== undefined && formData.company_commission !== null && formData.company_commission !== '') cleanedData.company_commission = formData.company_commission;
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Discount Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update discount offers and commission rates"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                    label: "Discount Text",
                    placeholder: "e.g., Flat 10% off on all items",
                    maxLength: 32,
                    ...register("discount_text"),
                    error: errors?.discount_text?.message
                })
            }),
            isPremium ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "Customer Discount (%)",
                                type: "number",
                                min: 0,
                                step: "0.01",
                                placeholder: "0",
                                ...register("customer_discount", {
                                    setValueAs: (v)=>v === "" ? null : parseFloat(v)
                                }),
                                error: errors?.customer_discount?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "Company Commission (%)",
                                type: "number",
                                min: 0,
                                step: "0.01",
                                placeholder: "0",
                                ...register("company_commission", {
                                    setValueAs: (v)=>v === "" ? null : parseFloat(v)
                                }),
                                error: errors?.company_commission?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "Fixed Discount (%)",
                                type: "number",
                                min: 0,
                                step: "0.01",
                                placeholder: "0",
                                disabled: true,
                                readOnly: true,
                                ...register("fixed_discount", {
                                    setValueAs: (v)=>v === "" ? null : parseFloat(v)
                                }),
                                error: errors?.fixed_discount?.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1",
                        children: "* Fixed Discount is automatically calculated as Customer Discount + Company Commission"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-blue-50 border border-blue-200 rounded-lg p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-blue-800",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Note:"
                        }),
                        " Discount percentages are only available for Premium businesses. Upgrade to Premium to access Customer Discount, Company Commission, and Fixed Discount features."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $48f24ed007e08f6c$export$229cdb157864b137 = ({ data: data, onSave: onSave, loading: loading = false })=>{
    const [existingImages, setExistingImages] = (0, $acw62.useState)(data?.gallery_images || []);
    const [newImages, setNewImages] = (0, $acw62.useState)([]);
    const [imagesToRemove, setImagesToRemove] = (0, $acw62.useState)([]);
    const handleRemoveExistingImage = (imageUuid)=>{
        setExistingImages((prev)=>prev.filter((img)=>img.uuid !== imageUuid));
        setImagesToRemove((prev)=>[
                ...prev,
                imageUuid
            ]);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        // Validate and clean gallery data
        const cleanedData = {
            gallery: newImages || [],
            remove_images: imagesToRemove || []
        };
        console.log('Gallery form submission:', {
            existingImages: existingImages.length,
            newImages: newImages?.length || 0,
            imagesToRemove: imagesToRemove.length,
            cleanedData: cleanedData
        });
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Gallery Images"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Manage business gallery photos (max 5 images)"
                    })
                ]
            }),
            existingImages.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Current Images"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4",
                        children: existingImages.map((img)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "aspect-square",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: img.image,
                                            alt: "Gallery",
                                            className: "w-full h-full object-cover rounded-lg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>handleRemoveExistingImage(img.uuid),
                                        className: "absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600 transition-colors",
                                        children: "\xd7"
                                    })
                                ]
                            }, img.uuid))
                    })
                ]
            }),
            existingImages.length < 5 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e49ca7aad3643dc7$export$3019c26e674dcdde), {
                    label: existingImages.length > 0 ? "Add More Images" : "Add New Images",
                    value: newImages,
                    onChange: setNewImages,
                    hint: `Drop up to ${5 - existingImages.length} images or click to browse`,
                    maxFiles: 5 - existingImages.length
                })
            }),
            existingImages.length >= 5 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center py-4 text-gray-500",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Maximum of 5 images allowed. Remove some existing images to add new ones."
                })
            }),
            existingImages.length === 0 && (!newImages || newImages.length === 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center py-8 text-gray-500",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "No gallery images found. Add some images to showcase your business."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $48f24ed007e08f6c$export$ce55fa95e70ee20c = ({ data: data, onSave: onSave, loading: loading = false })=>{
    console.log('BusinessInfoEditForm received data:', data);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($48f24ed007e08f6c$var$businessInfoSchema),
        defaultValues: {
            business_name: data?.business_name || "",
            about_business: data?.about_business || "",
            username: data?.username || "",
            is_trending: Boolean(data?.is_trending === true || data?.is_trending === 1 || data?.is_trending === '1'),
            is_recently_added: Boolean(data?.is_recently_added === true || data?.is_recently_added === 1 || data?.is_recently_added === '1')
        }
    });
    // Reset form when data changes
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            business_name: data?.business_name || "",
            about_business: data?.about_business || "",
            username: data?.username || "",
            is_trending: Boolean(data?.is_trending === true || data?.is_trending === 1 || data?.is_trending === '1'),
            is_recently_added: Boolean(data?.is_recently_added === true || data?.is_recently_added === 1 || data?.is_recently_added === '1')
        });
    }, [
        data,
        reset
    ]);
    const onSubmit = (formData)=>{
        // Clean and validate business info data
        const cleanedData = {
            business_name: formData.business_name,
            about_business: formData.about_business || '',
            username: formData.username,
            is_trending: Boolean(formData.is_trending),
            is_recently_added: Boolean(formData.is_recently_added)
        };
        console.log('Business Info Form Data:', formData);
        console.log('Cleaned Data:', cleanedData);
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Business Information"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update basic business details and settings"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                    label: "Business Name",
                    required: true,
                    placeholder: "Enter business name",
                    maxLength: 20,
                    ...register("business_name"),
                    error: errors?.business_name?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                    label: "Username",
                    required: true,
                    placeholder: "10-digit mobile number",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                    ...register("username"),
                    error: errors?.username?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                    label: "About Business",
                    rows: 3,
                    placeholder: "Describe your business...",
                    ...register("about_business"),
                    error: errors?.about_business?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "is_trending",
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                    label: "Add to Trending",
                                    checked: Boolean(field.value),
                                    onChange: (checked)=>{
                                        console.log('is_trending changed to:', checked);
                                        field.onChange(checked);
                                    }
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "is_recently_added",
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                    label: "Add to Recently Added",
                                    checked: Boolean(field.value),
                                    onChange: (checked)=>{
                                        console.log('is_recently_added changed to:', checked);
                                        field.onChange(checked);
                                    }
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $48f24ed007e08f6c$export$7b3c0d82e34ea765 = ({ data: data, onSave: onSave, loading: loading = false, subscriptionPackages: subscriptionPackages = [], paymentModes: paymentModes = [], dispatch: dispatch })=>{
    const allDays = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ];
    // Initialize business timings with 2 slots per day
    const initializeTimings = (businessData)=>{
        const existingTimings = businessData?.business_timings || {};
        const timings = {};
        allDays.forEach((day)=>{
            const daySlots = existingTimings[day] || [];
            // Ensure we always have 2 slots
            timings[day] = [
                daySlots[0] || {
                    open: '',
                    close: ''
                },
                daySlots[1] || {
                    open: '',
                    close: ''
                }
            ];
        });
        return timings;
    };
    // Filter payment modes to only include valid ones from the API
    const filterValidPaymentModes = (modes)=>{
        if (!Array.isArray(modes)) return [];
        const validModeNames = paymentModes.map((pm)=>pm.name);
        return modes.filter((mode)=>validModeNames.includes(mode));
    };
    const { register: register, control: control, handleSubmit: handleSubmit, watch: watch, setValue: setValue, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($48f24ed007e08f6c$var$businessSettingsSchema),
        defaultValues: {
            subscription_package_id: data?.subscription_package?.uuid || "",
            payment_modes: filterValidPaymentModes(data?.payment_modes),
            business_timings: initializeTimings(data)
        }
    });
    // Reset form when data changes
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            subscription_package_id: data?.subscription_package?.uuid || "",
            payment_modes: filterValidPaymentModes(data?.payment_modes),
            business_timings: initializeTimings(data)
        });
    }, [
        data,
        reset,
        paymentModes
    ]);
    // Filter only active payment modes
    const activePaymentModes = paymentModes.filter((pm)=>pm.status);
    const businessTimings = watch('business_timings') || {};
    const onSubmit = (formData)=>{
        const cleanedData = {};
        // Add subscription package if selected
        if (formData.subscription_package_id && formData.subscription_package_id.trim() !== '') cleanedData.subscription_package_id = formData.subscription_package_id;
        // Add payment modes if selected
        if (formData.payment_modes && formData.payment_modes.length > 0) cleanedData.payment_modes = formData.payment_modes;
        // Format business timings with shift-wise slots
        const formattedTimings = {};
        allDays.forEach((day)=>{
            const daySlots = formData.business_timings[day] || [];
            const validSlots = daySlots.filter((slot)=>slot.open && slot.close);
            if (validSlots.length > 0) formattedTimings[day] = validSlots;
            else formattedTimings[day] = [];
        });
        cleanedData.business_timings = formattedTimings;
        console.log('Business Settings Form Data:', formData);
        console.log('Cleaned Data:', cleanedData);
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Business Settings"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Configure subscription, payment modes, and working hours"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Subscription Package"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "subscription_package_id",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: field.value,
                                onChange: field.onChange,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select Subscription Package"
                                    }),
                                    subscriptionPackages.map((pkg)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: pkg.uuid,
                                            children: pkg.name
                                        }, pkg.uuid))
                                ]
                            })
                    }),
                    errors?.subscription_package_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.subscription_package_id.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Payment Modes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "payment_modes",
                        defaultValue: [],
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$81e0b04a08224b5), {
                                value: field.value,
                                onChange: field.onChange,
                                options: activePaymentModes.map((pm)=>({
                                        label: pm.name,
                                        value: pm.name
                                    })),
                                error: errors?.payment_modes?.message
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-3",
                        children: "Business Timings (Shift-wise)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-xs text-gray-500 mb-3",
                        children: "Configure up to 2 shifts per day. Leave empty if closed."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-4 max-h-96 overflow-y-auto",
                        children: allDays.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border rounded-lg p-3 bg-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm font-semibold text-gray-700 mb-2 capitalize",
                                        children: day
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Slot 1"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.0.open`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Open",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.0.close`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Close",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Slot 2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.1.open`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Open",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        control: control,
                                                        name: `business_timings.${day}.1.close`,
                                                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                type: "time",
                                                                placeholder: "Close",
                                                                value: field.value || "",
                                                                onChange: (e)=>field.onChange(e.target.value || "")
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, day))
                    }),
                    errors?.business_timings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.business_timings.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $48f24ed007e08f6c$export$5a75dea6e9eecbca = ({ data: data, onSave: onSave, loading: loading = false, states: states = [], districts: districts = [], talukas: talukas = [], dispatch: dispatch })=>{
    const { register: register, control: control, handleSubmit: handleSubmit, watch: watch, reset: reset, setValue: setValue, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($48f24ed007e08f6c$var$locationSchema),
        defaultValues: {
            state_id: data?.state?.uuid || "",
            district_id: data?.district?.uuid || "",
            taluka_id: data?.taluka?.uuid || "",
            address: data?.address || "",
            pincode: data?.pincode?.toString() || "",
            business_location_map: data?.business_location_map || data?.business_location_map || "",
            latitude: data?.latitude || null,
            longitude: data?.longitude || null
        }
    });
    // Reset form when data changes
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            state_id: data?.state?.uuid || "",
            district_id: data?.district?.uuid || "",
            taluka_id: data?.taluka?.uuid || "",
            address: data?.address || "",
            pincode: data?.pincode?.toString() || "",
            business_location_map: data?.business_location_map || data?.business_location_map || "",
            latitude: data?.latitude || null,
            longitude: data?.longitude || null
        });
    }, [
        data,
        reset
    ]);
    const selectedStateId = watch('state_id');
    const selectedDistrictId = watch('district_id');
    const currentLatitude = watch('latitude');
    const currentLongitude = watch('longitude');
    // Debug: Log current latitude and longitude values
    (0, $acw62.useEffect)(()=>{
        console.log('Current form values - latitude:', currentLatitude, 'longitude:', currentLongitude);
    }, [
        currentLatitude,
        currentLongitude
    ]);
    // Helper function to generate Google Maps URL
    const getGoogleMapsUrl = (lat, lng)=>{
        return `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    };
    // Handle live location
    const handleGetLocation = ()=>{
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser");
            return;
        }
        navigator.geolocation.getCurrentPosition((position)=>{
            const { latitude: latitude, longitude: longitude } = position.coords;
            console.log('Got location:', {
                latitude: latitude,
                longitude: longitude
            });
            const mapUrl = getGoogleMapsUrl(latitude, longitude);
            setValue("business_location_map", mapUrl);
            setValue("latitude", latitude);
            setValue("longitude", longitude);
            console.log('Set values - latitude:', latitude, 'longitude:', longitude);
        }, (error)=>{
            console.error("Error getting location:", error);
            alert("Unable to retrieve your location. Please check your browser permissions.");
        });
    };
    const onSubmit = (formData)=>{
        console.log('LocationEditForm - Raw form data:', formData);
        // Clean and validate location data
        const cleanedData = {};
        if (formData.state_id && formData.state_id.trim() !== '') cleanedData.state_id = formData.state_id;
        if (formData.district_id && formData.district_id.trim() !== '') cleanedData.district_id = formData.district_id;
        if (formData.taluka_id && formData.taluka_id.trim() !== '') cleanedData.taluka_id = formData.taluka_id;
        if (formData.address && formData.address.trim() !== '') cleanedData.address = formData.address;
        if (formData.pincode && formData.pincode.trim() !== '') cleanedData.pincode = formData.pincode;
        if (formData.business_location_map && formData.business_location_map.trim() !== '') cleanedData.business_location_map = formData.business_location_map;
        // Include latitude and longitude if available (check for valid numbers)
        if (typeof formData.latitude === 'number' && !isNaN(formData.latitude)) {
            cleanedData.latitude = formData.latitude;
            console.log("\u2705 Including latitude:", formData.latitude);
        } else console.log("\u274C Latitude not included:", formData.latitude, typeof formData.latitude);
        if (typeof formData.longitude === 'number' && !isNaN(formData.longitude)) {
            cleanedData.longitude = formData.longitude;
            console.log("\u2705 Including longitude:", formData.longitude);
        } else console.log("\u274C Longitude not included:", formData.longitude, typeof formData.longitude);
        console.log('LocationEditForm - Cleaned data:', cleanedData);
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Location Details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update business address and location information"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "State"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "state_id",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: field.value,
                                onChange: (e)=>{
                                    field.onChange(e.target.value);
                                    if (e.target.value && dispatch) dispatch((0, $bVR6A.fetchDistrictsByState)(e.target.value));
                                },
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select State"
                                    }),
                                    states.map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: state.uuid,
                                            children: state.name
                                        }, state.uuid))
                                ]
                            })
                    }),
                    errors?.state_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.state_id.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "District"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "district_id",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: field.value,
                                onChange: (e)=>{
                                    field.onChange(e.target.value);
                                    if (e.target.value && dispatch) dispatch((0, $bVR6A.fetchTalukasByDistrict)(e.target.value));
                                },
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select District"
                                    }),
                                    districts.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: district.uuid,
                                            children: district.name
                                        }, district.uuid))
                                ]
                            })
                    }),
                    errors?.district_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.district_id.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Taluka"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "taluka_id",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: field.value,
                                onChange: field.onChange,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select Taluka"
                                    }),
                                    talukas.map((taluka)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: taluka.uuid,
                                            children: taluka.name
                                        }, taluka.uuid))
                                ]
                            })
                    }),
                    errors?.taluka_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.taluka_id.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                    label: "Address",
                    rows: 3,
                    placeholder: "Enter full address",
                    ...register("address"),
                    error: errors?.address?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                    label: "Pincode",
                    placeholder: "6-digit pincode",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 6,
                    ...register("pincode"),
                    error: errors?.pincode?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-between mb-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700",
                                children: "Business Location Map URL"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: handleGetLocation,
                                className: "text-blue-600 text-sm hover:text-blue-800 flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-4 w-4",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                                            clipRule: "evenodd"
                                        })
                                    }),
                                    "Get Current Location"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        placeholder: "https://maps.google.com/...",
                        ...register("business_location_map"),
                        error: errors?.business_location_map?.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                ...register("latitude", {
                    setValueAs: (v)=>v === "" || v === null || v === undefined ? null : parseFloat(v)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                ...register("longitude", {
                    setValueAs: (v)=>v === "" || v === null || v === undefined ? null : parseFloat(v)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};
const $48f24ed007e08f6c$export$92bdfb547f6c05ee = ({ data: data, onSave: onSave, loading: loading = false, categories: categories = [], subCategories: subCategories = [], services: services = [], dispatch: dispatch })=>{
    console.log('CategoriesServicesEditForm - data:', data);
    console.log('CategoriesServicesEditForm - categories:', categories);
    console.log('CategoriesServicesEditForm - services:', services);
    const { register: register, control: control, handleSubmit: handleSubmit, watch: watch, reset: reset, setValue: setValue, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($48f24ed007e08f6c$var$categoriesServicesSchema),
        defaultValues: {
            category_id: data?.category?.uuid || "",
            sub_categories: data?.subcategories?.map((cat)=>cat.uuid) || [],
            services: data?.services?.map((service)=>service.uuid) || []
        }
    });
    // Reset form when data changes
    (0, $acw62.useEffect)(()=>{
        if (data) reset({
            category_id: data?.category?.uuid || "",
            sub_categories: data?.subcategories?.map((cat)=>cat.uuid) || [],
            services: data?.services?.map((service)=>service.uuid) || []
        });
    }, [
        data,
        reset
    ]);
    const selectedCategoryId = watch('category_id');
    console.log('Current form values - category:', selectedCategoryId);
    // Create enriched services options that include current shop services
    const enrichedServices = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const serviceMap = new Map();
        // Add all fetched services
        services.forEach((service)=>{
            serviceMap.set(service.uuid, service);
        });
        // Add current shop services if they're not already in the list
        if (data?.services) data.services.forEach((service)=>{
            if (!serviceMap.has(service.uuid)) serviceMap.set(service.uuid, service);
        });
        return Array.from(serviceMap.values());
    }, [
        services,
        data?.services
    ]);
    const onSubmit = (formData)=>{
        console.log('Categories & Services Form Data:', formData);
        console.log('Category ID value:', formData.category_id);
        console.log('Category ID type:', typeof formData.category_id);
        // Clean and validate categories and services data
        const cleanedData = {};
        // Add category if selected - more robust condition
        if (formData.category_id && String(formData.category_id).trim() !== '') {
            cleanedData.category_id = formData.category_id;
            console.log("\u2705 Category ID added to cleaned data:", formData.category_id);
        } else console.log("\u274C Category ID not added. Value:", formData.category_id);
        if (formData.sub_categories && formData.sub_categories.length > 0) cleanedData.sub_categories = formData.sub_categories;
        if (formData.services && formData.services.length > 0) cleanedData.services = formData.services;
        console.log('Categories & Services Cleaned Data:', cleanedData);
        onSave(cleanedData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900",
                        children: "Edit Categories & Services"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Update business category, subcategories, and services offered"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Category"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "category_id",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: field.value,
                                onChange: (e)=>{
                                    const newCategoryId = e.target.value;
                                    field.onChange(newCategoryId);
                                    // Reset subcategories and services when category changes
                                    setValue('sub_categories', []);
                                    setValue('services', []);
                                    if (newCategoryId && dispatch) {
                                        const selectedCategory = categories.find((cat)=>cat.uuid === newCategoryId);
                                        if (selectedCategory) {
                                            dispatch((0, $bVR6A.fetchSubcategoriesByCategory)(selectedCategory.slug));
                                            dispatch((0, $bVR6A.fetchServicesByCategory)(selectedCategory.slug));
                                        }
                                    }
                                },
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select Category"
                                    }),
                                    categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: category.uuid,
                                            children: category.name
                                        }, category.uuid))
                                ]
                            })
                    }),
                    errors?.category_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500 text-sm mt-1",
                        children: errors.category_id.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Sub Categories"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "sub_categories",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$4efd8d874a0cb609), {
                                value: field.value,
                                onChange: field.onChange,
                                options: subCategories.map((s)=>({
                                        label: s.name,
                                        value: s.uuid
                                    })),
                                placeholder: "Select Sub Categories",
                                error: errors?.sub_categories?.message,
                                disabled: !subCategories.length
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Services"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "services",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$ea84111f9d4d896), {
                                value: field.value,
                                onChange: field.onChange,
                                options: enrichedServices.map((s)=>({
                                        label: s.name,
                                        value: s.uuid
                                    })),
                                placeholder: "Select or type to add services...",
                                error: errors?.services?.message
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end space-x-2 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    children: loading ? "Saving..." : "Save Changes"
                })
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");


function $00fd5dec25d42394$export$2e2bcd8739ae039({ items: items = [], initialCount: initialCount = 2, renderItem: renderItem, title: title = "All Items", emptyMessage: emptyMessage = "No items available" }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    if (!items || items.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-gray-500 text-sm",
        children: emptyMessage
    });
    const visibleItems = items.slice(0, initialCount);
    const hasMore = items.length > initialCount;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-1",
                children: [
                    visibleItems.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                renderItem(item, index),
                                index < visibleItems.length - 1 && !hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: ","
                                }),
                                index < visibleItems.length - 1 && hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: ","
                                })
                            ]
                        }, index)),
                    hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: ","
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>setIsOpen(true),
                                className: "text-blue-600 hover:text-blue-800 text-sm font-medium inline-flex items-center gap-1 hover:underline",
                                children: [
                                    "+",
                                    items.length - initialCount,
                                    " more",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: "h-3 w-3"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
                open: isOpen,
                onOpenChange: setIsOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
                            className: "fixed inset-0 bg-black/50 z-50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                            className: "fixed left-[50%] top-[50%] z-50 max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-white p-6 shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center justify-between mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
                                            className: "text-lg font-semibold text-gray-900",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "rounded-full p-1 hover:bg-gray-100 transition-colors",
                                                "aria-label": "Close",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-500"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "max-h-[60vh] overflow-y-auto",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-2",
                                        children: items.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "px-3 py-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors",
                                                children: renderItem(item, index)
                                            }, index))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-4 flex justify-end",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors",
                                            children: "Close"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



function $3bc96bf802504e07$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [filterCategory, setFilterCategory] = (0, $acw62.useState)("all");
    const [filterState, setFilterState] = (0, $acw62.useState)("all");
    const [filterDistrict, setFilterDistrict] = (0, $acw62.useState)("all");
    const [filterTaluka, setFilterTaluka] = (0, $acw62.useState)("all");
    // Modal state management
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        subSection: null,
        loading: false
    });
    const { shops: shops = [], pagination: pagination, shopChangeStatus: shopChangeStatus, shopContactUpdateStatus: shopContactUpdateStatus, shopDiscountUpdateStatus: shopDiscountUpdateStatus, shopGalleryUpdateStatus: shopGalleryUpdateStatus, businessInfoUpdateStatus: businessInfoUpdateStatus, businessSettingsUpdateStatus: businessSettingsUpdateStatus, businessLocationUpdateStatus: businessLocationUpdateStatus, businessCategoriesServicesUpdateStatus: businessCategoriesServicesUpdateStatus, createUserAccountStatus: createUserAccountStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.shop);
    const { categories: categories = [], subcategories: subcategories = [], subscriptionPackages: subscriptionPackages = [], states: states = [], districts: districts = [], talukas: talukas = [], categoryServices: categoryServices = [], paymentModes: paymentModes = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need based on current frontend page
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        // Fetch the backend page that contains the records we need
        dispatch((0, $i32x1.fetchShops)({
            page: backendPage,
            per_page: backendPageSize
        }));
        dispatch((0, $bVR6A.fetchCategories)());
        dispatch((0, $bVR6A.fetchStates)());
        dispatch((0, $bVR6A.fetchSubscriptionPackages)());
        dispatch((0, $bVR6A.fetchPaymentModes)());
    }, [
        dispatch,
        backendPage
    ]);
    // Function to fetch related data when opening edit modals
    const fetchRelatedData = (shop, section)=>{
        if (section === 'location' || section === 'business_settings') {
            // Fetch districts and talukas based on shop's location
            if (shop.state?.uuid) dispatch((0, $bVR6A.fetchDistrictsByState)(shop.state.uuid));
            if (shop.district?.uuid) dispatch((0, $bVR6A.fetchTalukasByDistrict)(shop.district.uuid));
        }
        if (section === 'categories_services' || section === 'business_settings') // Fetch subcategories and services based on shop's category
        {
            if (shop.category?.uuid) {
                dispatch((0, $bVR6A.fetchSubcategoriesByCategory)(shop.category.slug));
                dispatch((0, $bVR6A.fetchServicesByCategory)(shop.category.slug));
            }
        }
    };
    // Check if any filters are active
    const hasActiveFilters = debouncedSearch !== "" || filterStatus !== "all" || filterCategory !== "all" || filterState !== "all" || filterDistrict !== "all" || filterTaluka !== "all";
    const filteredShops = shops.filter((shop)=>{
        const matchesSearch = shop.business_name.toLowerCase().includes(debouncedSearch.toLowerCase()) || shop.address.toLowerCase().includes(debouncedSearch.toLowerCase()) || shop.username.toLowerCase().includes(debouncedSearch.toLowerCase());
        const matchesFilter = filterStatus === "all" || (shop.is_trending ? "active" : "inactive") === filterStatus;
        const matchesCategory = filterCategory === "all" || shop.category?.uuid === filterCategory;
        const matchesState = filterState === "all" || shop.state?.uuid === filterState;
        const matchesDistrict = filterDistrict === "all" || shop.district?.uuid === filterDistrict;
        const matchesTaluka = filterTaluka === "all" || shop.taluka?.uuid === filterTaluka;
        return matchesSearch && matchesFilter && matchesCategory && matchesState && matchesDistrict && matchesTaluka;
    });
    // Client-side pagination from backend data
    // When filters are active, use filtered count for accurate page count
    // When no filters, use server total so pagination reflects all records
    const hasActiveClientFilters = debouncedSearch !== "" || filterStatus !== "all" || filterCategory !== "all" || filterState !== "all" || filterDistrict !== "all" || filterTaluka !== "all";
    const totalRecords = hasActiveClientFilters ? filteredShops.length : pagination?.total || filteredShops.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    // Calculate which records to show from the current backend page
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedShops = filteredShops.slice(localStartIndex, localEndIndex);
    const getStatusBadge = (status)=>{
        const statusStyles = {
            active: "bg-green-100 text-green-800",
            inactive: "bg-red-100 text-red-800"
        };
        return statusStyles[status] || "bg-gray-100 text-gray-800";
    };
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    // Handle state change to fetch districts
    const handleStateChange = (stateUuid)=>{
        setFilterState(stateUuid);
        setFilterDistrict("all");
        setFilterTaluka("all");
        if (stateUuid !== "all") dispatch((0, $bVR6A.fetchDistrictsByState)(stateUuid));
    };
    // Handle district change to fetch talukas
    const handleDistrictChange = (districtUuid)=>{
        setFilterDistrict(districtUuid);
        setFilterTaluka("all");
        if (districtUuid !== "all") dispatch((0, $bVR6A.fetchTalukasByDistrict)(districtUuid));
    };
    // Modal handlers
    const openModal = (type, data, subSection = null)=>{
        let entityType = 'Shop';
        // Set custom entity type for generate account
        if (subSection === 'generate_account') entityType = 'Generate User Account';
        else if (subSection) entityType = `${subSection.charAt(0).toUpperCase() + subSection.slice(1)} Information`;
        // Fetch related data for dropdowns
        if (subSection && subSection !== 'generate_account') fetchRelatedData(data, subSection);
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: entityType
            },
            subSection: subSection,
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            subSection: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (shopData)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $i32x1.updateShopStatus)({
                uuid: shopData?.uuid,
                status: shopData?.status ? "disable" : "enable"
            }));
            closeModal();
        } catch (error) {
            setModalLoading(false);
        }
    };
    const handleEditShop = (shop)=>{
        // console.log(shop)
        // Navigate to AddShopPage with shop UUID for editing
        navigate(`/shops/add?edit=${shop.uuid}`);
    };
    // Function to trigger form submission from modal
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteShop(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CONFIRM && modalState.subSection === 'generate_account') handleCreateUserAccount(modalState.data);
        else handleEditSubSection(modalState.data);
    };
    const handleDeleteShop = async (shopData)=>{
        setModalLoading(true);
        try {
            // TODO: Implement shop delete API call
            console.log('Deleting shop:', shopData.uuid);
            // await dispatch(deleteShop({ uuid: shopData.uuid }));
            // Simulate API call
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Shop deleted successfully");
            closeModal();
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to delete shop");
        }
    };
    const handleCreateUserAccount = async (shop)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $i32x1.createUserAccount)(shop.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("User account created successfully");
            closeModal();
            dispatch((0, $i32x1.fetchShops)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(error, error || "Failed to create user account");
        }
    };
    const handleEditSubSection = async (subSectionData)=>{
        if (!modalState.data?.uuid) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Business ID not found");
            return;
        }
        setModalLoading(true);
        try {
            const shopUuid = modalState.data.uuid;
            switch(modalState.subSection){
                case 'contact':
                    await dispatch((0, $i32x1.updateShopContact)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                case 'discount':
                    await dispatch((0, $i32x1.updateShopDiscount)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                case 'gallery':
                    await dispatch((0, $i32x1.updateShopGallery)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                case 'business_info':
                    await dispatch((0, $i32x1.updateBusinessInfo)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                case 'business_settings':
                    await dispatch((0, $i32x1.updateBusinessSettings)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                case 'location':
                    await dispatch((0, $i32x1.updateBusinessLocation)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                case 'categories_services':
                    await dispatch((0, $i32x1.updateBusinessCategoriesServices)({
                        uuid: shopUuid,
                        data: subSectionData
                    })).unwrap();
                    break;
                default:
                    throw new Error(`Unknown section type: ${modalState.subSection}`);
            }
            const sectionName = modalState.subSection.charAt(0).toUpperCase() + modalState.subSection.slice(1);
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)(`${sectionName} updated successfully`);
            closeModal();
            // Refresh the shops list to show updated data
            dispatch((0, $i32x1.fetchShops)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            const errorMessage = error.message || `Failed to update ${modalState.subSection}`;
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(error, error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (shopChangeStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Status updated successfully");
        else if (shopChangeStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Status update failed");
    }, [
        shopChangeStatus
    ]);
    // Handle contact update status
    (0, $acw62.useEffect)(()=>{
        if (shopContactUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Contact information updated successfully");
        else if (shopContactUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update contact information");
    }, [
        shopContactUpdateStatus
    ]);
    // Handle discount update status
    (0, $acw62.useEffect)(()=>{
        if (shopDiscountUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Discount information updated successfully");
        else if (shopDiscountUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update discount information");
    }, [
        shopDiscountUpdateStatus
    ]);
    // Handle gallery update status
    (0, $acw62.useEffect)(()=>{
        if (shopGalleryUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Gallery updated successfully");
        else if (shopGalleryUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update gallery");
    }, [
        shopGalleryUpdateStatus
    ]);
    // Handle business info update status
    (0, $acw62.useEffect)(()=>{
        if (businessInfoUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Business information updated successfully");
        else if (businessInfoUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update business information");
    }, [
        businessInfoUpdateStatus
    ]);
    // Handle business settings update status
    (0, $acw62.useEffect)(()=>{
        if (businessSettingsUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Business settings updated successfully");
        else if (businessSettingsUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update business settings");
    }, [
        businessSettingsUpdateStatus
    ]);
    // Handle business location update status
    (0, $acw62.useEffect)(()=>{
        if (businessLocationUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Business location updated successfully");
        else if (businessLocationUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update business location");
    }, [
        businessLocationUpdateStatus
    ]);
    // Handle business categories and services update status
    (0, $acw62.useEffect)(()=>{
        if (businessCategoriesServicesUpdateStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Categories and services updated successfully");
        else if (businessCategoriesServicesUpdateStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update categories and services");
    }, [
        businessCategoriesServicesUpdateStatus
    ]);
    // Handle create user account status
    (0, $acw62.useEffect)(()=>{
        if (createUserAccountStatus === "success") (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("User account created successfully");
        else if (createUserAccountStatus === "failed") (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to create user account");
    }, [
        createUserAccountStatus
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: "All Business"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate('/business/add'),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f17d085e2e0469d$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New Shop"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1 relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                placeholder: "Search shops...",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                                className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: filterStatus,
                                                onChange: (e)=>setFilterStatus(e.target.value),
                                                className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "all",
                                                        children: "All"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "active",
                                                        children: "Trending"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inactive",
                                                        children: "Not Trending"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterCategory,
                                            onChange: (e)=>setFilterCategory(e.target.value),
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All Categories"
                                                }),
                                                categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: category.uuid,
                                                        children: category.name
                                                    }, category.uuid))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterState,
                                            onChange: (e)=>handleStateChange(e.target.value),
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All States"
                                                }),
                                                states.map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: state.uuid,
                                                        children: state.name
                                                    }, state.uuid))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterDistrict,
                                            onChange: (e)=>handleDistrictChange(e.target.value),
                                            disabled: filterState === "all",
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All Districts"
                                                }),
                                                districts.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: district.uuid,
                                                        children: district.name
                                                    }, district.uuid))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterTaluka,
                                            onChange: (e)=>setFilterTaluka(e.target.value),
                                            disabled: filterDistrict === "all",
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All Talukas"
                                                }),
                                                talukas.map((taluka)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: taluka.uuid,
                                                        children: taluka.name
                                                    }, taluka.uuid))
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "w-12"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Shop"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Category"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Sub Categories"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Contact No."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            paginatedShops.length > 0 ? paginatedShops.map((shop, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3bc96bf802504e07$var$ExpandableRow, {
                                    idx: idx,
                                    shop: shop,
                                    getStatusBadge: getStatusBadge,
                                    onOpenModal: openModal,
                                    onEditShop: handleEditShop,
                                    onCreateUserAccount: handleCreateUserAccount
                                }, shop.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 6,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f17d085e2e0469d$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No shops found"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            hasActiveFilters && totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-yellow-800",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Note:"
                        }),
                        " Filters are applied to all data. Showing ",
                        paginatedShops.length,
                        " of ",
                        filteredShops.length,
                        " filtered results on this page."
                    ]
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                message: modalState.subSection === 'generate_account' ? `Are you sure you want to generate a user account for "${modalState.data?.business_name}"? Login credentials will be created for this business.` : undefined,
                onConfirm: handleModalConfirm,
                loading: modalState.loading,
                showActions: modalState.type !== (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM,
                size: modalState.subSection && modalState.subSection !== 'generate_account' ? "large" : "default",
                children: [
                    modalState.subSection && modalState.subSection === 'contact' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$bb0a7a5dca73e018), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading
                    }),
                    modalState.subSection && modalState.subSection === 'discount' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$3ed9e6b84623644d), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading
                    }),
                    modalState.subSection && modalState.subSection === 'gallery' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$229cdb157864b137), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading
                    }),
                    modalState.subSection && modalState.subSection === 'business_info' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$ce55fa95e70ee20c), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading
                    }),
                    modalState.subSection && modalState.subSection === 'business_settings' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$7b3c0d82e34ea765), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading,
                        subscriptionPackages: subscriptionPackages,
                        paymentModes: paymentModes,
                        dispatch: dispatch
                    }),
                    modalState.subSection && modalState.subSection === 'location' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$5a75dea6e9eecbca), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading,
                        states: states,
                        districts: districts,
                        talukas: talukas,
                        dispatch: dispatch
                    }),
                    modalState.subSection && modalState.subSection === 'categories_services' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f24ed007e08f6c$export$92bdfb547f6c05ee), {
                        data: modalState.data,
                        onSave: handleEditSubSection,
                        loading: modalState.loading,
                        categories: categories,
                        subCategories: subcategories,
                        services: categoryServices,
                        dispatch: dispatch
                    })
                ]
            })
        ]
    });
}
function $3bc96bf802504e07$var$ExpandableRow({ idx: idx, shop: shop, getStatusBadge: getStatusBadge, onOpenModal: onOpenModal, onEditShop: onEditShop, onCreateUserAccount: onCreateUserAccount }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d03a4306ca42645f$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: setOpen,
        asChild: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                    className: "hover:bg-gray-50 transition-colors",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            className: "px-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d03a4306ca42645f$export$41fb9f06171c75f4, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "p-1 rounded hover:bg-gray-100",
                                    children: open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            className: "px-6 py-4",
                            children: shop.business_name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            className: "px-6 py-4",
                            children: shop.category?.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            className: "px-6 py-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00fd5dec25d42394$export$2e2bcd8739ae039), {
                                items: shop.subcategories || [],
                                initialCount: 2,
                                renderItem: (subcategory)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm text-gray-900",
                                        children: subcategory?.name
                                    }),
                                title: "All Sub Categories",
                                emptyMessage: "No subcategories"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            className: "px-6 py-4",
                            children: shop?.contact_numbers[0]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            className: "px-6 py-4 text-sm",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row sm:items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                        id: `shop-status-${shop.uuid}`,
                                        checked: shop?.status,
                                        onCheckedChange: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, shop),
                                        className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                            className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex items-center",
                                        children: shop.has_user_account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800 border border-green-200 whitespace-nowrap",
                                            children: "Account Activated"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CONFIRM, shop, 'generate_account'),
                                            className: "theme-button-gradient px-4 py-1.5 text-xs font-medium rounded-lg transition-all hover:shadow-md whitespace-nowrap",
                                            title: "Create user account credentials",
                                            children: "Create Account"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d03a4306ca42645f$export$7c6e2c02157bb7d2, {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        className: "max-h-[100px]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            colSpan: 6,
                            className: "p-4  bg-gray-50",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Business Info"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'business_info'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Business Info",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Name:"
                                                    }),
                                                    " ",
                                                    shop.business_name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Username:"
                                                    }),
                                                    " ",
                                                    shop.username
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "About:"
                                                    }),
                                                    " ",
                                                    shop.about_business || 'Not provided'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-2 mt-2",
                                                children: [
                                                    shop.is_trending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2 py-1 text-xs bg-green-100 text-green-800 rounded",
                                                        children: "Trending"
                                                    }),
                                                    shop.is_recently_added && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded",
                                                        children: "Recently Added"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Contact"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'contact'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Contact Info",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                                        className: "inline h-4 w-4 mr-1"
                                                    }),
                                                    " ",
                                                    shop.contact_numbers?.join(", ")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                        className: "inline h-4 w-4 mr-1"
                                                    }),
                                                    " ",
                                                    shop.email
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                                        className: "inline h-4 w-4 mr-1"
                                                    }),
                                                    " ",
                                                    shop.website
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                        className: "inline h-4 w-4 mr-1"
                                                    }),
                                                    " ",
                                                    shop.pincode
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Discount"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'discount'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Discount",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            shop.active_discount ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94f7f4722a3e5887$export$2e2bcd8739ae039), {
                                                                className: "inline h-4 w-4 mr-1"
                                                            }),
                                                            " ",
                                                            shop.active_discount.discount_text
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            "Fixed: ",
                                                            shop.active_discount.fixed_discount,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            "Customer: ",
                                                            shop.active_discount.customer_discount,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            "Commission: ",
                                                            shop.active_discount.company_commission,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "No active discount"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Gallery"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'gallery'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Gallery",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex gap-2 flex-wrap",
                                                children: shop.gallery_images && shop.gallery_images.length > 0 ? shop.gallery_images.map((img)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: img.image,
                                                        alt: "shop gallery",
                                                        className: "w-20 h-20 rounded object-cover border"
                                                    }, img.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-500 text-sm",
                                                    children: "No images uploaded"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Business Settings"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'business_settings'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Business Settings",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-1 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Subscription:"
                                                            }),
                                                            " ",
                                                            shop.subscription_package?.name || shop.mode || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Payment Modes:"
                                                            }),
                                                            " ",
                                                            shop.payment_modes?.join(', ') || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Business Hours:"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3bc96bf802504e07$var$ShopTimings, {
                                                                timings: shop?.business_timings
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Location"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'location'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Location",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-1 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "State:"
                                                            }),
                                                            " ",
                                                            shop.state?.name || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "District:"
                                                            }),
                                                            " ",
                                                            shop.district?.name || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Taluka:"
                                                            }),
                                                            " ",
                                                            shop.taluka?.name || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Address:"
                                                            }),
                                                            " ",
                                                            shop.address || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Pincode:"
                                                            }),
                                                            " ",
                                                            shop.pincode || 'Not set'
                                                        ]
                                                    }),
                                                    shop.business_location_map && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold mb-2",
                                                                children: "Map Location:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "w-full h-48 border rounded overflow-hidden",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                                                    src: shop.business_location_map,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    style: {
                                                                        border: 0
                                                                    },
                                                                    allowFullScreen: "",
                                                                    loading: "lazy",
                                                                    referrerPolicy: "no-referrer-when-downgrade",
                                                                    title: "Business Location"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border rounded-lg p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-semibold",
                                                        children: "Categories & Services"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>onOpenModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).CUSTOM, shop, 'categories_services'),
                                                        className: "text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50",
                                                        title: "Edit Categories & Services",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-1 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Category:"
                                                            }),
                                                            " ",
                                                            shop.category?.name || 'Not set'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Sub Categories:"
                                                            }),
                                                            " ",
                                                            shop.subcategories?.map((cat)=>cat.name).join(', ') || 'Not set'
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
const $3bc96bf802504e07$var$ShopTimings = ({ timings: timings })=>{
    console.log('ShopTimings received:', timings);
    // Always show all 7 days of the week
    const allDays = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ];
    const timingsData = timings || {};
    const formatTime = (time)=>{
        if (!time) return "--";
        // Check if time is already in 12-hour format (contains AM/PM)
        if (time.includes('AM') || time.includes('PM')) return time;
        // Convert 24-hour format to 12-hour format
        const [hour, minute] = time.split(":").map(Number);
        const suffix = hour >= 12 ? "PM" : "AM";
        const formattedHour = (hour + 11) % 12 + 1;
        return `${formattedHour}:${minute.toString().padStart(2, "0")} ${suffix}`;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "space-y-2 text-sm",
            children: allDays.map((day)=>{
                const daySlots = timingsData[day] || [];
                const isClosed = !daySlots || daySlots.length === 0;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-b pb-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "font-medium capitalize text-gray-700 mb-1",
                            children: day
                        }),
                        isClosed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-red-500 text-xs",
                            children: "Closed"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "space-y-1",
                            children: daySlots.map((slot, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-xs text-gray-600",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "font-medium",
                                            children: [
                                                "Slot ",
                                                index + 1,
                                                ":"
                                            ]
                                        }),
                                        ' ',
                                        formatTime(slot.open),
                                        " - ",
                                        formatTime(slot.close)
                                    ]
                                }, index))
                        })
                    ]
                }, day);
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");






var $bVR6A = parcelRequire("bVR6A");




var $i32x1 = parcelRequire("i32x1");

// ----- Stepper -----
const $2714cc0ddcb00996$var$steps = [
    "Business Info",
    "Services & Gallery",
    "Discount Info",
    "Contact Info",
    "Working Hours"
];
const $2714cc0ddcb00996$var$Stepper = ({ currentStep: currentStep, onStepClick: onStepClick, validatedSteps: validatedSteps = [] })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full mb-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
            className: "flex items-center overflow-x-auto",
            children: $2714cc0ddcb00996$var$steps.map((label, idx)=>{
                const isActive = idx === currentStep;
                const isDone = idx < currentStep;
                const isValidated = validatedSteps.includes(idx);
                const isClickable = isDone || isValidated || idx === currentStep;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            onClick: ()=>isClickable && onStepClick && onStepClick(idx),
                            className: `flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold transition-colors ${isDone ? "bg-primary text-white cursor-pointer hover:bg-primary-600" : isActive ? "bg-primary-100 text-primary border-2 border-primary" : isValidated ? "bg-green-100 text-green-800 cursor-pointer hover:bg-green-200" : "bg-surface-200 text-text-secondary"} ${isClickable ? "cursor-pointer" : "cursor-not-allowed"}`,
                            children: idx + 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            onClick: ()=>isClickable && onStepClick && onStepClick(idx),
                            className: `ml-2 mr-4 whitespace-nowrap text-sm transition-colors ${isActive ? "text-primary font-medium" : "text-text-secondary"} ${isClickable ? "cursor-pointer hover:text-primary" : "cursor-not-allowed"}`,
                            children: label
                        }),
                        idx < $2714cc0ddcb00996$var$steps.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "h-0.5 w-6 sm:w-10 bg-border-medium mx-1 sm:mx-2"
                        })
                    ]
                }, label);
            })
        })
    });
};
// Payment options will be fetched from API
const $2714cc0ddcb00996$var$phoneRegex = /^[0-9]{10}$/;
const $2714cc0ddcb00996$var$pincodeRegex = /^[0-9]{6}$/;
const $2714cc0ddcb00996$var$days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
];
const $2714cc0ddcb00996$var$stepSchemas = [
    $cda9d0e1103d595f$export$be5493f9613cbbe({
        business_info: $cda9d0e1103d595f$export$be5493f9613cbbe({
            state: $cda9d0e1103d595f$export$22b082955e083ec3().required("State is required"),
            district: $cda9d0e1103d595f$export$22b082955e083ec3().required("District is required"),
            mode: $cda9d0e1103d595f$export$22b082955e083ec3().required("Mode is required"),
            taluka: $cda9d0e1103d595f$export$22b082955e083ec3().required("Taluk is required"),
            category: $cda9d0e1103d595f$export$22b082955e083ec3().required("Category is required"),
            sub_categories: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).min(1, "Select at least one sub category").required("Sub categories are required"),
            business_name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Shop Name is required").max(20, "Business name cannot exceed 20 characters"),
            username: $cda9d0e1103d595f$export$22b082955e083ec3().required("Mobile number is required").matches(/^[0-9]+$/, "Mobile number must contain only digits").min(10, "Mobile number must be exactly 10 digits").max(10, "Mobile number must be exactly 10 digits"),
            about_business: $cda9d0e1103d595f$export$22b082955e083ec3().required("About business is required")
        })
    }),
    // Step 2: Services & Gallery
    $cda9d0e1103d595f$export$be5493f9613cbbe({
        services: $cda9d0e1103d595f$export$2f23118c22fb2630().when("$isEditMode", {
            is: true,
            then: ()=>$cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).nullable(),
            otherwise: ()=>$cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).min(1, "Select at least one service").required("Services are required")
        }),
        payment_modes: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3()).min(1, "Select at least one mode of payment").required("Mode of Payment is required"),
        gallery: $cda9d0e1103d595f$export$9b30b6294c1449a8().when("$isEditMode", {
            is: true,
            then: ()=>$cda9d0e1103d595f$export$9b30b6294c1449a8().test("fileSize", "Image size must be less than 5MB", (value)=>{
                    if (!value || value.length === 0) return true;
                    return Array.from(value).every((file)=>{
                        // Skip size check for existing images
                        if (file.existing) return true;
                        // Check File objects
                        if (file instanceof File) return file.size <= 5000000;
                        // Check wrapped file objects
                        if (file.file) return file.file.size <= 5000000;
                        return true;
                    });
                }).nullable(),
            otherwise: ()=>$cda9d0e1103d595f$export$9b30b6294c1449a8().test("required", "At least one image is required", (value)=>{
                    return value && value.length > 0;
                }).test("fileSize", "Image size must be less than 5MB", (value)=>{
                    if (!value) return true;
                    return Array.from(value).every((file)=>{
                        // Check File objects
                        if (file instanceof File) return file.size <= 5000000;
                        // Check wrapped file objects
                        if (file.file) return file.file.size <= 5000000;
                        return true;
                    });
                }).required("Gallery images are required")
        })
    }),
    // Step 3: Discount Info
    $cda9d0e1103d595f$export$be5493f9613cbbe({
        discount: $cda9d0e1103d595f$export$be5493f9613cbbe({
            discount_text: $cda9d0e1103d595f$export$22b082955e083ec3().required("Discount text is required"),
            fixed_discount: $cda9d0e1103d595f$export$22b082955e083ec3().when("mode", {
                is: "Premium",
                then: ()=>$cda9d0e1103d595f$export$98e628dec113755e().typeError("Fixed discount must be a number").required("Fixed discount is required").min(0, "Must be 0 or more").test("non-negative", "Cannot be negative", (value)=>value >= 0),
                otherwise: ()=>$cda9d0e1103d595f$export$22b082955e083ec3().nullable()
            }),
            customer_discount: $cda9d0e1103d595f$export$22b082955e083ec3().when("mode", {
                is: "Premium",
                then: ()=>$cda9d0e1103d595f$export$98e628dec113755e().typeError("Customer discount must be a number").required("Customer discount is required").min(0, "Must be 0 or more"),
                otherwise: ()=>$cda9d0e1103d595f$export$22b082955e083ec3().nullable()
            }),
            company_commission: $cda9d0e1103d595f$export$22b082955e083ec3().when("mode", {
                is: "Premium",
                then: ()=>$cda9d0e1103d595f$export$98e628dec113755e().typeError("Company commission must be a number").required("Company commission is required").min(0, "Must be 0 or more"),
                otherwise: ()=>$cda9d0e1103d595f$export$22b082955e083ec3().nullable()
            })
        })
    }),
    // Step 4: Contact Info
    $cda9d0e1103d595f$export$be5493f9613cbbe({
        contact: $cda9d0e1103d595f$export$be5493f9613cbbe({
            address: $cda9d0e1103d595f$export$22b082955e083ec3().required("Address is required"),
            contact_numbers: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3().trim().matches(/^[0-9]*$/, "Contact number must be digits")).test("at-least-one", "Enter at least one contact number", (arr)=>(arr || []).filter((v)=>(v || "").trim().length > 0).length >= 1),
            whatsapp: $cda9d0e1103d595f$export$22b082955e083ec3().required("WhatsApp number is required").matches($2714cc0ddcb00996$var$phoneRegex, "WhatsApp number must be 10 digits"),
            email: $cda9d0e1103d595f$export$22b082955e083ec3().required("Email is required").email("Enter a valid email"),
            website: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().url("Enter a valid URL"),
            pincode: $cda9d0e1103d595f$export$22b082955e083ec3().required("Pincode is required").matches($2714cc0ddcb00996$var$pincodeRegex, "Pincode must be 6 digits"),
            business_location_map: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
            latitude: $cda9d0e1103d595f$export$98e628dec113755e().transform((value, originalValue)=>{
                return originalValue === '' ? null : value;
            }).min(-90).max(90).nullable(),
            longitude: $cda9d0e1103d595f$export$98e628dec113755e().transform((value, originalValue)=>{
                return originalValue === '' ? null : value;
            }).min(-180).max(180).nullable()
        })
    }),
    // Step 5: Working Hours (no strict validation on times)
    $cda9d0e1103d595f$export$be5493f9613cbbe({
        working_hours: $cda9d0e1103d595f$export$be5493f9613cbbe().shape($2714cc0ddcb00996$var$days.reduce((acc, day)=>{
            acc[day] = $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$be5493f9613cbbe({
                open: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
                close: $cda9d0e1103d595f$export$22b082955e083ec3().nullable()
            }));
            return acc;
        }, {})),
        flags: $cda9d0e1103d595f$export$be5493f9613cbbe({
            is_trending: $cda9d0e1103d595f$export$87b259aa03e3d267().default(false),
            is_recently_added: $cda9d0e1103d595f$export$87b259aa03e3d267().default(false)
        })
    }),
    // Step 6: Review & Submit
    $cda9d0e1103d595f$export$be5493f9613cbbe({})
];
// ----- Step field lists (for per-step validation trigger) -----
const $2714cc0ddcb00996$var$stepFields = [
    [
        "business_info.state",
        "business_info.district",
        "business_info.taluka",
        "business_info.category",
        "business_info.sub_categories",
        "business_info.mode",
        "business_info.business_name",
        "business_info.username",
        "business_info.about_business",
        "business_info.payment_modes"
    ],
    [
        "services",
        "payment_modes",
        "gallery"
    ],
    [
        "discount.discount_text",
        "discount.fixed_discount",
        "discount.customer_discount",
        "discount.company_commission"
    ],
    [
        "contact.address",
        "contact.contact_numbers",
        "contact.whatsapp",
        "contact.email",
        "contact.website",
        "contact.pincode",
        "contact.business_location_map"
    ],
    [
        "working_hours.monday",
        "working_hours.tuesday",
        "working_hours.wednesday",
        "working_hours.thursday",
        "working_hours.friday",
        "working_hours.saturday",
        "working_hours.sunday",
        "flags.is_trending",
        "flags.is_recently_added"
    ],
    []
];
// ----- Default values -----
const $2714cc0ddcb00996$var$defaultValues = {
    business_info: {
        state: "",
        district: "",
        taluka: "",
        category: "",
        sub_categories: [],
        business_name: "",
        mode: "",
        username: "",
        about_business: ""
    },
    services: [],
    payment_modes: [],
    gallery: null,
    discount: {
        mode: "",
        discount_text: "",
        fixed_discount: "",
        customer_discount: "",
        company_commission: ""
    },
    contact: {
        address: "",
        contact_numbers: [
            ""
        ],
        whatsapp: "",
        email: "",
        website: "",
        pincode: "",
        business_location_map: "",
        latitude: null,
        longitude: null
    },
    working_hours: {
        monday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ],
        tuesday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ],
        wednesday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ],
        thursday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ],
        friday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ],
        saturday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ],
        sunday: [
            {
                open: "",
                close: ""
            },
            {
                open: "",
                close: ""
            }
        ]
    },
    flags: {
        is_trending: false,
        is_recently_added: false
    }
};
const $2714cc0ddcb00996$var$AddBussinessWizard = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editShopId = searchParams.get("edit");
    const isEditMode = Boolean(editShopId);
    const { states: states, districts: districts, talukas: talukas, categories: categories, subcategories: subcategories, subscriptionPackages: subscriptionPackages, categoryServices: categoryServices, paymentModes: paymentModes, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const { shopCreateStatus: shopCreateStatus, shopCreateError: shopCreateError, shopUpdateStatus: shopUpdateStatus, shopUpdateError: shopUpdateError, shop: shop, shopFetchStatus: shopFetchStatus } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.shop);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bVR6A.fetchStates)());
        dispatch((0, $bVR6A.fetchCategories)());
        dispatch((0, $bVR6A.fetchSubscriptionPackages)());
        dispatch((0, $bVR6A.fetchPaymentModes)());
        // Fetch shop data if in edit mode
        if (isEditMode && editShopId) dispatch((0, $i32x1.fetchShopById)(editShopId));
    }, [
        dispatch,
        isEditMode,
        editShopId
    ]);
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(0);
    const [validatedSteps, setValidatedSteps] = (0, $acw62.useState)([]);
    const getGoogleMapsUrl = (lat, lng)=>{
        return `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    };
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        mode: "onSubmit",
        defaultValues: $2714cc0ddcb00996$var$defaultValues,
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($2714cc0ddcb00996$var$stepSchemas[currentStep]),
        context: {
            isEditMode: isEditMode
        }
    });
    // Update resolver when step changes
    (0, $acw62.useEffect)(()=>{
        methods.clearErrors();
        // Update the form's context for validation
        methods.context = {
            isEditMode: isEditMode
        };
    }, [
        currentStep,
        isEditMode,
        methods
    ]);
    // Populate form with shop data when in edit mode
    (0, $acw62.useEffect)(()=>{
        if (isEditMode && shop && shopFetchStatus === "success") {
            const formData = {
                business_info: {
                    state: shop.state?.uuid || "",
                    district: shop.district?.uuid || "",
                    taluka: shop.taluka?.uuid || shop.taluka?.uuid || "",
                    category: shop.category?.uuid || "",
                    sub_categories: shop.subcategories?.map((sub)=>sub.uuid) || [],
                    business_name: shop.business_name || "",
                    mode: shop.subscription_package?.name || shop.mode || "",
                    username: shop.username || "",
                    about_business: shop.about_business || ""
                },
                services: shop.services?.map((service)=>service.uuid) || [],
                payment_modes: Array.isArray(shop.payment_modes) ? shop.payment_modes : [],
                gallery: shop.gallery_images?.map((img)=>({
                        preview: img.image,
                        existing: true,
                        uuid: img.uuid
                    })) || null,
                discount: {
                    discount_text: shop.active_discount?.discount_text || "",
                    fixed_discount: shop.active_discount?.fixed_discount || "",
                    customer_discount: shop.active_discount?.customer_discount || "",
                    company_commission: shop.active_discount?.company_commission || ""
                },
                contact: {
                    address: shop.address || "",
                    contact_numbers: Array.isArray(shop.contact_numbers) ? shop.contact_numbers : shop.contact_numbers ? [
                        shop.contact_numbers
                    ] : [
                        ""
                    ],
                    whatsapp: shop.whatsapp_number || "",
                    email: shop.email || "",
                    website: shop.website || "",
                    pincode: shop.pincode?.toString() || "",
                    business_location_map: shop.business_location_map || "",
                    latitude: shop.latitude || null,
                    longitude: shop.longitude || null
                },
                working_hours: shop.business_timings || {
                    monday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ],
                    tuesday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ],
                    wednesday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ],
                    thursday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ],
                    friday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ],
                    saturday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ],
                    sunday: [
                        {
                            open: "",
                            close: ""
                        },
                        {
                            open: "",
                            close: ""
                        }
                    ]
                },
                flags: {
                    is_trending: shop.is_trending || false,
                    is_recently_added: shop.is_recently_added || false
                }
            };
            methods.reset(formData);
            // Fetch related data based on shop's location and category
            if (shop.state?.uuid) dispatch((0, $bVR6A.fetchDistrictsByState)(shop.state.uuid));
            if (shop.district?.uuid) dispatch((0, $bVR6A.fetchTalukasByDistrict)(shop.district.uuid));
            if (shop.category?.uuid) {
                dispatch((0, $bVR6A.fetchSubcategoriesByCategory)(shop.category.uuid));
                dispatch((0, $bVR6A.fetchServicesByCategory)(shop.category.uuid));
            }
            // Mark all steps as validated in edit mode since data is already present
            if (isEditMode) setValidatedSteps([
                0,
                1,
                2,
                3,
                4
            ]);
        }
    }, [
        isEditMode,
        shop,
        shopFetchStatus,
        methods,
        dispatch
    ]);
    const { register: register, control: control, handleSubmit: handleSubmit, trigger: trigger, getValues: getValues, formState: { errors: errors } } = methods;
    // Handle shop create status
    (0, $acw62.useEffect)(()=>{
        if (shopCreateStatus === "success") {
            methods.reset($2714cc0ddcb00996$var$defaultValues, {
                keepErrors: false,
                keepDirty: false,
                keepTouched: false,
                keepIsSubmitted: false,
                keepSubmitCount: false
            });
            setCurrentStep(0);
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Shop added successfully");
            navigate("/business");
        } else if (shopCreateStatus === "failed") {
            console.log('Shop create failed, error:', shopCreateError);
            if (shopCreateError?.data && typeof shopCreateError.data === 'object') {
                const validationErrors = shopCreateError.data;
                console.log('Validation errors:', validationErrors);
                // Build error message with all validation errors
                const errorMessages = [];
                Object.keys(validationErrors).forEach((field)=>{
                    const fieldErrors = validationErrors[field];
                    const errorMessage = Array.isArray(fieldErrors) ? fieldErrors[0] : fieldErrors;
                    errorMessages.push(errorMessage);
                    // Also set errors on form fields
                    const fieldMapping = {
                        'whatsapp_number': 'contact.whatsapp',
                        'email': 'contact.email',
                        'business_name': 'business_info.business_name',
                        'username': 'business_info.username',
                        'about_business': 'business_info.about_business',
                        'state_id': 'business_info.state',
                        'district_id': 'business_info.district',
                        'taluka_id': 'business_info.taluka',
                        'category_id': 'business_info.category',
                        'subscription_package_id': 'business_info.mode',
                        'address': 'contact.address',
                        'pincode': 'contact.pincode',
                        'website': 'contact.website'
                    };
                    const formField = fieldMapping[field] || field;
                    methods.setError(formField, {
                        type: 'manual',
                        message: errorMessage
                    });
                });
                // Show all errors in toast
                if (errorMessages.length > 0) {
                    const errorText = errorMessages.join('. ');
                    console.log('Showing error toast:', errorText);
                    (0, $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17).error(errorText);
                } else {
                    console.log('No validation errors found, showing general message');
                    (0, $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17).error(shopCreateError.message || "Failed to create shop");
                }
            } else {
                console.log('No validation data, showing general error');
                (0, $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17).error(shopCreateError?.message || "Failed to create shop");
            }
        }
    }, [
        shopCreateStatus,
        shopCreateError,
        navigate,
        methods
    ]);
    // Handle shop update status
    (0, $acw62.useEffect)(()=>{
        if (shopUpdateStatus === "success") {
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Shop updated successfully");
            navigate("/business");
        } else if (shopUpdateStatus === "failed") {
            console.log('Shop update failed, error:', shopUpdateError);
            if (shopUpdateError?.data && typeof shopUpdateError.data === 'object') {
                const validationErrors = shopUpdateError.data;
                console.log('Validation errors:', validationErrors);
                // Build error message with all validation errors
                const errorMessages = [];
                Object.keys(validationErrors).forEach((field)=>{
                    const fieldErrors = validationErrors[field];
                    const errorMessage = Array.isArray(fieldErrors) ? fieldErrors[0] : fieldErrors;
                    errorMessages.push(errorMessage);
                    // Also set errors on form fields
                    const fieldMapping = {
                        'whatsapp_number': 'contact.whatsapp',
                        'email': 'contact.email',
                        'business_name': 'business_info.business_name',
                        'username': 'business_info.username',
                        'about_business': 'business_info.about_business',
                        'state_id': 'business_info.state',
                        'district_id': 'business_info.district',
                        'taluka_id': 'business_info.taluka',
                        'category_id': 'business_info.category',
                        'subscription_package_id': 'business_info.mode',
                        'address': 'contact.address',
                        'pincode': 'contact.pincode',
                        'website': 'contact.website'
                    };
                    const formField = fieldMapping[field] || field;
                    methods.setError(formField, {
                        type: 'manual',
                        message: errorMessage
                    });
                });
                // Show all errors in toast
                if (errorMessages.length > 0) {
                    const errorText = errorMessages.join('. ');
                    console.log('Showing error toast:', errorText);
                    (0, $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17).error(errorText);
                } else {
                    console.log('No validation errors found, showing general message');
                    (0, $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17).error(shopUpdateError.message || "Failed to update shop");
                }
            } else {
                console.log('No validation data, showing general error');
                (0, $77fa8ab1aa12d8fb$export$f6cef6fcf9ca4e17).error(shopUpdateError?.message || "Failed to update shop");
            }
        }
    }, [
        shopUpdateStatus,
        shopUpdateError,
        navigate,
        methods
    ]);
    const { fields: contact_numbers, append: appendContactNumber, remove: removeContactNumber } = (0, $0d70f179cf56e662$export$310131896651d559)({
        name: "contact.contact_numbers",
        control: control
    });
    (0, $acw62.useEffect)(()=>{
        if (contact_numbers.length === 0) appendContactNumber("");
    }, [
        contact_numbers.length,
        appendContactNumber
    ]);
    const canGoBack = currentStep > 0;
    const isLastStep = currentStep === $2714cc0ddcb00996$var$steps.length - 1;
    const onNext = async ()=>{
        const fieldsToValidate = $2714cc0ddcb00996$var$stepFields[currentStep];
        const valid = await trigger(fieldsToValidate);
        if (!valid) return;
        // Mark current step as validated
        setValidatedSteps((prev)=>{
            if (!prev.includes(currentStep)) return [
                ...prev,
                currentStep
            ];
            return prev;
        });
        setCurrentStep((s)=>s + 1);
    };
    const onStepClick = async (stepIndex)=>{
        // If clicking on a previous step, just go there
        if (stepIndex < currentStep) {
            setCurrentStep(stepIndex);
            return;
        }
        // If clicking on current step, do nothing
        if (stepIndex === currentStep) return;
        // If clicking on a future step, validate current step first
        if (stepIndex > currentStep) {
            const fieldsToValidate = $2714cc0ddcb00996$var$stepFields[currentStep];
            const valid = await trigger(fieldsToValidate);
            if (!valid) return;
            // Mark current step as validated
            setValidatedSteps((prev)=>{
                if (!prev.includes(currentStep)) return [
                    ...prev,
                    currentStep
                ];
                return prev;
            });
            setCurrentStep(stepIndex);
        }
    };
    const onBack = ()=>setCurrentStep((s)=>Math.max(0, s - 1));
    const buildShopFormData = (shopData)=>{
        const formData = new FormData();
        formData.append("business_name", shopData.business_info.business_name);
        formData.append("state_id", shopData.business_info.state);
        formData.append("district_id", shopData.business_info.district);
        if (shopData.business_info.taluka) formData.append("taluka_id", shopData.business_info.taluka);
        formData.append("category_id", shopData.business_info.category);
        if (shopData.business_info.mode) formData.append("subscription_package_id", shopData.business_info.mode);
        formData.append("about_business", shopData.business_info.about_business);
        shopData.business_info.sub_categories.forEach((id, i)=>formData.append(`sub_categories[${i}]`, id));
        if (shopData.services && shopData.services.length > 0) shopData.services.forEach((id, i)=>formData.append(`services[${i}]`, id));
        // Append payment modes as JSON string (backend expects it this way)
        formData.append("payment_modes", JSON.stringify(shopData.payment_modes));
        // Format business_timings with shift-wise slots
        const formattedTimings = {};
        Object.keys(shopData.working_hours).forEach((day)=>{
            const daySlots = shopData.working_hours[day];
            const validSlots = daySlots.filter((slot)=>slot.open && slot.close);
            if (validSlots.length > 0) formattedTimings[day.charAt(0).toUpperCase() + day.slice(1)] = validSlots;
            else formattedTimings[day.charAt(0).toUpperCase() + day.slice(1)] = [];
        });
        formData.append("business_timings", JSON.stringify(formattedTimings));
        formData.append("contact_numbers", JSON.stringify(shopData.contact.contact_numbers));
        formData.append("address", shopData.contact.address);
        formData.append("whatsapp_number", shopData.contact.whatsapp);
        formData.append("email", shopData.contact.email);
        formData.append("website", shopData.contact.website);
        formData.append("pincode", shopData.contact.pincode);
        formData.append("business_location_map", shopData.contact.business_location_map);
        // Append latitude and longitude if available
        if (shopData.contact.latitude !== null && shopData.contact.latitude !== undefined) {
            formData.append("latitude", shopData.contact.latitude);
            console.log("\u2705 Appending latitude to FormData:", shopData.contact.latitude);
        } else console.log("\u274C Latitude not appended:", shopData.contact.latitude);
        if (shopData.contact.longitude !== null && shopData.contact.longitude !== undefined) {
            formData.append("longitude", shopData.contact.longitude);
            console.log("\u2705 Appending longitude to FormData:", shopData.contact.longitude);
        } else console.log("\u274C Longitude not appended:", shopData.contact.longitude);
        formData.append("username", shopData.business_info.username);
        formData.append("discount_text", shopData.discount.discount_text);
        formData.append("fixed_discount", shopData.discount.fixed_discount || 0);
        formData.append("customer_discount", shopData.discount.customer_discount);
        formData.append("company_commission", shopData.discount.company_commission);
        // Handle gallery images - append new files only
        if (shopData.gallery && shopData.gallery.length > 0) {
            let galleryIndex = 0;
            shopData.gallery.forEach((fileObj)=>{
                // Check if it's a File object directly
                if (fileObj instanceof File) {
                    formData.append(`gallery[${galleryIndex}]`, fileObj);
                    galleryIndex++;
                } else if (fileObj && typeof fileObj === 'object' && !fileObj.existing) {
                    if (fileObj.file) {
                        formData.append(`gallery[${galleryIndex}]`, fileObj.file);
                        galleryIndex++;
                    }
                }
            // Skip existing images - they don't need to be sent
            });
        }
        // Flags
        formData.append("is_trending", shopData.flags.is_trending ? 1 : 0);
        formData.append("is_recently_added", shopData.flags.is_recently_added ? 1 : 0);
        return formData;
    };
    const onFinalSubmit = (data)=>{
        console.log('Form data before building FormData:', data);
        console.log('Gallery data:', data.gallery);
        const modeUuid = subscriptionPackages.find((p)=>p.name === data.business_info.mode)?.uuid;
        const safeData = {
            ...data,
            business_info: {
                ...data.business_info,
                mode: modeUuid || data.business_info.mode
            }
        };
        const formData = buildShopFormData(safeData);
        // Debug: Log FormData contents
        console.log('FormData contents:');
        for (let [key, value] of formData.entries())console.log(key, value);
        if (isEditMode) dispatch((0, $i32x1.updateShop)({
            uuid: editShopId,
            data: formData
        }));
        else dispatch((0, $i32x1.createShop)(formData));
    };
    // ---- Step contents ----
    const Step1 = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-2 gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: [
                                "State ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "business_info.state",
                            disabled: !states.length,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$d55b50a564d0b931), {
                                    value: field.value,
                                    onChange: (val)=>{
                                        field.onChange(val);
                                        dispatch((0, $bVR6A.fetchDistrictsByState)(val));
                                    },
                                    options: states.map((s)=>({
                                            label: s.name,
                                            value: s.uuid
                                        })),
                                    placeholder: "Select State",
                                    error: errors?.business_info?.state?.message
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: [
                                "District ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "business_info.district",
                            disabled: !districts.length,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$d55b50a564d0b931), {
                                    value: field.value,
                                    onChange: (val)=>{
                                        field.onChange(val);
                                        dispatch((0, $bVR6A.fetchTalukasByDistrict)(val));
                                    },
                                    options: districts.map((s)=>({
                                            label: s.name,
                                            value: s.uuid
                                        })),
                                    placeholder: "Select District",
                                    error: errors?.business_info?.district?.message
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: [
                                "Taluk ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "business_info.taluka",
                            disabled: !talukas.length,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$d55b50a564d0b931), {
                                    value: field.value,
                                    onChange: field.onChange,
                                    options: talukas.map((s)=>({
                                            label: s.name,
                                            value: s.uuid
                                        })),
                                    placeholder: "Select Taluk",
                                    error: errors?.business_info?.taluka?.message
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: [
                                "Category ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "business_info.category",
                            disabled: !categories.length,
                            render: ({ field: field })=>{
                                // Find the matching category to construct the proper value format
                                const selectedCategory = categories.find((cat)=>cat.uuid === field.value);
                                const displayValue = selectedCategory ? `${selectedCategory.slug}|${selectedCategory.uuid}` : "";
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$d55b50a564d0b931), {
                                    value: displayValue,
                                    onChange: (val)=>{
                                        if (val) {
                                            const values = val.split("|");
                                            field.onChange(values[1]); // Store only the UUID
                                            dispatch((0, $bVR6A.fetchSubcategoriesByCategory)(values[0]));
                                            dispatch((0, $bVR6A.fetchServicesByCategory)(values[0]));
                                        } else field.onChange("");
                                    },
                                    options: categories.map((s)=>({
                                            label: s.name,
                                            value: `${s.slug}|${s.uuid}`
                                        })),
                                    placeholder: "Select Category",
                                    error: errors?.business_info?.category?.message
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: [
                                "Sub Category ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "business_info.sub_categories",
                            disabled: !subcategories.length,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$4efd8d874a0cb609), {
                                    value: field.value,
                                    onChange: field.onChange,
                                    options: subcategories.map((s)=>({
                                            label: s.name,
                                            value: s.uuid
                                        })),
                                    defaultValue: [],
                                    placeholder: "Select Sub Category",
                                    error: errors?.business_info?.sub_categories?.message
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: [
                                "Mode ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "business_info.mode",
                            disabled: !subscriptionPackages.length,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$d55b50a564d0b931), {
                                    value: field.value,
                                    onChange: field.onChange,
                                    options: subscriptionPackages.map((s)=>({
                                            label: s.name,
                                            value: s.name
                                        })),
                                    placeholder: "Select Mode",
                                    error: errors?.business_info?.mode?.message
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Business Name",
                        required: true,
                        placeholder: "Your Business Name",
                        maxLength: 20,
                        ...register("business_info.business_name"),
                        error: errors?.business_info?.business_name?.message
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Username",
                        required: true,
                        placeholder: "10-digit mobile number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 10,
                        ...register("business_info.username"),
                        error: errors?.business_info?.username?.message
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "md:col-span-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                        label: "About Business",
                        required: true,
                        rows: 3,
                        placeholder: "Describe your business...",
                        ...register("business_info.about_business"),
                        error: errors?.business_info?.about_business?.message
                    })
                })
            ]
        });
    };
    const Step2 = ()=>{
        // Filter only active payment modes
        const activePaymentModes = paymentModes.filter((pm)=>pm.status);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: [
                                "Mode of Payment ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "payment_modes",
                            defaultValue: [],
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$81e0b04a08224b5), {
                                    value: field.value,
                                    onChange: field.onChange,
                                    options: activePaymentModes.map((pm)=>({
                                            label: pm.name,
                                            value: pm.name
                                        })),
                                    error: errors?.payment_modes?.message,
                                    required: true
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: [
                                "Services ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "services",
                            defaultValue: [],
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$ea84111f9d4d896), {
                                    required: true,
                                    value: field.value,
                                    onChange: field.onChange,
                                    options: categoryServices.map((s)=>({
                                            label: s.name,
                                            value: s.uuid
                                        })),
                                    error: errors?.services?.message,
                                    placeholder: "Select or type to add services..."
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        control: control,
                        name: "gallery",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e49ca7aad3643dc7$export$3019c26e674dcdde), {
                                label: "Gallery Images",
                                required: true,
                                value: field.value,
                                onChange: (files)=>field.onChange(files),
                                hint: "Drop up to 5 images or click to browse",
                                maxFiles: 5,
                                error: errors?.gallery?.message
                            })
                    })
                })
            ]
        });
    };
    const Step3 = ()=>{
        const { watch: watch, setValue: setValue } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
        const mode = watch("business_info.mode");
        const isPremium = mode === "Premium";
        // Watch customer discount and company commission to auto-calculate fixed discount
        const customerDiscount = watch("discount.customer_discount");
        const companyCommission = watch("discount.company_commission");
        (0, $acw62.useEffect)(()=>{
            if (isPremium) {
                const customer = parseFloat(customerDiscount) || 0;
                const company = parseFloat(companyCommission) || 0;
                const total = customer + company;
                setValue("discount.fixed_discount", total > 0 ? total : "");
            }
        }, [
            customerDiscount,
            companyCommission,
            isPremium,
            setValue
        ]);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-2 gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "md:col-span-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Discount Text",
                        required: true,
                        placeholder: "e.g., Flat 10% off on all items",
                        maxLength: 32,
                        ...register("discount.discount_text"),
                        error: errors?.discount?.discount_text?.message
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            label: "Customer Discount",
                            type: "number",
                            min: 0,
                            step: "0.01",
                            required: isPremium,
                            disabled: !isPremium,
                            placeholder: "0",
                            ...register("discount.customer_discount"),
                            error: errors?.discount?.customer_discount?.message
                        }),
                        !isPremium && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-1 text-xs text-text-secondary",
                            children: "Available only in Premium mode"
                        })
                    ]
                }),
                isPremium && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        label: "Company Commission",
                        type: "number",
                        min: 0,
                        step: "0.01",
                        required: isPremium,
                        placeholder: "0",
                        ...register("discount.company_commission"),
                        error: errors?.discount?.company_commission?.message
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "md:col-span-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            label: "Fixed Discount (Auto-calculated)",
                            type: "number",
                            min: 0,
                            step: "0.01",
                            disabled: true,
                            readOnly: true,
                            placeholder: "0",
                            ...register("discount.fixed_discount", {
                                setValueAs: (v)=>v === "" ? undefined : parseFloat(v)
                            }),
                            error: errors?.discount?.fixed_discount?.message
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-1 text-xs text-gray-500",
                            children: "* Fixed Discount is automatically calculated as Customer Discount + Company Commission"
                        })
                    ]
                })
            ]
        });
    };
    const Step4 = ()=>{
        const { setValue: setValue } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
        const handleGetLocation = ()=>{
            if (!navigator.geolocation) {
                alert("Geolocation is not supported by your browser");
                return;
            }
            navigator.geolocation.getCurrentPosition((position)=>{
                const { latitude: latitude, longitude: longitude } = position.coords;
                const mapUrl = getGoogleMapsUrl(latitude, longitude);
                setValue("contact.business_location_map", mapUrl);
                setValue("contact.latitude", latitude);
                setValue("contact.longitude", longitude);
            }, (error)=>{
                console.error("Error getting location:", error);
                alert("Unable to retrieve your location. Please check your browser permissions.");
            });
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                    label: "Address",
                    required: true,
                    rows: 3,
                    placeholder: "Enter full address",
                    ...register("contact.address"),
                    error: errors?.contact?.address?.message
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: [
                                        "Contact Numbers ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-red-500",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        appendContactNumber("");
                                    },
                                    className: "text-primary text-sm hover:text-primary-600",
                                    children: "+ Add Number"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2714cc0ddcb00996$var$ContactNumbers, {
                            errors: errors,
                            register: register,
                            contact_numbers: contact_numbers,
                            removeContactNumber: removeContactNumber,
                            appendContactNumber: appendContactNumber
                        }),
                        errors?.contact?.contact_numbers && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-error text-sm mt-1",
                            children: errors.contact.contact_numbers.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            label: "WhatsApp Number",
                            required: true,
                            placeholder: "10-digit number",
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            numbersOnly: true,
                            maxLength: 10,
                            ...register("contact.whatsapp"),
                            error: errors?.contact?.whatsapp?.message
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            label: "Email",
                            required: true,
                            placeholder: "example@domain.com",
                            ...register("contact.email"),
                            error: errors?.contact?.email?.message
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            label: "Website",
                            placeholder: "https://example.com",
                            ...register("contact.website"),
                            error: errors?.contact?.website?.message
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            label: "Pincode",
                            required: true,
                            numbersOnly: true,
                            placeholder: "6-digit pincode",
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            maxLength: 6,
                            ...register("contact.pincode"),
                            error: errors?.contact?.pincode?.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between mb-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700",
                                    children: "Map Location (optional)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: handleGetLocation,
                                    className: "text-primary text-sm hover:text-primary-600 flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            className: "h-4 w-4",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                                                clipRule: "evenodd"
                                            })
                                        }),
                                        "Get Current Location"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                            placeholder: "Google Maps URL or short description",
                            ...register("contact.business_location_map")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    ...register("contact.latitude", {
                        setValueAs: (v)=>v === "" || v === null || v === undefined ? null : parseFloat(v)
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    ...register("contact.longitude", {
                        setValueAs: (v)=>v === "" || v === null || v === undefined ? null : parseFloat(v)
                    })
                })
            ]
        });
    };
    const Step5 = ()=>{
        const days = (0, $acw62.useMemo)(()=>[
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday"
            ], []);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-sm text-text-secondary mb-4",
                    children: "Configure working hours with up to 2 shifts per day. Leave empty if closed."
                }),
                days.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border rounded-lg p-4 bg-surface-50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-sm font-semibold text-text-primary capitalize mb-3",
                                children: d
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs font-medium text-text-secondary mb-2",
                                        children: "Slot 1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: `working_hours.${d}.0.open`,
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                        type: "time",
                                                        placeholder: "Open",
                                                        value: field.value ?? "",
                                                        onChange: (e)=>field.onChange(e.target.value === "" ? "" : e.target.value)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: `working_hours.${d}.0.close`,
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                        type: "time",
                                                        placeholder: "Close",
                                                        value: field.value ?? "",
                                                        onChange: (e)=>field.onChange(e.target.value === "" ? "" : e.target.value)
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs font-medium text-text-secondary mb-2",
                                        children: "Slot 2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: `working_hours.${d}.1.open`,
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                        type: "time",
                                                        placeholder: "Open",
                                                        value: field.value ?? "",
                                                        onChange: (e)=>field.onChange(e.target.value === "" ? "" : e.target.value)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: `working_hours.${d}.1.close`,
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                        type: "time",
                                                        placeholder: "Close",
                                                        value: field.value ?? "",
                                                        onChange: (e)=>field.onChange(e.target.value === "" ? "" : e.target.value)
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, d)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:space-x-6 space-y-3 sm:space-y-0 mt-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "flags.is_trending",
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                    label: "Add to Trending",
                                    checked: Boolean(field.value),
                                    onChange: field.onChange
                                })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: control,
                            name: "flags.is_recently_added",
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                    label: "Add to Recently Added",
                                    checked: Boolean(field.value),
                                    onChange: field.onChange
                                })
                        })
                    ]
                })
            ]
        });
    };
    const Step6 = ()=>{
        const values = getValues();
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-6 text-sm",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-text-primary font-semibold mb-2",
                            children: "Shop Info"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                            className: "bg-surface-50 border border-border-light rounded p-3 overflow-auto text-text-secondary",
                            children: JSON.stringify(values.business_info, null, 2)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-text-primary font-semibold mb-2",
                            children: "Services & Gallery"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-1 gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium text-text-primary",
                                            children: "Services: "
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-text-secondary",
                                            children: values.services?.join(", ") || "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "font-medium text-text-primary",
                                            children: [
                                                "Gallery Files:",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-text-secondary",
                                            children: values.gallery ? Array.from(values.gallery).map((f)=>f.name).join(", ") : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-text-primary font-semibold mb-2",
                            children: "Discount Info"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                            className: "bg-surface-50 border border-border-light rounded p-3 overflow-auto text-text-secondary",
                            children: JSON.stringify(values.discount, null, 2)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-text-primary font-semibold mb-2",
                            children: "Working Hours & Flags"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                            className: "bg-surface-50 border border-border-light rounded p-3 overflow-auto text-text-secondary",
                            children: JSON.stringify({
                                working_hours: values.working_hours,
                                flags: values.flags
                            }, null, 2)
                        })
                    ]
                })
            ]
        });
    };
    // Show loader while fetching shop data in edit mode
    if (isEditMode && shopFetchStatus === "loading") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {});
    // Show error if shop not found in edit mode
    if (isEditMode && shopFetchStatus === "failed") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-5xl mx-auto theme-card rounded-lg p-6 text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-xl font-bold text-red-600 mb-2",
                children: "Shop Not Found"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-600 mb-4",
                children: "The shop you're trying to edit could not be found."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>navigate("/business"),
                className: "bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700",
                children: "Back to Shops"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "max-w-5xl mx-auto theme-card rounded-lg p-6",
                onSubmit: handleSubmit(onFinalSubmit),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-2xl font-bold text-gray-900",
                                children: isEditMode ? "Edit Shop" : "Add New Business"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 mt-1",
                                children: isEditMode ? "Update shop information" : "Fill in the details to add a new Business"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2714cc0ddcb00996$var$Stepper, {
                        currentStep: currentStep,
                        onStepClick: onStepClick,
                        validatedSteps: validatedSteps
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            currentStep === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Step1, {}),
                            currentStep === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Step2, {}),
                            currentStep === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Step3, {}),
                            currentStep === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Step4, {}),
                            currentStep === 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Step5, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-8 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: canGoBack && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onBack,
                                    className: "theme-button-secondary px-4 py-2 rounded-md transition-colors",
                                    children: "Back"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-x-2",
                                children: !isLastStep ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onNext,
                                    className: "theme-button-primary px-4 py-2 rounded-md transition-colors",
                                    children: "Next"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>navigate("/business"),
                                            className: "theme-button-secondary px-4 py-2 rounded-md transition-colors",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "bg-success text-white px-4 py-2 rounded-md hover:bg-success-600 transition-colors",
                                            children: isEditMode ? "Update Business" : "Save Business"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// ---- Small sub-component for dynamic numbers (kept separate for clarity) ----
const $2714cc0ddcb00996$var$ContactNumbers = ({ errors: errors, register: register, contact_numbers: contact_numbers, removeContactNumber: removeContactNumber, appendContactNumber: appendContactNumber })=>{
    (0, $acw62.useEffect)(()=>{
        if (contact_numbers.length === 0) appendContactNumber("");
    }, [
        contact_numbers.length,
        appendContactNumber
    ]); // Add proper dependencies
    const handleKeyPress = (event)=>{
        // Allow only numbers and control keys (backspace, delete, arrows etc)
        if (!/[0-9]/.test(event.key) && event.key.length === 1) event.preventDefault();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "space-y-2",
        children: contact_numbers.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-2 ",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                        className: "flex-1",
                        placeholder: "10-digit number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 10,
                        onKeyPress: handleKeyPress,
                        ...register(`contact.contact_numbers.${index}`),
                        error: errors?.contact?.contact_numbers?.[index]?.message
                    }),
                    contact_numbers.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>removeContactNumber(index),
                        className: "text-error text-sm hover:text-error-600 underline transition-colors w-[100px] flex items-center justify-center bg-secondary-light rounded-md",
                        children: "Remove"
                    })
                ]
            }, field.id))
    });
};
var $2714cc0ddcb00996$export$2e2bcd8739ae039 = $2714cc0ddcb00996$var$AddBussinessWizard;




var $acw62 = parcelRequire("acw62");






var $3iTov = parcelRequire("3iTov");




function $879885febec94520$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { categories: categories = [], pagination: pagination, categoryStatusChangeStatus: categoryStatusChangeStatus, categoryDeleteStatus: categoryDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.categories);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        dispatch((0, $3iTov.fetchCategories)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "Category"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (category)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $3iTov.toggleCategoryStatus)(category.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category status updated successfully");
            closeModal();
            dispatch((0, $3iTov.fetchCategories)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update category status");
        }
    };
    const handleDeleteCategory = async (category)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $3iTov.deleteCategory)(category.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category deleted successfully");
            closeModal();
            dispatch((0, $3iTov.fetchCategories)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete category");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteCategory(modalState.data);
    };
    const handleEditCategory = (category)=>{
        navigate(`/categories/add?edit=${category.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (categoryStatusChangeStatus === "success") dispatch((0, $3iTov.resetCategoryStatuses)());
        else if (categoryStatusChangeStatus === "failed") dispatch((0, $3iTov.resetCategoryStatuses)());
    }, [
        categoryStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (categoryDeleteStatus === "success") dispatch((0, $3iTov.resetCategoryStatuses)());
        else if (categoryDeleteStatus === "failed") dispatch((0, $3iTov.resetCategoryStatuses)());
    }, [
        categoryDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || categories.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedCategories = categories.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "All Categories"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage your business categories"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/categories/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New Category"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search categories...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Icon"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Tagline"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Slug"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Subcategories"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Services"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedCategories.length > 0 ? paginatedCategories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: category.icon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: category.icon,
                                                    alt: category.name,
                                                    className: "w-10 h-10 rounded object-cover"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-10 h-10 rounded bg-gray-200 flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-gray-400"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: category.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: category.tagline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: category.tagline
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm text-gray-400 italic",
                                                    children: "No tagline"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: category.slug
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: category.subcategories?.length || 0
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: category.services?.length || 0
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(category.status)}`,
                                                    children: category.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `category-status-${category.uuid}`,
                                                            checked: category.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, category),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>handleEditCategory(category),
                                                                className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                title: "Edit Category",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, category.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 8,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No categories found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first category"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db54edda7e508228$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
];
const $db54edda7e508228$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("save", $db54edda7e508228$export$3efd853dbb351e94);



var $3iTov = parcelRequire("3iTov");




const $e767c4333a6beeb3$var$categorySchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Category name is required").max(255, "Category name must be less than 255 characters"),
    tagline: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().max(500, "Tagline must be less than 500 characters"),
    icon: $cda9d0e1103d595f$export$9b30b6294c1449a8().nullable(),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $e767c4333a6beeb3$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const [iconFile, setIconFile] = (0, $acw62.useState)(null);
    const [existingIcon, setExistingIcon] = (0, $acw62.useState)(null);
    const { category: category, categoryCreateStatus: categoryCreateStatus, categoryUpdateStatus: categoryUpdateStatus, categoryFetchStatus: categoryFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.categories);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($e767c4333a6beeb3$var$categorySchema),
        defaultValues: {
            name: "",
            tagline: "",
            status: true
        }
    });
    // Fetch category data if editing
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $3iTov.fetchCategoryById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    // Populate form when category data is loaded
    (0, $acw62.useEffect)(()=>{
        if (editUuid && category && categoryFetchStatus === "success") {
            reset({
                name: category.name || "",
                tagline: category.tagline || "",
                status: Boolean(category.status)
            });
            if (category.icon) setExistingIcon(category.icon);
        }
    }, [
        category,
        categoryFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = new FormData();
            payload.append("name", formData.name);
            payload.append("status", formData.status ? "1" : "0");
            // Add tagline if provided
            if (formData.tagline) payload.append("tagline", formData.tagline);
            // Add icon if new file is selected
            if (iconFile && iconFile.length > 0) payload.append("icon", iconFile[0]);
            if (editUuid) {
                await dispatch((0, $3iTov.updateCategory)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category updated successfully");
            } else {
                await dispatch((0, $3iTov.createCategory)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category created successfully");
            }
            navigate("/categories");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} category`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $3iTov.resetCategoryStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = categoryCreateStatus === "loading" || categoryUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/categories"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit Category" : "Add New Category"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update category information" : "Create a new category for your businesses"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "Basic Information"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                            label: "Category Name",
                                            required: true,
                                            placeholder: "Enter category name",
                                            ...register("name"),
                                            error: errors?.name?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                label: "Tagline",
                                                placeholder: "Enter category tagline (optional)",
                                                ...register("tagline"),
                                                error: errors?.tagline?.message
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "A short description or tagline for this category (max 500 characters)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: "status",
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                        label: "Active Status",
                                                        checked: Boolean(field.value),
                                                        onChange: (checked)=>field.onChange(checked)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "Enable this category to make it visible to users"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "Category Icon"
                            }),
                            existingIcon && !iconFile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-2",
                                        children: "Current Icon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative inline-block",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: existingIcon,
                                                alt: "Current category icon",
                                                className: "w-32 h-32 rounded-lg object-cover border-2 border-gray-200"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setExistingIcon(null),
                                                className: "absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-2",
                                        children: "Upload a new icon to replace the current one"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e49ca7aad3643dc7$export$3019c26e674dcdde), {
                                    label: existingIcon && !iconFile ? "Upload New Icon" : "Upload Icon",
                                    value: iconFile,
                                    onChange: setIconFile,
                                    hint: "Drop an icon image or click to browse (JPEG, PNG, JPG, WEBP - Max 5MB)",
                                    maxFiles: 1,
                                    accept: "image/jpeg,image/png,image/jpg,image/webp"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/categories"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update Category" : "Create Category"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $40c424bab0bc0a95$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const $40c424bab0bc0a95$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layers", $40c424bab0bc0a95$export$3efd853dbb351e94);





var $1vvaG = parcelRequire("1vvaG");

var $bVR6A = parcelRequire("bVR6A");




function $031d2ca71e7f6a5a$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [filterCategory, setFilterCategory] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { subCategories: subCategories = [], pagination: pagination, subCategoryStatusChangeStatus: subCategoryStatusChangeStatus, subCategoryDeleteStatus: subCategoryDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.subCategories);
    const { categories: categories = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bVR6A.fetchCategories)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        if (filterCategory !== "all") params.category_uuid = filterCategory;
        dispatch((0, $1vvaG.fetchSubCategories)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch,
        filterCategory
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "SubCategory"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (subCategory)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $1vvaG.toggleSubCategoryStatus)(subCategory.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("SubCategory status updated successfully");
            closeModal();
            dispatch((0, $1vvaG.fetchSubCategories)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update subcategory status");
        }
    };
    const handleDeleteSubCategory = async (subCategory)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $1vvaG.deleteSubCategory)(subCategory.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("SubCategory deleted successfully");
            closeModal();
            dispatch((0, $1vvaG.fetchSubCategories)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete subcategory");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteSubCategory(modalState.data);
    };
    const handleEditSubCategory = (subCategory)=>{
        navigate(`/sub-categories/add?edit=${subCategory.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (subCategoryStatusChangeStatus === "success") dispatch((0, $1vvaG.resetSubCategoryStatuses)());
        else if (subCategoryStatusChangeStatus === "failed") dispatch((0, $1vvaG.resetSubCategoryStatuses)());
    }, [
        subCategoryStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (subCategoryDeleteStatus === "success") dispatch((0, $1vvaG.resetSubCategoryStatuses)());
        else if (subCategoryDeleteStatus === "failed") dispatch((0, $1vvaG.resetSubCategoryStatuses)());
    }, [
        subCategoryDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || subCategories.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedSubCategories = subCategories.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "All SubCategories"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage your subcategories linked to categories"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/sub-categories/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New SubCategory"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search subcategories...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterCategory,
                                        onChange: (e)=>setFilterCategory(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Categories"
                                            }),
                                            categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: category.uuid,
                                                    children: category.name
                                                }, category.uuid))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Category"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Slug"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedSubCategories.length > 0 ? paginatedSubCategories.map((subCategory)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: subCategory.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800",
                                                    children: subCategory.category?.name || "N/A"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: subCategory.slug
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(subCategory.status)}`,
                                                    children: subCategory.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `subcategory-status-${subCategory.uuid}`,
                                                            checked: subCategory.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, subCategory),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>handleEditSubCategory(subCategory),
                                                                className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                title: "Edit SubCategory",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, subCategory.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 5,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c424bab0bc0a95$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No subcategories found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" || filterCategory !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first subcategory"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $1vvaG = parcelRequire("1vvaG");

var $bVR6A = parcelRequire("bVR6A");




const $1e68e2aaf5b1c400$var$subCategorySchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    category_uuid: $cda9d0e1103d595f$export$22b082955e083ec3().required("Category is required"),
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("SubCategory name is required").max(255, "SubCategory name must be less than 255 characters"),
    // tagline: yup
    //   .string()
    //   .nullable()
    //   .max(500, "Tagline must be less than 500 characters"),
    // icon: yup.mixed().nullable(),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $1e68e2aaf5b1c400$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const [iconFile, setIconFile] = (0, $acw62.useState)(null);
    const [existingIcon, setExistingIcon] = (0, $acw62.useState)(null);
    const { subCategory: subCategory, subCategoryCreateStatus: subCategoryCreateStatus, subCategoryUpdateStatus: subCategoryUpdateStatus, subCategoryFetchStatus: subCategoryFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.subCategories);
    const { categories: categories = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($1e68e2aaf5b1c400$var$subCategorySchema),
        defaultValues: {
            category_uuid: "",
            name: "",
            // tagline: "",
            status: true
        }
    });
    // Fetch categories for dropdown
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bVR6A.fetchCategories)());
    }, [
        dispatch
    ]);
    // Fetch subcategory data if editing
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $1vvaG.fetchSubCategoryById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    // Populate form when subcategory data is loaded
    (0, $acw62.useEffect)(()=>{
        if (editUuid && subCategory && subCategoryFetchStatus === "success") reset({
            category_uuid: subCategory.category?.uuid || "",
            name: subCategory.name || "",
            // tagline: subCategory.tagline || "",
            status: Boolean(subCategory.status)
        });
    }, [
        subCategory,
        subCategoryFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = new FormData();
            payload.append("category_uuid", formData.category_uuid);
            payload.append("name", formData.name);
            payload.append("status", formData.status ? "1" : "0");
            // Add tagline if provided
            // if (formData.tagline) {
            //   payload.append("tagline", formData.tagline);
            // }
            // Add icon if new file is selected
            // if (iconFile && iconFile.length > 0) {
            //   payload.append("icon", iconFile[0]);
            // }
            if (editUuid) {
                await dispatch((0, $1vvaG.updateSubCategory)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("SubCategory updated successfully");
            } else {
                await dispatch((0, $1vvaG.createSubCategory)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("SubCategory created successfully");
            }
            navigate("/sub-categories");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} subcategory`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $1vvaG.resetSubCategoryStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = subCategoryCreateStatus === "loading" || subCategoryUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/sub-categories"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit SubCategory" : "Add New SubCategory"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update subcategory information" : "Create a new subcategory linked to a category"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-lg shadow p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-lg font-semibold text-gray-900 mb-4",
                            children: "Basic Information"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-2",
                                            children: [
                                                "Parent Category ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-red-500",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            ...register("category_uuid"),
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select a category"
                                                }),
                                                categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: category.uuid,
                                                        children: category.name
                                                    }, category.uuid))
                                            ]
                                        }),
                                        errors?.category_uuid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-red-500 text-sm mt-1",
                                            children: errors.category_uuid.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                        label: "SubCategory Name",
                                        required: true,
                                        placeholder: "Enter subcategory name",
                                        ...register("name"),
                                        error: errors?.name?.message
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                            control: control,
                                            name: "status",
                                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                    label: "Active Status",
                                                    checked: Boolean(field.value),
                                                    onChange: (checked)=>field.onChange(checked)
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-500 mt-1",
                                            children: "Enable this subcategory to make it visible to users"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4 mt-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/sub-categories"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update SubCategory" : "Create SubCategory"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34c3e517ec92034a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("briefcase", $34c3e517ec92034a$export$3efd853dbb351e94);





var $uGwQ1 = parcelRequire("uGwQ1");

var $bVR6A = parcelRequire("bVR6A");




function $6872ee62324268c0$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [filterCategory, setFilterCategory] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { categoryServices: categoryServices = [], pagination: pagination, categoryServiceStatusChangeStatus: categoryServiceStatusChangeStatus, categoryServiceDeleteStatus: categoryServiceDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.categoryServices);
    const { categories: categories = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bVR6A.fetchCategories)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        if (filterCategory !== "all") params.category_uuid = filterCategory;
        dispatch((0, $uGwQ1.fetchCategoryServices)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch,
        filterCategory
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "Category Service"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (service)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $uGwQ1.toggleCategoryServiceStatus)(service.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category service status updated successfully");
            closeModal();
            dispatch((0, $uGwQ1.fetchCategoryServices)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update service status");
        }
    };
    const handleDeleteService = async (service)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $uGwQ1.deleteCategoryService)(service.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category service deleted successfully");
            closeModal();
            dispatch((0, $uGwQ1.fetchCategoryServices)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete service");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteService(modalState.data);
    };
    const handleEditService = (service)=>{
        navigate(`/category-services/add?edit=${service.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (categoryServiceStatusChangeStatus === "success") dispatch((0, $uGwQ1.resetCategoryServiceStatuses)());
        else if (categoryServiceStatusChangeStatus === "failed") dispatch((0, $uGwQ1.resetCategoryServiceStatuses)());
    }, [
        categoryServiceStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (categoryServiceDeleteStatus === "success") dispatch((0, $uGwQ1.resetCategoryServiceStatuses)());
        else if (categoryServiceDeleteStatus === "failed") dispatch((0, $uGwQ1.resetCategoryServiceStatuses)());
    }, [
        categoryServiceDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || categoryServices.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedServices = categoryServices.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Category Services"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage services linked to categories"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/category-services/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New Service"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search services...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterCategory,
                                        onChange: (e)=>setFilterCategory(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Categories"
                                            }),
                                            categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: category.uuid,
                                                    children: category.name
                                                }, category.uuid))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Service Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Tagline"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Category"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedServices.length > 0 ? paginatedServices.map((service)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: service.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: service.tagline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: service.tagline
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm text-gray-400 italic",
                                                    children: "No tagline"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800",
                                                    children: service.category?.name || "N/A"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(service.status)}`,
                                                    children: service.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `service-status-${service.uuid}`,
                                                            checked: service.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, service),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>handleEditService(service),
                                                                    className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                    title: "Edit Service",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE, service),
                                                                    className: "text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50",
                                                                    title: "Delete Service",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, service.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 5,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3e517ec92034a$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No services found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" || filterCategory !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first service"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $uGwQ1 = parcelRequire("uGwQ1");

var $bVR6A = parcelRequire("bVR6A");



const $7acd4dbd3d81e441$var$categoryServiceSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    category_uuid: $cda9d0e1103d595f$export$22b082955e083ec3().required("Category is required"),
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Service name is required").max(255, "Service name must be less than 255 characters"),
    tagline: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().max(500, "Tagline must be less than 500 characters"),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $7acd4dbd3d81e441$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const { categoryService: categoryService, categoryServiceCreateStatus: categoryServiceCreateStatus, categoryServiceUpdateStatus: categoryServiceUpdateStatus, categoryServiceFetchStatus: categoryServiceFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.categoryServices);
    const { categories: categories = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($7acd4dbd3d81e441$var$categoryServiceSchema),
        defaultValues: {
            category_uuid: "",
            name: "",
            tagline: "",
            status: true
        }
    });
    // Fetch categories for dropdown
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bVR6A.fetchCategories)());
    }, [
        dispatch
    ]);
    // Fetch service data if editing
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $uGwQ1.fetchCategoryServiceById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    // Populate form when service data is loaded
    (0, $acw62.useEffect)(()=>{
        if (editUuid && categoryService && categoryServiceFetchStatus === "success") reset({
            category_uuid: categoryService.category?.uuid || "",
            name: categoryService.name || "",
            tagline: categoryService.tagline || "",
            status: Boolean(categoryService.status)
        });
    }, [
        categoryService,
        categoryServiceFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = {
                category_uuid: formData.category_uuid,
                name: formData.name,
                status: formData.status
            };
            // Add tagline if provided
            if (formData.tagline) payload.tagline = formData.tagline;
            if (editUuid) {
                await dispatch((0, $uGwQ1.updateCategoryService)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category service updated successfully");
            } else {
                await dispatch((0, $uGwQ1.createCategoryService)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Category service created successfully");
            }
            navigate("/category-services");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} service`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $uGwQ1.resetCategoryServiceStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = categoryServiceCreateStatus === "loading" || categoryServiceUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/category-services"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit Category Service" : "Add New Category Service"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update service information" : "Create a new service linked to a category"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "Service Information"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "Category ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-red-500",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                ...register("category_uuid"),
                                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select a category"
                                                    }),
                                                    categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: category.uuid,
                                                            children: category.name
                                                        }, category.uuid))
                                                ]
                                            }),
                                            errors?.category_uuid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-red-500 text-sm mt-1",
                                                children: errors.category_uuid.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                            label: "Service Name",
                                            required: true,
                                            placeholder: "Enter service name (e.g., Plumbing, Electrical, etc.)",
                                            ...register("name"),
                                            error: errors?.name?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                label: "Tagline",
                                                placeholder: "Enter service tagline (optional)",
                                                ...register("tagline"),
                                                error: errors?.tagline?.message
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "A short description or tagline for this service (max 500 characters)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: "status",
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                        label: "Active Status",
                                                        checked: Boolean(field.value),
                                                        onChange: (checked)=>field.onChange(checked)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "Enable this service to make it available for selection"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/category-services"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update Service" : "Create Service"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






var $5vhYX = parcelRequire("5vhYX");




function $b666c30a3298784b$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { states: states = [], pagination: pagination, stateStatusChangeStatus: stateStatusChangeStatus, stateDeleteStatus: stateDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.states);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        dispatch((0, $5vhYX.fetchStates)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "State"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (state)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $5vhYX.toggleStateStatus)(state.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("State status updated successfully");
            closeModal();
            dispatch((0, $5vhYX.fetchStates)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update state status");
        }
    };
    const handleDeleteState = async (state)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $5vhYX.deleteState)(state.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("State deleted successfully");
            closeModal();
            dispatch((0, $5vhYX.fetchStates)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete state");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteState(modalState.data);
    };
    const handleEditState = (state)=>{
        navigate(`/states/add?edit=${state.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (stateStatusChangeStatus === "success" || stateStatusChangeStatus === "failed") dispatch((0, $5vhYX.resetStateStatuses)());
    }, [
        stateStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (stateDeleteStatus === "success" || stateDeleteStatus === "failed") dispatch((0, $5vhYX.resetStateStatuses)());
    }, [
        stateDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || states.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedStates = states.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "States"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage states for location hierarchy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/states/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New State"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search states...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "State Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Districts"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedStates.length > 0 ? paginatedStates.map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: state.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: [
                                                    state.districts?.length || 0,
                                                    " districts"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(state.status)}`,
                                                    children: state.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `state-status-${state.uuid}`,
                                                            checked: state.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, state),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>handleEditState(state),
                                                                className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                title: "Edit State",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, state.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 4,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No states found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first state"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $5vhYX = parcelRequire("5vhYX");



const $a1c9dbd9a02d4c12$var$stateSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("State name is required").max(255, "State name must be less than 255 characters"),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $a1c9dbd9a02d4c12$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const { state: state, stateCreateStatus: stateCreateStatus, stateUpdateStatus: stateUpdateStatus, stateFetchStatus: stateFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.states);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($a1c9dbd9a02d4c12$var$stateSchema),
        defaultValues: {
            name: "",
            status: true
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $5vhYX.fetchStateById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editUuid && state && stateFetchStatus === "success") reset({
            name: state.name || "",
            status: Boolean(state.status)
        });
    }, [
        state,
        stateFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = {
                name: formData.name,
                status: formData.status
            };
            if (editUuid) {
                await dispatch((0, $5vhYX.updateState)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("State updated successfully");
            } else {
                await dispatch((0, $5vhYX.createState)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("State created successfully");
            }
            navigate("/states");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} state`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $5vhYX.resetStateStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = stateCreateStatus === "loading" || stateUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/states"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit State" : "Add New State"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update state information" : "Create a new state"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "State Information"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                            label: "State Name",
                                            required: true,
                                            placeholder: "Enter state name",
                                            ...register("name"),
                                            error: errors?.name?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: "status",
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                        label: "Active Status",
                                                        checked: Boolean(field.value),
                                                        onChange: (checked)=>field.onChange(checked)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "Enable this state to make it available for selection"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/states"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update State" : "Create State"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5daea11859835dfd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
            key: "169xi5"
        }
    ],
    [
        "path",
        {
            d: "M15 5.764v15",
            key: "1pn4in"
        }
    ],
    [
        "path",
        {
            d: "M9 3.236v15",
            key: "1uimfh"
        }
    ]
];
const $5daea11859835dfd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("map", $5daea11859835dfd$export$3efd853dbb351e94);





var $bG6ee = parcelRequire("bG6ee");

var $5vhYX = parcelRequire("5vhYX");




function $847eb4d90a322314$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [filterState, setFilterState] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { districts: districts = [], pagination: pagination, districtStatusChangeStatus: districtStatusChangeStatus, districtDeleteStatus: districtDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.districts);
    const { states: states = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.states);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $5vhYX.fetchStates)({}));
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        if (filterState !== "all") params.state_uuid = filterState;
        dispatch((0, $bG6ee.fetchDistricts)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch,
        filterState
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "District"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (district)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $bG6ee.toggleDistrictStatus)(district.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("District status updated successfully");
            closeModal();
            dispatch((0, $bG6ee.fetchDistricts)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update district status");
        }
    };
    const handleDeleteDistrict = async (district)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $bG6ee.deleteDistrict)(district.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("District deleted successfully");
            closeModal();
            dispatch((0, $bG6ee.fetchDistricts)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete district");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteDistrict(modalState.data);
    };
    const handleEditDistrict = (district)=>{
        navigate(`/districts/add?edit=${district.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (districtStatusChangeStatus === "success" || districtStatusChangeStatus === "failed") dispatch((0, $bG6ee.resetDistrictStatuses)());
    }, [
        districtStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (districtDeleteStatus === "success" || districtDeleteStatus === "failed") dispatch((0, $bG6ee.resetDistrictStatuses)());
    }, [
        districtDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || districts.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedDistricts = districts.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Districts"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage districts linked to states"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/districts/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New District"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search districts...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterState,
                                        onChange: (e)=>setFilterState(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All States"
                                            }),
                                            states.map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: state.uuid,
                                                    children: state.name
                                                }, state.uuid))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "District Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "State"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Talukas"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedDistricts.length > 0 ? paginatedDistricts.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: district.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800",
                                                    children: district.state?.name || "N/A"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: [
                                                    district.talukas?.length || 0,
                                                    " talukas"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(district.status)}`,
                                                    children: district.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `district-status-${district.uuid}`,
                                                            checked: district.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, district),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>handleEditDistrict(district),
                                                                className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                title: "Edit District",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, district.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 5,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5daea11859835dfd$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No districts found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" || filterState !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first district"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $bG6ee = parcelRequire("bG6ee");

var $5vhYX = parcelRequire("5vhYX");



const $f449381380db0c2b$var$districtSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    state_uuid: $cda9d0e1103d595f$export$22b082955e083ec3().required("State is required"),
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("District name is required").max(255, "District name must be less than 255 characters"),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $f449381380db0c2b$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const { district: district, districtCreateStatus: districtCreateStatus, districtUpdateStatus: districtUpdateStatus, districtFetchStatus: districtFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.districts);
    const { states: states = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.states);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($f449381380db0c2b$var$districtSchema),
        defaultValues: {
            state_uuid: "",
            name: "",
            status: true
        }
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $5vhYX.fetchStates)({}));
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $bG6ee.fetchDistrictById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editUuid && district && districtFetchStatus === "success") reset({
            state_uuid: district.state?.uuid || "",
            name: district.name || "",
            status: Boolean(district.status)
        });
    }, [
        district,
        districtFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = {
                state_uuid: formData.state_uuid,
                name: formData.name,
                status: formData.status
            };
            if (editUuid) {
                await dispatch((0, $bG6ee.updateDistrict)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("District updated successfully");
            } else {
                await dispatch((0, $bG6ee.createDistrict)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("District created successfully");
            }
            navigate("/districts");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} district`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $bG6ee.resetDistrictStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = districtCreateStatus === "loading" || districtUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/districts"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit District" : "Add New District"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update district information" : "Create a new district linked to a state"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "District Information"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "State ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-red-500",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                ...register("state_uuid"),
                                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select a state"
                                                    }),
                                                    states.map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: state.uuid,
                                                            children: state.name
                                                        }, state.uuid))
                                                ]
                                            }),
                                            errors?.state_uuid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-red-500 text-sm mt-1",
                                                children: errors.state_uuid.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                            label: "District Name",
                                            required: true,
                                            placeholder: "Enter district name",
                                            ...register("name"),
                                            error: errors?.name?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: "status",
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                        label: "Active Status",
                                                        checked: Boolean(field.value),
                                                        onChange: (checked)=>field.onChange(checked)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "Enable this district to make it available for selection"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/districts"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update District" : "Create District"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






var $824th = parcelRequire("824th");

var $bG6ee = parcelRequire("bG6ee");




function $2c09b09221adb259$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [filterDistrict, setFilterDistrict] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { talukas: talukas = [], pagination: pagination, talukaStatusChangeStatus: talukaStatusChangeStatus, talukaDeleteStatus: talukaDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.talukas);
    const { districts: districts = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.districts);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bG6ee.fetchDistricts)({}));
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        if (filterDistrict !== "all") params.district_uuid = filterDistrict;
        dispatch((0, $824th.fetchTalukas)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch,
        filterDistrict
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "Taluka"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (taluka)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $824th.toggleTalukaStatus)(taluka.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Taluka status updated successfully");
            closeModal();
            dispatch((0, $824th.fetchTalukas)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update taluka status");
        }
    };
    const handleDeleteTaluka = async (taluka)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $824th.deleteTaluka)(taluka.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Taluka deleted successfully");
            closeModal();
            dispatch((0, $824th.fetchTalukas)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete taluka");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeleteTaluka(modalState.data);
    };
    const handleEditTaluka = (taluka)=>{
        navigate(`/talukas/add?edit=${taluka.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (talukaStatusChangeStatus === "success" || talukaStatusChangeStatus === "failed") dispatch((0, $824th.resetTalukaStatuses)());
    }, [
        talukaStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (talukaDeleteStatus === "success" || talukaDeleteStatus === "failed") dispatch((0, $824th.resetTalukaStatuses)());
    }, [
        talukaDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || talukas.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedTalukas = talukas.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Talukas"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage talukas linked to districts"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/talukas/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New Taluka"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search talukas...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterDistrict,
                                        onChange: (e)=>setFilterDistrict(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Districts"
                                            }),
                                            districts.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: district.uuid,
                                                    children: district.name
                                                }, district.uuid))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Taluka Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "District"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "State"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedTalukas.length > 0 ? paginatedTalukas.map((taluka)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: taluka.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800",
                                                    children: taluka.district?.name || "N/A"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-800",
                                                    children: taluka.district?.state?.name || "N/A"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(taluka.status)}`,
                                                    children: taluka.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `taluka-status-${taluka.uuid}`,
                                                            checked: taluka.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, taluka),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>handleEditTaluka(taluka),
                                                                className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                title: "Edit Taluka",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, taluka.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 5,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No talukas found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" || filterDistrict !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first taluka"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $824th = parcelRequire("824th");

var $bG6ee = parcelRequire("bG6ee");



const $c47182f8a84f37f4$var$talukaSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    district_uuid: $cda9d0e1103d595f$export$22b082955e083ec3().required("District is required"),
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Taluka name is required").max(255, "Taluka name must be less than 255 characters"),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $c47182f8a84f37f4$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const { taluka: taluka, talukaCreateStatus: talukaCreateStatus, talukaUpdateStatus: talukaUpdateStatus, talukaFetchStatus: talukaFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.talukas);
    const { districts: districts = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.districts);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($c47182f8a84f37f4$var$talukaSchema),
        defaultValues: {
            district_uuid: "",
            name: "",
            status: true
        }
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bG6ee.fetchDistricts)({}));
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $824th.fetchTalukaById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editUuid && taluka && talukaFetchStatus === "success") reset({
            district_uuid: taluka.district?.uuid || "",
            name: taluka.name || "",
            status: Boolean(taluka.status)
        });
    }, [
        taluka,
        talukaFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = {
                district_uuid: formData.district_uuid,
                name: formData.name,
                status: formData.status
            };
            if (editUuid) {
                await dispatch((0, $824th.updateTaluka)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Taluka updated successfully");
            } else {
                await dispatch((0, $824th.createTaluka)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Taluka created successfully");
            }
            navigate("/talukas");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} taluka`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $824th.resetTalukaStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = talukaCreateStatus === "loading" || talukaUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/talukas"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit Taluka" : "Add New Taluka"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update taluka information" : "Create a new taluka linked to a district"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "Taluka Information"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "District ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-red-500",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                ...register("district_uuid"),
                                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select a district"
                                                    }),
                                                    districts.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                            value: district.uuid,
                                                            children: [
                                                                district.name,
                                                                " (",
                                                                district.state?.name || "N/A",
                                                                ")"
                                                            ]
                                                        }, district.uuid))
                                                ]
                                            }),
                                            errors?.district_uuid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-red-500 text-sm mt-1",
                                                children: errors.district_uuid.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                            label: "Taluka Name",
                                            required: true,
                                            placeholder: "Enter taluka name",
                                            ...register("name"),
                                            error: errors?.name?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: "status",
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                        label: "Active Status",
                                                        checked: Boolean(field.value),
                                                        onChange: (checked)=>field.onChange(checked)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "Enable this taluka to make it available for selection"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/talukas"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update Taluka" : "Create Taluka"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






var $bGldA = parcelRequire("bGldA");




function $58e18ea8c6cd8696$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const { subscriptionPackages: subscriptionPackages = [], pagination: pagination, packageStatusChangeStatus: packageStatusChangeStatus, packageDeleteStatus: packageDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.subscriptionPackages);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        const params = {
            page: backendPage,
            per_page: backendPageSize
        };
        if (filterStatus !== "all") params.status = filterStatus === "active";
        if (debouncedSearch) params.search = debouncedSearch;
        dispatch((0, $bGldA.fetchSubscriptionPackages)(params));
    }, [
        dispatch,
        backendPage,
        filterStatus,
        debouncedSearch
    ]);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "Subscription Package"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (pkg)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $bGldA.toggleSubscriptionPackageStatus)(pkg.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Subscription package status updated successfully");
            closeModal();
            dispatch((0, $bGldA.fetchSubscriptionPackages)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update subscription package status");
        }
    };
    const handleDeletePackage = async (pkg)=>{
        setModalLoading(true);
        try {
            await dispatch((0, $bGldA.deleteSubscriptionPackage)(pkg.uuid)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Subscription package deleted successfully");
            closeModal();
            dispatch((0, $bGldA.fetchSubscriptionPackages)({
                page: backendPage,
                per_page: backendPageSize
            }));
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete subscription package");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeletePackage(modalState.data);
    };
    const handleEditPackage = (pkg)=>{
        navigate(`/subscription-packages/add?edit=${pkg.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (packageStatusChangeStatus === "success" || packageStatusChangeStatus === "failed") dispatch((0, $bGldA.resetPackageStatuses)());
    }, [
        packageStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (packageDeleteStatus === "success" || packageDeleteStatus === "failed") dispatch((0, $bGldA.resetPackageStatuses)());
    }, [
        packageDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    // Client-side pagination
    const totalRecords = pagination?.total || subscriptionPackages.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedPackages = subscriptionPackages.slice(localStartIndex, localEndIndex);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Subscription Packages"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage subscription packages for businesses"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/subscription-packages/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add New Package"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search packages...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedPackages.length > 0 ? paginatedPackages.map((pkg)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: pkg.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: pkg.description || "No description"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(pkg.status)}`,
                                                    children: pkg.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `package-status-${pkg.uuid}`,
                                                            checked: pkg.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, pkg),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>handleEditPackage(pkg),
                                                                className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                title: "Edit Package",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, pkg.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 4,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $437c67a40c1b8279$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No subscription packages found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first subscription package"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $bGldA = parcelRequire("bGldA");



const $be6dbc900338bf04$var$packageSchema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Package name is required").max(255, "Package name must be less than 255 characters"),
    description: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    status: $cda9d0e1103d595f$export$87b259aa03e3d267()
});
function $be6dbc900338bf04$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editUuid = searchParams.get("edit");
    const { subscriptionPackage: subscriptionPackage, packageCreateStatus: packageCreateStatus, packageUpdateStatus: packageUpdateStatus, packageFetchStatus: packageFetchStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.subscriptionPackages);
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($be6dbc900338bf04$var$packageSchema),
        defaultValues: {
            name: "",
            description: "",
            status: true
        }
    });
    // Fetch package data if editing
    (0, $acw62.useEffect)(()=>{
        if (editUuid) dispatch((0, $bGldA.fetchSubscriptionPackageById)(editUuid));
    }, [
        editUuid,
        dispatch
    ]);
    // Populate form when package data is loaded
    (0, $acw62.useEffect)(()=>{
        if (editUuid && subscriptionPackage && packageFetchStatus === "success") reset({
            name: subscriptionPackage.name || "",
            description: subscriptionPackage.description || "",
            status: Boolean(subscriptionPackage.status)
        });
    }, [
        subscriptionPackage,
        packageFetchStatus,
        editUuid,
        reset
    ]);
    const onSubmit = async (formData)=>{
        try {
            const payload = {
                name: formData.name,
                description: formData.description || null,
                status: formData.status
            };
            if (editUuid) {
                await dispatch((0, $bGldA.updateSubscriptionPackage)({
                    uuid: editUuid,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Subscription package updated successfully");
            } else {
                await dispatch((0, $bGldA.createSubscriptionPackage)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Subscription package created successfully");
            }
            navigate("/subscription-packages");
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || `Failed to ${editUuid ? "update" : "create"} subscription package`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $bGldA.resetPackageStatuses)());
        };
    }, [
        dispatch
    ]);
    const isSubmitting = packageCreateStatus === "loading" || packageUpdateStatus === "loading";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>navigate("/subscription-packages"),
                                className: "text-gray-600 hover:text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: editUuid ? "Edit Subscription Package" : "Add New Subscription Package"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: editUuid ? "Update subscription package information" : "Create a new subscription package"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 mb-4",
                                children: "Package Information"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                            disabled: !!editUuid,
                                            label: "Package Name",
                                            required: true,
                                            placeholder: "Enter package name",
                                            ...register("name"),
                                            error: errors?.name?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                                            label: "Description",
                                            placeholder: "Enter package description (optional)",
                                            rows: 4,
                                            ...register("description"),
                                            error: errors?.description?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                control: control,
                                                name: "status",
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$94195a47b94ed396), {
                                                        label: "Active Status",
                                                        checked: Boolean(field.value),
                                                        onChange: (checked)=>field.onChange(checked)
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-1",
                                                children: "Enable this package to make it available for businesses"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-end space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigate("/subscription-packages"),
                                    className: "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors",
                                    disabled: isSubmitting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: isSubmitting ? "Saving..." : editUuid ? "Update Package" : "Create Package"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");










function $19e41449be3ca01f$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("all");
    const [modalState, setModalState] = (0, $acw62.useState)({
        open: false,
        type: null,
        data: null,
        loading: false
    });
    const entireState = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state);
    console.log("ViewPaymentModesPage - ENTIRE Redux state:", entireState);
    console.log("ViewPaymentModesPage - state.paymentModes:", entireState.paymentModes);
    const { paymentModes: paymentModes = [], pagination: pagination, paymentModeStatusChangeStatus: paymentModeStatusChangeStatus, paymentModeDeleteStatus: paymentModeDeleteStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.paymentModes || {});
    console.log("ViewPaymentModesPage - paymentModes from state:", paymentModes);
    console.log("ViewPaymentModesPage - paymentModes length:", paymentModes?.length);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        console.log("ViewPaymentModesPage - Dispatching fetchPaymentModes");
        const result = dispatch((0, $524252bcdc82386d$export$14d3ed471e81ae25)({
            page: backendPage,
            per_page: backendPageSize
        }));
        console.log("ViewPaymentModesPage - Dispatch result:", result);
    }, [
        dispatch,
        backendPage
    ]);
    // Client-side filtering
    const filteredPaymentModes = paymentModes.filter((paymentMode)=>{
        const matchesSearch = !debouncedSearch || paymentMode.name && paymentMode.name.toLowerCase().includes(debouncedSearch.toLowerCase()) || paymentMode.description && paymentMode.description.toLowerCase().includes(debouncedSearch.toLowerCase());
        const matchesFilter = filterStatus === "all" || (paymentMode.status ? "active" : "inactive") === filterStatus;
        return matchesSearch && matchesFilter;
    });
    const hasActiveClientFilters = debouncedSearch !== "" || filterStatus !== "all";
    // Client-side pagination
    const totalRecords = hasActiveClientFilters ? filteredPaymentModes.length : pagination?.total || filteredPaymentModes.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedPaymentModes = filteredPaymentModes.slice(localStartIndex, localEndIndex);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    const openModal = (type, data)=>{
        setModalState({
            open: true,
            type: type,
            data: {
                ...data,
                entityType: "Payment Mode"
            },
            loading: false
        });
    };
    const closeModal = ()=>{
        setModalState({
            open: false,
            type: null,
            data: null,
            loading: false
        });
    };
    const setModalLoading = (loading)=>{
        setModalState((prev)=>({
                ...prev,
                loading: loading
            }));
    };
    const handleStatusChange = async (paymentMode)=>{
        setModalLoading(true);
        try {
            const result = await dispatch((0, $524252bcdc82386d$export$e4f9c96ad027e489)(paymentMode.uuid));
            if ((0, $524252bcdc82386d$export$e4f9c96ad027e489).fulfilled.match(result)) {
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Payment mode status updated successfully");
                closeModal();
                dispatch((0, $524252bcdc82386d$export$14d3ed471e81ae25)());
            } else {
                setModalLoading(false);
                (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update payment mode status");
            }
        } catch (error) {
            console.log("===Console of the ui");
            console.log(error);
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to update payment mode status");
        }
    };
    const handleDeletePaymentMode = async (paymentMode)=>{
        setModalLoading(true);
        try {
            const result = await dispatch((0, $524252bcdc82386d$export$618aee30ea370ed3)(paymentMode.uuid));
            if ((0, $524252bcdc82386d$export$618aee30ea370ed3).fulfilled.match(result)) {
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Payment mode deleted successfully");
                closeModal();
                dispatch((0, $524252bcdc82386d$export$14d3ed471e81ae25)());
            } else {
                setModalLoading(false);
                (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to delete payment mode");
            }
        } catch (error) {
            setModalLoading(false);
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, error || "Failed to delete payment mode");
        }
    };
    const handleModalConfirm = ()=>{
        if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE) handleStatusChange(modalState.data);
        else if (modalState.type === (0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE) handleDeletePaymentMode(modalState.data);
    };
    const handleEditPaymentMode = (paymentMode)=>{
        navigate(`/payment-modes/add?edit=${paymentMode.uuid}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (paymentModeStatusChangeStatus === "success") dispatch((0, $524252bcdc82386d$export$943fb531692d88c9)());
        else if (paymentModeStatusChangeStatus === "failed") dispatch((0, $524252bcdc82386d$export$943fb531692d88c9)());
    }, [
        paymentModeStatusChangeStatus,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (paymentModeDeleteStatus === "success") dispatch((0, $524252bcdc82386d$export$943fb531692d88c9)());
        else if (paymentModeDeleteStatus === "failed") dispatch((0, $524252bcdc82386d$export$943fb531692d88c9)());
    }, [
        paymentModeDeleteStatus,
        dispatch
    ]);
    const getStatusBadge = (status)=>{
        return status ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Payment Modes"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 mt-1",
                                        children: "Manage payment methods for businesses"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>navigate("/payment-modes/add"),
                                className: "mt-4 sm:mt-0 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Add Payment Mode"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search payment modes...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: filterStatus,
                                        onChange: (e)=>setFilterStatus(e.target.value),
                                        className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inactive",
                                                children: "Inactive"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200",
                                children: paginatedPaymentModes.length > 0 ? paginatedPaymentModes.map((paymentMode)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 font-medium text-gray-900",
                                                children: paymentMode.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-gray-500",
                                                children: paymentMode.description ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: paymentMode.description
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm text-gray-400 italic",
                                                    children: "No description"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `px-2 py-1 text-xs rounded-full ${getStatusBadge(paymentMode.status)}`,
                                                    children: paymentMode.status ? "Active" : "Inactive"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                            id: `payment-mode-status-${paymentMode.uuid}`,
                                                            checked: paymentMode.status,
                                                            onCheckedChange: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).ENABLE_DISABLE, paymentMode),
                                                            className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm  data-[state=checked]:bg-blue-600 outline-none cursor-pointer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform  translate-x-0.5 will-change-transform  data-[state=checked]:translate-x-[19px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>handleEditPaymentMode(paymentMode),
                                                                    className: "text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50",
                                                                    title: "Edit Payment Mode",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>openModal((0, $eb5638f2ca6d7b93$export$e8372f5a01af8b26).DELETE, paymentMode),
                                                                    className: "text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50",
                                                                    title: "Delete Payment Mode",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, paymentMode.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 4,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No payment modes found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterStatus !== "all" ? "Try adjusting your search or filters" : "Get started by creating your first payment mode"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: modalState.open,
                onOpenChange: closeModal,
                type: modalState.type,
                data: modalState.data,
                onConfirm: handleModalConfirm,
                loading: modalState.loading
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");









const $e9937b65f1b0b37f$var$schema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Payment mode name is required"),
    description: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    status: $cda9d0e1103d595f$export$22b082955e083ec3().required("Status is required")
});
function $e9937b65f1b0b37f$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const editPaymentModeId = searchParams.get("edit");
    const isEditMode = Boolean(editPaymentModeId);
    const { paymentMode: paymentMode, paymentModeCreateStatus: paymentModeCreateStatus, paymentModeFetchStatus: paymentModeFetchStatus, paymentModeUpdateStatus: paymentModeUpdateStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.paymentModes || {});
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($e9937b65f1b0b37f$var$schema),
        defaultValues: {
            name: "",
            description: "",
            status: "true"
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (isEditMode && editPaymentModeId) dispatch((0, $524252bcdc82386d$export$21bfdeebc9dbb847)(editPaymentModeId));
    }, [
        dispatch,
        isEditMode,
        editPaymentModeId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isEditMode && paymentMode && paymentModeFetchStatus === "success") reset({
            name: paymentMode.name || "",
            description: paymentMode.description || "",
            status: paymentMode.status ? "true" : "false"
        });
    }, [
        isEditMode,
        paymentMode,
        paymentModeFetchStatus,
        reset
    ]);
    const onSubmitHandler = async (data)=>{
        const payload = {
            name: data.name,
            description: data.description || "",
            status: data.status
        };
        try {
            if (isEditMode) {
                await dispatch((0, $524252bcdc82386d$export$511059e0e2893be0)({
                    uuid: editPaymentModeId,
                    data: payload
                })).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Payment mode updated successfully");
            } else {
                await dispatch((0, $524252bcdc82386d$export$4d752bfeb2738c76)(payload)).unwrap();
                (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Payment mode created successfully");
            }
            navigate("/payment-modes");
        } catch (error) {
            console.log('Caught error:', error);
            console.log('Error type:', typeof error);
            // When using unwrap(), the error is the rejected value directly (err.response.data from the thunk)
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)("Failed to save payment mode", error);
        }
    };
    if (isEditMode && paymentModeFetchStatus === "loading") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {});
    if (isEditMode && paymentModeFetchStatus === "failed") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-2xl mx-auto theme-card rounded-lg p-6 text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-xl font-bold text-red-600 mb-2",
                children: "Payment Mode Not Found"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-600 mb-4",
                children: "The payment mode you're trying to edit could not be found."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>navigate("/payment-modes"),
                className: "bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700",
                children: "Back to Payment Modes"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-2xl mx-auto",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "theme-card rounded-lg p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-2xl font-bold text-gray-900",
                                children: isEditMode ? "Edit Payment Mode" : "Add New Payment Mode"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 mt-1",
                                children: isEditMode ? "Update payment mode information" : "Fill in the details to add a new payment mode"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: handleSubmit(onSubmitHandler),
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                label: "Payment Mode Name",
                                required: true,
                                placeholder: "e.g., Cash, Card, UPI",
                                ...register("name"),
                                error: errors?.name?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                                label: "Description",
                                rows: 3,
                                placeholder: "Optional description for this payment mode",
                                ...register("description"),
                                error: errors?.description?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                control: control,
                                name: "status",
                                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$d55b50a564d0b931), {
                                        label: "Status",
                                        required: true,
                                        value: field.value,
                                        onChange: field.onChange,
                                        options: [
                                            {
                                                label: "Active",
                                                value: "true"
                                            },
                                            {
                                                label: "Inactive",
                                                value: "false"
                                            }
                                        ],
                                        error: errors?.status?.message
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-end space-x-4 pt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>navigate("/payment-modes"),
                                        className: "theme-button-secondary px-6 py-2 rounded-md transition-colors",
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        className: "bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors",
                                        children: isEditMode ? "Update Payment Mode" : "Create Payment Mode"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






var $5cRsT = parcelRequire("5cRsT");



const $4d57e9e74c252552$var$schema = $cda9d0e1103d595f$export$be5493f9613cbbe({
    address: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    contact_numbers: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3().required("Contact number is required")),
    emails: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$22b082955e083ec3().email("Invalid email").required("Email is required")),
    social_media_links: $cda9d0e1103d595f$export$2f23118c22fb2630().of($cda9d0e1103d595f$export$be5493f9613cbbe({
        platform: $cda9d0e1103d595f$export$22b082955e083ec3().required("Platform is required"),
        link: $cda9d0e1103d595f$export$22b082955e083ec3().url("Invalid URL").required("Link is required")
    }))
});
function $4d57e9e74c252552$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { companyDetails: companyDetails, companyDetailsFetchStatus: companyDetailsFetchStatus, companyDetailsSaveStatus: companyDetailsSaveStatus, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.companyDetails || {});
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($4d57e9e74c252552$var$schema),
        defaultValues: {
            address: "",
            contact_numbers: [
                ""
            ],
            emails: [
                ""
            ],
            social_media_links: [
                {
                    platform: "",
                    link: ""
                }
            ]
        }
    });
    const { fields: contactFields, append: appendContact, remove: removeContact } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: control,
        name: "contact_numbers"
    });
    const { fields: emailFields, append: appendEmail, remove: removeEmail } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: control,
        name: "emails"
    });
    const { fields: socialFields, append: appendSocial, remove: removeSocial } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: control,
        name: "social_media_links"
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $5cRsT.fetchCompanyDetails)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (companyDetails && companyDetailsFetchStatus === "success") reset({
            address: companyDetails.address || "",
            contact_numbers: companyDetails.contact_numbers?.length > 0 ? companyDetails.contact_numbers : [
                ""
            ],
            emails: companyDetails.emails?.length > 0 ? companyDetails.emails : [
                ""
            ],
            social_media_links: companyDetails.social_media_links?.length > 0 ? companyDetails.social_media_links : [
                {
                    platform: "",
                    link: ""
                }
            ]
        });
    }, [
        companyDetails,
        companyDetailsFetchStatus,
        reset
    ]);
    const onSubmitHandler = async (data)=>{
        // Filter out empty values
        const payload = {
            address: data.address || null,
            contact_numbers: data.contact_numbers.filter((num)=>num.trim() !== ""),
            emails: data.emails.filter((email)=>email.trim() !== ""),
            social_media_links: data.social_media_links.filter((link)=>link.platform.trim() !== "" && link.link.trim() !== "")
        };
        try {
            await dispatch((0, $5cRsT.storeOrUpdateCompanyDetails)(payload)).unwrap();
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)(companyDetails ? "Company details updated successfully" : "Company details created successfully");
            dispatch((0, $5cRsT.fetchCompanyDetails)());
        } catch (error) {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)("Failed to save company details", error);
        }
    };
    if (companyDetailsFetchStatus === "loading" && !companyDetails) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "theme-card rounded-lg p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-6 flex items-center space-x-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                className: "h-8 w-8 text-blue-600"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Company Details"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-600 mt-1",
                                        children: "Manage your company information and contact details"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: handleSubmit(onSubmitHandler),
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$301bf6213f61d17f), {
                                label: "Address",
                                rows: 3,
                                placeholder: "Enter company address",
                                ...register("address"),
                                error: errors?.address?.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-2",
                                        children: "Contact Numbers"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-2",
                                        children: contactFields.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-start space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex-1",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                            placeholder: "Enter contact number",
                                                            ...register(`contact_numbers.${index}`),
                                                            error: errors?.contact_numbers?.[index]?.message
                                                        })
                                                    }),
                                                    contactFields.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>removeContact(index),
                                                        className: "mt-2 text-red-600 hover:text-red-800 p-2 rounded hover:bg-red-50",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    })
                                                ]
                                            }, field.id))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>appendContact(""),
                                        className: "mt-2 flex items-center space-x-2 text-blue-600 hover:text-blue-800 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Add Contact Number"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-2",
                                        children: "Email Addresses"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-2",
                                        children: emailFields.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-start space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex-1",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                            type: "email",
                                                            placeholder: "Enter email address",
                                                            ...register(`emails.${index}`),
                                                            error: errors?.emails?.[index]?.message
                                                        })
                                                    }),
                                                    emailFields.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>removeEmail(index),
                                                        className: "mt-2 text-red-600 hover:text-red-800 p-2 rounded hover:bg-red-50",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    })
                                                ]
                                            }, field.id))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>appendEmail(""),
                                        className: "mt-2 flex items-center space-x-2 text-blue-600 hover:text-blue-800 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Add Email"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-2",
                                        children: "Social Media Links"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-3",
                                        children: socialFields.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-start space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex-1 grid grid-cols-2 gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                placeholder: "Platform (e.g., Facebook)",
                                                                ...register(`social_media_links.${index}.platform`),
                                                                error: errors?.social_media_links?.[index]?.platform?.message
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b936de565d5e0d9$export$2c73285ae9390cec), {
                                                                placeholder: "URL",
                                                                ...register(`social_media_links.${index}.link`),
                                                                error: errors?.social_media_links?.[index]?.link?.message
                                                            })
                                                        ]
                                                    }),
                                                    socialFields.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>removeSocial(index),
                                                        className: "mt-2 text-red-600 hover:text-red-800 p-2 rounded hover:bg-red-50",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    })
                                                ]
                                            }, field.id))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>appendSocial({
                                                platform: "",
                                                link: ""
                                            }),
                                        className: "mt-2 flex items-center space-x-2 text-blue-600 hover:text-blue-800 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Add Social Media Link"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex items-center justify-end space-x-4 pt-4 border-t",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors",
                                    children: companyDetails ? "Update Company Details" : "Save Company Details"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.539.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0f45c1e8ae52ad76$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user", $0f45c1e8ae52ad76$export$3efd853dbb351e94);





var $a3mgw = parcelRequire("a3mgw");

var $bVR6A = parcelRequire("bVR6A");


function $cbbcc4a94192c47f$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(searchTerm);
    const [filterGender, setFilterGender] = (0, $acw62.useState)("all");
    const [filterState, setFilterState] = (0, $acw62.useState)("all");
    const [filterDistrict, setFilterDistrict] = (0, $acw62.useState)("all");
    const [filterTaluka, setFilterTaluka] = (0, $acw62.useState)("all");
    const { customers: customers = [], pagination: pagination, loading: loading } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.customers);
    const { states: states = [], districts: districts = [], talukas: talukas = [] } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common);
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const itemsPerPage = 10;
    // Calculate which backend page we need based on current frontend page
    const backendPageSize = 100;
    const startRecord = (currentPage - 1) * itemsPerPage;
    const backendPage = Math.floor(startRecord / backendPageSize) + 1;
    (0, $acw62.useEffect)(()=>{
        // Fetch the backend page that contains the records we need
        dispatch((0, $a3mgw.fetchCustomers)({
            page: backendPage,
            per_page: backendPageSize
        }));
        dispatch((0, $bVR6A.fetchStates)());
    }, [
        dispatch,
        backendPage
    ]);
    // Check if any filters are active
    const hasActiveFilters = debouncedSearch !== "" || filterGender !== "all" || filterState !== "all" || filterDistrict !== "all" || filterTaluka !== "all";
    const filteredCustomers = customers.filter((customer)=>{
        const matchesSearch = (customer.name || "").toLowerCase().includes(debouncedSearch.toLowerCase()) || (customer.email || "").toLowerCase().includes(debouncedSearch.toLowerCase()) || (customer.mobile || "").includes(debouncedSearch);
        const matchesFilter = filterGender === "all" || (customer.gender || "").toLowerCase() === filterGender.toLowerCase();
        const matchesState = filterState === "all" || customer.state?.uuid === filterState;
        const matchesDistrict = filterDistrict === "all" || customer.district?.uuid === filterDistrict;
        const matchesTaluka = filterTaluka === "all" || customer.taluka?.uuid === filterTaluka;
        return matchesSearch && matchesFilter && matchesState && matchesDistrict && matchesTaluka;
    });
    // Client-side pagination from backend data
    // Use filtered count when filters are active so page count is accurate
    const totalRecords = hasActiveFilters ? filteredCustomers.length : pagination?.total || filteredCustomers.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    // Calculate which records to show from the current backend page
    const backendStartIndex = (backendPage - 1) * backendPageSize;
    const localStartIndex = startRecord - backendStartIndex;
    const localEndIndex = localStartIndex + itemsPerPage;
    const paginatedCustomers = filteredCustomers.slice(localStartIndex, localEndIndex);
    const handlePageChange = (page)=>{
        navigate(`?page=${page}`);
    };
    // Handle state change to fetch districts
    const handleStateChange = (stateUuid)=>{
        setFilterState(stateUuid);
        setFilterDistrict("all");
        setFilterTaluka("all");
        if (stateUuid !== "all") dispatch((0, $bVR6A.fetchDistrictsByState)(stateUuid));
    };
    // Handle district change to fetch talukas
    const handleDistrictChange = (districtUuid)=>{
        setFilterDistrict(districtUuid);
        setFilterTaluka("all");
        if (districtUuid !== "all") dispatch((0, $bVR6A.fetchTalukasByDistrict)(districtUuid));
    };
    const formatDate = (dateString)=>{
        if (!dateString) return "Not provided";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0903e4def38d82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: "All Customers"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mt-1",
                                    children: "Manage and view customer information"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1 relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                placeholder: "Search customers by name, email, or mobile...",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                                className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: filterGender,
                                                onChange: (e)=>setFilterGender(e.target.value),
                                                className: "pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "all",
                                                        children: "All Genders"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "male",
                                                        children: "Male"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "female",
                                                        children: "Female"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "other",
                                                        children: "Other"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-3 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterState,
                                            onChange: (e)=>handleStateChange(e.target.value),
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All States"
                                                }),
                                                states.map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: state.uuid,
                                                        children: state.name
                                                    }, state.uuid))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterDistrict,
                                            onChange: (e)=>handleDistrictChange(e.target.value),
                                            disabled: filterState === "all",
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All Districts"
                                                }),
                                                districts.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: district.uuid,
                                                        children: district.name
                                                    }, district.uuid))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: filterTaluka,
                                            onChange: (e)=>setFilterTaluka(e.target.value),
                                            disabled: filterDistrict === "all",
                                            className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All Talukas"
                                                }),
                                                talukas.map((taluka)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: taluka.uuid,
                                                        children: taluka.name
                                                    }, taluka.uuid))
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Customer"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Contact"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Location"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Gender"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Date of Birth"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase",
                                            children: "Joined"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "bg-white divide-y divide-gray-200",
                                children: paginatedCustomers.length > 0 ? paginatedCustomers.map((customer)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex-shrink-0 h-10 w-10",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-blue-600"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "ml-4",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: customer.name ?? "N/A"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center text-sm text-gray-900",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4 mr-2 text-gray-400"
                                                                }),
                                                                customer.mobile ?? "N/A"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center text-sm text-gray-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4 mr-2 text-gray-400"
                                                                }),
                                                                customer.email ?? "N/A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center text-sm text-gray-900",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4 mr-2 text-gray-400"
                                                                }),
                                                                customer.state?.name || "N/A"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "text-sm text-gray-500",
                                                            children: [
                                                                customer.district?.name || "N/A",
                                                                ", ",
                                                                customer.taluka?.name || "N/A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `inline-flex px-2 py-1 text-xs font-semibold rounded-full ${customer.gender ? customer.gender.toLowerCase() === 'male' ? 'bg-blue-100 text-blue-800' : customer.gender.toLowerCase() === 'female' ? 'bg-pink-100 text-pink-800' : 'bg-gray-100 text-gray-800' : 'bg-gray-100 text-gray-800'}`,
                                                    children: customer.gender ?? "N/A"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center text-sm text-gray-900",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 mr-2 text-gray-400"
                                                        }),
                                                        formatDate(customer.date_of_birth)
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-6 py-4 text-sm text-gray-500",
                                                children: formatDate(customer.created_at)
                                            })
                                        ]
                                    }, customer.uuid)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: 6,
                                        className: "px-6 py-12 text-center text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                className: "mx-auto h-12 w-12 text-gray-300 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-lg font-medium mb-2",
                                                children: "No customers found"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm",
                                                children: searchTerm || filterGender !== "all" ? "Try adjusting your search or filter criteria" : "No customers have registered yet"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            hasActiveFilters && totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-yellow-800",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Note:"
                        }),
                        " Filters are applied to all data. Showing ",
                        paginatedCustomers.length,
                        " of ",
                        filteredCustomers.length,
                        " filtered results on this page."
                    ]
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                totalPages: totalPages,
                totalItems: totalRecords,
                itemsPerPage: itemsPerPage,
                onPageChange: handlePageChange
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $ivNbC = parcelRequire("ivNbC");




// ─── constants ───────────────────────────────────────────────────────────────
const $aba259e8fcb27c2d$var$now = new Date();
const $aba259e8fcb27c2d$var$currentYear = $aba259e8fcb27c2d$var$now.getFullYear();
const $aba259e8fcb27c2d$var$currentMonth = $aba259e8fcb27c2d$var$now.getMonth() + 1;
const $aba259e8fcb27c2d$var$defaultMonth = $aba259e8fcb27c2d$var$currentMonth === 1 ? 12 : $aba259e8fcb27c2d$var$currentMonth - 1;
const $aba259e8fcb27c2d$var$defaultYear = $aba259e8fcb27c2d$var$currentMonth === 1 ? $aba259e8fcb27c2d$var$currentYear - 1 : $aba259e8fcb27c2d$var$currentYear;
const $aba259e8fcb27c2d$var$DEFAULT_FILTERS = {
    month: $aba259e8fcb27c2d$var$defaultMonth,
    year: $aba259e8fcb27c2d$var$defaultYear,
    district_id: "",
    taluka_id: "",
    category_id: "",
    sub_category_id: "",
    search: ""
};
// ─── helpers ─────────────────────────────────────────────────────────────────
const $aba259e8fcb27c2d$var$fmt = (amount)=>new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount || 0);
function $aba259e8fcb27c2d$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { invoiceLoadingMap: invoiceLoadingMap } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.adminReport);
    // ── filters (synced with URL) ──────────────────────────────────────────────
    const { filters: filters, updateFilter: updateFilter, resetFilters: resetFilters, currentPage: currentPage, setPage: setPage } = (0, $b316e3322c39850e$export$2e2bcd8739ae039)({
        ...$aba259e8fcb27c2d$var$DEFAULT_FILTERS,
        per_page: 15
    }, {
        numberFields: [
            "month",
            "year",
            "per_page"
        ]
    });
    const debouncedSearch = (0, $b552d0b73e8c29fd$export$2e2bcd8739ae039)(filters.search);
    // ── dropdown data (reusable hook) ──────────────────────────────────────────
    const dropdowns = (0, $aa3a63da9f164658$export$2e2bcd8739ae039)({
        district_id: filters.district_id,
        category_id: filters.category_id
    });
    // ── state ──────────────────────────────────────────────────────────────────
    const [data, setData] = (0, $acw62.useState)([]);
    const [pagination, setPagination] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // ── fetch report ───────────────────────────────────────────────────────────
    const fetchReport = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            params.append("month", filters.month);
            params.append("year", filters.year);
            params.append("page", currentPage);
            params.append("per_page", filters.per_page);
            if (filters.district_id) params.append("district_id", filters.district_id);
            if (filters.taluka_id) params.append("taluka_id", filters.taluka_id);
            if (filters.category_id) params.append("category_id", filters.category_id);
            if (filters.sub_category_id) params.append("sub_category_id", filters.sub_category_id);
            const res = await (0, $ivNbC.default).get(`/dashboard/reports?${params.toString()}`);
            const payload = res?.data || res;
            setData(payload?.data || []);
            setPagination(payload?.pagination || null);
        } catch (err) {
            setError(err.response?.data?.message || "Failed to fetch reports");
            setData([]);
            setPagination(null);
        } finally{
            setLoading(false);
        }
    }, [
        filters.month,
        filters.year,
        filters.district_id,
        filters.taluka_id,
        filters.category_id,
        filters.sub_category_id,
        filters.per_page,
        currentPage
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchReport();
    }, [
        fetchReport
    ]);
    // ── filter actions ─────────────────────────────────────────────────────────
    const handlePageChange = (page)=>{
        setPage(page);
    };
    const handleViewTransactions = (businessUuid)=>{
        navigate(`/reports/${businessUuid}`);
    };
    const handleDownloadInvoice = (0, $acw62.useCallback)(async (businessUuid)=>{
        const result = await dispatch((0, $8c30697bb77af718$export$4f3db089c45274df)({
            businessUuid: businessUuid,
            month: filters.month,
            year: filters.year
        }));
        if ((0, $8c30697bb77af718$export$4f3db089c45274df).fulfilled.match(result)) (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Invoice downloaded successfully");
        else (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Invoice not available for this period");
    }, [
        dispatch,
        filters.month,
        filters.year
    ]);
    // Client-side search filter on top of API data
    const filteredData = data.filter((row)=>{
        if (!debouncedSearch.trim()) return true;
        const term = debouncedSearch.toLowerCase();
        const contactStr = Array.isArray(row.contact_number) ? row.contact_number.join(" ") : String(row.contact_number || "");
        return (row.business_name || "").toLowerCase().includes(term) || contactStr.toLowerCase().includes(term);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-blue-100 p-2 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 sm:h-7 sm:w-7 text-blue-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-xl sm:text-2xl font-bold text-gray-900",
                                            children: "Reports"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs sm:text-sm text-gray-500",
                                            children: "Business commission reports \u2014 select a business to view transactions"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: fetchReport,
                            disabled: loading,
                            className: "self-end sm:self-auto p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-40",
                            title: "Refresh",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                className: `h-5 w-5 ${loading ? "animate-spin" : ""}`
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 border-b border-gray-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab5dd6ff469aedd$export$2e2bcd8739ae039), {
                            filters: filters,
                            onFilterChange: updateFilter,
                            onReset: resetFilters,
                            dropdowns: dropdowns,
                            showFields: [
                                "year",
                                "month",
                                "district",
                                "taluka",
                                "category",
                                "sub_category",
                                "search"
                            ],
                            searchPlaceholder: "Business name or contact\u2026"
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center py-16 gap-3 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 animate-spin text-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Loading reports\u2026"
                            })
                        ]
                    }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-red-400"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: fetchReport,
                                className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-colors",
                                children: "Try Again"
                            })
                        ]
                    }) : filteredData.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f17d085e2e0469d$export$2e2bcd8739ae039), {
                                className: "h-12 w-12 text-gray-300"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-500 font-medium",
                                children: "No businesses found"
                            }),
                            filters.search && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400 text-sm",
                                children: "Try a different search term"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-50 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: [
                                            "#",
                                            "Business Name",
                                            "Contact No",
                                            "District",
                                            "Taluka",
                                            "Category",
                                            "Total Revenue",
                                            "Discount Given",
                                            "Commission",
                                            "Actions"
                                        ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                                children: col
                                            }, col))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-100",
                                    children: filteredData.map((row, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                    children: (pagination ? (pagination.current_page - 1) * pagination.per_page : 0) + idx + 1
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 whitespace-nowrap",
                                                        children: row.business_name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: Array.isArray(row.contact_number) ? row.contact_number[0] || "\u2014" : row.contact_number || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: row.district?.name || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: row.taluka?.name || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: row.category?.name || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-semibold text-gray-900 whitespace-nowrap",
                                                    children: $aba259e8fcb27c2d$var$fmt(row.total_revenue)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-yellow-600 whitespace-nowrap",
                                                    children: $aba259e8fcb27c2d$var$fmt(row.discount_to_customers)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-bold text-orange-600 whitespace-nowrap",
                                                    children: $aba259e8fcb27c2d$var$fmt(row.connectri_commission)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                onClick: ()=>handleViewTransactions(row.business_uuid),
                                                                className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 transition-colors",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                                        className: "h-3.5 w-3.5"
                                                                    }),
                                                                    "View Transactions"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                onClick: ()=>handleDownloadInvoice(row.business_uuid),
                                                                disabled: invoiceLoadingMap[row.business_uuid],
                                                                className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 transition-colors disabled:opacity-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                        className: `h-3.5 w-3.5 ${invoiceLoadingMap[row.business_uuid] ? "animate-pulse" : ""}`
                                                                    }),
                                                                    invoiceLoadingMap[row.business_uuid] ? "Generating\u2026" : "Generate Invoice"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, row.business_uuid))
                                })
                            ]
                        })
                    }),
                    pagination && pagination.last_page > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                        currentPage: pagination.current_page,
                        totalPages: pagination.last_page,
                        totalItems: pagination.total,
                        itemsPerPage: pagination.per_page,
                        onPageChange: handlePageChange
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



var $ivNbC = parcelRequire("ivNbC");

var $i4rfT = parcelRequire("i4rfT");



// ─── constants ───────────────────────────────────────────────────────────────
const $80dc91cfdbbd7b6e$var$MONTHS = [
    {
        value: 1,
        label: "January"
    },
    {
        value: 2,
        label: "February"
    },
    {
        value: 3,
        label: "March"
    },
    {
        value: 4,
        label: "April"
    },
    {
        value: 5,
        label: "May"
    },
    {
        value: 6,
        label: "June"
    },
    {
        value: 7,
        label: "July"
    },
    {
        value: 8,
        label: "August"
    },
    {
        value: 9,
        label: "September"
    },
    {
        value: 10,
        label: "October"
    },
    {
        value: 11,
        label: "November"
    },
    {
        value: 12,
        label: "December"
    }
];
const $80dc91cfdbbd7b6e$var$now = new Date();
const $80dc91cfdbbd7b6e$var$currentYear = $80dc91cfdbbd7b6e$var$now.getFullYear();
const $80dc91cfdbbd7b6e$var$currentMonth = $80dc91cfdbbd7b6e$var$now.getMonth() + 1;
const $80dc91cfdbbd7b6e$var$YEARS = Array.from({
    length: $80dc91cfdbbd7b6e$var$currentYear - 2023
}, (_, i)=>$80dc91cfdbbd7b6e$var$currentYear - i);
const $80dc91cfdbbd7b6e$var$getAvailableMonths = (year)=>{
    if (year < $80dc91cfdbbd7b6e$var$currentYear) return $80dc91cfdbbd7b6e$var$MONTHS;
    if (year === $80dc91cfdbbd7b6e$var$currentYear) return $80dc91cfdbbd7b6e$var$MONTHS.filter((m)=>m.value <= $80dc91cfdbbd7b6e$var$currentMonth);
    return [];
};
// ─── helpers ────────────────────────────────────────────────────────────────
const $80dc91cfdbbd7b6e$var$formatCurrency = (amount)=>new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount || 0);
const $80dc91cfdbbd7b6e$var$formatDate = (dateString)=>new Date(dateString).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
const $80dc91cfdbbd7b6e$var$getDefaultDateRange = (year, month)=>{
    const monthStart = new Date(Date.UTC(year, month - 1, 1));
    const monthEnd = new Date(Date.UTC(year, month, 0));
    const fmt = (d)=>`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
    return {
        from_date: fmt(monthStart),
        to_date: fmt(monthEnd)
    };
};
// ─── sub-components ─────────────────────────────────────────────────────────
function $80dc91cfdbbd7b6e$var$SummaryCard({ icon: Icon, label: label, value: value, iconBg: iconBg, textColor: textColor }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex items-start space-x-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${iconBg} p-2.5 rounded-lg flex-shrink-0`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    className: `h-5 w-5 ${textColor}`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 font-medium truncate",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `text-lg font-bold ${textColor} mt-0.5 truncate`,
                        children: value
                    })
                ]
            })
        ]
    });
}
function $80dc91cfdbbd7b6e$var$SettlementBadge({ status: status }) {
    const isSettled = status === "Settled";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold border ${isSettled ? "bg-green-50 text-green-700 border-green-200" : "bg-yellow-50 text-yellow-700 border-yellow-200"}`,
        children: [
            isSettled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e23b961d77b488$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5"
            }),
            status
        ]
    });
}
function $80dc91cfdbbd7b6e$export$2e2bcd8739ae039() {
    const { businessUuid: businessUuid } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    // ── State ──────────────────────────────────────────────────────────────
    const [business, setBusiness] = (0, $acw62.useState)(null);
    const [businessLoading, setBusinessLoading] = (0, $acw62.useState)(true);
    const [report, setReport] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [exportLoading, setExportLoading] = (0, $acw62.useState)(false);
    const defaultDateRange = $80dc91cfdbbd7b6e$var$getDefaultDateRange($80dc91cfdbbd7b6e$var$currentYear, $80dc91cfdbbd7b6e$var$currentMonth);
    const pageFromUrl = parseInt(searchParams.get("page") || "1", 10);
    const [filters, setFilters] = (0, $acw62.useState)({
        year: $80dc91cfdbbd7b6e$var$currentYear,
        month: $80dc91cfdbbd7b6e$var$currentMonth,
        from_date: defaultDateRange.from_date,
        to_date: defaultDateRange.to_date,
        page: pageFromUrl,
        per_page: 15
    });
    // Sync filters.page when URL changes externally
    (0, $acw62.useEffect)(()=>{
        if (pageFromUrl !== filters.page) setFilters((prev)=>({
                ...prev,
                page: pageFromUrl
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageFromUrl
    ]);
    // ── Fetch business details ─────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!businessUuid) return;
        setBusinessLoading(true);
        (0, $ivNbC.default).get(`/dashboard/businesses/${businessUuid}`).then((res)=>{
            setBusiness(res.data || res);
            setBusinessLoading(false);
        }).catch(()=>{
            setBusiness(null);
            setBusinessLoading(false);
        });
    }, [
        businessUuid
    ]);
    // ── Fetch report ───────────────────────────────────────────────────────
    const fetchReport = (0, $acw62.useCallback)(async ()=>{
        if (!businessUuid) return;
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            params.append("year", filters.year);
            params.append("month", filters.month);
            params.append("business_uuid", businessUuid);
            if (filters.from_date) params.append("from_date", filters.from_date);
            if (filters.to_date) params.append("to_date", filters.to_date);
            params.append("per_page", filters.per_page);
            params.append("page", filters.page);
            const res = await (0, $ivNbC.default).get(`/dashboard/reports/businesses/${businessUuid}/transactions/summary?${params.toString()}`);
            const responseData = res?.data || res;
            setReport({
                data: responseData?.data || [],
                pagination: responseData?.pagination || null,
                filter: responseData?.filter || null,
                stats: responseData?.stats || null
            });
        } catch (err) {
            setError(err.response?.data?.message || "Failed to fetch report");
            setReport(null);
        } finally{
            setLoading(false);
        }
    }, [
        businessUuid,
        filters
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchReport();
    }, [
        fetchReport
    ]);
    // ── Filter actions ─────────────────────────────────────────────────────
    const updateFilter = (0, $acw62.useCallback)((key, value)=>{
        setFilters((prev)=>{
            const updated = {
                ...prev,
                [key]: value
            };
            if (key !== "page") updated.page = 1;
            if (key === "year" || key === "month") {
                const newYear = key === "year" ? value : updated.year;
                const newMonth = key === "month" ? value : updated.month;
                const range = $80dc91cfdbbd7b6e$var$getDefaultDateRange(newYear, newMonth);
                updated.from_date = range.from_date;
                updated.to_date = range.to_date;
            }
            return updated;
        });
        if (key !== "page") setSearchParams({
            page: "1"
        });
    }, [
        setSearchParams
    ]);
    const handlePageChange = (0, $acw62.useCallback)((page)=>{
        setFilters((prev)=>({
                ...prev,
                page: page
            }));
        setSearchParams({
            page: String(page)
        });
    }, [
        setSearchParams
    ]);
    // ── Export ─────────────────────────────────────────────────────────────
    const triggerDownload = (blobUrl, filename)=>{
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    };
    const handleExportXlsx = async ()=>{
        setExportLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            const params = new URLSearchParams();
            params.append("year", filters.year);
            params.append("month", filters.month);
            params.append("business_uuid", businessUuid);
            if (filters.from_date) params.append("from_date", filters.from_date);
            if (filters.to_date) params.append("to_date", filters.to_date);
            const url = `${(0, $i4rfT.config).API_BASE_URL}/dashboard/reports/businesses/${businessUuid}/transactions/export?${params.toString()}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Export failed");
            const blob = await response.blob();
            triggerDownload(URL.createObjectURL(blob), `transactions_${businessUuid}_${filters.year}_${filters.month}.xlsx`);
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("XLSX downloaded successfully");
        } catch  {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to export XLSX");
        } finally{
            setExportLoading(false);
        }
    };
    const handleExportPdf = async ()=>{
        setExportLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            const params = new URLSearchParams();
            params.append("year", filters.year);
            params.append("month", filters.month);
            params.append("business_uuid", businessUuid);
            if (filters.from_date) params.append("from_date", filters.from_date);
            if (filters.to_date) params.append("to_date", filters.to_date);
            const url = `${(0, $i4rfT.config).API_BASE_URL}/dashboard/reports/businesses/${businessUuid}/transactions/export-pdf?${params.toString()}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Export failed");
            const blob = await response.blob();
            triggerDownload(URL.createObjectURL(blob), `transactions_${businessUuid}_${filters.year}_${filters.month}.pdf`);
            (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("PDF downloaded successfully");
        } catch  {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to export PDF");
        } finally{
            setExportLoading(false);
        }
    };
    // ── Derived data ───────────────────────────────────────────────────────
    const transactions = Array.isArray(report?.data) ? report.data : [];
    const pagination = report?.pagination || null;
    const stats = report?.stats || null;
    const selectedMonthLabel = $80dc91cfdbbd7b6e$var$MONTHS.find((m)=>m.value === filters.month)?.label || "";
    const summaryTotals = {
        totalBillAmount: transactions.reduce((sum, t)=>sum + (t.bill_amount || 0), 0),
        totalCustomerDiscount: transactions.reduce((sum, t)=>sum + (t.customer_discount || 0), 0),
        totalPlatformCommission: transactions.reduce((sum, t)=>sum + (t.platform_commission || 0), 0),
        totalFinalAmount: transactions.reduce((sum, t)=>sum + (t.final_amount || 0), 0)
    };
    const cards = [
        {
            icon: (0, $cab856bf30f1b37f$export$2e2bcd8739ae039),
            label: "Total Transactions",
            value: stats?.total_transactions || 0,
            iconBg: "bg-blue-100",
            textColor: "text-blue-600"
        },
        {
            icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
            label: "Total Revenue",
            value: $80dc91cfdbbd7b6e$var$formatCurrency(stats?.total_revenue || 0),
            iconBg: "bg-purple-100",
            textColor: "text-purple-600"
        },
        {
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            label: "Customer Savings",
            value: $80dc91cfdbbd7b6e$var$formatCurrency(stats?.customer_savings || 0),
            iconBg: "bg-green-100",
            textColor: "text-green-600"
        },
        {
            icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
            label: "Platform Commission",
            value: $80dc91cfdbbd7b6e$var$formatCurrency(stats?.platform_commission || 0),
            iconBg: "bg-orange-100",
            textColor: "text-orange-600"
        },
        {
            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
            label: "Net Earnings",
            value: $80dc91cfdbbd7b6e$var$formatCurrency(stats?.net_earnings || 0),
            iconBg: "bg-emerald-100",
            textColor: "text-emerald-600"
        }
    ];
    if (businessLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center justify-center py-20 gap-3 text-gray-500",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                className: "h-6 w-6 animate-spin text-blue-500"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "Loading\u2026"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>navigate("/reports"),
                            className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                className: "h-5 w-5"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-blue-100 p-2 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 sm:h-7 sm:w-7 text-blue-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                            className: "text-xl sm:text-2xl font-bold text-gray-900",
                                            children: [
                                                business?.business_name || "Business",
                                                " \u2014 Transactions"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs sm:text-sm text-gray-500",
                                            children: business?.email || ""
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            stats && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4",
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($80dc91cfdbbd7b6e$var$SummaryCard, {
                        ...card
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-visible",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-4 sm:px-6 py-4 border-b border-gray-200 relative z-10",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-gray-600 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 flex-shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs font-medium uppercase whitespace-nowrap",
                                        children: "Filter by:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-2 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: filters.year,
                                        onChange: (e)=>{
                                            const newYear = Number(e.target.value);
                                            updateFilter("year", newYear);
                                            const available = $80dc91cfdbbd7b6e$var$getAvailableMonths(newYear);
                                            if (!available.find((m)=>m.value === filters.month)) updateFilter("month", available[available.length - 1].value);
                                        },
                                        className: "flex-1 sm:flex-none px-3 py-2 border border-gray-300 rounded text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white",
                                        children: $80dc91cfdbbd7b6e$var$YEARS.map((y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: y,
                                                children: y
                                            }, y))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: filters.month,
                                        onChange: (e)=>updateFilter("month", Number(e.target.value)),
                                        className: "flex-1 sm:flex-none px-3 py-2 border border-gray-300 rounded text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white",
                                        children: $80dc91cfdbbd7b6e$var$getAvailableMonths(filters.year).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: m.value,
                                                children: m.label
                                            }, m.value))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex-1 sm:flex-none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10480bbe50d1925d$export$2e2bcd8739ae039), {
                                            year: filters.year,
                                            month: filters.month,
                                            fromDate: filters.from_date,
                                            toDate: filters.to_date,
                                            onFromDateChange: (date)=>updateFilter("from_date", date),
                                            onToDateChange: (date)=>updateFilter("to_date", date)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap gap-2 items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>{
                                            const range = $80dc91cfdbbd7b6e$var$getDefaultDateRange(filters.year, filters.month);
                                            setFilters((prev)=>({
                                                    ...prev,
                                                    from_date: range.from_date,
                                                    to_date: range.to_date,
                                                    page: 1
                                                }));
                                        },
                                        className: "px-3 py-2 rounded border border-gray-300 text-xs font-medium text-gray-600 hover:bg-gray-50 transition-colors",
                                        children: "Reset"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 ml-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: handleExportXlsx,
                                                disabled: exportLoading || loading || transactions.length === 0,
                                                className: "flex items-center gap-1.5 px-3 py-2 rounded border border-green-600 text-green-700 hover:bg-green-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs font-medium",
                                                children: [
                                                    exportLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 animate-spin"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26cec67c26de53a9$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "hidden sm:inline",
                                                        children: "Excel"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: handleExportPdf,
                                                disabled: exportLoading || loading || transactions.length === 0,
                                                className: "flex items-center gap-1.5 px-3 py-2 rounded border border-red-500 text-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs font-medium",
                                                children: [
                                                    exportLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 animate-spin"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "hidden sm:inline",
                                                        children: "PDF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: fetchReport,
                                                disabled: loading,
                                                title: "Refresh",
                                                className: "p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors disabled:opacity-50",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                    className: `h-4 w-4 ${loading ? "animate-spin" : ""}`
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-4 sm:px-6 py-3 border-b border-gray-200 bg-gray-50",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "text-sm font-semibold text-gray-700",
                            children: [
                                "Transaction Details",
                                pagination && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "ml-2 font-normal text-gray-500",
                                    children: [
                                        "(",
                                        pagination.total,
                                        " total)"
                                    ]
                                })
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center py-16 gap-3 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 animate-spin text-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Loading report\u2026"
                            })
                        ]
                    }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-red-400"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: fetchReport,
                                className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-colors",
                                children: "Try Again"
                            })
                        ]
                    }) : transactions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                className: "h-12 w-12 text-gray-300"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-gray-500 font-medium",
                                children: [
                                    "No transactions for ",
                                    selectedMonthLabel,
                                    " ",
                                    filters.year
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400 text-sm",
                                children: "Try selecting a different month or year."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-50 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: [
                                            "#",
                                            "Reference ID",
                                            "Customer",
                                            "Mobile",
                                            "Bill Amount",
                                            "Customer Discount",
                                            "Final Amount",
                                            "Date & Time",
                                            "Platform Commission",
                                            "Settlement"
                                        ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                                children: col
                                            }, col))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-100",
                                    children: transactions.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                    children: t.sl_no
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-mono text-xs text-blue-700 bg-blue-50 px-2 py-0.5 rounded",
                                                        children: t.reference_id
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-medium text-gray-800 whitespace-nowrap",
                                                    children: t.customer_name || "N/A"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 font-mono",
                                                    children: t.mobile
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-semibold text-gray-900 whitespace-nowrap",
                                                    children: $80dc91cfdbbd7b6e$var$formatCurrency(t.bill_amount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "px-4 py-3 whitespace-nowrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-green-700 font-medium",
                                                            children: $80dc91cfdbbd7b6e$var$formatCurrency(t.customer_discount)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-xs text-gray-400 ml-1",
                                                            children: [
                                                                "(",
                                                                t.bill_amount ? (t.customer_discount / t.bill_amount * 100).toFixed(1) : 0,
                                                                "%)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-bold text-emerald-700 whitespace-nowrap",
                                                    children: $80dc91cfdbbd7b6e$var$formatCurrency(t.final_amount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-500 whitespace-nowrap text-xs",
                                                    children: $80dc91cfdbbd7b6e$var$formatDate(t.date_time)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "px-4 py-3 whitespace-nowrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-orange-600 font-medium",
                                                            children: $80dc91cfdbbd7b6e$var$formatCurrency(t.platform_commission)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-xs text-gray-400 ml-1",
                                                            children: [
                                                                "(",
                                                                t.bill_amount ? (t.platform_commission / t.bill_amount * 100).toFixed(1) : 0,
                                                                "%)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($80dc91cfdbbd7b6e$var$SettlementBadge, {
                                                        status: t.settlement_status
                                                    })
                                                })
                                            ]
                                        }, t.reference_id))
                                }),
                                transactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tfoot", {
                                    className: "bg-gray-50 border-t-2 border-gray-300",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 4,
                                                className: "px-4 py-3 text-sm font-semibold text-gray-700",
                                                children: "Page Total"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-gray-900 whitespace-nowrap",
                                                children: $80dc91cfdbbd7b6e$var$formatCurrency(summaryTotals.totalBillAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-green-700 whitespace-nowrap",
                                                children: $80dc91cfdbbd7b6e$var$formatCurrency(summaryTotals.totalCustomerDiscount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-emerald-700 whitespace-nowrap",
                                                children: $80dc91cfdbbd7b6e$var$formatCurrency(summaryTotals.totalFinalAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-3 font-bold text-orange-600 whitespace-nowrap",
                                                children: $80dc91cfdbbd7b6e$var$formatCurrency(summaryTotals.totalPlatformCommission)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 1
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    pagination && pagination.last_page > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                        currentPage: pagination.current_page,
                        totalPages: pagination.last_page,
                        totalItems: pagination.total,
                        itemsPerPage: pagination.per_page,
                        onPageChange: handlePageChange
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







// ─── constants ───────────────────────────────────────────────────────────────
const $6844e90273e0fd8c$var$now = new Date();
const $6844e90273e0fd8c$var$currentYear = $6844e90273e0fd8c$var$now.getFullYear();
const $6844e90273e0fd8c$var$currentMonth = $6844e90273e0fd8c$var$now.getMonth() + 1;
const $6844e90273e0fd8c$var$defaultMonth = $6844e90273e0fd8c$var$currentMonth === 1 ? 12 : $6844e90273e0fd8c$var$currentMonth - 1;
const $6844e90273e0fd8c$var$defaultYear = $6844e90273e0fd8c$var$currentMonth === 1 ? $6844e90273e0fd8c$var$currentYear - 1 : $6844e90273e0fd8c$var$currentYear;
const $6844e90273e0fd8c$var$DEFAULT_FILTERS = {
    month: $6844e90273e0fd8c$var$defaultMonth,
    year: $6844e90273e0fd8c$var$defaultYear
};
// ─── helpers ─────────────────────────────────────────────────────────────────
const $6844e90273e0fd8c$var$fmt = (amount)=>new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount || 0);
const $6844e90273e0fd8c$var$fmtDate = (dateString)=>{
    if (!dateString) return "\u2014";
    return new Date(dateString).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};
function $6844e90273e0fd8c$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { invoices: invoices, invoicesPagination: invoicesPagination, invoicesPeriod: invoicesPeriod, invoicesLoading: invoicesLoading, invoicesError: invoicesError, invoiceLoadingMap: invoiceLoadingMap } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.adminReport);
    // ── filters (synced with URL) ──────────────────────────────────────────────
    const { filters: filters, updateFilter: updateFilter, resetFilters: resetFilters, currentPage: currentPage, setPage: setPage } = (0, $b316e3322c39850e$export$2e2bcd8739ae039)($6844e90273e0fd8c$var$DEFAULT_FILTERS, {
        numberFields: [
            "month",
            "year"
        ]
    });
    // ── fetch invoices ─────────────────────────────────────────────────────────
    const fetchInvoices = (0, $acw62.useCallback)(()=>{
        dispatch((0, $8c30697bb77af718$export$52e092e766585b82)({
            ...filters,
            per_page: 15,
            page: currentPage
        }));
    }, [
        dispatch,
        filters,
        currentPage
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchInvoices();
    }, [
        fetchInvoices
    ]);
    // ── filter actions ─────────────────────────────────────────────────────────
    const handlePageChange = (page)=>{
        setPage(page);
    };
    // ── download invoice ───────────────────────────────────────────────────────
    const handleDownloadInvoice = (0, $acw62.useCallback)(async (businessUuid)=>{
        const result = await dispatch((0, $8c30697bb77af718$export$4f3db089c45274df)({
            businessUuid: businessUuid,
            month: filters.month,
            year: filters.year
        }));
        if ((0, $8c30697bb77af718$export$4f3db089c45274df).fulfilled.match(result)) (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Invoice downloaded successfully");
        else (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Invoice not available");
    }, [
        dispatch,
        filters.month,
        filters.year
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-purple-100 p-2 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 sm:h-7 sm:w-7 text-purple-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-xl sm:text-2xl font-bold text-gray-900",
                                            children: "All Invoices"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs sm:text-sm text-gray-500",
                                            children: "View and download paid commission invoices across all businesses"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: fetchInvoices,
                            disabled: invoicesLoading,
                            className: "self-end sm:self-auto p-2 text-gray-400 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors disabled:opacity-40",
                            title: "Refresh",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                className: `h-5 w-5 ${invoicesLoading ? "animate-spin" : ""}`
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 border-b border-gray-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab5dd6ff469aedd$export$2e2bcd8739ae039), {
                            filters: filters,
                            onFilterChange: updateFilter,
                            onReset: resetFilters,
                            dropdowns: {},
                            showFields: [
                                "year",
                                "month"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-4 sm:px-6 py-3 border-b border-gray-100 flex items-center justify-between bg-gray-50/50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-sm font-semibold text-gray-700",
                                children: [
                                    "Paid Invoices",
                                    invoicesPeriod && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "ml-1 font-normal text-gray-500",
                                        children: [
                                            "\u2014 ",
                                            invoicesPeriod.month_name,
                                            " ",
                                            invoicesPeriod.year
                                        ]
                                    })
                                ]
                            }),
                            invoicesPagination && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-xs text-gray-500",
                                children: [
                                    invoicesPagination.total,
                                    " invoices"
                                ]
                            })
                        ]
                    }),
                    invoicesLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center py-16 gap-3 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 animate-spin text-purple-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Loading invoices\u2026"
                            })
                        ]
                    }) : invoicesError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-red-400"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600",
                                children: "Failed to load invoices."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: fetchInvoices,
                                className: "px-4 py-2 bg-purple-600 text-white rounded-lg text-sm hover:bg-purple-700 transition-colors",
                                children: "Try Again"
                            })
                        ]
                    }) : invoices.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                className: "h-12 w-12 text-gray-300"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-500 font-medium",
                                children: "No paid invoices for this period"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400 text-sm",
                                children: "Try a different month or year."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-50 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: [
                                            "#",
                                            "Business Name",
                                            "Transactions",
                                            "Total Revenue",
                                            "Commission",
                                            "Paid At",
                                            "Action"
                                        ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                                children: col
                                            }, col))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-100",
                                    children: invoices.map((row, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                    children: (invoicesPagination ? (invoicesPagination.current_page - 1) * invoicesPagination.per_page : 0) + idx + 1
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 whitespace-nowrap",
                                                        children: row.business_name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-700 whitespace-nowrap",
                                                    children: row.transaction_count
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-semibold text-gray-900 whitespace-nowrap",
                                                    children: $6844e90273e0fd8c$var$fmt(row.total_revenue)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-bold text-orange-600 whitespace-nowrap",
                                                    children: $6844e90273e0fd8c$var$fmt(row.commission)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-500 text-xs whitespace-nowrap",
                                                    children: $6844e90273e0fd8c$var$fmtDate(row.paid_at)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: ()=>handleDownloadInvoice(row.business_uuid),
                                                        disabled: invoiceLoadingMap[row.business_uuid],
                                                        className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-purple-50 text-purple-700 border border-purple-200 hover:bg-purple-100 transition-colors disabled:opacity-50",
                                                        children: [
                                                            invoiceLoadingMap[row.business_uuid] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                className: "h-3.5 w-3.5 animate-spin"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                                                className: "h-3.5 w-3.5"
                                                            }),
                                                            invoiceLoadingMap[row.business_uuid] ? "Downloading\u2026" : "Download"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, row.uuid))
                                })
                            ]
                        })
                    }),
                    invoicesPagination && invoicesPagination.last_page > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                        currentPage: invoicesPagination.current_page,
                        totalPages: invoicesPagination.last_page,
                        totalItems: invoicesPagination.total,
                        itemsPerPage: invoicesPagination.per_page,
                        onPageChange: handlePageChange
                    })
                ]
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





const $06c6b6c3092c355c$export$558e8ef8f8c97d57 = [
    {
        value: "all",
        label: "All"
    },
    {
        value: "paid",
        label: "Paid"
    },
    {
        value: "unpaid",
        label: "Unpaid"
    }
];
const $06c6b6c3092c355c$export$f9a766aa2475e8ba = [
    {
        value: 1,
        label: "January"
    },
    {
        value: 2,
        label: "February"
    },
    {
        value: 3,
        label: "March"
    },
    {
        value: 4,
        label: "April"
    },
    {
        value: 5,
        label: "May"
    },
    {
        value: 6,
        label: "June"
    },
    {
        value: 7,
        label: "July"
    },
    {
        value: 8,
        label: "August"
    },
    {
        value: 9,
        label: "September"
    },
    {
        value: 10,
        label: "October"
    },
    {
        value: 11,
        label: "November"
    },
    {
        value: 12,
        label: "December"
    }
];
const $06c6b6c3092c355c$var$now = new Date();
const $06c6b6c3092c355c$var$currentYear = $06c6b6c3092c355c$var$now.getFullYear();
const $06c6b6c3092c355c$var$currentMonth = $06c6b6c3092c355c$var$now.getMonth() + 1;
// Default to previous month (backend pattern — settlements are for past months)
const $06c6b6c3092c355c$var$defaultMonth = $06c6b6c3092c355c$var$currentMonth === 1 ? 12 : $06c6b6c3092c355c$var$currentMonth - 1;
const $06c6b6c3092c355c$var$defaultYear = $06c6b6c3092c355c$var$currentMonth === 1 ? $06c6b6c3092c355c$var$currentYear - 1 : $06c6b6c3092c355c$var$currentYear;
const $06c6b6c3092c355c$export$17bc28c2fa7cc78 = Array.from({
    length: $06c6b6c3092c355c$var$currentYear - 2023
}, (_, i)=>$06c6b6c3092c355c$var$currentYear - i);
const $06c6b6c3092c355c$export$bdd329cd94e6c133 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    // ── Redux state ────────────────────────────────────────────────────────────
    const { payments: payments, paymentsPagination: paymentsPagination, paymentsFilter: paymentsFilter, paymentsLoading: paymentsLoading, paymentsError: paymentsError, summary: summary, summaryLoading: summaryLoading, summaryError: summaryError, toggleLoadingMap: toggleLoadingMap } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.adminReport);
    // ── filters (synced with URL) ──────────────────────────────────────────────
    const { filters: filters, updateFilter: updateFilter, resetFilters: resetFilters, currentPage: currentPage, setPage: setPage } = (0, $b316e3322c39850e$export$2e2bcd8739ae039)({
        month: $06c6b6c3092c355c$var$defaultMonth,
        year: $06c6b6c3092c355c$var$defaultYear,
        status: "all",
        search: "",
        district_id: "",
        taluka_id: "",
        category_id: "",
        sub_category_id: ""
    }, {
        numberFields: [
            "month",
            "year"
        ]
    });
    // ── dropdown data (reusable hook) ───────────────────────────────────────────
    const dropdowns = (0, $aa3a63da9f164658$export$2e2bcd8739ae039)({
        district_id: filters.district_id,
        category_id: filters.category_id
    });
    // Debounce search
    const searchTimerRef = (0, $acw62.useRef)(null);
    // ── fetch commission data ──────────────────────────────────────────────────
    const fetchData = (0, $acw62.useCallback)(async (currentFilters = filters, page = currentPage)=>{
        await Promise.all([
            dispatch((0, $8c30697bb77af718$export$89e3feaf0c78d9fc)({
                ...currentFilters,
                page: page,
                per_page: 15
            })),
            dispatch((0, $8c30697bb77af718$export$681103cb048131c6)({
                month: currentFilters.month,
                year: currentFilters.year,
                district_id: currentFilters.district_id,
                taluka_id: currentFilters.taluka_id,
                category_id: currentFilters.category_id,
                sub_category_id: currentFilters.sub_category_id
            }))
        ]);
    }, [
        dispatch,
        filters,
        currentPage
    ]);
    // ── auto-fetch when filters change (except search — debounced separately) ──
    (0, $acw62.useEffect)(()=>{
        fetchData(filters, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.month,
        filters.year,
        filters.status,
        filters.district_id,
        filters.taluka_id,
        filters.category_id,
        filters.sub_category_id,
        currentPage
    ]);
    // ── debounced search ───────────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
        searchTimerRef.current = setTimeout(()=>{
            fetchData(filters, 1);
        }, 400);
        return ()=>clearTimeout(searchTimerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.search
    ]);
    // ── actions ────────────────────────────────────────────────────────────────
    const handlePageChange = (0, $acw62.useCallback)((page)=>{
        setPage(page);
    }, [
        setPage
    ]);
    const handleTogglePayment = (0, $acw62.useCallback)(async (uuid, currentIsPaid)=>{
        const newIsPaid = !currentIsPaid;
        try {
            const result = await dispatch((0, $8c30697bb77af718$export$4ade18399978e9ad)({
                uuid: uuid,
                is_paid: newIsPaid
            }));
            if ((0, $8c30697bb77af718$export$4ade18399978e9ad).fulfilled.match(result)) (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)(newIsPaid ? "Marked as paid" : "Marked as unpaid");
            else {
                (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Failed to update status");
                dispatch((0, $8c30697bb77af718$export$cb5b6ed699b4293)());
            }
        } catch  {
            (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, "Failed to update status");
        }
    }, [
        dispatch
    ]);
    const refreshData = (0, $acw62.useCallback)(()=>fetchData(filters, currentPage), [
        fetchData,
        filters,
        currentPage
    ]);
    // ── derived helpers ────────────────────────────────────────────────────────
    const selectedMonthLabel = $06c6b6c3092c355c$export$f9a766aa2475e8ba.find((m)=>m.value === filters.month)?.label || "";
    return {
        payments: // Data
        payments,
        paymentsPagination: paymentsPagination,
        paymentsFilter: paymentsFilter,
        paymentsLoading: paymentsLoading,
        paymentsError: paymentsError,
        summary: summary,
        summaryLoading: summaryLoading,
        filters: // Filters
        filters,
        updateFilter: updateFilter,
        handlePageChange: handlePageChange,
        resetFilters: resetFilters,
        dropdowns: // Dropdown options
        dropdowns,
        toggleLoadingMap: // Toggle
        toggleLoadingMap,
        handleTogglePayment: handleTogglePayment,
        refreshData: // Actions
        refreshData,
        STATUS_OPTIONS: // Constants
        $06c6b6c3092c355c$export$558e8ef8f8c97d57,
        MONTHS: $06c6b6c3092c355c$export$f9a766aa2475e8ba,
        YEARS: $06c6b6c3092c355c$export$17bc28c2fa7cc78,
        selectedMonthLabel: selectedMonthLabel
    };
};
var $06c6b6c3092c355c$export$2e2bcd8739ae039 = $06c6b6c3092c355c$export$bdd329cd94e6c133;







// ─── helpers ─────────────────────────────────────────────────────────────────
const $077a7c628fb05e35$var$fmt = (amount)=>new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount || 0);
const $077a7c628fb05e35$var$fmtDate = (dateString)=>{
    if (!dateString) return "\u2014";
    return new Date(dateString).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};
const $077a7c628fb05e35$var$num = (v)=>(v ?? 0).toLocaleString("en-IN");
// ─── sub-components ──────────────────────────────────────────────────────────
function $077a7c628fb05e35$var$PaidBadge({ isPaid: isPaid }) {
    return isPaid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800 border border-green-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e23b961d77b488$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5"
            }),
            "Paid"
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800 border border-red-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5"
            }),
            "Unpaid"
        ]
    });
}
function $077a7c628fb05e35$var$KpiCard({ icon: Icon, label: label, value: value, iconBg: iconBg, textColor: textColor }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-lg p-4 border border-gray-200 shadow-sm flex items-start space-x-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${iconBg} p-2.5 rounded-lg flex-shrink-0`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    className: `h-5 w-5 ${textColor}`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 uppercase tracking-wide font-medium",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `text-lg font-bold ${textColor} mt-0.5`,
                        children: value
                    })
                ]
            })
        ]
    });
}
function $077a7c628fb05e35$export$2e2bcd8739ae039() {
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { invoiceLoadingMap: invoiceLoadingMap } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.adminReport);
    const { payments: payments, paymentsPagination: paymentsPagination, paymentsFilter: paymentsFilter, paymentsLoading: paymentsLoading, paymentsError: paymentsError, summary: summary, summaryLoading: summaryLoading, filters: filters, updateFilter: updateFilter, handlePageChange: handlePageChange, resetFilters: resetFilters, dropdowns: dropdowns, toggleLoadingMap: toggleLoadingMap, handleTogglePayment: handleTogglePayment, refreshData: refreshData, selectedMonthLabel: selectedMonthLabel } = (0, $06c6b6c3092c355c$export$bdd329cd94e6c133)();
    // Confirmation modal state
    const [confirmModal, setConfirmModal] = (0, $acw62.useState)({
        open: false,
        uuid: null,
        isPaid: false,
        businessName: ""
    });
    const openConfirmModal = (uuid, isPaid, businessName)=>{
        setConfirmModal({
            open: true,
            uuid: uuid,
            isPaid: isPaid,
            businessName: businessName
        });
    };
    const closeConfirmModal = ()=>{
        setConfirmModal({
            open: false,
            uuid: null,
            isPaid: false,
            businessName: ""
        });
    };
    const handleConfirmToggle = ()=>{
        handleTogglePayment(confirmModal.uuid, confirmModal.isPaid);
        closeConfirmModal();
    };
    const handleDownloadInvoice = (0, $acw62.useCallback)(async (businessUuid)=>{
        const result = await dispatch((0, $8c30697bb77af718$export$4f3db089c45274df)({
            businessUuid: businessUuid,
            month: filters.month,
            year: filters.year
        }));
        if ((0, $8c30697bb77af718$export$4f3db089c45274df).fulfilled.match(result)) (0, $77fa8ab1aa12d8fb$export$89ca83e968d729c5)("Invoice downloaded successfully");
        else (0, $77fa8ab1aa12d8fb$export$bfe1b0910e33c1e3)(null, result.payload || "Invoice not available for this period");
    }, [
        dispatch,
        filters.month,
        filters.year
    ]);
    // ── derived summary data ───────────────────────────────────────────────────
    const totals = summary?.totals || {};
    const revenueBreakdown = summary?.revenue_breakdown || {};
    const collectionRate = totals.total_amount > 0 ? Math.round(totals.paid_amount / totals.total_amount * 100) : 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-blue-100 p-2 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29f89703686dcaa9$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 sm:h-7 sm:w-7 text-blue-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-xl sm:text-2xl font-bold text-gray-900",
                                            children: "Commission Payments"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs sm:text-sm text-gray-500",
                                            children: "Manage monthly commission settlements for premium businesses"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: refreshData,
                            disabled: paymentsLoading,
                            className: "self-end sm:self-auto p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-40",
                            title: "Refresh",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                className: `h-5 w-5 ${paymentsLoading ? "animate-spin" : ""}`
                            })
                        })
                    ]
                })
            }),
            summary && !summaryLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$KpiCard, {
                        icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
                        label: "Total Businesses",
                        value: $077a7c628fb05e35$var$num(totals.total_businesses),
                        iconBg: "bg-gray-100",
                        textColor: "text-gray-700"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$KpiCard, {
                        icon: (0, $f4e23b961d77b488$export$2e2bcd8739ae039),
                        label: "Paid",
                        value: $077a7c628fb05e35$var$num(totals.paid_businesses),
                        iconBg: "bg-green-100",
                        textColor: "text-green-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$KpiCard, {
                        icon: (0, $839eea37a960d2b1$export$2e2bcd8739ae039),
                        label: "Unpaid",
                        value: $077a7c628fb05e35$var$num(totals.unpaid_businesses),
                        iconBg: "bg-red-100",
                        textColor: "text-red-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$KpiCard, {
                        icon: (0, $29f89703686dcaa9$export$2e2bcd8739ae039),
                        label: "Amount Collected",
                        value: $077a7c628fb05e35$var$fmt(totals.paid_amount),
                        iconBg: "bg-emerald-100",
                        textColor: "text-emerald-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$KpiCard, {
                        icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
                        label: "Amount Pending",
                        value: $077a7c628fb05e35$var$fmt(totals.unpaid_amount),
                        iconBg: "bg-yellow-100",
                        textColor: "text-yellow-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$KpiCard, {
                        icon: (0, $7b97e024910b40ff$export$2e2bcd8739ae039),
                        label: "Collection Rate",
                        value: `${collectionRate}%`,
                        iconBg: "bg-blue-100",
                        textColor: "text-blue-600"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 border-b border-gray-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab5dd6ff469aedd$export$2e2bcd8739ae039), {
                            filters: filters,
                            onFilterChange: updateFilter,
                            onReset: resetFilters,
                            dropdowns: dropdowns,
                            showFields: [
                                "year",
                                "month",
                                "status",
                                "district",
                                "taluka",
                                "category",
                                "sub_category",
                                "search"
                            ],
                            statusOptions: (0, $06c6b6c3092c355c$export$558e8ef8f8c97d57),
                            searchPlaceholder: "Business name or email\u2026"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-4 sm:px-6 py-3 border-b border-gray-100 flex items-center justify-between bg-gray-50/50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-sm font-semibold text-gray-700",
                                children: [
                                    "Settlements",
                                    paymentsFilter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "ml-1 font-normal text-gray-500",
                                        children: [
                                            "\u2014 ",
                                            paymentsFilter.month_name,
                                            " ",
                                            paymentsFilter.year
                                        ]
                                    })
                                ]
                            }),
                            paymentsPagination && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-xs text-gray-500",
                                children: [
                                    paymentsPagination.total,
                                    " businesses"
                                ]
                            })
                        ]
                    }),
                    paymentsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center py-16 gap-3 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 animate-spin text-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Loading settlements\u2026"
                            })
                        ]
                    }) : paymentsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-red-400"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600",
                                children: "Failed to load settlements."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: refreshData,
                                className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-colors",
                                children: "Try Again"
                            })
                        ]
                    }) : payments.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center py-16 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfbd1e8d8b150cb$export$2e2bcd8739ae039), {
                                className: "h-12 w-12 text-gray-300"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-gray-500 font-medium",
                                children: [
                                    "No commission data for ",
                                    selectedMonthLabel,
                                    " ",
                                    filters.year
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-400 text-sm",
                                children: "Try a different month, year, or filter combination."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-50 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: [
                                            "#",
                                            "Business Name",
                                            "Contact No",
                                            "District",
                                            "Taluka",
                                            "Category",
                                            "Total Revenue",
                                            "Commission",
                                            "Paid At",
                                            "Status",
                                            "Action"
                                        ].map((col)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                                children: col
                                            }, col))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-100",
                                    children: payments.map((row, idx)=>{
                                        const biz = row.business || {};
                                        const fin = row.financials || {};
                                        const settlement = row.settlement;
                                        const uuid = settlement?.uuid;
                                        const isPaid = settlement?.is_paid ?? false;
                                        const isToggling = uuid ? toggleLoadingMap[uuid] ?? false : false;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: `transition-colors ${isPaid ? "bg-green-100 hover:bg-green-200" : "bg-red-100 hover:bg-red-200"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-400 font-mono text-xs",
                                                    children: (paymentsPagination ? (paymentsPagination.current_page - 1) * paymentsPagination.per_page : 0) + idx + 1
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 whitespace-nowrap",
                                                        children: biz.business_name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: Array.isArray(biz.contact_numbers) && biz.contact_numbers.length > 0 ? biz.contact_numbers[0] : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: biz.district?.name || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: biz.taluka?.name || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-600 text-xs whitespace-nowrap",
                                                    children: biz.category?.name || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-semibold text-gray-900 whitespace-nowrap",
                                                    children: $077a7c628fb05e35$var$fmt(fin.total_revenue)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 font-bold text-orange-600 whitespace-nowrap",
                                                    children: $077a7c628fb05e35$var$fmt(fin.total_commission)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3 text-gray-500 text-xs whitespace-nowrap",
                                                    children: $077a7c628fb05e35$var$fmtDate(settlement?.paid_at)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: settlement ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($077a7c628fb05e35$var$PaidBadge, {
                                                        isPaid: isPaid
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs text-gray-400",
                                                        children: "No record"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: settlement ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$be92b6f5f03c0fe9, {
                                                                        checked: isPaid,
                                                                        onCheckedChange: ()=>openConfirmModal(uuid, isPaid, biz.business_name),
                                                                        disabled: isToggling,
                                                                        className: "w-[42px] h-[25px] bg-gray-200 rounded-full relative shadow-sm data-[state=checked]:bg-green-600 outline-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8210163b65dd94e3$export$6521433ed15a34db, {
                                                                            className: "block w-[21px] h-[21px] bg-white rounded-full transition-transform translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]"
                                                                        })
                                                                    }),
                                                                    isToggling ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                        className: "h-3.5 w-3.5 animate-spin text-gray-400"
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `text-xs font-semibold ${isPaid ? "text-green-700" : "text-gray-500"}`,
                                                                        children: isPaid ? "Paid" : "Unpaid"
                                                                    })
                                                                ]
                                                            }),
                                                            isPaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                onClick: ()=>handleDownloadInvoice(biz.uuid),
                                                                disabled: invoiceLoadingMap[biz.uuid],
                                                                className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-purple-50 text-purple-700 border border-purple-200 hover:bg-purple-100 transition-colors disabled:opacity-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                        className: `h-3.5 w-3.5 ${invoiceLoadingMap[biz.uuid] ? "animate-pulse" : ""}`
                                                                    }),
                                                                    invoiceLoadingMap[biz.uuid] ? "Downloading\u2026" : "Receipt"
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs text-gray-400",
                                                        children: "\u2014"
                                                    })
                                                })
                                            ]
                                        }, uuid || idx);
                                    })
                                })
                            ]
                        })
                    }),
                    paymentsPagination && paymentsPagination.last_page > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26fc24463b599c87$export$2e2bcd8739ae039), {
                        currentPage: paymentsPagination.current_page,
                        totalPages: paymentsPagination.last_page,
                        totalItems: paymentsPagination.total,
                        itemsPerPage: paymentsPagination.per_page,
                        onPageChange: handlePageChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5638f2ca6d7b93$export$2e2bcd8739ae039), {
                open: confirmModal.open,
                onOpenChange: (open)=>!open && closeConfirmModal(),
                type: "confirm",
                title: confirmModal.isPaid ? "Mark as Unpaid" : "Mark as Paid",
                message: `Are you sure you want to mark the commission for "${confirmModal.businessName}" as ${confirmModal.isPaid ? "unpaid" : "paid"}?`,
                confirmText: confirmModal.isPaid ? "Yes, Mark Unpaid" : "Yes, Mark Paid",
                onConfirm: handleConfirmToggle,
                onCancel: closeConfirmModal
            })
        ]
    });
}


function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7759d308bfd5bce4$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0580f20f003de903$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad8b30ddf8aa3463$export$2e2bcd8739ae039), {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/admin/auth/login",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e415fc81efb69301$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/verify-otp",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2062adef70ab299$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25248a71699946fb$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48d716d2db5c5c8d$export$2e2bcd8739ae039), {}),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff172fa0860d2cf4$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/change-password",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d5b99c7796d428bb$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3bc96bf802504e07$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2714cc0ddcb00996$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/banners",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afdc4b2a62c9dd6f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/banners/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46e407298bd610e0$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/categories",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $879885febec94520$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/categories/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e767c4333a6beeb3$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/sub-categories",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $031d2ca71e7f6a5a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/sub-categories/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e68e2aaf5b1c400$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/category-services",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6872ee62324268c0$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/category-services/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7acd4dbd3d81e441$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/states",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b666c30a3298784b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/states/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1c9dbd9a02d4c12$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/districts",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $847eb4d90a322314$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/districts/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f449381380db0c2b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/talukas",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c09b09221adb259$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/talukas/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c47182f8a84f37f4$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/subscription-packages",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58e18ea8c6cd8696$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/subscription-packages/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be6dbc900338bf04$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/payment-modes",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19e41449be3ca01f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/payment-modes/add",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9937b65f1b0b37f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/company-details",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d57e9e74c252552$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/customers",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbbcc4a94192c47f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/commission-payments",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $077a7c628fb05e35$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/reports",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba259e8fcb27c2d$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/reports/:businessUuid",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80dc91cfdbbd7b6e$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/invoices",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6844e90273e0fd8c$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/forgot-password",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5093fb378d234caa$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/reset-password",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c197229f57811059$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c35ec894696d9aa$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2f4a9eb275a3c8$export$2e2bcd8739ae039), {}),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/first-change-password",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdd3dfc62704f8ef$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/dashboard",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd10028b55710d0f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/transactions",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d7116f15adf22f5$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/transactions/history",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8f8f8678902f50b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/discount",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d7fa548309cba8a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/reports",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26b735d7a7eaab51$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/invoices",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bceb295920399bcc$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/settings",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60254a0300f25c2f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/business/change-password",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c1aeecd666e9e58$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");
class $aa7071e0f713f419$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "min-h-screen flex items-center justify-center bg-gray-100 p-4",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full max-w-md bg-white rounded-lg shadow p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-2xl font-bold text-red-600 mb-4",
                        children: "Something went wrong"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-600 mb-4",
                        children: "An unexpected error occurred. Please refresh the page and try again."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>window.location.reload(),
                        className: "w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors",
                        children: "Refresh Page"
                    })
                ]
            })
        });
        return this.props.children;
    }
}
var $aa7071e0f713f419$export$2e2bcd8739ae039 = $aa7071e0f713f419$var$ErrorBoundary;




const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa7071e0f713f419$export$2e2bcd8739ae039), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: (0, $6a862eba3a58be75$export$6f57813fe9f31bf9),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3478a115f13707d$exports.Toaster), {
                position: "top-right",
                toastOptions: {
                    duration: 5000,
                    style: {
                        background: "var(--color-card-bg)",
                        color: "var(--color-text-primary)",
                        border: "1px solid var(--color-card-border)"
                    }
                }
            })
        ]
    })
}));


//# sourceMappingURL=public.c41ab371.js.map
